// [tempo-build] skip: true
/**
 * This is generated from `node bin/scrape-tailwind.js` in tempo-api.
 * It's a manually scraped list of properties from the official Tailwind docs.
 */
export type ClassType = {
  tailwind: string;
  css: string;
};

const PROPERTIES: {
  tailwind: string;
  css: string;
}[] = [
  {
    tailwind: "aspect-auto",
    css: "aspect-ratio: auto;",
  },
  {
    tailwind: "aspect-square",
    css: "aspect-ratio: 1 / 1;",
  },
  {
    tailwind: "aspect-video",
    css: "aspect-ratio: 16 / 9;",
  },
  {
    tailwind: "container",
    css: "width: 100%;",
  },
  {
    tailwind: "columns-1",
    css: "columns: 1;",
  },
  {
    tailwind: "columns-2",
    css: "columns: 2;",
  },
  {
    tailwind: "columns-3",
    css: "columns: 3;",
  },
  {
    tailwind: "columns-4",
    css: "columns: 4;",
  },
  {
    tailwind: "columns-5",
    css: "columns: 5;",
  },
  {
    tailwind: "columns-6",
    css: "columns: 6;",
  },
  {
    tailwind: "columns-7",
    css: "columns: 7;",
  },
  {
    tailwind: "columns-8",
    css: "columns: 8;",
  },
  {
    tailwind: "columns-9",
    css: "columns: 9;",
  },
  {
    tailwind: "columns-10",
    css: "columns: 10;",
  },
  {
    tailwind: "columns-11",
    css: "columns: 11;",
  },
  {
    tailwind: "columns-12",
    css: "columns: 12;",
  },
  {
    tailwind: "columns-auto",
    css: "columns: auto;",
  },
  {
    tailwind: "columns-3xs",
    css: "columns: 16rem; /* 256px */",
  },
  {
    tailwind: "columns-2xs",
    css: "columns: 18rem; /* 288px */",
  },
  {
    tailwind: "columns-xs",
    css: "columns: 20rem; /* 320px */",
  },
  {
    tailwind: "columns-sm",
    css: "columns: 24rem; /* 384px */",
  },
  {
    tailwind: "columns-md",
    css: "columns: 28rem; /* 448px */",
  },
  {
    tailwind: "columns-lg",
    css: "columns: 32rem; /* 512px */",
  },
  {
    tailwind: "columns-xl",
    css: "columns: 36rem; /* 576px */",
  },
  {
    tailwind: "columns-2xl",
    css: "columns: 42rem; /* 672px */",
  },
  {
    tailwind: "columns-3xl",
    css: "columns: 48rem; /* 768px */",
  },
  {
    tailwind: "columns-4xl",
    css: "columns: 56rem; /* 896px */",
  },
  {
    tailwind: "columns-5xl",
    css: "columns: 64rem; /* 1024px */",
  },
  {
    tailwind: "columns-6xl",
    css: "columns: 72rem; /* 1152px */",
  },
  {
    tailwind: "columns-7xl",
    css: "columns: 80rem; /* 1280px */",
  },
  {
    tailwind: "break-after-auto",
    css: "break-after: auto;",
  },
  {
    tailwind: "break-after-avoid",
    css: "break-after: avoid;",
  },
  {
    tailwind: "break-after-all",
    css: "break-after: all;",
  },
  {
    tailwind: "break-after-avoid-page",
    css: "break-after: avoid-page;",
  },
  {
    tailwind: "break-after-page",
    css: "break-after: page;",
  },
  {
    tailwind: "break-after-left",
    css: "break-after: left;",
  },
  {
    tailwind: "break-after-right",
    css: "break-after: right;",
  },
  {
    tailwind: "break-after-column",
    css: "break-after: column;",
  },
  {
    tailwind: "break-before-auto",
    css: "break-before: auto;",
  },
  {
    tailwind: "break-before-avoid",
    css: "break-before: avoid;",
  },
  {
    tailwind: "break-before-all",
    css: "break-before: all;",
  },
  {
    tailwind: "break-before-avoid-page",
    css: "break-before: avoid-page;",
  },
  {
    tailwind: "break-before-page",
    css: "break-before: page;",
  },
  {
    tailwind: "break-before-left",
    css: "break-before: left;",
  },
  {
    tailwind: "break-before-right",
    css: "break-before: right;",
  },
  {
    tailwind: "break-before-column",
    css: "break-before: column;",
  },
  {
    tailwind: "break-inside-auto",
    css: "break-inside: auto;",
  },
  {
    tailwind: "break-inside-avoid",
    css: "break-inside: avoid;",
  },
  {
    tailwind: "break-inside-avoid-page",
    css: "break-inside: avoid-page;",
  },
  {
    tailwind: "break-inside-avoid-column",
    css: "break-inside: avoid-column;",
  },
  {
    tailwind: "box-decoration-clone",
    css: "box-decoration-break: clone;",
  },
  {
    tailwind: "box-decoration-slice",
    css: "box-decoration-break: slice;",
  },
  {
    tailwind: "box-border",
    css: "box-sizing: border-box;",
  },
  {
    tailwind: "box-content",
    css: "box-sizing: content-box;",
  },
  {
    tailwind: "block",
    css: "display: block;",
  },
  {
    tailwind: "inline-block",
    css: "display: inline-block;",
  },
  {
    tailwind: "inline",
    css: "display: inline;",
  },
  {
    tailwind: "flex",
    css: "display: flex;",
  },
  {
    tailwind: "inline-flex",
    css: "display: inline-flex;",
  },
  {
    tailwind: "table",
    css: "display: table;",
  },
  {
    tailwind: "inline-table",
    css: "display: inline-table;",
  },
  {
    tailwind: "table-caption",
    css: "display: table-caption;",
  },
  {
    tailwind: "table-cell",
    css: "display: table-cell;",
  },
  {
    tailwind: "table-column",
    css: "display: table-column;",
  },
  {
    tailwind: "table-column-group",
    css: "display: table-column-group;",
  },
  {
    tailwind: "table-footer-group",
    css: "display: table-footer-group;",
  },
  {
    tailwind: "table-header-group",
    css: "display: table-header-group;",
  },
  {
    tailwind: "table-row-group",
    css: "display: table-row-group;",
  },
  {
    tailwind: "table-row",
    css: "display: table-row;",
  },
  {
    tailwind: "flow-root",
    css: "display: flow-root;",
  },
  {
    tailwind: "grid",
    css: "display: grid;",
  },
  {
    tailwind: "inline-grid",
    css: "display: inline-grid;",
  },
  {
    tailwind: "contents",
    css: "display: contents;",
  },
  {
    tailwind: "list-item",
    css: "display: list-item;",
  },
  {
    tailwind: "hidden",
    css: "display: none;",
  },
  {
    tailwind: "float-right",
    css: "float: right;",
  },
  {
    tailwind: "float-left",
    css: "float: left;",
  },
  {
    tailwind: "float-none",
    css: "float: none;",
  },
  {
    tailwind: "clear-left",
    css: "clear: left;",
  },
  {
    tailwind: "clear-right",
    css: "clear: right;",
  },
  {
    tailwind: "clear-both",
    css: "clear: both;",
  },
  {
    tailwind: "clear-none",
    css: "clear: none;",
  },
  {
    tailwind: "isolate",
    css: "isolation: isolate;",
  },
  {
    tailwind: "isolation-auto",
    css: "isolation: auto;",
  },
  {
    tailwind: "object-contain",
    css: "object-fit: contain;",
  },
  {
    tailwind: "object-cover",
    css: "object-fit: cover;",
  },
  {
    tailwind: "object-fill",
    css: "object-fit: fill;",
  },
  {
    tailwind: "object-none",
    css: "object-fit: none;",
  },
  {
    tailwind: "object-scale-down",
    css: "object-fit: scale-down;",
  },
  {
    tailwind: "object-bottom",
    css: "object-position: bottom;",
  },
  {
    tailwind: "object-center",
    css: "object-position: center;",
  },
  {
    tailwind: "object-left",
    css: "object-position: left;",
  },
  {
    tailwind: "object-left-bottom",
    css: "object-position: left bottom;",
  },
  {
    tailwind: "object-left-top",
    css: "object-position: left top;",
  },
  {
    tailwind: "object-right",
    css: "object-position: right;",
  },
  {
    tailwind: "object-right-bottom",
    css: "object-position: right bottom;",
  },
  {
    tailwind: "object-right-top",
    css: "object-position: right top;",
  },
  {
    tailwind: "object-top",
    css: "object-position: top;",
  },
  {
    tailwind: "overflow-auto",
    css: "overflow: auto;",
  },
  {
    tailwind: "overflow-hidden",
    css: "overflow: hidden;",
  },
  {
    tailwind: "overflow-clip",
    css: "overflow: clip;",
  },
  {
    tailwind: "overflow-visible",
    css: "overflow: visible;",
  },
  {
    tailwind: "overflow-scroll",
    css: "overflow: scroll;",
  },
  {
    tailwind: "overflow-x-auto",
    css: "overflow-x: auto;",
  },
  {
    tailwind: "overflow-y-auto",
    css: "overflow-y: auto;",
  },
  {
    tailwind: "overflow-x-hidden",
    css: "overflow-x: hidden;",
  },
  {
    tailwind: "overflow-y-hidden",
    css: "overflow-y: hidden;",
  },
  {
    tailwind: "overflow-x-clip",
    css: "overflow-x: clip;",
  },
  {
    tailwind: "overflow-y-clip",
    css: "overflow-y: clip;",
  },
  {
    tailwind: "overflow-x-visible",
    css: "overflow-x: visible;",
  },
  {
    tailwind: "overflow-y-visible",
    css: "overflow-y: visible;",
  },
  {
    tailwind: "overflow-x-scroll",
    css: "overflow-x: scroll;",
  },
  {
    tailwind: "overflow-y-scroll",
    css: "overflow-y: scroll;",
  },
  {
    tailwind: "overscroll-auto",
    css: "overscroll-behavior: auto;",
  },
  {
    tailwind: "overscroll-contain",
    css: "overscroll-behavior: contain;",
  },
  {
    tailwind: "overscroll-none",
    css: "overscroll-behavior: none;",
  },
  {
    tailwind: "overscroll-y-auto",
    css: "overscroll-behavior-y: auto;",
  },
  {
    tailwind: "overscroll-y-contain",
    css: "overscroll-behavior-y: contain;",
  },
  {
    tailwind: "overscroll-y-none",
    css: "overscroll-behavior-y: none;",
  },
  {
    tailwind: "overscroll-x-auto",
    css: "overscroll-behavior-x: auto;",
  },
  {
    tailwind: "overscroll-x-contain",
    css: "overscroll-behavior-x: contain;",
  },
  {
    tailwind: "overscroll-x-none",
    css: "overscroll-behavior-x: none;",
  },
  {
    tailwind: "static",
    css: "position: static;",
  },
  {
    tailwind: "fixed",
    css: "position: fixed;",
  },
  {
    tailwind: "absolute",
    css: "position: absolute;",
  },
  {
    tailwind: "relative",
    css: "position: relative;",
  },
  {
    tailwind: "sticky",
    css: "position: sticky;",
  },
  {
    tailwind: "inset-0",
    css: "inset: 0px;",
  },
  {
    tailwind: "inset-x-0",
    css: "left: 0px;\nright: 0px;",
  },
  {
    tailwind: "inset-y-0",
    css: "top: 0px;\nbottom: 0px;",
  },
  {
    tailwind: "start-0",
    css: "inset-inline-start: 0px;",
  },
  {
    tailwind: "end-0",
    css: "inset-inline-end: 0px;",
  },
  {
    tailwind: "top-0",
    css: "top: 0px;",
  },
  {
    tailwind: "right-0",
    css: "right: 0px;",
  },
  {
    tailwind: "bottom-0",
    css: "bottom: 0px;",
  },
  {
    tailwind: "left-0",
    css: "left: 0px;",
  },
  {
    tailwind: "inset-px",
    css: "inset: 1px;",
  },
  {
    tailwind: "inset-x-px",
    css: "left: 1px;\nright: 1px;",
  },
  {
    tailwind: "inset-y-px",
    css: "top: 1px;\nbottom: 1px;",
  },
  {
    tailwind: "start-px",
    css: "inset-inline-start: 1px;",
  },
  {
    tailwind: "end-px",
    css: "inset-inline-end: 1px;",
  },
  {
    tailwind: "top-px",
    css: "top: 1px;",
  },
  {
    tailwind: "right-px",
    css: "right: 1px;",
  },
  {
    tailwind: "bottom-px",
    css: "bottom: 1px;",
  },
  {
    tailwind: "left-px",
    css: "left: 1px;",
  },
  {
    tailwind: "inset-0.5",
    css: "inset: 0.125rem; /* 2px */",
  },
  {
    tailwind: "inset-x-0.5",
    css: "left: 0.125rem; /* 2px */\nright: 0.125rem; /* 2px */",
  },
  {
    tailwind: "inset-y-0.5",
    css: "top: 0.125rem; /* 2px */\nbottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "start-0.5",
    css: "inset-inline-start: 0.125rem; /* 2px */",
  },
  {
    tailwind: "end-0.5",
    css: "inset-inline-end: 0.125rem; /* 2px */",
  },
  {
    tailwind: "top-0.5",
    css: "top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "right-0.5",
    css: "right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "bottom-0.5",
    css: "bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "left-0.5",
    css: "left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "inset-1",
    css: "inset: 0.25rem; /* 4px */",
  },
  {
    tailwind: "inset-x-1",
    css: "left: 0.25rem; /* 4px */\nright: 0.25rem; /* 4px */",
  },
  {
    tailwind: "inset-y-1",
    css: "top: 0.25rem; /* 4px */\nbottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "start-1",
    css: "inset-inline-start: 0.25rem; /* 4px */",
  },
  {
    tailwind: "end-1",
    css: "inset-inline-end: 0.25rem; /* 4px */",
  },
  {
    tailwind: "top-1",
    css: "top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "right-1",
    css: "right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "bottom-1",
    css: "bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "left-1",
    css: "left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "inset-1.5",
    css: "inset: 0.375rem; /* 6px */",
  },
  {
    tailwind: "inset-x-1.5",
    css: "left: 0.375rem; /* 6px */\nright: 0.375rem; /* 6px */",
  },
  {
    tailwind: "inset-y-1.5",
    css: "top: 0.375rem; /* 6px */\nbottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "start-1.5",
    css: "inset-inline-start: 0.375rem; /* 6px */",
  },
  {
    tailwind: "end-1.5",
    css: "inset-inline-end: 0.375rem; /* 6px */",
  },
  {
    tailwind: "top-1.5",
    css: "top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "right-1.5",
    css: "right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "bottom-1.5",
    css: "bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "left-1.5",
    css: "left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "inset-2",
    css: "inset: 0.5rem; /* 8px */",
  },
  {
    tailwind: "inset-x-2",
    css: "left: 0.5rem; /* 8px */\nright: 0.5rem; /* 8px */",
  },
  {
    tailwind: "inset-y-2",
    css: "top: 0.5rem; /* 8px */\nbottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "start-2",
    css: "inset-inline-start: 0.5rem; /* 8px */",
  },
  {
    tailwind: "end-2",
    css: "inset-inline-end: 0.5rem; /* 8px */",
  },
  {
    tailwind: "top-2",
    css: "top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "right-2",
    css: "right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "bottom-2",
    css: "bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "left-2",
    css: "left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "inset-2.5",
    css: "inset: 0.625rem; /* 10px */",
  },
  {
    tailwind: "inset-x-2.5",
    css: "left: 0.625rem; /* 10px */\nright: 0.625rem; /* 10px */",
  },
  {
    tailwind: "inset-y-2.5",
    css: "top: 0.625rem; /* 10px */\nbottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "start-2.5",
    css: "inset-inline-start: 0.625rem; /* 10px */",
  },
  {
    tailwind: "end-2.5",
    css: "inset-inline-end: 0.625rem; /* 10px */",
  },
  {
    tailwind: "top-2.5",
    css: "top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "right-2.5",
    css: "right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "bottom-2.5",
    css: "bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "left-2.5",
    css: "left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "inset-3",
    css: "inset: 0.75rem; /* 12px */",
  },
  {
    tailwind: "inset-x-3",
    css: "left: 0.75rem; /* 12px */\nright: 0.75rem; /* 12px */",
  },
  {
    tailwind: "inset-y-3",
    css: "top: 0.75rem; /* 12px */\nbottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "start-3",
    css: "inset-inline-start: 0.75rem; /* 12px */",
  },
  {
    tailwind: "end-3",
    css: "inset-inline-end: 0.75rem; /* 12px */",
  },
  {
    tailwind: "top-3",
    css: "top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "right-3",
    css: "right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "bottom-3",
    css: "bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "left-3",
    css: "left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "inset-3.5",
    css: "inset: 0.875rem; /* 14px */",
  },
  {
    tailwind: "inset-x-3.5",
    css: "left: 0.875rem; /* 14px */\nright: 0.875rem; /* 14px */",
  },
  {
    tailwind: "inset-y-3.5",
    css: "top: 0.875rem; /* 14px */\nbottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "start-3.5",
    css: "inset-inline-start: 0.875rem; /* 14px */",
  },
  {
    tailwind: "end-3.5",
    css: "inset-inline-end: 0.875rem; /* 14px */",
  },
  {
    tailwind: "top-3.5",
    css: "top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "right-3.5",
    css: "right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "bottom-3.5",
    css: "bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "left-3.5",
    css: "left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "inset-4",
    css: "inset: 1rem; /* 16px */",
  },
  {
    tailwind: "inset-x-4",
    css: "left: 1rem; /* 16px */\nright: 1rem; /* 16px */",
  },
  {
    tailwind: "inset-y-4",
    css: "top: 1rem; /* 16px */\nbottom: 1rem; /* 16px */",
  },
  {
    tailwind: "start-4",
    css: "inset-inline-start: 1rem; /* 16px */",
  },
  {
    tailwind: "end-4",
    css: "inset-inline-end: 1rem; /* 16px */",
  },
  {
    tailwind: "top-4",
    css: "top: 1rem; /* 16px */",
  },
  {
    tailwind: "right-4",
    css: "right: 1rem; /* 16px */",
  },
  {
    tailwind: "bottom-4",
    css: "bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "left-4",
    css: "left: 1rem; /* 16px */",
  },
  {
    tailwind: "inset-5",
    css: "inset: 1.25rem; /* 20px */",
  },
  {
    tailwind: "inset-x-5",
    css: "left: 1.25rem; /* 20px */\nright: 1.25rem; /* 20px */",
  },
  {
    tailwind: "inset-y-5",
    css: "top: 1.25rem; /* 20px */\nbottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "start-5",
    css: "inset-inline-start: 1.25rem; /* 20px */",
  },
  {
    tailwind: "end-5",
    css: "inset-inline-end: 1.25rem; /* 20px */",
  },
  {
    tailwind: "top-5",
    css: "top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "right-5",
    css: "right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "bottom-5",
    css: "bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "left-5",
    css: "left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "inset-6",
    css: "inset: 1.5rem; /* 24px */",
  },
  {
    tailwind: "inset-x-6",
    css: "left: 1.5rem; /* 24px */\nright: 1.5rem; /* 24px */",
  },
  {
    tailwind: "inset-y-6",
    css: "top: 1.5rem; /* 24px */\nbottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "start-6",
    css: "inset-inline-start: 1.5rem; /* 24px */",
  },
  {
    tailwind: "end-6",
    css: "inset-inline-end: 1.5rem; /* 24px */",
  },
  {
    tailwind: "top-6",
    css: "top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "right-6",
    css: "right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "bottom-6",
    css: "bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "left-6",
    css: "left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "inset-7",
    css: "inset: 1.75rem; /* 28px */",
  },
  {
    tailwind: "inset-x-7",
    css: "left: 1.75rem; /* 28px */\nright: 1.75rem; /* 28px */",
  },
  {
    tailwind: "inset-y-7",
    css: "top: 1.75rem; /* 28px */\nbottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "start-7",
    css: "inset-inline-start: 1.75rem; /* 28px */",
  },
  {
    tailwind: "end-7",
    css: "inset-inline-end: 1.75rem; /* 28px */",
  },
  {
    tailwind: "top-7",
    css: "top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "right-7",
    css: "right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "bottom-7",
    css: "bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "left-7",
    css: "left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "inset-8",
    css: "inset: 2rem; /* 32px */",
  },
  {
    tailwind: "inset-x-8",
    css: "left: 2rem; /* 32px */\nright: 2rem; /* 32px */",
  },
  {
    tailwind: "inset-y-8",
    css: "top: 2rem; /* 32px */\nbottom: 2rem; /* 32px */",
  },
  {
    tailwind: "start-8",
    css: "inset-inline-start: 2rem; /* 32px */",
  },
  {
    tailwind: "end-8",
    css: "inset-inline-end: 2rem; /* 32px */",
  },
  {
    tailwind: "top-8",
    css: "top: 2rem; /* 32px */",
  },
  {
    tailwind: "right-8",
    css: "right: 2rem; /* 32px */",
  },
  {
    tailwind: "bottom-8",
    css: "bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "left-8",
    css: "left: 2rem; /* 32px */",
  },
  {
    tailwind: "inset-9",
    css: "inset: 2.25rem; /* 36px */",
  },
  {
    tailwind: "inset-x-9",
    css: "left: 2.25rem; /* 36px */\nright: 2.25rem; /* 36px */",
  },
  {
    tailwind: "inset-y-9",
    css: "top: 2.25rem; /* 36px */\nbottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "start-9",
    css: "inset-inline-start: 2.25rem; /* 36px */",
  },
  {
    tailwind: "end-9",
    css: "inset-inline-end: 2.25rem; /* 36px */",
  },
  {
    tailwind: "top-9",
    css: "top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "right-9",
    css: "right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "bottom-9",
    css: "bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "left-9",
    css: "left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "inset-10",
    css: "inset: 2.5rem; /* 40px */",
  },
  {
    tailwind: "inset-x-10",
    css: "left: 2.5rem; /* 40px */\nright: 2.5rem; /* 40px */",
  },
  {
    tailwind: "inset-y-10",
    css: "top: 2.5rem; /* 40px */\nbottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "start-10",
    css: "inset-inline-start: 2.5rem; /* 40px */",
  },
  {
    tailwind: "end-10",
    css: "inset-inline-end: 2.5rem; /* 40px */",
  },
  {
    tailwind: "top-10",
    css: "top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "right-10",
    css: "right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "bottom-10",
    css: "bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "left-10",
    css: "left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "inset-11",
    css: "inset: 2.75rem; /* 44px */",
  },
  {
    tailwind: "inset-x-11",
    css: "left: 2.75rem; /* 44px */\nright: 2.75rem; /* 44px */",
  },
  {
    tailwind: "inset-y-11",
    css: "top: 2.75rem; /* 44px */\nbottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "start-11",
    css: "inset-inline-start: 2.75rem; /* 44px */",
  },
  {
    tailwind: "end-11",
    css: "inset-inline-end: 2.75rem; /* 44px */",
  },
  {
    tailwind: "top-11",
    css: "top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "right-11",
    css: "right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "bottom-11",
    css: "bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "left-11",
    css: "left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "inset-12",
    css: "inset: 3rem; /* 48px */",
  },
  {
    tailwind: "inset-x-12",
    css: "left: 3rem; /* 48px */\nright: 3rem; /* 48px */",
  },
  {
    tailwind: "inset-y-12",
    css: "top: 3rem; /* 48px */\nbottom: 3rem; /* 48px */",
  },
  {
    tailwind: "start-12",
    css: "inset-inline-start: 3rem; /* 48px */",
  },
  {
    tailwind: "end-12",
    css: "inset-inline-end: 3rem; /* 48px */",
  },
  {
    tailwind: "top-12",
    css: "top: 3rem; /* 48px */",
  },
  {
    tailwind: "right-12",
    css: "right: 3rem; /* 48px */",
  },
  {
    tailwind: "bottom-12",
    css: "bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "left-12",
    css: "left: 3rem; /* 48px */",
  },
  {
    tailwind: "inset-14",
    css: "inset: 3.5rem; /* 56px */",
  },
  {
    tailwind: "inset-x-14",
    css: "left: 3.5rem; /* 56px */\nright: 3.5rem; /* 56px */",
  },
  {
    tailwind: "inset-y-14",
    css: "top: 3.5rem; /* 56px */\nbottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "start-14",
    css: "inset-inline-start: 3.5rem; /* 56px */",
  },
  {
    tailwind: "end-14",
    css: "inset-inline-end: 3.5rem; /* 56px */",
  },
  {
    tailwind: "top-14",
    css: "top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "right-14",
    css: "right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "bottom-14",
    css: "bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "left-14",
    css: "left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "inset-16",
    css: "inset: 4rem; /* 64px */",
  },
  {
    tailwind: "inset-x-16",
    css: "left: 4rem; /* 64px */\nright: 4rem; /* 64px */",
  },
  {
    tailwind: "inset-y-16",
    css: "top: 4rem; /* 64px */\nbottom: 4rem; /* 64px */",
  },
  {
    tailwind: "start-16",
    css: "inset-inline-start: 4rem; /* 64px */",
  },
  {
    tailwind: "end-16",
    css: "inset-inline-end: 4rem; /* 64px */",
  },
  {
    tailwind: "top-16",
    css: "top: 4rem; /* 64px */",
  },
  {
    tailwind: "right-16",
    css: "right: 4rem; /* 64px */",
  },
  {
    tailwind: "bottom-16",
    css: "bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "left-16",
    css: "left: 4rem; /* 64px */",
  },
  {
    tailwind: "inset-20",
    css: "inset: 5rem; /* 80px */",
  },
  {
    tailwind: "inset-x-20",
    css: "left: 5rem; /* 80px */\nright: 5rem; /* 80px */",
  },
  {
    tailwind: "inset-y-20",
    css: "top: 5rem; /* 80px */\nbottom: 5rem; /* 80px */",
  },
  {
    tailwind: "start-20",
    css: "inset-inline-start: 5rem; /* 80px */",
  },
  {
    tailwind: "end-20",
    css: "inset-inline-end: 5rem; /* 80px */",
  },
  {
    tailwind: "top-20",
    css: "top: 5rem; /* 80px */",
  },
  {
    tailwind: "right-20",
    css: "right: 5rem; /* 80px */",
  },
  {
    tailwind: "bottom-20",
    css: "bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "left-20",
    css: "left: 5rem; /* 80px */",
  },
  {
    tailwind: "inset-24",
    css: "inset: 6rem; /* 96px */",
  },
  {
    tailwind: "inset-x-24",
    css: "left: 6rem; /* 96px */\nright: 6rem; /* 96px */",
  },
  {
    tailwind: "inset-y-24",
    css: "top: 6rem; /* 96px */\nbottom: 6rem; /* 96px */",
  },
  {
    tailwind: "start-24",
    css: "inset-inline-start: 6rem; /* 96px */",
  },
  {
    tailwind: "end-24",
    css: "inset-inline-end: 6rem; /* 96px */",
  },
  {
    tailwind: "top-24",
    css: "top: 6rem; /* 96px */",
  },
  {
    tailwind: "right-24",
    css: "right: 6rem; /* 96px */",
  },
  {
    tailwind: "bottom-24",
    css: "bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "left-24",
    css: "left: 6rem; /* 96px */",
  },
  {
    tailwind: "inset-28",
    css: "inset: 7rem; /* 112px */",
  },
  {
    tailwind: "inset-x-28",
    css: "left: 7rem; /* 112px */\nright: 7rem; /* 112px */",
  },
  {
    tailwind: "inset-y-28",
    css: "top: 7rem; /* 112px */\nbottom: 7rem; /* 112px */",
  },
  {
    tailwind: "start-28",
    css: "inset-inline-start: 7rem; /* 112px */",
  },
  {
    tailwind: "end-28",
    css: "inset-inline-end: 7rem; /* 112px */",
  },
  {
    tailwind: "top-28",
    css: "top: 7rem; /* 112px */",
  },
  {
    tailwind: "right-28",
    css: "right: 7rem; /* 112px */",
  },
  {
    tailwind: "bottom-28",
    css: "bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "left-28",
    css: "left: 7rem; /* 112px */",
  },
  {
    tailwind: "inset-32",
    css: "inset: 8rem; /* 128px */",
  },
  {
    tailwind: "inset-x-32",
    css: "left: 8rem; /* 128px */\nright: 8rem; /* 128px */",
  },
  {
    tailwind: "inset-y-32",
    css: "top: 8rem; /* 128px */\nbottom: 8rem; /* 128px */",
  },
  {
    tailwind: "start-32",
    css: "inset-inline-start: 8rem; /* 128px */",
  },
  {
    tailwind: "end-32",
    css: "inset-inline-end: 8rem; /* 128px */",
  },
  {
    tailwind: "top-32",
    css: "top: 8rem; /* 128px */",
  },
  {
    tailwind: "right-32",
    css: "right: 8rem; /* 128px */",
  },
  {
    tailwind: "bottom-32",
    css: "bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "left-32",
    css: "left: 8rem; /* 128px */",
  },
  {
    tailwind: "inset-36",
    css: "inset: 9rem; /* 144px */",
  },
  {
    tailwind: "inset-x-36",
    css: "left: 9rem; /* 144px */\nright: 9rem; /* 144px */",
  },
  {
    tailwind: "inset-y-36",
    css: "top: 9rem; /* 144px */\nbottom: 9rem; /* 144px */",
  },
  {
    tailwind: "start-36",
    css: "inset-inline-start: 9rem; /* 144px */",
  },
  {
    tailwind: "end-36",
    css: "inset-inline-end: 9rem; /* 144px */",
  },
  {
    tailwind: "top-36",
    css: "top: 9rem; /* 144px */",
  },
  {
    tailwind: "right-36",
    css: "right: 9rem; /* 144px */",
  },
  {
    tailwind: "bottom-36",
    css: "bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "left-36",
    css: "left: 9rem; /* 144px */",
  },
  {
    tailwind: "inset-40",
    css: "inset: 10rem; /* 160px */",
  },
  {
    tailwind: "inset-x-40",
    css: "left: 10rem; /* 160px */\nright: 10rem; /* 160px */",
  },
  {
    tailwind: "inset-y-40",
    css: "top: 10rem; /* 160px */\nbottom: 10rem; /* 160px */",
  },
  {
    tailwind: "start-40",
    css: "inset-inline-start: 10rem; /* 160px */",
  },
  {
    tailwind: "end-40",
    css: "inset-inline-end: 10rem; /* 160px */",
  },
  {
    tailwind: "top-40",
    css: "top: 10rem; /* 160px */",
  },
  {
    tailwind: "right-40",
    css: "right: 10rem; /* 160px */",
  },
  {
    tailwind: "bottom-40",
    css: "bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "left-40",
    css: "left: 10rem; /* 160px */",
  },
  {
    tailwind: "inset-44",
    css: "inset: 11rem; /* 176px */",
  },
  {
    tailwind: "inset-x-44",
    css: "left: 11rem; /* 176px */\nright: 11rem; /* 176px */",
  },
  {
    tailwind: "inset-y-44",
    css: "top: 11rem; /* 176px */\nbottom: 11rem; /* 176px */",
  },
  {
    tailwind: "start-44",
    css: "inset-inline-start: 11rem; /* 176px */",
  },
  {
    tailwind: "end-44",
    css: "inset-inline-end: 11rem; /* 176px */",
  },
  {
    tailwind: "top-44",
    css: "top: 11rem; /* 176px */",
  },
  {
    tailwind: "right-44",
    css: "right: 11rem; /* 176px */",
  },
  {
    tailwind: "bottom-44",
    css: "bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "left-44",
    css: "left: 11rem; /* 176px */",
  },
  {
    tailwind: "inset-48",
    css: "inset: 12rem; /* 192px */",
  },
  {
    tailwind: "inset-x-48",
    css: "left: 12rem; /* 192px */\nright: 12rem; /* 192px */",
  },
  {
    tailwind: "inset-y-48",
    css: "top: 12rem; /* 192px */\nbottom: 12rem; /* 192px */",
  },
  {
    tailwind: "start-48",
    css: "inset-inline-start: 12rem; /* 192px */",
  },
  {
    tailwind: "end-48",
    css: "inset-inline-end: 12rem; /* 192px */",
  },
  {
    tailwind: "top-48",
    css: "top: 12rem; /* 192px */",
  },
  {
    tailwind: "right-48",
    css: "right: 12rem; /* 192px */",
  },
  {
    tailwind: "bottom-48",
    css: "bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "left-48",
    css: "left: 12rem; /* 192px */",
  },
  {
    tailwind: "inset-52",
    css: "inset: 13rem; /* 208px */",
  },
  {
    tailwind: "inset-x-52",
    css: "left: 13rem; /* 208px */\nright: 13rem; /* 208px */",
  },
  {
    tailwind: "inset-y-52",
    css: "top: 13rem; /* 208px */\nbottom: 13rem; /* 208px */",
  },
  {
    tailwind: "start-52",
    css: "inset-inline-start: 13rem; /* 208px */",
  },
  {
    tailwind: "end-52",
    css: "inset-inline-end: 13rem; /* 208px */",
  },
  {
    tailwind: "top-52",
    css: "top: 13rem; /* 208px */",
  },
  {
    tailwind: "right-52",
    css: "right: 13rem; /* 208px */",
  },
  {
    tailwind: "bottom-52",
    css: "bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "left-52",
    css: "left: 13rem; /* 208px */",
  },
  {
    tailwind: "inset-56",
    css: "inset: 14rem; /* 224px */",
  },
  {
    tailwind: "inset-x-56",
    css: "left: 14rem; /* 224px */\nright: 14rem; /* 224px */",
  },
  {
    tailwind: "inset-y-56",
    css: "top: 14rem; /* 224px */\nbottom: 14rem; /* 224px */",
  },
  {
    tailwind: "start-56",
    css: "inset-inline-start: 14rem; /* 224px */",
  },
  {
    tailwind: "end-56",
    css: "inset-inline-end: 14rem; /* 224px */",
  },
  {
    tailwind: "top-56",
    css: "top: 14rem; /* 224px */",
  },
  {
    tailwind: "right-56",
    css: "right: 14rem; /* 224px */",
  },
  {
    tailwind: "bottom-56",
    css: "bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "left-56",
    css: "left: 14rem; /* 224px */",
  },
  {
    tailwind: "inset-60",
    css: "inset: 15rem; /* 240px */",
  },
  {
    tailwind: "inset-x-60",
    css: "left: 15rem; /* 240px */\nright: 15rem; /* 240px */",
  },
  {
    tailwind: "inset-y-60",
    css: "top: 15rem; /* 240px */\nbottom: 15rem; /* 240px */",
  },
  {
    tailwind: "start-60",
    css: "inset-inline-start: 15rem; /* 240px */",
  },
  {
    tailwind: "end-60",
    css: "inset-inline-end: 15rem; /* 240px */",
  },
  {
    tailwind: "top-60",
    css: "top: 15rem; /* 240px */",
  },
  {
    tailwind: "right-60",
    css: "right: 15rem; /* 240px */",
  },
  {
    tailwind: "bottom-60",
    css: "bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "left-60",
    css: "left: 15rem; /* 240px */",
  },
  {
    tailwind: "inset-64",
    css: "inset: 16rem; /* 256px */",
  },
  {
    tailwind: "inset-x-64",
    css: "left: 16rem; /* 256px */\nright: 16rem; /* 256px */",
  },
  {
    tailwind: "inset-y-64",
    css: "top: 16rem; /* 256px */\nbottom: 16rem; /* 256px */",
  },
  {
    tailwind: "start-64",
    css: "inset-inline-start: 16rem; /* 256px */",
  },
  {
    tailwind: "end-64",
    css: "inset-inline-end: 16rem; /* 256px */",
  },
  {
    tailwind: "top-64",
    css: "top: 16rem; /* 256px */",
  },
  {
    tailwind: "right-64",
    css: "right: 16rem; /* 256px */",
  },
  {
    tailwind: "bottom-64",
    css: "bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "left-64",
    css: "left: 16rem; /* 256px */",
  },
  {
    tailwind: "inset-72",
    css: "inset: 18rem; /* 288px */",
  },
  {
    tailwind: "inset-x-72",
    css: "left: 18rem; /* 288px */\nright: 18rem; /* 288px */",
  },
  {
    tailwind: "inset-y-72",
    css: "top: 18rem; /* 288px */\nbottom: 18rem; /* 288px */",
  },
  {
    tailwind: "start-72",
    css: "inset-inline-start: 18rem; /* 288px */",
  },
  {
    tailwind: "end-72",
    css: "inset-inline-end: 18rem; /* 288px */",
  },
  {
    tailwind: "top-72",
    css: "top: 18rem; /* 288px */",
  },
  {
    tailwind: "right-72",
    css: "right: 18rem; /* 288px */",
  },
  {
    tailwind: "bottom-72",
    css: "bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "left-72",
    css: "left: 18rem; /* 288px */",
  },
  {
    tailwind: "inset-80",
    css: "inset: 20rem; /* 320px */",
  },
  {
    tailwind: "inset-x-80",
    css: "left: 20rem; /* 320px */\nright: 20rem; /* 320px */",
  },
  {
    tailwind: "inset-y-80",
    css: "top: 20rem; /* 320px */\nbottom: 20rem; /* 320px */",
  },
  {
    tailwind: "start-80",
    css: "inset-inline-start: 20rem; /* 320px */",
  },
  {
    tailwind: "end-80",
    css: "inset-inline-end: 20rem; /* 320px */",
  },
  {
    tailwind: "top-80",
    css: "top: 20rem; /* 320px */",
  },
  {
    tailwind: "right-80",
    css: "right: 20rem; /* 320px */",
  },
  {
    tailwind: "bottom-80",
    css: "bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "left-80",
    css: "left: 20rem; /* 320px */",
  },
  {
    tailwind: "inset-96",
    css: "inset: 24rem; /* 384px */",
  },
  {
    tailwind: "inset-x-96",
    css: "left: 24rem; /* 384px */\nright: 24rem; /* 384px */",
  },
  {
    tailwind: "inset-y-96",
    css: "top: 24rem; /* 384px */\nbottom: 24rem; /* 384px */",
  },
  {
    tailwind: "start-96",
    css: "inset-inline-start: 24rem; /* 384px */",
  },
  {
    tailwind: "end-96",
    css: "inset-inline-end: 24rem; /* 384px */",
  },
  {
    tailwind: "top-96",
    css: "top: 24rem; /* 384px */",
  },
  {
    tailwind: "right-96",
    css: "right: 24rem; /* 384px */",
  },
  {
    tailwind: "bottom-96",
    css: "bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "left-96",
    css: "left: 24rem; /* 384px */",
  },
  {
    tailwind: "inset-auto",
    css: "inset: auto;",
  },
  {
    tailwind: "inset-1/2",
    css: "inset: 50%;",
  },
  {
    tailwind: "inset-1/3",
    css: "inset: 33.333333%;",
  },
  {
    tailwind: "inset-2/3",
    css: "inset: 66.666667%;",
  },
  {
    tailwind: "inset-1/4",
    css: "inset: 25%;",
  },
  {
    tailwind: "inset-2/4",
    css: "inset: 50%;",
  },
  {
    tailwind: "inset-3/4",
    css: "inset: 75%;",
  },
  {
    tailwind: "inset-full",
    css: "inset: 100%;",
  },
  {
    tailwind: "inset-x-auto",
    css: "left: auto;\nright: auto;",
  },
  {
    tailwind: "inset-x-1/2",
    css: "left: 50%;\nright: 50%;",
  },
  {
    tailwind: "inset-x-1/3",
    css: "left: 33.333333%;\nright: 33.333333%;",
  },
  {
    tailwind: "inset-x-2/3",
    css: "left: 66.666667%;\nright: 66.666667%;",
  },
  {
    tailwind: "inset-x-1/4",
    css: "left: 25%;\nright: 25%;",
  },
  {
    tailwind: "inset-x-2/4",
    css: "left: 50%;\nright: 50%;",
  },
  {
    tailwind: "inset-x-3/4",
    css: "left: 75%;\nright: 75%;",
  },
  {
    tailwind: "inset-x-full",
    css: "left: 100%;\nright: 100%;",
  },
  {
    tailwind: "inset-y-auto",
    css: "top: auto;\nbottom: auto;",
  },
  {
    tailwind: "inset-y-1/2",
    css: "top: 50%;\nbottom: 50%;",
  },
  {
    tailwind: "inset-y-1/3",
    css: "top: 33.333333%;\nbottom: 33.333333%;",
  },
  {
    tailwind: "inset-y-2/3",
    css: "top: 66.666667%;\nbottom: 66.666667%;",
  },
  {
    tailwind: "inset-y-1/4",
    css: "top: 25%;\nbottom: 25%;",
  },
  {
    tailwind: "inset-y-2/4",
    css: "top: 50%;\nbottom: 50%;",
  },
  {
    tailwind: "inset-y-3/4",
    css: "top: 75%;\nbottom: 75%;",
  },
  {
    tailwind: "inset-y-full",
    css: "top: 100%;\nbottom: 100%;",
  },
  {
    tailwind: "start-auto",
    css: "inset-inline-start: auto;",
  },
  {
    tailwind: "start-1/2",
    css: "inset-inline-start: 50%;",
  },
  {
    tailwind: "start-1/3",
    css: "inset-inline-start: 33.333333%;",
  },
  {
    tailwind: "start-2/3",
    css: "inset-inline-start: 66.666667%;",
  },
  {
    tailwind: "start-1/4",
    css: "inset-inline-start: 25%;",
  },
  {
    tailwind: "start-2/4",
    css: "inset-inline-start: 50%;",
  },
  {
    tailwind: "start-3/4",
    css: "inset-inline-start: 75%;",
  },
  {
    tailwind: "start-full",
    css: "inset-inline-start: 100%;",
  },
  {
    tailwind: "end-auto",
    css: "inset-inline-end: auto;",
  },
  {
    tailwind: "end-1/2",
    css: "inset-inline-end: 50%;",
  },
  {
    tailwind: "end-1/3",
    css: "inset-inline-end: 33.333333%;",
  },
  {
    tailwind: "end-2/3",
    css: "inset-inline-end: 66.666667%;",
  },
  {
    tailwind: "end-1/4",
    css: "inset-inline-end: 25%;",
  },
  {
    tailwind: "end-2/4",
    css: "inset-inline-end: 50%;",
  },
  {
    tailwind: "end-3/4",
    css: "inset-inline-end: 75%;",
  },
  {
    tailwind: "end-full",
    css: "inset-inline-end: 100%;",
  },
  {
    tailwind: "top-auto",
    css: "top: auto;",
  },
  {
    tailwind: "top-1/2",
    css: "top: 50%;",
  },
  {
    tailwind: "top-1/3",
    css: "top: 33.333333%;",
  },
  {
    tailwind: "top-2/3",
    css: "top: 66.666667%;",
  },
  {
    tailwind: "top-1/4",
    css: "top: 25%;",
  },
  {
    tailwind: "top-2/4",
    css: "top: 50%;",
  },
  {
    tailwind: "top-3/4",
    css: "top: 75%;",
  },
  {
    tailwind: "top-full",
    css: "top: 100%;",
  },
  {
    tailwind: "right-auto",
    css: "right: auto;",
  },
  {
    tailwind: "right-1/2",
    css: "right: 50%;",
  },
  {
    tailwind: "right-1/3",
    css: "right: 33.333333%;",
  },
  {
    tailwind: "right-2/3",
    css: "right: 66.666667%;",
  },
  {
    tailwind: "right-1/4",
    css: "right: 25%;",
  },
  {
    tailwind: "right-2/4",
    css: "right: 50%;",
  },
  {
    tailwind: "right-3/4",
    css: "right: 75%;",
  },
  {
    tailwind: "right-full",
    css: "right: 100%;",
  },
  {
    tailwind: "bottom-auto",
    css: "bottom: auto;",
  },
  {
    tailwind: "bottom-1/2",
    css: "bottom: 50%;",
  },
  {
    tailwind: "bottom-1/3",
    css: "bottom: 33.333333%;",
  },
  {
    tailwind: "bottom-2/3",
    css: "bottom: 66.666667%;",
  },
  {
    tailwind: "bottom-1/4",
    css: "bottom: 25%;",
  },
  {
    tailwind: "bottom-2/4",
    css: "bottom: 50%;",
  },
  {
    tailwind: "bottom-3/4",
    css: "bottom: 75%;",
  },
  {
    tailwind: "bottom-full",
    css: "bottom: 100%;",
  },
  {
    tailwind: "left-auto",
    css: "left: auto;",
  },
  {
    tailwind: "left-1/2",
    css: "left: 50%;",
  },
  {
    tailwind: "left-1/3",
    css: "left: 33.333333%;",
  },
  {
    tailwind: "left-2/3",
    css: "left: 66.666667%;",
  },
  {
    tailwind: "left-1/4",
    css: "left: 25%;",
  },
  {
    tailwind: "left-2/4",
    css: "left: 50%;",
  },
  {
    tailwind: "left-3/4",
    css: "left: 75%;",
  },
  {
    tailwind: "left-full",
    css: "left: 100%;",
  },
  {
    tailwind: "visible",
    css: "visibility: visible;",
  },
  {
    tailwind: "invisible",
    css: "visibility: hidden;",
  },
  {
    tailwind: "collapse",
    css: "visibility: collapse;",
  },
  {
    tailwind: "z-0",
    css: "z-index: 0;",
  },
  {
    tailwind: "z-10",
    css: "z-index: 10;",
  },
  {
    tailwind: "z-20",
    css: "z-index: 20;",
  },
  {
    tailwind: "z-30",
    css: "z-index: 30;",
  },
  {
    tailwind: "z-40",
    css: "z-index: 40;",
  },
  {
    tailwind: "z-50",
    css: "z-index: 50;",
  },
  {
    tailwind: "z-auto",
    css: "z-index: auto;",
  },
  {
    tailwind: "basis-0",
    css: "flex-basis: 0px;",
  },
  {
    tailwind: "basis-1",
    css: "flex-basis: 0.25rem; /* 4px */",
  },
  {
    tailwind: "basis-2",
    css: "flex-basis: 0.5rem; /* 8px */",
  },
  {
    tailwind: "basis-3",
    css: "flex-basis: 0.75rem; /* 12px */",
  },
  {
    tailwind: "basis-4",
    css: "flex-basis: 1rem; /* 16px */",
  },
  {
    tailwind: "basis-5",
    css: "flex-basis: 1.25rem; /* 20px */",
  },
  {
    tailwind: "basis-6",
    css: "flex-basis: 1.5rem; /* 24px */",
  },
  {
    tailwind: "basis-7",
    css: "flex-basis: 1.75rem; /* 28px */",
  },
  {
    tailwind: "basis-8",
    css: "flex-basis: 2rem; /* 32px */",
  },
  {
    tailwind: "basis-9",
    css: "flex-basis: 2.25rem; /* 36px */",
  },
  {
    tailwind: "basis-10",
    css: "flex-basis: 2.5rem; /* 40px */",
  },
  {
    tailwind: "basis-11",
    css: "flex-basis: 2.75rem; /* 44px */",
  },
  {
    tailwind: "basis-12",
    css: "flex-basis: 3rem; /* 48px */",
  },
  {
    tailwind: "basis-14",
    css: "flex-basis: 3.5rem; /* 56px */",
  },
  {
    tailwind: "basis-16",
    css: "flex-basis: 4rem; /* 64px */",
  },
  {
    tailwind: "basis-20",
    css: "flex-basis: 5rem; /* 80px */",
  },
  {
    tailwind: "basis-24",
    css: "flex-basis: 6rem; /* 96px */",
  },
  {
    tailwind: "basis-28",
    css: "flex-basis: 7rem; /* 112px */",
  },
  {
    tailwind: "basis-32",
    css: "flex-basis: 8rem; /* 128px */",
  },
  {
    tailwind: "basis-36",
    css: "flex-basis: 9rem; /* 144px */",
  },
  {
    tailwind: "basis-40",
    css: "flex-basis: 10rem; /* 160px */",
  },
  {
    tailwind: "basis-44",
    css: "flex-basis: 11rem; /* 176px */",
  },
  {
    tailwind: "basis-48",
    css: "flex-basis: 12rem; /* 192px */",
  },
  {
    tailwind: "basis-52",
    css: "flex-basis: 13rem; /* 208px */",
  },
  {
    tailwind: "basis-56",
    css: "flex-basis: 14rem; /* 224px */",
  },
  {
    tailwind: "basis-60",
    css: "flex-basis: 15rem; /* 240px */",
  },
  {
    tailwind: "basis-64",
    css: "flex-basis: 16rem; /* 256px */",
  },
  {
    tailwind: "basis-72",
    css: "flex-basis: 18rem; /* 288px */",
  },
  {
    tailwind: "basis-80",
    css: "flex-basis: 20rem; /* 320px */",
  },
  {
    tailwind: "basis-96",
    css: "flex-basis: 24rem; /* 384px */",
  },
  {
    tailwind: "basis-auto",
    css: "flex-basis: auto;",
  },
  {
    tailwind: "basis-px",
    css: "flex-basis: 1px;",
  },
  {
    tailwind: "basis-0.5",
    css: "flex-basis: 0.125rem; /* 2px */",
  },
  {
    tailwind: "basis-1.5",
    css: "flex-basis: 0.375rem; /* 6px */",
  },
  {
    tailwind: "basis-2.5",
    css: "flex-basis: 0.625rem; /* 10px */",
  },
  {
    tailwind: "basis-3.5",
    css: "flex-basis: 0.875rem; /* 14px */",
  },
  {
    tailwind: "basis-1/2",
    css: "flex-basis: 50%;",
  },
  {
    tailwind: "basis-1/3",
    css: "flex-basis: 33.333333%;",
  },
  {
    tailwind: "basis-2/3",
    css: "flex-basis: 66.666667%;",
  },
  {
    tailwind: "basis-1/4",
    css: "flex-basis: 25%;",
  },
  {
    tailwind: "basis-2/4",
    css: "flex-basis: 50%;",
  },
  {
    tailwind: "basis-3/4",
    css: "flex-basis: 75%;",
  },
  {
    tailwind: "basis-1/5",
    css: "flex-basis: 20%;",
  },
  {
    tailwind: "basis-2/5",
    css: "flex-basis: 40%;",
  },
  {
    tailwind: "basis-3/5",
    css: "flex-basis: 60%;",
  },
  {
    tailwind: "basis-4/5",
    css: "flex-basis: 80%;",
  },
  {
    tailwind: "basis-1/6",
    css: "flex-basis: 16.666667%;",
  },
  {
    tailwind: "basis-2/6",
    css: "flex-basis: 33.333333%;",
  },
  {
    tailwind: "basis-3/6",
    css: "flex-basis: 50%;",
  },
  {
    tailwind: "basis-4/6",
    css: "flex-basis: 66.666667%;",
  },
  {
    tailwind: "basis-5/6",
    css: "flex-basis: 83.333333%;",
  },
  {
    tailwind: "basis-1/12",
    css: "flex-basis: 8.333333%;",
  },
  {
    tailwind: "basis-2/12",
    css: "flex-basis: 16.666667%;",
  },
  {
    tailwind: "basis-3/12",
    css: "flex-basis: 25%;",
  },
  {
    tailwind: "basis-4/12",
    css: "flex-basis: 33.333333%;",
  },
  {
    tailwind: "basis-5/12",
    css: "flex-basis: 41.666667%;",
  },
  {
    tailwind: "basis-6/12",
    css: "flex-basis: 50%;",
  },
  {
    tailwind: "basis-7/12",
    css: "flex-basis: 58.333333%;",
  },
  {
    tailwind: "basis-8/12",
    css: "flex-basis: 66.666667%;",
  },
  {
    tailwind: "basis-9/12",
    css: "flex-basis: 75%;",
  },
  {
    tailwind: "basis-10/12",
    css: "flex-basis: 83.333333%;",
  },
  {
    tailwind: "basis-11/12",
    css: "flex-basis: 91.666667%;",
  },
  {
    tailwind: "basis-full",
    css: "flex-basis: 100%;",
  },
  {
    tailwind: "flex-row",
    css: "flex-direction: row;",
  },
  {
    tailwind: "flex-row-reverse",
    css: "flex-direction: row-reverse;",
  },
  {
    tailwind: "flex-col",
    css: "flex-direction: column;",
  },
  {
    tailwind: "flex-col-reverse",
    css: "flex-direction: column-reverse;",
  },
  {
    tailwind: "flex-wrap",
    css: "flex-wrap: wrap;",
  },
  {
    tailwind: "flex-wrap-reverse",
    css: "flex-wrap: wrap-reverse;",
  },
  {
    tailwind: "flex-nowrap",
    css: "flex-wrap: nowrap;",
  },
  {
    tailwind: "flex-1",
    css: "flex: 1 1 0%;",
  },
  {
    tailwind: "flex-auto",
    css: "flex: 1 1 auto;",
  },
  {
    tailwind: "flex-initial",
    css: "flex: 0 1 auto;",
  },
  {
    tailwind: "flex-none",
    css: "flex: none;",
  },
  {
    tailwind: "grow",
    css: "flex-grow: 1;",
  },
  {
    tailwind: "grow-0",
    css: "flex-grow: 0;",
  },
  {
    tailwind: "shrink",
    css: "flex-shrink: 1;",
  },
  {
    tailwind: "shrink-0",
    css: "flex-shrink: 0;",
  },
  {
    tailwind: "order-1",
    css: "order: 1;",
  },
  {
    tailwind: "order-2",
    css: "order: 2;",
  },
  {
    tailwind: "order-3",
    css: "order: 3;",
  },
  {
    tailwind: "order-4",
    css: "order: 4;",
  },
  {
    tailwind: "order-5",
    css: "order: 5;",
  },
  {
    tailwind: "order-6",
    css: "order: 6;",
  },
  {
    tailwind: "order-7",
    css: "order: 7;",
  },
  {
    tailwind: "order-8",
    css: "order: 8;",
  },
  {
    tailwind: "order-9",
    css: "order: 9;",
  },
  {
    tailwind: "order-10",
    css: "order: 10;",
  },
  {
    tailwind: "order-11",
    css: "order: 11;",
  },
  {
    tailwind: "order-12",
    css: "order: 12;",
  },
  {
    tailwind: "order-first",
    css: "order: -9999;",
  },
  {
    tailwind: "order-last",
    css: "order: 9999;",
  },
  {
    tailwind: "order-none",
    css: "order: 0;",
  },
  {
    tailwind: "grid-cols-1",
    css: "grid-template-columns: repeat(1, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-2",
    css: "grid-template-columns: repeat(2, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-3",
    css: "grid-template-columns: repeat(3, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-4",
    css: "grid-template-columns: repeat(4, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-5",
    css: "grid-template-columns: repeat(5, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-6",
    css: "grid-template-columns: repeat(6, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-7",
    css: "grid-template-columns: repeat(7, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-8",
    css: "grid-template-columns: repeat(8, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-9",
    css: "grid-template-columns: repeat(9, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-10",
    css: "grid-template-columns: repeat(10, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-11",
    css: "grid-template-columns: repeat(11, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-12",
    css: "grid-template-columns: repeat(12, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-cols-none",
    css: "grid-template-columns: none;",
  },
  {
    tailwind: "col-auto",
    css: "grid-column: auto;",
  },
  {
    tailwind: "col-span-1",
    css: "grid-column: span 1 / span 1;",
  },
  {
    tailwind: "col-span-2",
    css: "grid-column: span 2 / span 2;",
  },
  {
    tailwind: "col-span-3",
    css: "grid-column: span 3 / span 3;",
  },
  {
    tailwind: "col-span-4",
    css: "grid-column: span 4 / span 4;",
  },
  {
    tailwind: "col-span-5",
    css: "grid-column: span 5 / span 5;",
  },
  {
    tailwind: "col-span-6",
    css: "grid-column: span 6 / span 6;",
  },
  {
    tailwind: "col-span-7",
    css: "grid-column: span 7 / span 7;",
  },
  {
    tailwind: "col-span-8",
    css: "grid-column: span 8 / span 8;",
  },
  {
    tailwind: "col-span-9",
    css: "grid-column: span 9 / span 9;",
  },
  {
    tailwind: "col-span-10",
    css: "grid-column: span 10 / span 10;",
  },
  {
    tailwind: "col-span-11",
    css: "grid-column: span 11 / span 11;",
  },
  {
    tailwind: "col-span-12",
    css: "grid-column: span 12 / span 12;",
  },
  {
    tailwind: "col-span-full",
    css: "grid-column: 1 / -1;",
  },
  {
    tailwind: "col-start-1",
    css: "grid-column-start: 1;",
  },
  {
    tailwind: "col-start-2",
    css: "grid-column-start: 2;",
  },
  {
    tailwind: "col-start-3",
    css: "grid-column-start: 3;",
  },
  {
    tailwind: "col-start-4",
    css: "grid-column-start: 4;",
  },
  {
    tailwind: "col-start-5",
    css: "grid-column-start: 5;",
  },
  {
    tailwind: "col-start-6",
    css: "grid-column-start: 6;",
  },
  {
    tailwind: "col-start-7",
    css: "grid-column-start: 7;",
  },
  {
    tailwind: "col-start-8",
    css: "grid-column-start: 8;",
  },
  {
    tailwind: "col-start-9",
    css: "grid-column-start: 9;",
  },
  {
    tailwind: "col-start-10",
    css: "grid-column-start: 10;",
  },
  {
    tailwind: "col-start-11",
    css: "grid-column-start: 11;",
  },
  {
    tailwind: "col-start-12",
    css: "grid-column-start: 12;",
  },
  {
    tailwind: "col-start-13",
    css: "grid-column-start: 13;",
  },
  {
    tailwind: "col-start-auto",
    css: "grid-column-start: auto;",
  },
  {
    tailwind: "col-end-1",
    css: "grid-column-end: 1;",
  },
  {
    tailwind: "col-end-2",
    css: "grid-column-end: 2;",
  },
  {
    tailwind: "col-end-3",
    css: "grid-column-end: 3;",
  },
  {
    tailwind: "col-end-4",
    css: "grid-column-end: 4;",
  },
  {
    tailwind: "col-end-5",
    css: "grid-column-end: 5;",
  },
  {
    tailwind: "col-end-6",
    css: "grid-column-end: 6;",
  },
  {
    tailwind: "col-end-7",
    css: "grid-column-end: 7;",
  },
  {
    tailwind: "col-end-8",
    css: "grid-column-end: 8;",
  },
  {
    tailwind: "col-end-9",
    css: "grid-column-end: 9;",
  },
  {
    tailwind: "col-end-10",
    css: "grid-column-end: 10;",
  },
  {
    tailwind: "col-end-11",
    css: "grid-column-end: 11;",
  },
  {
    tailwind: "col-end-12",
    css: "grid-column-end: 12;",
  },
  {
    tailwind: "col-end-13",
    css: "grid-column-end: 13;",
  },
  {
    tailwind: "col-end-auto",
    css: "grid-column-end: auto;",
  },
  {
    tailwind: "grid-rows-1",
    css: "grid-template-rows: repeat(1, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-2",
    css: "grid-template-rows: repeat(2, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-3",
    css: "grid-template-rows: repeat(3, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-4",
    css: "grid-template-rows: repeat(4, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-5",
    css: "grid-template-rows: repeat(5, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-6",
    css: "grid-template-rows: repeat(6, minmax(0, 1fr));",
  },
  {
    tailwind: "grid-rows-none",
    css: "grid-template-rows: none;",
  },
  {
    tailwind: "row-auto",
    css: "grid-row: auto;",
  },
  {
    tailwind: "row-span-1",
    css: "grid-row: span 1 / span 1;",
  },
  {
    tailwind: "row-span-2",
    css: "grid-row: span 2 / span 2;",
  },
  {
    tailwind: "row-span-3",
    css: "grid-row: span 3 / span 3;",
  },
  {
    tailwind: "row-span-4",
    css: "grid-row: span 4 / span 4;",
  },
  {
    tailwind: "row-span-5",
    css: "grid-row: span 5 / span 5;",
  },
  {
    tailwind: "row-span-6",
    css: "grid-row: span 6 / span 6;",
  },
  {
    tailwind: "row-span-full",
    css: "grid-row: 1 / -1;",
  },
  {
    tailwind: "row-start-1",
    css: "grid-row-start: 1;",
  },
  {
    tailwind: "row-start-2",
    css: "grid-row-start: 2;",
  },
  {
    tailwind: "row-start-3",
    css: "grid-row-start: 3;",
  },
  {
    tailwind: "row-start-4",
    css: "grid-row-start: 4;",
  },
  {
    tailwind: "row-start-5",
    css: "grid-row-start: 5;",
  },
  {
    tailwind: "row-start-6",
    css: "grid-row-start: 6;",
  },
  {
    tailwind: "row-start-7",
    css: "grid-row-start: 7;",
  },
  {
    tailwind: "row-start-auto",
    css: "grid-row-start: auto;",
  },
  {
    tailwind: "row-end-1",
    css: "grid-row-end: 1;",
  },
  {
    tailwind: "row-end-2",
    css: "grid-row-end: 2;",
  },
  {
    tailwind: "row-end-3",
    css: "grid-row-end: 3;",
  },
  {
    tailwind: "row-end-4",
    css: "grid-row-end: 4;",
  },
  {
    tailwind: "row-end-5",
    css: "grid-row-end: 5;",
  },
  {
    tailwind: "row-end-6",
    css: "grid-row-end: 6;",
  },
  {
    tailwind: "row-end-7",
    css: "grid-row-end: 7;",
  },
  {
    tailwind: "row-end-auto",
    css: "grid-row-end: auto;",
  },
  {
    tailwind: "grid-flow-row",
    css: "grid-auto-flow: row;",
  },
  {
    tailwind: "grid-flow-col",
    css: "grid-auto-flow: column;",
  },
  {
    tailwind: "grid-flow-dense",
    css: "grid-auto-flow: dense;",
  },
  {
    tailwind: "grid-flow-row-dense",
    css: "grid-auto-flow: row dense;",
  },
  {
    tailwind: "grid-flow-col-dense",
    css: "grid-auto-flow: column dense;",
  },
  {
    tailwind: "auto-cols-auto",
    css: "grid-auto-columns: auto;",
  },
  {
    tailwind: "auto-cols-min",
    css: "grid-auto-columns: min-content;",
  },
  {
    tailwind: "auto-cols-max",
    css: "grid-auto-columns: max-content;",
  },
  {
    tailwind: "auto-cols-fr",
    css: "grid-auto-columns: minmax(0, 1fr);",
  },
  {
    tailwind: "auto-rows-auto",
    css: "grid-auto-rows: auto;",
  },
  {
    tailwind: "auto-rows-min",
    css: "grid-auto-rows: min-content;",
  },
  {
    tailwind: "auto-rows-max",
    css: "grid-auto-rows: max-content;",
  },
  {
    tailwind: "auto-rows-fr",
    css: "grid-auto-rows: minmax(0, 1fr);",
  },
  {
    tailwind: "gap-0",
    css: "gap: 0px;",
  },
  {
    tailwind: "gap-x-0",
    css: "column-gap: 0px;",
  },
  {
    tailwind: "gap-y-0",
    css: "row-gap: 0px;",
  },
  {
    tailwind: "gap-px",
    css: "gap: 1px;",
  },
  {
    tailwind: "gap-x-px",
    css: "column-gap: 1px;",
  },
  {
    tailwind: "gap-y-px",
    css: "row-gap: 1px;",
  },
  {
    tailwind: "gap-0.5",
    css: "gap: 0.125rem; /* 2px */",
  },
  {
    tailwind: "gap-x-0.5",
    css: "column-gap: 0.125rem; /* 2px */",
  },
  {
    tailwind: "gap-y-0.5",
    css: "row-gap: 0.125rem; /* 2px */",
  },
  {
    tailwind: "gap-1",
    css: "gap: 0.25rem; /* 4px */",
  },
  {
    tailwind: "gap-x-1",
    css: "column-gap: 0.25rem; /* 4px */",
  },
  {
    tailwind: "gap-y-1",
    css: "row-gap: 0.25rem; /* 4px */",
  },
  {
    tailwind: "gap-1.5",
    css: "gap: 0.375rem; /* 6px */",
  },
  {
    tailwind: "gap-x-1.5",
    css: "column-gap: 0.375rem; /* 6px */",
  },
  {
    tailwind: "gap-y-1.5",
    css: "row-gap: 0.375rem; /* 6px */",
  },
  {
    tailwind: "gap-2",
    css: "gap: 0.5rem; /* 8px */",
  },
  {
    tailwind: "gap-x-2",
    css: "column-gap: 0.5rem; /* 8px */",
  },
  {
    tailwind: "gap-y-2",
    css: "row-gap: 0.5rem; /* 8px */",
  },
  {
    tailwind: "gap-2.5",
    css: "gap: 0.625rem; /* 10px */",
  },
  {
    tailwind: "gap-x-2.5",
    css: "column-gap: 0.625rem; /* 10px */",
  },
  {
    tailwind: "gap-y-2.5",
    css: "row-gap: 0.625rem; /* 10px */",
  },
  {
    tailwind: "gap-3",
    css: "gap: 0.75rem; /* 12px */",
  },
  {
    tailwind: "gap-x-3",
    css: "column-gap: 0.75rem; /* 12px */",
  },
  {
    tailwind: "gap-y-3",
    css: "row-gap: 0.75rem; /* 12px */",
  },
  {
    tailwind: "gap-3.5",
    css: "gap: 0.875rem; /* 14px */",
  },
  {
    tailwind: "gap-x-3.5",
    css: "column-gap: 0.875rem; /* 14px */",
  },
  {
    tailwind: "gap-y-3.5",
    css: "row-gap: 0.875rem; /* 14px */",
  },
  {
    tailwind: "gap-4",
    css: "gap: 1rem; /* 16px */",
  },
  {
    tailwind: "gap-x-4",
    css: "column-gap: 1rem; /* 16px */",
  },
  {
    tailwind: "gap-y-4",
    css: "row-gap: 1rem; /* 16px */",
  },
  {
    tailwind: "gap-5",
    css: "gap: 1.25rem; /* 20px */",
  },
  {
    tailwind: "gap-x-5",
    css: "column-gap: 1.25rem; /* 20px */",
  },
  {
    tailwind: "gap-y-5",
    css: "row-gap: 1.25rem; /* 20px */",
  },
  {
    tailwind: "gap-6",
    css: "gap: 1.5rem; /* 24px */",
  },
  {
    tailwind: "gap-x-6",
    css: "column-gap: 1.5rem; /* 24px */",
  },
  {
    tailwind: "gap-y-6",
    css: "row-gap: 1.5rem; /* 24px */",
  },
  {
    tailwind: "gap-7",
    css: "gap: 1.75rem; /* 28px */",
  },
  {
    tailwind: "gap-x-7",
    css: "column-gap: 1.75rem; /* 28px */",
  },
  {
    tailwind: "gap-y-7",
    css: "row-gap: 1.75rem; /* 28px */",
  },
  {
    tailwind: "gap-8",
    css: "gap: 2rem; /* 32px */",
  },
  {
    tailwind: "gap-x-8",
    css: "column-gap: 2rem; /* 32px */",
  },
  {
    tailwind: "gap-y-8",
    css: "row-gap: 2rem; /* 32px */",
  },
  {
    tailwind: "gap-9",
    css: "gap: 2.25rem; /* 36px */",
  },
  {
    tailwind: "gap-x-9",
    css: "column-gap: 2.25rem; /* 36px */",
  },
  {
    tailwind: "gap-y-9",
    css: "row-gap: 2.25rem; /* 36px */",
  },
  {
    tailwind: "gap-10",
    css: "gap: 2.5rem; /* 40px */",
  },
  {
    tailwind: "gap-x-10",
    css: "column-gap: 2.5rem; /* 40px */",
  },
  {
    tailwind: "gap-y-10",
    css: "row-gap: 2.5rem; /* 40px */",
  },
  {
    tailwind: "gap-11",
    css: "gap: 2.75rem; /* 44px */",
  },
  {
    tailwind: "gap-x-11",
    css: "column-gap: 2.75rem; /* 44px */",
  },
  {
    tailwind: "gap-y-11",
    css: "row-gap: 2.75rem; /* 44px */",
  },
  {
    tailwind: "gap-12",
    css: "gap: 3rem; /* 48px */",
  },
  {
    tailwind: "gap-x-12",
    css: "column-gap: 3rem; /* 48px */",
  },
  {
    tailwind: "gap-y-12",
    css: "row-gap: 3rem; /* 48px */",
  },
  {
    tailwind: "gap-14",
    css: "gap: 3.5rem; /* 56px */",
  },
  {
    tailwind: "gap-x-14",
    css: "column-gap: 3.5rem; /* 56px */",
  },
  {
    tailwind: "gap-y-14",
    css: "row-gap: 3.5rem; /* 56px */",
  },
  {
    tailwind: "gap-16",
    css: "gap: 4rem; /* 64px */",
  },
  {
    tailwind: "gap-x-16",
    css: "column-gap: 4rem; /* 64px */",
  },
  {
    tailwind: "gap-y-16",
    css: "row-gap: 4rem; /* 64px */",
  },
  {
    tailwind: "gap-20",
    css: "gap: 5rem; /* 80px */",
  },
  {
    tailwind: "gap-x-20",
    css: "column-gap: 5rem; /* 80px */",
  },
  {
    tailwind: "gap-y-20",
    css: "row-gap: 5rem; /* 80px */",
  },
  {
    tailwind: "gap-24",
    css: "gap: 6rem; /* 96px */",
  },
  {
    tailwind: "gap-x-24",
    css: "column-gap: 6rem; /* 96px */",
  },
  {
    tailwind: "gap-y-24",
    css: "row-gap: 6rem; /* 96px */",
  },
  {
    tailwind: "gap-28",
    css: "gap: 7rem; /* 112px */",
  },
  {
    tailwind: "gap-x-28",
    css: "column-gap: 7rem; /* 112px */",
  },
  {
    tailwind: "gap-y-28",
    css: "row-gap: 7rem; /* 112px */",
  },
  {
    tailwind: "gap-32",
    css: "gap: 8rem; /* 128px */",
  },
  {
    tailwind: "gap-x-32",
    css: "column-gap: 8rem; /* 128px */",
  },
  {
    tailwind: "gap-y-32",
    css: "row-gap: 8rem; /* 128px */",
  },
  {
    tailwind: "gap-36",
    css: "gap: 9rem; /* 144px */",
  },
  {
    tailwind: "gap-x-36",
    css: "column-gap: 9rem; /* 144px */",
  },
  {
    tailwind: "gap-y-36",
    css: "row-gap: 9rem; /* 144px */",
  },
  {
    tailwind: "gap-40",
    css: "gap: 10rem; /* 160px */",
  },
  {
    tailwind: "gap-x-40",
    css: "column-gap: 10rem; /* 160px */",
  },
  {
    tailwind: "gap-y-40",
    css: "row-gap: 10rem; /* 160px */",
  },
  {
    tailwind: "gap-44",
    css: "gap: 11rem; /* 176px */",
  },
  {
    tailwind: "gap-x-44",
    css: "column-gap: 11rem; /* 176px */",
  },
  {
    tailwind: "gap-y-44",
    css: "row-gap: 11rem; /* 176px */",
  },
  {
    tailwind: "gap-48",
    css: "gap: 12rem; /* 192px */",
  },
  {
    tailwind: "gap-x-48",
    css: "column-gap: 12rem; /* 192px */",
  },
  {
    tailwind: "gap-y-48",
    css: "row-gap: 12rem; /* 192px */",
  },
  {
    tailwind: "gap-52",
    css: "gap: 13rem; /* 208px */",
  },
  {
    tailwind: "gap-x-52",
    css: "column-gap: 13rem; /* 208px */",
  },
  {
    tailwind: "gap-y-52",
    css: "row-gap: 13rem; /* 208px */",
  },
  {
    tailwind: "gap-56",
    css: "gap: 14rem; /* 224px */",
  },
  {
    tailwind: "gap-x-56",
    css: "column-gap: 14rem; /* 224px */",
  },
  {
    tailwind: "gap-y-56",
    css: "row-gap: 14rem; /* 224px */",
  },
  {
    tailwind: "gap-60",
    css: "gap: 15rem; /* 240px */",
  },
  {
    tailwind: "gap-x-60",
    css: "column-gap: 15rem; /* 240px */",
  },
  {
    tailwind: "gap-y-60",
    css: "row-gap: 15rem; /* 240px */",
  },
  {
    tailwind: "gap-64",
    css: "gap: 16rem; /* 256px */",
  },
  {
    tailwind: "gap-x-64",
    css: "column-gap: 16rem; /* 256px */",
  },
  {
    tailwind: "gap-y-64",
    css: "row-gap: 16rem; /* 256px */",
  },
  {
    tailwind: "gap-72",
    css: "gap: 18rem; /* 288px */",
  },
  {
    tailwind: "gap-x-72",
    css: "column-gap: 18rem; /* 288px */",
  },
  {
    tailwind: "gap-y-72",
    css: "row-gap: 18rem; /* 288px */",
  },
  {
    tailwind: "gap-80",
    css: "gap: 20rem; /* 320px */",
  },
  {
    tailwind: "gap-x-80",
    css: "column-gap: 20rem; /* 320px */",
  },
  {
    tailwind: "gap-y-80",
    css: "row-gap: 20rem; /* 320px */",
  },
  {
    tailwind: "gap-96",
    css: "gap: 24rem; /* 384px */",
  },
  {
    tailwind: "gap-x-96",
    css: "column-gap: 24rem; /* 384px */",
  },
  {
    tailwind: "gap-y-96",
    css: "row-gap: 24rem; /* 384px */",
  },
  {
    tailwind: "justify-normal",
    css: "justify-content: normal;",
  },
  {
    tailwind: "justify-start",
    css: "justify-content: flex-start;",
  },
  {
    tailwind: "justify-end",
    css: "justify-content: flex-end;",
  },
  {
    tailwind: "justify-center",
    css: "justify-content: center;",
  },
  {
    tailwind: "justify-between",
    css: "justify-content: space-between;",
  },
  {
    tailwind: "justify-around",
    css: "justify-content: space-around;",
  },
  {
    tailwind: "justify-evenly",
    css: "justify-content: space-evenly;",
  },
  {
    tailwind: "justify-stretch",
    css: "justify-content: stretch;",
  },
  {
    tailwind: "justify-items-start",
    css: "justify-items: start;",
  },
  {
    tailwind: "justify-items-end",
    css: "justify-items: end;",
  },
  {
    tailwind: "justify-items-center",
    css: "justify-items: center;",
  },
  {
    tailwind: "justify-items-stretch",
    css: "justify-items: stretch;",
  },
  {
    tailwind: "justify-self-auto",
    css: "justify-self: auto;",
  },
  {
    tailwind: "justify-self-start",
    css: "justify-self: start;",
  },
  {
    tailwind: "justify-self-end",
    css: "justify-self: end;",
  },
  {
    tailwind: "justify-self-center",
    css: "justify-self: center;",
  },
  {
    tailwind: "justify-self-stretch",
    css: "justify-self: stretch;",
  },
  {
    tailwind: "content-normal",
    css: "align-content: normal;",
  },
  {
    tailwind: "content-center",
    css: "align-content: center;",
  },
  {
    tailwind: "content-start",
    css: "align-content: flex-start;",
  },
  {
    tailwind: "content-end",
    css: "align-content: flex-end;",
  },
  {
    tailwind: "content-between",
    css: "align-content: space-between;",
  },
  {
    tailwind: "content-around",
    css: "align-content: space-around;",
  },
  {
    tailwind: "content-evenly",
    css: "align-content: space-evenly;",
  },
  {
    tailwind: "content-baseline",
    css: "align-content: baseline;",
  },
  {
    tailwind: "content-stretch",
    css: "align-content: stretch;",
  },
  {
    tailwind: "items-start",
    css: "align-items: flex-start;",
  },
  {
    tailwind: "items-end",
    css: "align-items: flex-end;",
  },
  {
    tailwind: "items-center",
    css: "align-items: center;",
  },
  {
    tailwind: "items-baseline",
    css: "align-items: baseline;",
  },
  {
    tailwind: "items-stretch",
    css: "align-items: stretch;",
  },
  {
    tailwind: "self-auto",
    css: "align-self: auto;",
  },
  {
    tailwind: "self-start",
    css: "align-self: flex-start;",
  },
  {
    tailwind: "self-end",
    css: "align-self: flex-end;",
  },
  {
    tailwind: "self-center",
    css: "align-self: center;",
  },
  {
    tailwind: "self-stretch",
    css: "align-self: stretch;",
  },
  {
    tailwind: "self-baseline",
    css: "align-self: baseline;",
  },
  {
    tailwind: "place-content-center",
    css: "place-content: center;",
  },
  {
    tailwind: "place-content-start",
    css: "place-content: start;",
  },
  {
    tailwind: "place-content-end",
    css: "place-content: end;",
  },
  {
    tailwind: "place-content-between",
    css: "place-content: space-between;",
  },
  {
    tailwind: "place-content-around",
    css: "place-content: space-around;",
  },
  {
    tailwind: "place-content-evenly",
    css: "place-content: space-evenly;",
  },
  {
    tailwind: "place-content-baseline",
    css: "place-content: baseline;",
  },
  {
    tailwind: "place-content-stretch",
    css: "place-content: stretch;",
  },
  {
    tailwind: "place-items-start",
    css: "place-items: start;",
  },
  {
    tailwind: "place-items-end",
    css: "place-items: end;",
  },
  {
    tailwind: "place-items-center",
    css: "place-items: center;",
  },
  {
    tailwind: "place-items-baseline",
    css: "place-items: baseline;",
  },
  {
    tailwind: "place-items-stretch",
    css: "place-items: stretch;",
  },
  {
    tailwind: "place-self-auto",
    css: "place-self: auto;",
  },
  {
    tailwind: "place-self-start",
    css: "place-self: start;",
  },
  {
    tailwind: "place-self-end",
    css: "place-self: end;",
  },
  {
    tailwind: "place-self-center",
    css: "place-self: center;",
  },
  {
    tailwind: "place-self-stretch",
    css: "place-self: stretch;",
  },
  {
    tailwind: "p-0",
    css: "padding: 0px;",
  },
  {
    tailwind: "px-0",
    css: "padding-left: 0px;\npadding-right: 0px;",
  },
  {
    tailwind: "py-0",
    css: "padding-top: 0px;\npadding-bottom: 0px;",
  },
  {
    tailwind: "ps-0",
    css: "padding-inline-start: 0px;",
  },
  {
    tailwind: "pe-0",
    css: "padding-inline-end: 0px;",
  },
  {
    tailwind: "pt-0",
    css: "padding-top: 0px;",
  },
  {
    tailwind: "pr-0",
    css: "padding-right: 0px;",
  },
  {
    tailwind: "pb-0",
    css: "padding-bottom: 0px;",
  },
  {
    tailwind: "pl-0",
    css: "padding-left: 0px;",
  },
  {
    tailwind: "p-px",
    css: "padding: 1px;",
  },
  {
    tailwind: "px-px",
    css: "padding-left: 1px;\npadding-right: 1px;",
  },
  {
    tailwind: "py-px",
    css: "padding-top: 1px;\npadding-bottom: 1px;",
  },
  {
    tailwind: "ps-px",
    css: "padding-inline-start: 1px;",
  },
  {
    tailwind: "pe-px",
    css: "padding-inline-end: 1px;",
  },
  {
    tailwind: "pt-px",
    css: "padding-top: 1px;",
  },
  {
    tailwind: "pr-px",
    css: "padding-right: 1px;",
  },
  {
    tailwind: "pb-px",
    css: "padding-bottom: 1px;",
  },
  {
    tailwind: "pl-px",
    css: "padding-left: 1px;",
  },
  {
    tailwind: "p-0.5",
    css: "padding: 0.125rem; /* 2px */",
  },
  {
    tailwind: "px-0.5",
    css: "padding-left: 0.125rem; /* 2px */\npadding-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "py-0.5",
    css: "padding-top: 0.125rem; /* 2px */\npadding-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "ps-0.5",
    css: "padding-inline-start: 0.125rem; /* 2px */",
  },
  {
    tailwind: "pe-0.5",
    css: "padding-inline-end: 0.125rem; /* 2px */",
  },
  {
    tailwind: "pt-0.5",
    css: "padding-top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "pr-0.5",
    css: "padding-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "pb-0.5",
    css: "padding-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "pl-0.5",
    css: "padding-left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "p-1",
    css: "padding: 0.25rem; /* 4px */",
  },
  {
    tailwind: "px-1",
    css: "padding-left: 0.25rem; /* 4px */\npadding-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "py-1",
    css: "padding-top: 0.25rem; /* 4px */\npadding-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "ps-1",
    css: "padding-inline-start: 0.25rem; /* 4px */",
  },
  {
    tailwind: "pe-1",
    css: "padding-inline-end: 0.25rem; /* 4px */",
  },
  {
    tailwind: "pt-1",
    css: "padding-top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "pr-1",
    css: "padding-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "pb-1",
    css: "padding-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "pl-1",
    css: "padding-left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "p-1.5",
    css: "padding: 0.375rem; /* 6px */",
  },
  {
    tailwind: "px-1.5",
    css: "padding-left: 0.375rem; /* 6px */\npadding-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "py-1.5",
    css: "padding-top: 0.375rem; /* 6px */\npadding-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "ps-1.5",
    css: "padding-inline-start: 0.375rem; /* 6px */",
  },
  {
    tailwind: "pe-1.5",
    css: "padding-inline-end: 0.375rem; /* 6px */",
  },
  {
    tailwind: "pt-1.5",
    css: "padding-top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "pr-1.5",
    css: "padding-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "pb-1.5",
    css: "padding-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "pl-1.5",
    css: "padding-left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "p-2",
    css: "padding: 0.5rem; /* 8px */",
  },
  {
    tailwind: "px-2",
    css: "padding-left: 0.5rem; /* 8px */\npadding-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "py-2",
    css: "padding-top: 0.5rem; /* 8px */\npadding-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "ps-2",
    css: "padding-inline-start: 0.5rem; /* 8px */",
  },
  {
    tailwind: "pe-2",
    css: "padding-inline-end: 0.5rem; /* 8px */",
  },
  {
    tailwind: "pt-2",
    css: "padding-top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "pr-2",
    css: "padding-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "pb-2",
    css: "padding-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "pl-2",
    css: "padding-left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "p-2.5",
    css: "padding: 0.625rem; /* 10px */",
  },
  {
    tailwind: "px-2.5",
    css: "padding-left: 0.625rem; /* 10px */\npadding-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "py-2.5",
    css: "padding-top: 0.625rem; /* 10px */\npadding-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "ps-2.5",
    css: "padding-inline-start: 0.625rem; /* 10px */",
  },
  {
    tailwind: "pe-2.5",
    css: "padding-inline-end: 0.625rem; /* 10px */",
  },
  {
    tailwind: "pt-2.5",
    css: "padding-top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "pr-2.5",
    css: "padding-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "pb-2.5",
    css: "padding-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "pl-2.5",
    css: "padding-left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "p-3",
    css: "padding: 0.75rem; /* 12px */",
  },
  {
    tailwind: "px-3",
    css: "padding-left: 0.75rem; /* 12px */\npadding-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "py-3",
    css: "padding-top: 0.75rem; /* 12px */\npadding-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "ps-3",
    css: "padding-inline-start: 0.75rem; /* 12px */",
  },
  {
    tailwind: "pe-3",
    css: "padding-inline-end: 0.75rem; /* 12px */",
  },
  {
    tailwind: "pt-3",
    css: "padding-top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "pr-3",
    css: "padding-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "pb-3",
    css: "padding-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "pl-3",
    css: "padding-left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "p-3.5",
    css: "padding: 0.875rem; /* 14px */",
  },
  {
    tailwind: "px-3.5",
    css: "padding-left: 0.875rem; /* 14px */\npadding-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "py-3.5",
    css: "padding-top: 0.875rem; /* 14px */\npadding-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "ps-3.5",
    css: "padding-inline-start: 0.875rem; /* 14px */",
  },
  {
    tailwind: "pe-3.5",
    css: "padding-inline-end: 0.875rem; /* 14px */",
  },
  {
    tailwind: "pt-3.5",
    css: "padding-top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "pr-3.5",
    css: "padding-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "pb-3.5",
    css: "padding-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "pl-3.5",
    css: "padding-left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "p-4",
    css: "padding: 1rem; /* 16px */",
  },
  {
    tailwind: "px-4",
    css: "padding-left: 1rem; /* 16px */\npadding-right: 1rem; /* 16px */",
  },
  {
    tailwind: "py-4",
    css: "padding-top: 1rem; /* 16px */\npadding-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "ps-4",
    css: "padding-inline-start: 1rem; /* 16px */",
  },
  {
    tailwind: "pe-4",
    css: "padding-inline-end: 1rem; /* 16px */",
  },
  {
    tailwind: "pt-4",
    css: "padding-top: 1rem; /* 16px */",
  },
  {
    tailwind: "pr-4",
    css: "padding-right: 1rem; /* 16px */",
  },
  {
    tailwind: "pb-4",
    css: "padding-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "pl-4",
    css: "padding-left: 1rem; /* 16px */",
  },
  {
    tailwind: "p-5",
    css: "padding: 1.25rem; /* 20px */",
  },
  {
    tailwind: "px-5",
    css: "padding-left: 1.25rem; /* 20px */\npadding-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "py-5",
    css: "padding-top: 1.25rem; /* 20px */\npadding-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "ps-5",
    css: "padding-inline-start: 1.25rem; /* 20px */",
  },
  {
    tailwind: "pe-5",
    css: "padding-inline-end: 1.25rem; /* 20px */",
  },
  {
    tailwind: "pt-5",
    css: "padding-top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "pr-5",
    css: "padding-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "pb-5",
    css: "padding-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "pl-5",
    css: "padding-left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "p-6",
    css: "padding: 1.5rem; /* 24px */",
  },
  {
    tailwind: "px-6",
    css: "padding-left: 1.5rem; /* 24px */\npadding-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "py-6",
    css: "padding-top: 1.5rem; /* 24px */\npadding-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "ps-6",
    css: "padding-inline-start: 1.5rem; /* 24px */",
  },
  {
    tailwind: "pe-6",
    css: "padding-inline-end: 1.5rem; /* 24px */",
  },
  {
    tailwind: "pt-6",
    css: "padding-top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "pr-6",
    css: "padding-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "pb-6",
    css: "padding-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "pl-6",
    css: "padding-left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "p-7",
    css: "padding: 1.75rem; /* 28px */",
  },
  {
    tailwind: "px-7",
    css: "padding-left: 1.75rem; /* 28px */\npadding-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "py-7",
    css: "padding-top: 1.75rem; /* 28px */\npadding-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "ps-7",
    css: "padding-inline-start: 1.75rem; /* 28px */",
  },
  {
    tailwind: "pe-7",
    css: "padding-inline-end: 1.75rem; /* 28px */",
  },
  {
    tailwind: "pt-7",
    css: "padding-top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "pr-7",
    css: "padding-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "pb-7",
    css: "padding-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "pl-7",
    css: "padding-left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "p-8",
    css: "padding: 2rem; /* 32px */",
  },
  {
    tailwind: "px-8",
    css: "padding-left: 2rem; /* 32px */\npadding-right: 2rem; /* 32px */",
  },
  {
    tailwind: "py-8",
    css: "padding-top: 2rem; /* 32px */\npadding-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "ps-8",
    css: "padding-inline-start: 2rem; /* 32px */",
  },
  {
    tailwind: "pe-8",
    css: "padding-inline-end: 2rem; /* 32px */",
  },
  {
    tailwind: "pt-8",
    css: "padding-top: 2rem; /* 32px */",
  },
  {
    tailwind: "pr-8",
    css: "padding-right: 2rem; /* 32px */",
  },
  {
    tailwind: "pb-8",
    css: "padding-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "pl-8",
    css: "padding-left: 2rem; /* 32px */",
  },
  {
    tailwind: "p-9",
    css: "padding: 2.25rem; /* 36px */",
  },
  {
    tailwind: "px-9",
    css: "padding-left: 2.25rem; /* 36px */\npadding-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "py-9",
    css: "padding-top: 2.25rem; /* 36px */\npadding-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "ps-9",
    css: "padding-inline-start: 2.25rem; /* 36px */",
  },
  {
    tailwind: "pe-9",
    css: "padding-inline-end: 2.25rem; /* 36px */",
  },
  {
    tailwind: "pt-9",
    css: "padding-top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "pr-9",
    css: "padding-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "pb-9",
    css: "padding-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "pl-9",
    css: "padding-left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "p-10",
    css: "padding: 2.5rem; /* 40px */",
  },
  {
    tailwind: "px-10",
    css: "padding-left: 2.5rem; /* 40px */\npadding-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "py-10",
    css: "padding-top: 2.5rem; /* 40px */\npadding-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "ps-10",
    css: "padding-inline-start: 2.5rem; /* 40px */",
  },
  {
    tailwind: "pe-10",
    css: "padding-inline-end: 2.5rem; /* 40px */",
  },
  {
    tailwind: "pt-10",
    css: "padding-top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "pr-10",
    css: "padding-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "pb-10",
    css: "padding-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "pl-10",
    css: "padding-left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "p-11",
    css: "padding: 2.75rem; /* 44px */",
  },
  {
    tailwind: "px-11",
    css: "padding-left: 2.75rem; /* 44px */\npadding-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "py-11",
    css: "padding-top: 2.75rem; /* 44px */\npadding-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "ps-11",
    css: "padding-inline-start: 2.75rem; /* 44px */",
  },
  {
    tailwind: "pe-11",
    css: "padding-inline-end: 2.75rem; /* 44px */",
  },
  {
    tailwind: "pt-11",
    css: "padding-top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "pr-11",
    css: "padding-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "pb-11",
    css: "padding-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "pl-11",
    css: "padding-left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "p-12",
    css: "padding: 3rem; /* 48px */",
  },
  {
    tailwind: "px-12",
    css: "padding-left: 3rem; /* 48px */\npadding-right: 3rem; /* 48px */",
  },
  {
    tailwind: "py-12",
    css: "padding-top: 3rem; /* 48px */\npadding-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "ps-12",
    css: "padding-inline-start: 3rem; /* 48px */",
  },
  {
    tailwind: "pe-12",
    css: "padding-inline-end: 3rem; /* 48px */",
  },
  {
    tailwind: "pt-12",
    css: "padding-top: 3rem; /* 48px */",
  },
  {
    tailwind: "pr-12",
    css: "padding-right: 3rem; /* 48px */",
  },
  {
    tailwind: "pb-12",
    css: "padding-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "pl-12",
    css: "padding-left: 3rem; /* 48px */",
  },
  {
    tailwind: "p-14",
    css: "padding: 3.5rem; /* 56px */",
  },
  {
    tailwind: "px-14",
    css: "padding-left: 3.5rem; /* 56px */\npadding-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "py-14",
    css: "padding-top: 3.5rem; /* 56px */\npadding-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "ps-14",
    css: "padding-inline-start: 3.5rem; /* 56px */",
  },
  {
    tailwind: "pe-14",
    css: "padding-inline-end: 3.5rem; /* 56px */",
  },
  {
    tailwind: "pt-14",
    css: "padding-top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "pr-14",
    css: "padding-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "pb-14",
    css: "padding-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "pl-14",
    css: "padding-left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "p-16",
    css: "padding: 4rem; /* 64px */",
  },
  {
    tailwind: "px-16",
    css: "padding-left: 4rem; /* 64px */\npadding-right: 4rem; /* 64px */",
  },
  {
    tailwind: "py-16",
    css: "padding-top: 4rem; /* 64px */\npadding-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "ps-16",
    css: "padding-inline-start: 4rem; /* 64px */",
  },
  {
    tailwind: "pe-16",
    css: "padding-inline-end: 4rem; /* 64px */",
  },
  {
    tailwind: "pt-16",
    css: "padding-top: 4rem; /* 64px */",
  },
  {
    tailwind: "pr-16",
    css: "padding-right: 4rem; /* 64px */",
  },
  {
    tailwind: "pb-16",
    css: "padding-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "pl-16",
    css: "padding-left: 4rem; /* 64px */",
  },
  {
    tailwind: "p-20",
    css: "padding: 5rem; /* 80px */",
  },
  {
    tailwind: "px-20",
    css: "padding-left: 5rem; /* 80px */\npadding-right: 5rem; /* 80px */",
  },
  {
    tailwind: "py-20",
    css: "padding-top: 5rem; /* 80px */\npadding-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "ps-20",
    css: "padding-inline-start: 5rem; /* 80px */",
  },
  {
    tailwind: "pe-20",
    css: "padding-inline-end: 5rem; /* 80px */",
  },
  {
    tailwind: "pt-20",
    css: "padding-top: 5rem; /* 80px */",
  },
  {
    tailwind: "pr-20",
    css: "padding-right: 5rem; /* 80px */",
  },
  {
    tailwind: "pb-20",
    css: "padding-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "pl-20",
    css: "padding-left: 5rem; /* 80px */",
  },
  {
    tailwind: "p-24",
    css: "padding: 6rem; /* 96px */",
  },
  {
    tailwind: "px-24",
    css: "padding-left: 6rem; /* 96px */\npadding-right: 6rem; /* 96px */",
  },
  {
    tailwind: "py-24",
    css: "padding-top: 6rem; /* 96px */\npadding-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "ps-24",
    css: "padding-inline-start: 6rem; /* 96px */",
  },
  {
    tailwind: "pe-24",
    css: "padding-inline-end: 6rem; /* 96px */",
  },
  {
    tailwind: "pt-24",
    css: "padding-top: 6rem; /* 96px */",
  },
  {
    tailwind: "pr-24",
    css: "padding-right: 6rem; /* 96px */",
  },
  {
    tailwind: "pb-24",
    css: "padding-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "pl-24",
    css: "padding-left: 6rem; /* 96px */",
  },
  {
    tailwind: "p-28",
    css: "padding: 7rem; /* 112px */",
  },
  {
    tailwind: "px-28",
    css: "padding-left: 7rem; /* 112px */\npadding-right: 7rem; /* 112px */",
  },
  {
    tailwind: "py-28",
    css: "padding-top: 7rem; /* 112px */\npadding-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "ps-28",
    css: "padding-inline-start: 7rem; /* 112px */",
  },
  {
    tailwind: "pe-28",
    css: "padding-inline-end: 7rem; /* 112px */",
  },
  {
    tailwind: "pt-28",
    css: "padding-top: 7rem; /* 112px */",
  },
  {
    tailwind: "pr-28",
    css: "padding-right: 7rem; /* 112px */",
  },
  {
    tailwind: "pb-28",
    css: "padding-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "pl-28",
    css: "padding-left: 7rem; /* 112px */",
  },
  {
    tailwind: "p-32",
    css: "padding: 8rem; /* 128px */",
  },
  {
    tailwind: "px-32",
    css: "padding-left: 8rem; /* 128px */\npadding-right: 8rem; /* 128px */",
  },
  {
    tailwind: "py-32",
    css: "padding-top: 8rem; /* 128px */\npadding-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "ps-32",
    css: "padding-inline-start: 8rem; /* 128px */",
  },
  {
    tailwind: "pe-32",
    css: "padding-inline-end: 8rem; /* 128px */",
  },
  {
    tailwind: "pt-32",
    css: "padding-top: 8rem; /* 128px */",
  },
  {
    tailwind: "pr-32",
    css: "padding-right: 8rem; /* 128px */",
  },
  {
    tailwind: "pb-32",
    css: "padding-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "pl-32",
    css: "padding-left: 8rem; /* 128px */",
  },
  {
    tailwind: "p-36",
    css: "padding: 9rem; /* 144px */",
  },
  {
    tailwind: "px-36",
    css: "padding-left: 9rem; /* 144px */\npadding-right: 9rem; /* 144px */",
  },
  {
    tailwind: "py-36",
    css: "padding-top: 9rem; /* 144px */\npadding-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "ps-36",
    css: "padding-inline-start: 9rem; /* 144px */",
  },
  {
    tailwind: "pe-36",
    css: "padding-inline-end: 9rem; /* 144px */",
  },
  {
    tailwind: "pt-36",
    css: "padding-top: 9rem; /* 144px */",
  },
  {
    tailwind: "pr-36",
    css: "padding-right: 9rem; /* 144px */",
  },
  {
    tailwind: "pb-36",
    css: "padding-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "pl-36",
    css: "padding-left: 9rem; /* 144px */",
  },
  {
    tailwind: "p-40",
    css: "padding: 10rem; /* 160px */",
  },
  {
    tailwind: "px-40",
    css: "padding-left: 10rem; /* 160px */\npadding-right: 10rem; /* 160px */",
  },
  {
    tailwind: "py-40",
    css: "padding-top: 10rem; /* 160px */\npadding-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "ps-40",
    css: "padding-inline-start: 10rem; /* 160px */",
  },
  {
    tailwind: "pe-40",
    css: "padding-inline-end: 10rem; /* 160px */",
  },
  {
    tailwind: "pt-40",
    css: "padding-top: 10rem; /* 160px */",
  },
  {
    tailwind: "pr-40",
    css: "padding-right: 10rem; /* 160px */",
  },
  {
    tailwind: "pb-40",
    css: "padding-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "pl-40",
    css: "padding-left: 10rem; /* 160px */",
  },
  {
    tailwind: "p-44",
    css: "padding: 11rem; /* 176px */",
  },
  {
    tailwind: "px-44",
    css: "padding-left: 11rem; /* 176px */\npadding-right: 11rem; /* 176px */",
  },
  {
    tailwind: "py-44",
    css: "padding-top: 11rem; /* 176px */\npadding-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "ps-44",
    css: "padding-inline-start: 11rem; /* 176px */",
  },
  {
    tailwind: "pe-44",
    css: "padding-inline-end: 11rem; /* 176px */",
  },
  {
    tailwind: "pt-44",
    css: "padding-top: 11rem; /* 176px */",
  },
  {
    tailwind: "pr-44",
    css: "padding-right: 11rem; /* 176px */",
  },
  {
    tailwind: "pb-44",
    css: "padding-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "pl-44",
    css: "padding-left: 11rem; /* 176px */",
  },
  {
    tailwind: "p-48",
    css: "padding: 12rem; /* 192px */",
  },
  {
    tailwind: "px-48",
    css: "padding-left: 12rem; /* 192px */\npadding-right: 12rem; /* 192px */",
  },
  {
    tailwind: "py-48",
    css: "padding-top: 12rem; /* 192px */\npadding-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "ps-48",
    css: "padding-inline-start: 12rem; /* 192px */",
  },
  {
    tailwind: "pe-48",
    css: "padding-inline-end: 12rem; /* 192px */",
  },
  {
    tailwind: "pt-48",
    css: "padding-top: 12rem; /* 192px */",
  },
  {
    tailwind: "pr-48",
    css: "padding-right: 12rem; /* 192px */",
  },
  {
    tailwind: "pb-48",
    css: "padding-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "pl-48",
    css: "padding-left: 12rem; /* 192px */",
  },
  {
    tailwind: "p-52",
    css: "padding: 13rem; /* 208px */",
  },
  {
    tailwind: "px-52",
    css: "padding-left: 13rem; /* 208px */\npadding-right: 13rem; /* 208px */",
  },
  {
    tailwind: "py-52",
    css: "padding-top: 13rem; /* 208px */\npadding-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "ps-52",
    css: "padding-inline-start: 13rem; /* 208px */",
  },
  {
    tailwind: "pe-52",
    css: "padding-inline-end: 13rem; /* 208px */",
  },
  {
    tailwind: "pt-52",
    css: "padding-top: 13rem; /* 208px */",
  },
  {
    tailwind: "pr-52",
    css: "padding-right: 13rem; /* 208px */",
  },
  {
    tailwind: "pb-52",
    css: "padding-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "pl-52",
    css: "padding-left: 13rem; /* 208px */",
  },
  {
    tailwind: "p-56",
    css: "padding: 14rem; /* 224px */",
  },
  {
    tailwind: "px-56",
    css: "padding-left: 14rem; /* 224px */\npadding-right: 14rem; /* 224px */",
  },
  {
    tailwind: "py-56",
    css: "padding-top: 14rem; /* 224px */\npadding-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "ps-56",
    css: "padding-inline-start: 14rem; /* 224px */",
  },
  {
    tailwind: "pe-56",
    css: "padding-inline-end: 14rem; /* 224px */",
  },
  {
    tailwind: "pt-56",
    css: "padding-top: 14rem; /* 224px */",
  },
  {
    tailwind: "pr-56",
    css: "padding-right: 14rem; /* 224px */",
  },
  {
    tailwind: "pb-56",
    css: "padding-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "pl-56",
    css: "padding-left: 14rem; /* 224px */",
  },
  {
    tailwind: "p-60",
    css: "padding: 15rem; /* 240px */",
  },
  {
    tailwind: "px-60",
    css: "padding-left: 15rem; /* 240px */\npadding-right: 15rem; /* 240px */",
  },
  {
    tailwind: "py-60",
    css: "padding-top: 15rem; /* 240px */\npadding-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "ps-60",
    css: "padding-inline-start: 15rem; /* 240px */",
  },
  {
    tailwind: "pe-60",
    css: "padding-inline-end: 15rem; /* 240px */",
  },
  {
    tailwind: "pt-60",
    css: "padding-top: 15rem; /* 240px */",
  },
  {
    tailwind: "pr-60",
    css: "padding-right: 15rem; /* 240px */",
  },
  {
    tailwind: "pb-60",
    css: "padding-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "pl-60",
    css: "padding-left: 15rem; /* 240px */",
  },
  {
    tailwind: "p-64",
    css: "padding: 16rem; /* 256px */",
  },
  {
    tailwind: "px-64",
    css: "padding-left: 16rem; /* 256px */\npadding-right: 16rem; /* 256px */",
  },
  {
    tailwind: "py-64",
    css: "padding-top: 16rem; /* 256px */\npadding-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "ps-64",
    css: "padding-inline-start: 16rem; /* 256px */",
  },
  {
    tailwind: "pe-64",
    css: "padding-inline-end: 16rem; /* 256px */",
  },
  {
    tailwind: "pt-64",
    css: "padding-top: 16rem; /* 256px */",
  },
  {
    tailwind: "pr-64",
    css: "padding-right: 16rem; /* 256px */",
  },
  {
    tailwind: "pb-64",
    css: "padding-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "pl-64",
    css: "padding-left: 16rem; /* 256px */",
  },
  {
    tailwind: "p-72",
    css: "padding: 18rem; /* 288px */",
  },
  {
    tailwind: "px-72",
    css: "padding-left: 18rem; /* 288px */\npadding-right: 18rem; /* 288px */",
  },
  {
    tailwind: "py-72",
    css: "padding-top: 18rem; /* 288px */\npadding-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "ps-72",
    css: "padding-inline-start: 18rem; /* 288px */",
  },
  {
    tailwind: "pe-72",
    css: "padding-inline-end: 18rem; /* 288px */",
  },
  {
    tailwind: "pt-72",
    css: "padding-top: 18rem; /* 288px */",
  },
  {
    tailwind: "pr-72",
    css: "padding-right: 18rem; /* 288px */",
  },
  {
    tailwind: "pb-72",
    css: "padding-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "pl-72",
    css: "padding-left: 18rem; /* 288px */",
  },
  {
    tailwind: "p-80",
    css: "padding: 20rem; /* 320px */",
  },
  {
    tailwind: "px-80",
    css: "padding-left: 20rem; /* 320px */\npadding-right: 20rem; /* 320px */",
  },
  {
    tailwind: "py-80",
    css: "padding-top: 20rem; /* 320px */\npadding-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "ps-80",
    css: "padding-inline-start: 20rem; /* 320px */",
  },
  {
    tailwind: "pe-80",
    css: "padding-inline-end: 20rem; /* 320px */",
  },
  {
    tailwind: "pt-80",
    css: "padding-top: 20rem; /* 320px */",
  },
  {
    tailwind: "pr-80",
    css: "padding-right: 20rem; /* 320px */",
  },
  {
    tailwind: "pb-80",
    css: "padding-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "pl-80",
    css: "padding-left: 20rem; /* 320px */",
  },
  {
    tailwind: "p-96",
    css: "padding: 24rem; /* 384px */",
  },
  {
    tailwind: "px-96",
    css: "padding-left: 24rem; /* 384px */\npadding-right: 24rem; /* 384px */",
  },
  {
    tailwind: "py-96",
    css: "padding-top: 24rem; /* 384px */\npadding-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "ps-96",
    css: "padding-inline-start: 24rem; /* 384px */",
  },
  {
    tailwind: "pe-96",
    css: "padding-inline-end: 24rem; /* 384px */",
  },
  {
    tailwind: "pt-96",
    css: "padding-top: 24rem; /* 384px */",
  },
  {
    tailwind: "pr-96",
    css: "padding-right: 24rem; /* 384px */",
  },
  {
    tailwind: "pb-96",
    css: "padding-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "pl-96",
    css: "padding-left: 24rem; /* 384px */",
  },
  {
    tailwind: "m-0",
    css: "margin: 0px;",
  },
  {
    tailwind: "mx-0",
    css: "margin-left: 0px;\nmargin-right: 0px;",
  },
  {
    tailwind: "my-0",
    css: "margin-top: 0px;\nmargin-bottom: 0px;",
  },
  {
    tailwind: "ms-0",
    css: "margin-inline-start: 0px;",
  },
  {
    tailwind: "me-0",
    css: "margin-inline-end: 0px;",
  },
  {
    tailwind: "mt-0",
    css: "margin-top: 0px;",
  },
  {
    tailwind: "mr-0",
    css: "margin-right: 0px;",
  },
  {
    tailwind: "mb-0",
    css: "margin-bottom: 0px;",
  },
  {
    tailwind: "ml-0",
    css: "margin-left: 0px;",
  },
  {
    tailwind: "m-px",
    css: "margin: 1px;",
  },
  {
    tailwind: "mx-px",
    css: "margin-left: 1px;\nmargin-right: 1px;",
  },
  {
    tailwind: "my-px",
    css: "margin-top: 1px;\nmargin-bottom: 1px;",
  },
  {
    tailwind: "ms-px",
    css: "margin-inline-start: 1px;",
  },
  {
    tailwind: "me-px",
    css: "margin-inline-end: 1px;",
  },
  {
    tailwind: "mt-px",
    css: "margin-top: 1px;",
  },
  {
    tailwind: "mr-px",
    css: "margin-right: 1px;",
  },
  {
    tailwind: "mb-px",
    css: "margin-bottom: 1px;",
  },
  {
    tailwind: "ml-px",
    css: "margin-left: 1px;",
  },
  {
    tailwind: "m-0.5",
    css: "margin: 0.125rem; /* 2px */",
  },
  {
    tailwind: "mx-0.5",
    css: "margin-left: 0.125rem; /* 2px */\nmargin-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "my-0.5",
    css: "margin-top: 0.125rem; /* 2px */\nmargin-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "ms-0.5",
    css: "margin-inline-start: 0.125rem; /* 2px */",
  },
  {
    tailwind: "me-0.5",
    css: "margin-inline-end: 0.125rem; /* 2px */",
  },
  {
    tailwind: "mt-0.5",
    css: "margin-top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "mr-0.5",
    css: "margin-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "mb-0.5",
    css: "margin-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "ml-0.5",
    css: "margin-left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "m-1",
    css: "margin: 0.25rem; /* 4px */",
  },
  {
    tailwind: "mx-1",
    css: "margin-left: 0.25rem; /* 4px */\nmargin-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "my-1",
    css: "margin-top: 0.25rem; /* 4px */\nmargin-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "ms-1",
    css: "margin-inline-start: 0.25rem; /* 4px */",
  },
  {
    tailwind: "me-1",
    css: "margin-inline-end: 0.25rem; /* 4px */",
  },
  {
    tailwind: "mt-1",
    css: "margin-top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "mr-1",
    css: "margin-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "mb-1",
    css: "margin-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "ml-1",
    css: "margin-left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "m-1.5",
    css: "margin: 0.375rem; /* 6px */",
  },
  {
    tailwind: "mx-1.5",
    css: "margin-left: 0.375rem; /* 6px */\nmargin-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "my-1.5",
    css: "margin-top: 0.375rem; /* 6px */\nmargin-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "ms-1.5",
    css: "margin-inline-start: 0.375rem; /* 6px */",
  },
  {
    tailwind: "me-1.5",
    css: "margin-inline-end: 0.375rem; /* 6px */",
  },
  {
    tailwind: "mt-1.5",
    css: "margin-top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "mr-1.5",
    css: "margin-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "mb-1.5",
    css: "margin-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "ml-1.5",
    css: "margin-left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "m-2",
    css: "margin: 0.5rem; /* 8px */",
  },
  {
    tailwind: "mx-2",
    css: "margin-left: 0.5rem; /* 8px */\nmargin-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "my-2",
    css: "margin-top: 0.5rem; /* 8px */\nmargin-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "ms-2",
    css: "margin-inline-start: 0.5rem; /* 8px */",
  },
  {
    tailwind: "me-2",
    css: "margin-inline-end: 0.5rem; /* 8px */",
  },
  {
    tailwind: "mt-2",
    css: "margin-top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "mr-2",
    css: "margin-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "mb-2",
    css: "margin-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "ml-2",
    css: "margin-left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "m-2.5",
    css: "margin: 0.625rem; /* 10px */",
  },
  {
    tailwind: "mx-2.5",
    css: "margin-left: 0.625rem; /* 10px */\nmargin-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "my-2.5",
    css: "margin-top: 0.625rem; /* 10px */\nmargin-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "ms-2.5",
    css: "margin-inline-start: 0.625rem; /* 10px */",
  },
  {
    tailwind: "me-2.5",
    css: "margin-inline-end: 0.625rem; /* 10px */",
  },
  {
    tailwind: "mt-2.5",
    css: "margin-top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "mr-2.5",
    css: "margin-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "mb-2.5",
    css: "margin-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "ml-2.5",
    css: "margin-left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "m-3",
    css: "margin: 0.75rem; /* 12px */",
  },
  {
    tailwind: "mx-3",
    css: "margin-left: 0.75rem; /* 12px */\nmargin-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "my-3",
    css: "margin-top: 0.75rem; /* 12px */\nmargin-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "ms-3",
    css: "margin-inline-start: 0.75rem; /* 12px */",
  },
  {
    tailwind: "me-3",
    css: "margin-inline-end: 0.75rem; /* 12px */",
  },
  {
    tailwind: "mt-3",
    css: "margin-top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "mr-3",
    css: "margin-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "mb-3",
    css: "margin-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "ml-3",
    css: "margin-left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "m-3.5",
    css: "margin: 0.875rem; /* 14px */",
  },
  {
    tailwind: "mx-3.5",
    css: "margin-left: 0.875rem; /* 14px */\nmargin-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "my-3.5",
    css: "margin-top: 0.875rem; /* 14px */\nmargin-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "ms-3.5",
    css: "margin-inline-start: 0.875rem; /* 14px */",
  },
  {
    tailwind: "me-3.5",
    css: "margin-inline-end: 0.875rem; /* 14px */",
  },
  {
    tailwind: "mt-3.5",
    css: "margin-top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "mr-3.5",
    css: "margin-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "mb-3.5",
    css: "margin-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "ml-3.5",
    css: "margin-left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "m-4",
    css: "margin: 1rem; /* 16px */",
  },
  {
    tailwind: "mx-4",
    css: "margin-left: 1rem; /* 16px */\nmargin-right: 1rem; /* 16px */",
  },
  {
    tailwind: "my-4",
    css: "margin-top: 1rem; /* 16px */\nmargin-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "ms-4",
    css: "margin-inline-start: 1rem; /* 16px */",
  },
  {
    tailwind: "me-4",
    css: "margin-inline-end: 1rem; /* 16px */",
  },
  {
    tailwind: "mt-4",
    css: "margin-top: 1rem; /* 16px */",
  },
  {
    tailwind: "mr-4",
    css: "margin-right: 1rem; /* 16px */",
  },
  {
    tailwind: "mb-4",
    css: "margin-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "ml-4",
    css: "margin-left: 1rem; /* 16px */",
  },
  {
    tailwind: "m-5",
    css: "margin: 1.25rem; /* 20px */",
  },
  {
    tailwind: "mx-5",
    css: "margin-left: 1.25rem; /* 20px */\nmargin-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "my-5",
    css: "margin-top: 1.25rem; /* 20px */\nmargin-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "ms-5",
    css: "margin-inline-start: 1.25rem; /* 20px */",
  },
  {
    tailwind: "me-5",
    css: "margin-inline-end: 1.25rem; /* 20px */",
  },
  {
    tailwind: "mt-5",
    css: "margin-top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "mr-5",
    css: "margin-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "mb-5",
    css: "margin-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "ml-5",
    css: "margin-left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "m-6",
    css: "margin: 1.5rem; /* 24px */",
  },
  {
    tailwind: "mx-6",
    css: "margin-left: 1.5rem; /* 24px */\nmargin-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "my-6",
    css: "margin-top: 1.5rem; /* 24px */\nmargin-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "ms-6",
    css: "margin-inline-start: 1.5rem; /* 24px */",
  },
  {
    tailwind: "me-6",
    css: "margin-inline-end: 1.5rem; /* 24px */",
  },
  {
    tailwind: "mt-6",
    css: "margin-top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "mr-6",
    css: "margin-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "mb-6",
    css: "margin-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "ml-6",
    css: "margin-left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "m-7",
    css: "margin: 1.75rem; /* 28px */",
  },
  {
    tailwind: "mx-7",
    css: "margin-left: 1.75rem; /* 28px */\nmargin-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "my-7",
    css: "margin-top: 1.75rem; /* 28px */\nmargin-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "ms-7",
    css: "margin-inline-start: 1.75rem; /* 28px */",
  },
  {
    tailwind: "me-7",
    css: "margin-inline-end: 1.75rem; /* 28px */",
  },
  {
    tailwind: "mt-7",
    css: "margin-top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "mr-7",
    css: "margin-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "mb-7",
    css: "margin-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "ml-7",
    css: "margin-left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "m-8",
    css: "margin: 2rem; /* 32px */",
  },
  {
    tailwind: "mx-8",
    css: "margin-left: 2rem; /* 32px */\nmargin-right: 2rem; /* 32px */",
  },
  {
    tailwind: "my-8",
    css: "margin-top: 2rem; /* 32px */\nmargin-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "ms-8",
    css: "margin-inline-start: 2rem; /* 32px */",
  },
  {
    tailwind: "me-8",
    css: "margin-inline-end: 2rem; /* 32px */",
  },
  {
    tailwind: "mt-8",
    css: "margin-top: 2rem; /* 32px */",
  },
  {
    tailwind: "mr-8",
    css: "margin-right: 2rem; /* 32px */",
  },
  {
    tailwind: "mb-8",
    css: "margin-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "ml-8",
    css: "margin-left: 2rem; /* 32px */",
  },
  {
    tailwind: "m-9",
    css: "margin: 2.25rem; /* 36px */",
  },
  {
    tailwind: "mx-9",
    css: "margin-left: 2.25rem; /* 36px */\nmargin-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "my-9",
    css: "margin-top: 2.25rem; /* 36px */\nmargin-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "ms-9",
    css: "margin-inline-start: 2.25rem; /* 36px */",
  },
  {
    tailwind: "me-9",
    css: "margin-inline-end: 2.25rem; /* 36px */",
  },
  {
    tailwind: "mt-9",
    css: "margin-top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "mr-9",
    css: "margin-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "mb-9",
    css: "margin-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "ml-9",
    css: "margin-left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "m-10",
    css: "margin: 2.5rem; /* 40px */",
  },
  {
    tailwind: "mx-10",
    css: "margin-left: 2.5rem; /* 40px */\nmargin-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "my-10",
    css: "margin-top: 2.5rem; /* 40px */\nmargin-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "ms-10",
    css: "margin-inline-start: 2.5rem; /* 40px */",
  },
  {
    tailwind: "me-10",
    css: "margin-inline-end: 2.5rem; /* 40px */",
  },
  {
    tailwind: "mt-10",
    css: "margin-top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "mr-10",
    css: "margin-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "mb-10",
    css: "margin-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "ml-10",
    css: "margin-left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "m-11",
    css: "margin: 2.75rem; /* 44px */",
  },
  {
    tailwind: "mx-11",
    css: "margin-left: 2.75rem; /* 44px */\nmargin-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "my-11",
    css: "margin-top: 2.75rem; /* 44px */\nmargin-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "ms-11",
    css: "margin-inline-start: 2.75rem; /* 44px */",
  },
  {
    tailwind: "me-11",
    css: "margin-inline-end: 2.75rem; /* 44px */",
  },
  {
    tailwind: "mt-11",
    css: "margin-top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "mr-11",
    css: "margin-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "mb-11",
    css: "margin-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "ml-11",
    css: "margin-left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "m-12",
    css: "margin: 3rem; /* 48px */",
  },
  {
    tailwind: "mx-12",
    css: "margin-left: 3rem; /* 48px */\nmargin-right: 3rem; /* 48px */",
  },
  {
    tailwind: "my-12",
    css: "margin-top: 3rem; /* 48px */\nmargin-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "ms-12",
    css: "margin-inline-start: 3rem; /* 48px */",
  },
  {
    tailwind: "me-12",
    css: "margin-inline-end: 3rem; /* 48px */",
  },
  {
    tailwind: "mt-12",
    css: "margin-top: 3rem; /* 48px */",
  },
  {
    tailwind: "mr-12",
    css: "margin-right: 3rem; /* 48px */",
  },
  {
    tailwind: "mb-12",
    css: "margin-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "ml-12",
    css: "margin-left: 3rem; /* 48px */",
  },
  {
    tailwind: "m-14",
    css: "margin: 3.5rem; /* 56px */",
  },
  {
    tailwind: "mx-14",
    css: "margin-left: 3.5rem; /* 56px */\nmargin-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "my-14",
    css: "margin-top: 3.5rem; /* 56px */\nmargin-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "ms-14",
    css: "margin-inline-start: 3.5rem; /* 56px */",
  },
  {
    tailwind: "me-14",
    css: "margin-inline-end: 3.5rem; /* 56px */",
  },
  {
    tailwind: "mt-14",
    css: "margin-top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "mr-14",
    css: "margin-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "mb-14",
    css: "margin-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "ml-14",
    css: "margin-left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "m-16",
    css: "margin: 4rem; /* 64px */",
  },
  {
    tailwind: "mx-16",
    css: "margin-left: 4rem; /* 64px */\nmargin-right: 4rem; /* 64px */",
  },
  {
    tailwind: "my-16",
    css: "margin-top: 4rem; /* 64px */\nmargin-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "ms-16",
    css: "margin-inline-start: 4rem; /* 64px */",
  },
  {
    tailwind: "me-16",
    css: "margin-inline-end: 4rem; /* 64px */",
  },
  {
    tailwind: "mt-16",
    css: "margin-top: 4rem; /* 64px */",
  },
  {
    tailwind: "mr-16",
    css: "margin-right: 4rem; /* 64px */",
  },
  {
    tailwind: "mb-16",
    css: "margin-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "ml-16",
    css: "margin-left: 4rem; /* 64px */",
  },
  {
    tailwind: "m-20",
    css: "margin: 5rem; /* 80px */",
  },
  {
    tailwind: "mx-20",
    css: "margin-left: 5rem; /* 80px */\nmargin-right: 5rem; /* 80px */",
  },
  {
    tailwind: "my-20",
    css: "margin-top: 5rem; /* 80px */\nmargin-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "ms-20",
    css: "margin-inline-start: 5rem; /* 80px */",
  },
  {
    tailwind: "me-20",
    css: "margin-inline-end: 5rem; /* 80px */",
  },
  {
    tailwind: "mt-20",
    css: "margin-top: 5rem; /* 80px */",
  },
  {
    tailwind: "mr-20",
    css: "margin-right: 5rem; /* 80px */",
  },
  {
    tailwind: "mb-20",
    css: "margin-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "ml-20",
    css: "margin-left: 5rem; /* 80px */",
  },
  {
    tailwind: "m-24",
    css: "margin: 6rem; /* 96px */",
  },
  {
    tailwind: "mx-24",
    css: "margin-left: 6rem; /* 96px */\nmargin-right: 6rem; /* 96px */",
  },
  {
    tailwind: "my-24",
    css: "margin-top: 6rem; /* 96px */\nmargin-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "ms-24",
    css: "margin-inline-start: 6rem; /* 96px */",
  },
  {
    tailwind: "me-24",
    css: "margin-inline-end: 6rem; /* 96px */",
  },
  {
    tailwind: "mt-24",
    css: "margin-top: 6rem; /* 96px */",
  },
  {
    tailwind: "mr-24",
    css: "margin-right: 6rem; /* 96px */",
  },
  {
    tailwind: "mb-24",
    css: "margin-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "ml-24",
    css: "margin-left: 6rem; /* 96px */",
  },
  {
    tailwind: "m-28",
    css: "margin: 7rem; /* 112px */",
  },
  {
    tailwind: "mx-28",
    css: "margin-left: 7rem; /* 112px */\nmargin-right: 7rem; /* 112px */",
  },
  {
    tailwind: "my-28",
    css: "margin-top: 7rem; /* 112px */\nmargin-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "ms-28",
    css: "margin-inline-start: 7rem; /* 112px */",
  },
  {
    tailwind: "me-28",
    css: "margin-inline-end: 7rem; /* 112px */",
  },
  {
    tailwind: "mt-28",
    css: "margin-top: 7rem; /* 112px */",
  },
  {
    tailwind: "mr-28",
    css: "margin-right: 7rem; /* 112px */",
  },
  {
    tailwind: "mb-28",
    css: "margin-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "ml-28",
    css: "margin-left: 7rem; /* 112px */",
  },
  {
    tailwind: "m-32",
    css: "margin: 8rem; /* 128px */",
  },
  {
    tailwind: "mx-32",
    css: "margin-left: 8rem; /* 128px */\nmargin-right: 8rem; /* 128px */",
  },
  {
    tailwind: "my-32",
    css: "margin-top: 8rem; /* 128px */\nmargin-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "ms-32",
    css: "margin-inline-start: 8rem; /* 128px */",
  },
  {
    tailwind: "me-32",
    css: "margin-inline-end: 8rem; /* 128px */",
  },
  {
    tailwind: "mt-32",
    css: "margin-top: 8rem; /* 128px */",
  },
  {
    tailwind: "mr-32",
    css: "margin-right: 8rem; /* 128px */",
  },
  {
    tailwind: "mb-32",
    css: "margin-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "ml-32",
    css: "margin-left: 8rem; /* 128px */",
  },
  {
    tailwind: "m-36",
    css: "margin: 9rem; /* 144px */",
  },
  {
    tailwind: "mx-36",
    css: "margin-left: 9rem; /* 144px */\nmargin-right: 9rem; /* 144px */",
  },
  {
    tailwind: "my-36",
    css: "margin-top: 9rem; /* 144px */\nmargin-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "ms-36",
    css: "margin-inline-start: 9rem; /* 144px */",
  },
  {
    tailwind: "me-36",
    css: "margin-inline-end: 9rem; /* 144px */",
  },
  {
    tailwind: "mt-36",
    css: "margin-top: 9rem; /* 144px */",
  },
  {
    tailwind: "mr-36",
    css: "margin-right: 9rem; /* 144px */",
  },
  {
    tailwind: "mb-36",
    css: "margin-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "ml-36",
    css: "margin-left: 9rem; /* 144px */",
  },
  {
    tailwind: "m-40",
    css: "margin: 10rem; /* 160px */",
  },
  {
    tailwind: "mx-40",
    css: "margin-left: 10rem; /* 160px */\nmargin-right: 10rem; /* 160px */",
  },
  {
    tailwind: "my-40",
    css: "margin-top: 10rem; /* 160px */\nmargin-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "ms-40",
    css: "margin-inline-start: 10rem; /* 160px */",
  },
  {
    tailwind: "me-40",
    css: "margin-inline-end: 10rem; /* 160px */",
  },
  {
    tailwind: "mt-40",
    css: "margin-top: 10rem; /* 160px */",
  },
  {
    tailwind: "mr-40",
    css: "margin-right: 10rem; /* 160px */",
  },
  {
    tailwind: "mb-40",
    css: "margin-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "ml-40",
    css: "margin-left: 10rem; /* 160px */",
  },
  {
    tailwind: "m-44",
    css: "margin: 11rem; /* 176px */",
  },
  {
    tailwind: "mx-44",
    css: "margin-left: 11rem; /* 176px */\nmargin-right: 11rem; /* 176px */",
  },
  {
    tailwind: "my-44",
    css: "margin-top: 11rem; /* 176px */\nmargin-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "ms-44",
    css: "margin-inline-start: 11rem; /* 176px */",
  },
  {
    tailwind: "me-44",
    css: "margin-inline-end: 11rem; /* 176px */",
  },
  {
    tailwind: "mt-44",
    css: "margin-top: 11rem; /* 176px */",
  },
  {
    tailwind: "mr-44",
    css: "margin-right: 11rem; /* 176px */",
  },
  {
    tailwind: "mb-44",
    css: "margin-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "ml-44",
    css: "margin-left: 11rem; /* 176px */",
  },
  {
    tailwind: "m-48",
    css: "margin: 12rem; /* 192px */",
  },
  {
    tailwind: "mx-48",
    css: "margin-left: 12rem; /* 192px */\nmargin-right: 12rem; /* 192px */",
  },
  {
    tailwind: "my-48",
    css: "margin-top: 12rem; /* 192px */\nmargin-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "ms-48",
    css: "margin-inline-start: 12rem; /* 192px */",
  },
  {
    tailwind: "me-48",
    css: "margin-inline-end: 12rem; /* 192px */",
  },
  {
    tailwind: "mt-48",
    css: "margin-top: 12rem; /* 192px */",
  },
  {
    tailwind: "mr-48",
    css: "margin-right: 12rem; /* 192px */",
  },
  {
    tailwind: "mb-48",
    css: "margin-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "ml-48",
    css: "margin-left: 12rem; /* 192px */",
  },
  {
    tailwind: "m-52",
    css: "margin: 13rem; /* 208px */",
  },
  {
    tailwind: "mx-52",
    css: "margin-left: 13rem; /* 208px */\nmargin-right: 13rem; /* 208px */",
  },
  {
    tailwind: "my-52",
    css: "margin-top: 13rem; /* 208px */\nmargin-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "ms-52",
    css: "margin-inline-start: 13rem; /* 208px */",
  },
  {
    tailwind: "me-52",
    css: "margin-inline-end: 13rem; /* 208px */",
  },
  {
    tailwind: "mt-52",
    css: "margin-top: 13rem; /* 208px */",
  },
  {
    tailwind: "mr-52",
    css: "margin-right: 13rem; /* 208px */",
  },
  {
    tailwind: "mb-52",
    css: "margin-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "ml-52",
    css: "margin-left: 13rem; /* 208px */",
  },
  {
    tailwind: "m-56",
    css: "margin: 14rem; /* 224px */",
  },
  {
    tailwind: "mx-56",
    css: "margin-left: 14rem; /* 224px */\nmargin-right: 14rem; /* 224px */",
  },
  {
    tailwind: "my-56",
    css: "margin-top: 14rem; /* 224px */\nmargin-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "ms-56",
    css: "margin-inline-start: 14rem; /* 224px */",
  },
  {
    tailwind: "me-56",
    css: "margin-inline-end: 14rem; /* 224px */",
  },
  {
    tailwind: "mt-56",
    css: "margin-top: 14rem; /* 224px */",
  },
  {
    tailwind: "mr-56",
    css: "margin-right: 14rem; /* 224px */",
  },
  {
    tailwind: "mb-56",
    css: "margin-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "ml-56",
    css: "margin-left: 14rem; /* 224px */",
  },
  {
    tailwind: "m-60",
    css: "margin: 15rem; /* 240px */",
  },
  {
    tailwind: "mx-60",
    css: "margin-left: 15rem; /* 240px */\nmargin-right: 15rem; /* 240px */",
  },
  {
    tailwind: "my-60",
    css: "margin-top: 15rem; /* 240px */\nmargin-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "ms-60",
    css: "margin-inline-start: 15rem; /* 240px */",
  },
  {
    tailwind: "me-60",
    css: "margin-inline-end: 15rem; /* 240px */",
  },
  {
    tailwind: "mt-60",
    css: "margin-top: 15rem; /* 240px */",
  },
  {
    tailwind: "mr-60",
    css: "margin-right: 15rem; /* 240px */",
  },
  {
    tailwind: "mb-60",
    css: "margin-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "ml-60",
    css: "margin-left: 15rem; /* 240px */",
  },
  {
    tailwind: "m-64",
    css: "margin: 16rem; /* 256px */",
  },
  {
    tailwind: "mx-64",
    css: "margin-left: 16rem; /* 256px */\nmargin-right: 16rem; /* 256px */",
  },
  {
    tailwind: "my-64",
    css: "margin-top: 16rem; /* 256px */\nmargin-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "ms-64",
    css: "margin-inline-start: 16rem; /* 256px */",
  },
  {
    tailwind: "me-64",
    css: "margin-inline-end: 16rem; /* 256px */",
  },
  {
    tailwind: "mt-64",
    css: "margin-top: 16rem; /* 256px */",
  },
  {
    tailwind: "mr-64",
    css: "margin-right: 16rem; /* 256px */",
  },
  {
    tailwind: "mb-64",
    css: "margin-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "ml-64",
    css: "margin-left: 16rem; /* 256px */",
  },
  {
    tailwind: "m-72",
    css: "margin: 18rem; /* 288px */",
  },
  {
    tailwind: "mx-72",
    css: "margin-left: 18rem; /* 288px */\nmargin-right: 18rem; /* 288px */",
  },
  {
    tailwind: "my-72",
    css: "margin-top: 18rem; /* 288px */\nmargin-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "ms-72",
    css: "margin-inline-start: 18rem; /* 288px */",
  },
  {
    tailwind: "me-72",
    css: "margin-inline-end: 18rem; /* 288px */",
  },
  {
    tailwind: "mt-72",
    css: "margin-top: 18rem; /* 288px */",
  },
  {
    tailwind: "mr-72",
    css: "margin-right: 18rem; /* 288px */",
  },
  {
    tailwind: "mb-72",
    css: "margin-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "ml-72",
    css: "margin-left: 18rem; /* 288px */",
  },
  {
    tailwind: "m-80",
    css: "margin: 20rem; /* 320px */",
  },
  {
    tailwind: "mx-80",
    css: "margin-left: 20rem; /* 320px */\nmargin-right: 20rem; /* 320px */",
  },
  {
    tailwind: "my-80",
    css: "margin-top: 20rem; /* 320px */\nmargin-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "ms-80",
    css: "margin-inline-start: 20rem; /* 320px */",
  },
  {
    tailwind: "me-80",
    css: "margin-inline-end: 20rem; /* 320px */",
  },
  {
    tailwind: "mt-80",
    css: "margin-top: 20rem; /* 320px */",
  },
  {
    tailwind: "mr-80",
    css: "margin-right: 20rem; /* 320px */",
  },
  {
    tailwind: "mb-80",
    css: "margin-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "ml-80",
    css: "margin-left: 20rem; /* 320px */",
  },
  {
    tailwind: "m-96",
    css: "margin: 24rem; /* 384px */",
  },
  {
    tailwind: "mx-96",
    css: "margin-left: 24rem; /* 384px */\nmargin-right: 24rem; /* 384px */",
  },
  {
    tailwind: "my-96",
    css: "margin-top: 24rem; /* 384px */\nmargin-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "ms-96",
    css: "margin-inline-start: 24rem; /* 384px */",
  },
  {
    tailwind: "me-96",
    css: "margin-inline-end: 24rem; /* 384px */",
  },
  {
    tailwind: "mt-96",
    css: "margin-top: 24rem; /* 384px */",
  },
  {
    tailwind: "mr-96",
    css: "margin-right: 24rem; /* 384px */",
  },
  {
    tailwind: "mb-96",
    css: "margin-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "ml-96",
    css: "margin-left: 24rem; /* 384px */",
  },
  {
    tailwind: "m-auto",
    css: "margin: auto;",
  },
  {
    tailwind: "mx-auto",
    css: "margin-left: auto;\nmargin-right: auto;",
  },
  {
    tailwind: "my-auto",
    css: "margin-top: auto;\nmargin-bottom: auto;",
  },
  {
    tailwind: "ms-auto",
    css: "margin-inline-start: auto;",
  },
  {
    tailwind: "me-auto",
    css: "margin-inline-end: auto;",
  },
  {
    tailwind: "mt-auto",
    css: "margin-top: auto;",
  },
  {
    tailwind: "mr-auto",
    css: "margin-right: auto;",
  },
  {
    tailwind: "mb-auto",
    css: "margin-bottom: auto;",
  },
  {
    tailwind: "ml-auto",
    css: "margin-left: auto;",
  },
  {
    tailwind: "space-x-0",
    css: "margin-left: 0px;",
  },
  {
    tailwind: "space-y-0",
    css: "margin-top: 0px;",
  },
  {
    tailwind: "space-x-0.5",
    css: "margin-left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "space-y-0.5",
    css: "margin-top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "space-x-1",
    css: "margin-left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "space-y-1",
    css: "margin-top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "space-x-1.5",
    css: "margin-left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "space-y-1.5",
    css: "margin-top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "space-x-2",
    css: "margin-left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "space-y-2",
    css: "margin-top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "space-x-2.5",
    css: "margin-left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "space-y-2.5",
    css: "margin-top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "space-x-3",
    css: "margin-left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "space-y-3",
    css: "margin-top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "space-x-3.5",
    css: "margin-left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "space-y-3.5",
    css: "margin-top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "space-x-4",
    css: "margin-left: 1rem; /* 16px */",
  },
  {
    tailwind: "space-y-4",
    css: "margin-top: 1rem; /* 16px */",
  },
  {
    tailwind: "space-x-5",
    css: "margin-left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "space-y-5",
    css: "margin-top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "space-x-6",
    css: "margin-left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "space-y-6",
    css: "margin-top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "space-x-7",
    css: "margin-left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "space-y-7",
    css: "margin-top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "space-x-8",
    css: "margin-left: 2rem; /* 32px */",
  },
  {
    tailwind: "space-y-8",
    css: "margin-top: 2rem; /* 32px */",
  },
  {
    tailwind: "space-x-9",
    css: "margin-left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "space-y-9",
    css: "margin-top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "space-x-10",
    css: "margin-left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "space-y-10",
    css: "margin-top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "space-x-11",
    css: "margin-left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "space-y-11",
    css: "margin-top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "space-x-12",
    css: "margin-left: 3rem; /* 48px */",
  },
  {
    tailwind: "space-y-12",
    css: "margin-top: 3rem; /* 48px */",
  },
  {
    tailwind: "space-x-14",
    css: "margin-left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "space-y-14",
    css: "margin-top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "space-x-16",
    css: "margin-left: 4rem; /* 64px */",
  },
  {
    tailwind: "space-y-16",
    css: "margin-top: 4rem; /* 64px */",
  },
  {
    tailwind: "space-x-20",
    css: "margin-left: 5rem; /* 80px */",
  },
  {
    tailwind: "space-y-20",
    css: "margin-top: 5rem; /* 80px */",
  },
  {
    tailwind: "space-x-24",
    css: "margin-left: 6rem; /* 96px */",
  },
  {
    tailwind: "space-y-24",
    css: "margin-top: 6rem; /* 96px */",
  },
  {
    tailwind: "space-x-28",
    css: "margin-left: 7rem; /* 112px */",
  },
  {
    tailwind: "space-y-28",
    css: "margin-top: 7rem; /* 112px */",
  },
  {
    tailwind: "space-x-32",
    css: "margin-left: 8rem; /* 128px */",
  },
  {
    tailwind: "space-y-32",
    css: "margin-top: 8rem; /* 128px */",
  },
  {
    tailwind: "space-x-36",
    css: "margin-left: 9rem; /* 144px */",
  },
  {
    tailwind: "space-y-36",
    css: "margin-top: 9rem; /* 144px */",
  },
  {
    tailwind: "space-x-40",
    css: "margin-left: 10rem; /* 160px */",
  },
  {
    tailwind: "space-y-40",
    css: "margin-top: 10rem; /* 160px */",
  },
  {
    tailwind: "space-x-44",
    css: "margin-left: 11rem; /* 176px */",
  },
  {
    tailwind: "space-y-44",
    css: "margin-top: 11rem; /* 176px */",
  },
  {
    tailwind: "space-x-48",
    css: "margin-left: 12rem; /* 192px */",
  },
  {
    tailwind: "space-y-48",
    css: "margin-top: 12rem; /* 192px */",
  },
  {
    tailwind: "space-x-52",
    css: "margin-left: 13rem; /* 208px */",
  },
  {
    tailwind: "space-y-52",
    css: "margin-top: 13rem; /* 208px */",
  },
  {
    tailwind: "space-x-56",
    css: "margin-left: 14rem; /* 224px */",
  },
  {
    tailwind: "space-y-56",
    css: "margin-top: 14rem; /* 224px */",
  },
  {
    tailwind: "space-x-60",
    css: "margin-left: 15rem; /* 240px */",
  },
  {
    tailwind: "space-y-60",
    css: "margin-top: 15rem; /* 240px */",
  },
  {
    tailwind: "space-x-64",
    css: "margin-left: 16rem; /* 256px */",
  },
  {
    tailwind: "space-y-64",
    css: "margin-top: 16rem; /* 256px */",
  },
  {
    tailwind: "space-x-72",
    css: "margin-left: 18rem; /* 288px */",
  },
  {
    tailwind: "space-y-72",
    css: "margin-top: 18rem; /* 288px */",
  },
  {
    tailwind: "space-x-80",
    css: "margin-left: 20rem; /* 320px */",
  },
  {
    tailwind: "space-y-80",
    css: "margin-top: 20rem; /* 320px */",
  },
  {
    tailwind: "space-x-96",
    css: "margin-left: 24rem; /* 384px */",
  },
  {
    tailwind: "space-y-96",
    css: "margin-top: 24rem; /* 384px */",
  },
  {
    tailwind: "space-x-px",
    css: "margin-left: 1px;",
  },
  {
    tailwind: "space-y-px",
    css: "margin-top: 1px;",
  },
  {
    tailwind: "space-y-reverse",
    css: "--tw-space-y-reverse: 1;",
  },
  {
    tailwind: "space-x-reverse",
    css: "--tw-space-x-reverse: 1;",
  },
  {
    tailwind: "w-0",
    css: "width: 0px;",
  },
  {
    tailwind: "w-px",
    css: "width: 1px;",
  },
  {
    tailwind: "w-0.5",
    css: "width: 0.125rem; /* 2px */",
  },
  {
    tailwind: "w-1",
    css: "width: 0.25rem; /* 4px */",
  },
  {
    tailwind: "w-1.5",
    css: "width: 0.375rem; /* 6px */",
  },
  {
    tailwind: "w-2",
    css: "width: 0.5rem; /* 8px */",
  },
  {
    tailwind: "w-2.5",
    css: "width: 0.625rem; /* 10px */",
  },
  {
    tailwind: "w-3",
    css: "width: 0.75rem; /* 12px */",
  },
  {
    tailwind: "w-3.5",
    css: "width: 0.875rem; /* 14px */",
  },
  {
    tailwind: "w-4",
    css: "width: 1rem; /* 16px */",
  },
  {
    tailwind: "w-5",
    css: "width: 1.25rem; /* 20px */",
  },
  {
    tailwind: "w-6",
    css: "width: 1.5rem; /* 24px */",
  },
  {
    tailwind: "w-7",
    css: "width: 1.75rem; /* 28px */",
  },
  {
    tailwind: "w-8",
    css: "width: 2rem; /* 32px */",
  },
  {
    tailwind: "w-9",
    css: "width: 2.25rem; /* 36px */",
  },
  {
    tailwind: "w-10",
    css: "width: 2.5rem; /* 40px */",
  },
  {
    tailwind: "w-11",
    css: "width: 2.75rem; /* 44px */",
  },
  {
    tailwind: "w-12",
    css: "width: 3rem; /* 48px */",
  },
  {
    tailwind: "w-14",
    css: "width: 3.5rem; /* 56px */",
  },
  {
    tailwind: "w-16",
    css: "width: 4rem; /* 64px */",
  },
  {
    tailwind: "w-20",
    css: "width: 5rem; /* 80px */",
  },
  {
    tailwind: "w-24",
    css: "width: 6rem; /* 96px */",
  },
  {
    tailwind: "w-28",
    css: "width: 7rem; /* 112px */",
  },
  {
    tailwind: "w-32",
    css: "width: 8rem; /* 128px */",
  },
  {
    tailwind: "w-36",
    css: "width: 9rem; /* 144px */",
  },
  {
    tailwind: "w-40",
    css: "width: 10rem; /* 160px */",
  },
  {
    tailwind: "w-44",
    css: "width: 11rem; /* 176px */",
  },
  {
    tailwind: "w-48",
    css: "width: 12rem; /* 192px */",
  },
  {
    tailwind: "w-52",
    css: "width: 13rem; /* 208px */",
  },
  {
    tailwind: "w-56",
    css: "width: 14rem; /* 224px */",
  },
  {
    tailwind: "w-60",
    css: "width: 15rem; /* 240px */",
  },
  {
    tailwind: "w-64",
    css: "width: 16rem; /* 256px */",
  },
  {
    tailwind: "w-72",
    css: "width: 18rem; /* 288px */",
  },
  {
    tailwind: "w-80",
    css: "width: 20rem; /* 320px */",
  },
  {
    tailwind: "w-96",
    css: "width: 24rem; /* 384px */",
  },
  {
    tailwind: "w-auto",
    css: "width: auto;",
  },
  {
    tailwind: "w-1/2",
    css: "width: 50%;",
  },
  {
    tailwind: "w-1/3",
    css: "width: 33.333333%;",
  },
  {
    tailwind: "w-2/3",
    css: "width: 66.666667%;",
  },
  {
    tailwind: "w-1/4",
    css: "width: 25%;",
  },
  {
    tailwind: "w-2/4",
    css: "width: 50%;",
  },
  {
    tailwind: "w-3/4",
    css: "width: 75%;",
  },
  {
    tailwind: "w-1/5",
    css: "width: 20%;",
  },
  {
    tailwind: "w-2/5",
    css: "width: 40%;",
  },
  {
    tailwind: "w-3/5",
    css: "width: 60%;",
  },
  {
    tailwind: "w-4/5",
    css: "width: 80%;",
  },
  {
    tailwind: "w-1/6",
    css: "width: 16.666667%;",
  },
  {
    tailwind: "w-2/6",
    css: "width: 33.333333%;",
  },
  {
    tailwind: "w-3/6",
    css: "width: 50%;",
  },
  {
    tailwind: "w-4/6",
    css: "width: 66.666667%;",
  },
  {
    tailwind: "w-5/6",
    css: "width: 83.333333%;",
  },
  {
    tailwind: "w-1/12",
    css: "width: 8.333333%;",
  },
  {
    tailwind: "w-2/12",
    css: "width: 16.666667%;",
  },
  {
    tailwind: "w-3/12",
    css: "width: 25%;",
  },
  {
    tailwind: "w-4/12",
    css: "width: 33.333333%;",
  },
  {
    tailwind: "w-5/12",
    css: "width: 41.666667%;",
  },
  {
    tailwind: "w-6/12",
    css: "width: 50%;",
  },
  {
    tailwind: "w-7/12",
    css: "width: 58.333333%;",
  },
  {
    tailwind: "w-8/12",
    css: "width: 66.666667%;",
  },
  {
    tailwind: "w-9/12",
    css: "width: 75%;",
  },
  {
    tailwind: "w-10/12",
    css: "width: 83.333333%;",
  },
  {
    tailwind: "w-11/12",
    css: "width: 91.666667%;",
  },
  {
    tailwind: "w-full",
    css: "width: 100%;",
  },
  {
    tailwind: "w-screen",
    css: "width: 100vw;",
  },
  {
    tailwind: "w-min",
    css: "width: min-content;",
  },
  {
    tailwind: "w-max",
    css: "width: max-content;",
  },
  {
    tailwind: "w-fit",
    css: "width: fit-content;",
  },
  {
    tailwind: "min-w-0",
    css: "min-width: 0px;",
  },
  {
    tailwind: "min-w-full",
    css: "min-width: 100%;",
  },
  {
    tailwind: "min-w-min",
    css: "min-width: min-content;",
  },
  {
    tailwind: "min-w-max",
    css: "min-width: max-content;",
  },
  {
    tailwind: "min-w-fit",
    css: "min-width: fit-content;",
  },
  {
    tailwind: "max-w-0",
    css: "max-width: 0rem; /* 0px */",
  },
  {
    tailwind: "max-w-none",
    css: "max-width: none;",
  },
  {
    tailwind: "max-w-xs",
    css: "max-width: 20rem; /* 320px */",
  },
  {
    tailwind: "max-w-sm",
    css: "max-width: 24rem; /* 384px */",
  },
  {
    tailwind: "max-w-md",
    css: "max-width: 28rem; /* 448px */",
  },
  {
    tailwind: "max-w-lg",
    css: "max-width: 32rem; /* 512px */",
  },
  {
    tailwind: "max-w-xl",
    css: "max-width: 36rem; /* 576px */",
  },
  {
    tailwind: "max-w-2xl",
    css: "max-width: 42rem; /* 672px */",
  },
  {
    tailwind: "max-w-3xl",
    css: "max-width: 48rem; /* 768px */",
  },
  {
    tailwind: "max-w-4xl",
    css: "max-width: 56rem; /* 896px */",
  },
  {
    tailwind: "max-w-5xl",
    css: "max-width: 64rem; /* 1024px */",
  },
  {
    tailwind: "max-w-6xl",
    css: "max-width: 72rem; /* 1152px */",
  },
  {
    tailwind: "max-w-7xl",
    css: "max-width: 80rem; /* 1280px */",
  },
  {
    tailwind: "max-w-full",
    css: "max-width: 100%;",
  },
  {
    tailwind: "max-w-min",
    css: "max-width: min-content;",
  },
  {
    tailwind: "max-w-max",
    css: "max-width: max-content;",
  },
  {
    tailwind: "max-w-fit",
    css: "max-width: fit-content;",
  },
  {
    tailwind: "max-w-prose",
    css: "max-width: 65ch;",
  },
  {
    tailwind: "max-w-screen-sm",
    css: "max-width: 640px;",
  },
  {
    tailwind: "max-w-screen-md",
    css: "max-width: 768px;",
  },
  {
    tailwind: "max-w-screen-lg",
    css: "max-width: 1024px;",
  },
  {
    tailwind: "max-w-screen-xl",
    css: "max-width: 1280px;",
  },
  {
    tailwind: "max-w-screen-2xl",
    css: "max-width: 1536px;",
  },
  {
    tailwind: "h-0",
    css: "height: 0px;",
  },
  {
    tailwind: "h-px",
    css: "height: 1px;",
  },
  {
    tailwind: "h-0.5",
    css: "height: 0.125rem; /* 2px */",
  },
  {
    tailwind: "h-1",
    css: "height: 0.25rem; /* 4px */",
  },
  {
    tailwind: "h-1.5",
    css: "height: 0.375rem; /* 6px */",
  },
  {
    tailwind: "h-2",
    css: "height: 0.5rem; /* 8px */",
  },
  {
    tailwind: "h-2.5",
    css: "height: 0.625rem; /* 10px */",
  },
  {
    tailwind: "h-3",
    css: "height: 0.75rem; /* 12px */",
  },
  {
    tailwind: "h-3.5",
    css: "height: 0.875rem; /* 14px */",
  },
  {
    tailwind: "h-4",
    css: "height: 1rem; /* 16px */",
  },
  {
    tailwind: "h-5",
    css: "height: 1.25rem; /* 20px */",
  },
  {
    tailwind: "h-6",
    css: "height: 1.5rem; /* 24px */",
  },
  {
    tailwind: "h-7",
    css: "height: 1.75rem; /* 28px */",
  },
  {
    tailwind: "h-8",
    css: "height: 2rem; /* 32px */",
  },
  {
    tailwind: "h-9",
    css: "height: 2.25rem; /* 36px */",
  },
  {
    tailwind: "h-10",
    css: "height: 2.5rem; /* 40px */",
  },
  {
    tailwind: "h-11",
    css: "height: 2.75rem; /* 44px */",
  },
  {
    tailwind: "h-12",
    css: "height: 3rem; /* 48px */",
  },
  {
    tailwind: "h-14",
    css: "height: 3.5rem; /* 56px */",
  },
  {
    tailwind: "h-16",
    css: "height: 4rem; /* 64px */",
  },
  {
    tailwind: "h-20",
    css: "height: 5rem; /* 80px */",
  },
  {
    tailwind: "h-24",
    css: "height: 6rem; /* 96px */",
  },
  {
    tailwind: "h-28",
    css: "height: 7rem; /* 112px */",
  },
  {
    tailwind: "h-32",
    css: "height: 8rem; /* 128px */",
  },
  {
    tailwind: "h-36",
    css: "height: 9rem; /* 144px */",
  },
  {
    tailwind: "h-40",
    css: "height: 10rem; /* 160px */",
  },
  {
    tailwind: "h-44",
    css: "height: 11rem; /* 176px */",
  },
  {
    tailwind: "h-48",
    css: "height: 12rem; /* 192px */",
  },
  {
    tailwind: "h-52",
    css: "height: 13rem; /* 208px */",
  },
  {
    tailwind: "h-56",
    css: "height: 14rem; /* 224px */",
  },
  {
    tailwind: "h-60",
    css: "height: 15rem; /* 240px */",
  },
  {
    tailwind: "h-64",
    css: "height: 16rem; /* 256px */",
  },
  {
    tailwind: "h-72",
    css: "height: 18rem; /* 288px */",
  },
  {
    tailwind: "h-80",
    css: "height: 20rem; /* 320px */",
  },
  {
    tailwind: "h-96",
    css: "height: 24rem; /* 384px */",
  },
  {
    tailwind: "h-auto",
    css: "height: auto;",
  },
  {
    tailwind: "h-1/2",
    css: "height: 50%;",
  },
  {
    tailwind: "h-1/3",
    css: "height: 33.333333%;",
  },
  {
    tailwind: "h-2/3",
    css: "height: 66.666667%;",
  },
  {
    tailwind: "h-1/4",
    css: "height: 25%;",
  },
  {
    tailwind: "h-2/4",
    css: "height: 50%;",
  },
  {
    tailwind: "h-3/4",
    css: "height: 75%;",
  },
  {
    tailwind: "h-1/5",
    css: "height: 20%;",
  },
  {
    tailwind: "h-2/5",
    css: "height: 40%;",
  },
  {
    tailwind: "h-3/5",
    css: "height: 60%;",
  },
  {
    tailwind: "h-4/5",
    css: "height: 80%;",
  },
  {
    tailwind: "h-1/6",
    css: "height: 16.666667%;",
  },
  {
    tailwind: "h-2/6",
    css: "height: 33.333333%;",
  },
  {
    tailwind: "h-3/6",
    css: "height: 50%;",
  },
  {
    tailwind: "h-4/6",
    css: "height: 66.666667%;",
  },
  {
    tailwind: "h-5/6",
    css: "height: 83.333333%;",
  },
  {
    tailwind: "h-full",
    css: "height: 100%;",
  },
  {
    tailwind: "h-screen",
    css: "height: 100vh;",
  },
  {
    tailwind: "h-min",
    css: "height: min-content;",
  },
  {
    tailwind: "h-max",
    css: "height: max-content;",
  },
  {
    tailwind: "h-fit",
    css: "height: fit-content;",
  },
  {
    tailwind: "min-h-0",
    css: "min-height: 0px;",
  },
  {
    tailwind: "min-h-full",
    css: "min-height: 100%;",
  },
  {
    tailwind: "min-h-screen",
    css: "min-height: 100vh;",
  },
  {
    tailwind: "min-h-min",
    css: "min-height: min-content;",
  },
  {
    tailwind: "min-h-max",
    css: "min-height: max-content;",
  },
  {
    tailwind: "min-h-fit",
    css: "min-height: fit-content;",
  },
  {
    tailwind: "max-h-0",
    css: "max-height: 0px;",
  },
  {
    tailwind: "max-h-px",
    css: "max-height: 1px;",
  },
  {
    tailwind: "max-h-0.5",
    css: "max-height: 0.125rem; /* 2px */",
  },
  {
    tailwind: "max-h-1",
    css: "max-height: 0.25rem; /* 4px */",
  },
  {
    tailwind: "max-h-1.5",
    css: "max-height: 0.375rem; /* 6px */",
  },
  {
    tailwind: "max-h-2",
    css: "max-height: 0.5rem; /* 8px */",
  },
  {
    tailwind: "max-h-2.5",
    css: "max-height: 0.625rem; /* 10px */",
  },
  {
    tailwind: "max-h-3",
    css: "max-height: 0.75rem; /* 12px */",
  },
  {
    tailwind: "max-h-3.5",
    css: "max-height: 0.875rem; /* 14px */",
  },
  {
    tailwind: "max-h-4",
    css: "max-height: 1rem; /* 16px */",
  },
  {
    tailwind: "max-h-5",
    css: "max-height: 1.25rem; /* 20px */",
  },
  {
    tailwind: "max-h-6",
    css: "max-height: 1.5rem; /* 24px */",
  },
  {
    tailwind: "max-h-7",
    css: "max-height: 1.75rem; /* 28px */",
  },
  {
    tailwind: "max-h-8",
    css: "max-height: 2rem; /* 32px */",
  },
  {
    tailwind: "max-h-9",
    css: "max-height: 2.25rem; /* 36px */",
  },
  {
    tailwind: "max-h-10",
    css: "max-height: 2.5rem; /* 40px */",
  },
  {
    tailwind: "max-h-11",
    css: "max-height: 2.75rem; /* 44px */",
  },
  {
    tailwind: "max-h-12",
    css: "max-height: 3rem; /* 48px */",
  },
  {
    tailwind: "max-h-14",
    css: "max-height: 3.5rem; /* 56px */",
  },
  {
    tailwind: "max-h-16",
    css: "max-height: 4rem; /* 64px */",
  },
  {
    tailwind: "max-h-20",
    css: "max-height: 5rem; /* 80px */",
  },
  {
    tailwind: "max-h-24",
    css: "max-height: 6rem; /* 96px */",
  },
  {
    tailwind: "max-h-28",
    css: "max-height: 7rem; /* 112px */",
  },
  {
    tailwind: "max-h-32",
    css: "max-height: 8rem; /* 128px */",
  },
  {
    tailwind: "max-h-36",
    css: "max-height: 9rem; /* 144px */",
  },
  {
    tailwind: "max-h-40",
    css: "max-height: 10rem; /* 160px */",
  },
  {
    tailwind: "max-h-44",
    css: "max-height: 11rem; /* 176px */",
  },
  {
    tailwind: "max-h-48",
    css: "max-height: 12rem; /* 192px */",
  },
  {
    tailwind: "max-h-52",
    css: "max-height: 13rem; /* 208px */",
  },
  {
    tailwind: "max-h-56",
    css: "max-height: 14rem; /* 224px */",
  },
  {
    tailwind: "max-h-60",
    css: "max-height: 15rem; /* 240px */",
  },
  {
    tailwind: "max-h-64",
    css: "max-height: 16rem; /* 256px */",
  },
  {
    tailwind: "max-h-72",
    css: "max-height: 18rem; /* 288px */",
  },
  {
    tailwind: "max-h-80",
    css: "max-height: 20rem; /* 320px */",
  },
  {
    tailwind: "max-h-96",
    css: "max-height: 24rem; /* 384px */",
  },
  {
    tailwind: "max-h-none",
    css: "max-height: none;",
  },
  {
    tailwind: "max-h-full",
    css: "max-height: 100%;",
  },
  {
    tailwind: "max-h-screen",
    css: "max-height: 100vh;",
  },
  {
    tailwind: "max-h-min",
    css: "max-height: min-content;",
  },
  {
    tailwind: "max-h-max",
    css: "max-height: max-content;",
  },
  {
    tailwind: "max-h-fit",
    css: "max-height: fit-content;",
  },
  {
    tailwind: "font-sans",
    css: 'font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";',
  },
  {
    tailwind: "font-serif",
    css: 'font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;',
  },
  {
    tailwind: "font-mono",
    css: 'font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;',
  },
  {
    tailwind: "text-xs",
    css: "font-size: 0.75rem; /* 12px */\nline-height: 1rem; /* 16px */",
  },
  {
    tailwind: "text-sm",
    css: "font-size: 0.875rem; /* 14px */\nline-height: 1.25rem; /* 20px */",
  },
  {
    tailwind: "text-base",
    css: "font-size: 1rem; /* 16px */\nline-height: 1.5rem; /* 24px */",
  },
  {
    tailwind: "text-lg",
    css: "font-size: 1.125rem; /* 18px */\nline-height: 1.75rem; /* 28px */",
  },
  {
    tailwind: "text-xl",
    css: "font-size: 1.25rem; /* 20px */\nline-height: 1.75rem; /* 28px */",
  },
  {
    tailwind: "text-2xl",
    css: "font-size: 1.5rem; /* 24px */\nline-height: 2rem; /* 32px */",
  },
  {
    tailwind: "text-3xl",
    css: "font-size: 1.875rem; /* 30px */\nline-height: 2.25rem; /* 36px */",
  },
  {
    tailwind: "text-4xl",
    css: "font-size: 2.25rem; /* 36px */\nline-height: 2.5rem; /* 40px */",
  },
  {
    tailwind: "text-5xl",
    css: "font-size: 3rem; /* 48px */\nline-height: 1;",
  },
  {
    tailwind: "text-6xl",
    css: "font-size: 3.75rem; /* 60px */\nline-height: 1;",
  },
  {
    tailwind: "text-7xl",
    css: "font-size: 4.5rem; /* 72px */\nline-height: 1;",
  },
  {
    tailwind: "text-8xl",
    css: "font-size: 6rem; /* 96px */\nline-height: 1;",
  },
  {
    tailwind: "text-9xl",
    css: "font-size: 8rem; /* 128px */\nline-height: 1;",
  },
  {
    tailwind: "antialiased",
    css: "-webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale;",
  },
  {
    tailwind: "subpixel-antialiased",
    css: "-webkit-font-smoothing: auto;\n-moz-osx-font-smoothing: auto;",
  },
  {
    tailwind: "italic",
    css: "font-style: italic;",
  },
  {
    tailwind: "not-italic",
    css: "font-style: normal;",
  },
  {
    tailwind: "font-thin",
    css: "font-weight: 100;",
  },
  {
    tailwind: "font-extralight",
    css: "font-weight: 200;",
  },
  {
    tailwind: "font-light",
    css: "font-weight: 300;",
  },
  {
    tailwind: "font-normal",
    css: "font-weight: 400;",
  },
  {
    tailwind: "font-medium",
    css: "font-weight: 500;",
  },
  {
    tailwind: "font-semibold",
    css: "font-weight: 600;",
  },
  {
    tailwind: "font-bold",
    css: "font-weight: 700;",
  },
  {
    tailwind: "font-extrabold",
    css: "font-weight: 800;",
  },
  {
    tailwind: "font-black",
    css: "font-weight: 900;",
  },
  {
    tailwind: "normal-nums",
    css: "font-variant-numeric: normal;",
  },
  {
    tailwind: "ordinal",
    css: "font-variant-numeric: ordinal;",
  },
  {
    tailwind: "slashed-zero",
    css: "font-variant-numeric: slashed-zero;",
  },
  {
    tailwind: "lining-nums",
    css: "font-variant-numeric: lining-nums;",
  },
  {
    tailwind: "oldstyle-nums",
    css: "font-variant-numeric: oldstyle-nums;",
  },
  {
    tailwind: "proportional-nums",
    css: "font-variant-numeric: proportional-nums;",
  },
  {
    tailwind: "tabular-nums",
    css: "font-variant-numeric: tabular-nums;",
  },
  {
    tailwind: "diagonal-fractions",
    css: "font-variant-numeric: diagonal-fractions;",
  },
  {
    tailwind: "stacked-fractions",
    css: "font-variant-numeric: stacked-fractions;",
  },
  {
    tailwind: "tracking-tighter",
    css: "letter-spacing: -0.05em;",
  },
  {
    tailwind: "tracking-tight",
    css: "letter-spacing: -0.025em;",
  },
  {
    tailwind: "tracking-normal",
    css: "letter-spacing: 0em;",
  },
  {
    tailwind: "tracking-wide",
    css: "letter-spacing: 0.025em;",
  },
  {
    tailwind: "tracking-wider",
    css: "letter-spacing: 0.05em;",
  },
  {
    tailwind: "tracking-widest",
    css: "letter-spacing: 0.1em;",
  },
  {
    tailwind: "line-clamp-1",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 1;",
  },
  {
    tailwind: "line-clamp-2",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 2;",
  },
  {
    tailwind: "line-clamp-3",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 3;",
  },
  {
    tailwind: "line-clamp-4",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 4;",
  },
  {
    tailwind: "line-clamp-5",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 5;",
  },
  {
    tailwind: "line-clamp-6",
    css: "overflow: hidden;\ndisplay: -webkit-box;\n-webkit-box-orient: vertical;\n-webkit-line-clamp: 6;",
  },
  {
    tailwind: "line-clamp-none",
    css: "overflow: visible;\ndisplay: block;\n-webkit-box-orient: horizontal;\n-webkit-line-clamp: none;",
  },
  {
    tailwind: "leading-3",
    css: "line-height: .75rem; /* 12px */",
  },
  {
    tailwind: "leading-4",
    css: "line-height: 1rem; /* 16px */",
  },
  {
    tailwind: "leading-5",
    css: "line-height: 1.25rem; /* 20px */",
  },
  {
    tailwind: "leading-6",
    css: "line-height: 1.5rem; /* 24px */",
  },
  {
    tailwind: "leading-7",
    css: "line-height: 1.75rem; /* 28px */",
  },
  {
    tailwind: "leading-8",
    css: "line-height: 2rem; /* 32px */",
  },
  {
    tailwind: "leading-9",
    css: "line-height: 2.25rem; /* 36px */",
  },
  {
    tailwind: "leading-10",
    css: "line-height: 2.5rem; /* 40px */",
  },
  {
    tailwind: "leading-none",
    css: "line-height: 1;",
  },
  {
    tailwind: "leading-tight",
    css: "line-height: 1.25;",
  },
  {
    tailwind: "leading-snug",
    css: "line-height: 1.375;",
  },
  {
    tailwind: "leading-normal",
    css: "line-height: 1.5;",
  },
  {
    tailwind: "leading-relaxed",
    css: "line-height: 1.625;",
  },
  {
    tailwind: "leading-loose",
    css: "line-height: 2;",
  },
  {
    tailwind: "list-image-none",
    css: "list-style-image: none;",
  },
  {
    tailwind: "list-inside",
    css: "list-style-position: inside;",
  },
  {
    tailwind: "list-outside",
    css: "list-style-position: outside;",
  },
  {
    tailwind: "list-none",
    css: "list-style-type: none;",
  },
  {
    tailwind: "list-disc",
    css: "list-style-type: disc;",
  },
  {
    tailwind: "list-decimal",
    css: "list-style-type: decimal;",
  },
  {
    tailwind: "text-left",
    css: "text-align: left;",
  },
  {
    tailwind: "text-center",
    css: "text-align: center;",
  },
  {
    tailwind: "text-right",
    css: "text-align: right;",
  },
  {
    tailwind: "text-justify",
    css: "text-align: justify;",
  },
  {
    tailwind: "text-start",
    css: "text-align: start;",
  },
  {
    tailwind: "text-end",
    css: "text-align: end;",
  },
  {
    tailwind: "text-inherit",
    css: "color: inherit;",
  },
  {
    tailwind: "text-current",
    css: "color: currentColor;",
  },
  {
    tailwind: "text-transparent",
    css: "color: transparent;",
  },
  {
    tailwind: "text-black",
    css: "color: rgb(0 0 0);",
  },
  {
    tailwind: "text-white",
    css: "color: rgb(255 255 255);",
  },
  {
    tailwind: "text-slate-50",
    css: "color: rgb(248 250 252);",
  },
  {
    tailwind: "text-slate-100",
    css: "color: rgb(241 245 249);",
  },
  {
    tailwind: "text-slate-200",
    css: "color: rgb(226 232 240);",
  },
  {
    tailwind: "text-slate-300",
    css: "color: rgb(203 213 225);",
  },
  {
    tailwind: "text-slate-400",
    css: "color: rgb(148 163 184);",
  },
  {
    tailwind: "text-slate-500",
    css: "color: rgb(100 116 139);",
  },
  {
    tailwind: "text-slate-600",
    css: "color: rgb(71 85 105);",
  },
  {
    tailwind: "text-slate-700",
    css: "color: rgb(51 65 85);",
  },
  {
    tailwind: "text-slate-800",
    css: "color: rgb(30 41 59);",
  },
  {
    tailwind: "text-slate-900",
    css: "color: rgb(15 23 42);",
  },
  {
    tailwind: "text-slate-950",
    css: "color: rgb(2 6 23);",
  },
  {
    tailwind: "text-gray-50",
    css: "color: rgb(249 250 251);",
  },
  {
    tailwind: "text-gray-100",
    css: "color: rgb(243 244 246);",
  },
  {
    tailwind: "text-gray-200",
    css: "color: rgb(229 231 235);",
  },
  {
    tailwind: "text-gray-300",
    css: "color: rgb(209 213 219);",
  },
  {
    tailwind: "text-gray-400",
    css: "color: rgb(156 163 175);",
  },
  {
    tailwind: "text-gray-500",
    css: "color: rgb(107 114 128);",
  },
  {
    tailwind: "text-gray-600",
    css: "color: rgb(75 85 99);",
  },
  {
    tailwind: "text-gray-700",
    css: "color: rgb(55 65 81);",
  },
  {
    tailwind: "text-gray-800",
    css: "color: rgb(31 41 55);",
  },
  {
    tailwind: "text-gray-900",
    css: "color: rgb(17 24 39);",
  },
  {
    tailwind: "text-gray-950",
    css: "color: rgb(3 7 18);",
  },
  {
    tailwind: "text-zinc-50",
    css: "color: rgb(250 250 250);",
  },
  {
    tailwind: "text-zinc-100",
    css: "color: rgb(244 244 245);",
  },
  {
    tailwind: "text-zinc-200",
    css: "color: rgb(228 228 231);",
  },
  {
    tailwind: "text-zinc-300",
    css: "color: rgb(212 212 216);",
  },
  {
    tailwind: "text-zinc-400",
    css: "color: rgb(161 161 170);",
  },
  {
    tailwind: "text-zinc-500",
    css: "color: rgb(113 113 122);",
  },
  {
    tailwind: "text-zinc-600",
    css: "color: rgb(82 82 91);",
  },
  {
    tailwind: "text-zinc-700",
    css: "color: rgb(63 63 70);",
  },
  {
    tailwind: "text-zinc-800",
    css: "color: rgb(39 39 42);",
  },
  {
    tailwind: "text-zinc-900",
    css: "color: rgb(24 24 27);",
  },
  {
    tailwind: "text-zinc-950",
    css: "color: rgb(9 9 11);",
  },
  {
    tailwind: "text-neutral-50",
    css: "color: rgb(250 250 250);",
  },
  {
    tailwind: "text-neutral-100",
    css: "color: rgb(245 245 245);",
  },
  {
    tailwind: "text-neutral-200",
    css: "color: rgb(229 229 229);",
  },
  {
    tailwind: "text-neutral-300",
    css: "color: rgb(212 212 212);",
  },
  {
    tailwind: "text-neutral-400",
    css: "color: rgb(163 163 163);",
  },
  {
    tailwind: "text-neutral-500",
    css: "color: rgb(115 115 115);",
  },
  {
    tailwind: "text-neutral-600",
    css: "color: rgb(82 82 82);",
  },
  {
    tailwind: "text-neutral-700",
    css: "color: rgb(64 64 64);",
  },
  {
    tailwind: "text-neutral-800",
    css: "color: rgb(38 38 38);",
  },
  {
    tailwind: "text-neutral-900",
    css: "color: rgb(23 23 23);",
  },
  {
    tailwind: "text-neutral-950",
    css: "color: rgb(10 10 10);",
  },
  {
    tailwind: "text-stone-50",
    css: "color: rgb(250 250 249);",
  },
  {
    tailwind: "text-stone-100",
    css: "color: rgb(245 245 244);",
  },
  {
    tailwind: "text-stone-200",
    css: "color: rgb(231 229 228);",
  },
  {
    tailwind: "text-stone-300",
    css: "color: rgb(214 211 209);",
  },
  {
    tailwind: "text-stone-400",
    css: "color: rgb(168 162 158);",
  },
  {
    tailwind: "text-stone-500",
    css: "color: rgb(120 113 108);",
  },
  {
    tailwind: "text-stone-600",
    css: "color: rgb(87 83 78);",
  },
  {
    tailwind: "text-stone-700",
    css: "color: rgb(68 64 60);",
  },
  {
    tailwind: "text-stone-800",
    css: "color: rgb(41 37 36);",
  },
  {
    tailwind: "text-stone-900",
    css: "color: rgb(28 25 23);",
  },
  {
    tailwind: "text-stone-950",
    css: "color: rgb(12 10 9);",
  },
  {
    tailwind: "text-red-50",
    css: "color: rgb(254 242 242);",
  },
  {
    tailwind: "text-red-100",
    css: "color: rgb(254 226 226);",
  },
  {
    tailwind: "text-red-200",
    css: "color: rgb(254 202 202);",
  },
  {
    tailwind: "text-red-300",
    css: "color: rgb(252 165 165);",
  },
  {
    tailwind: "text-red-400",
    css: "color: rgb(248 113 113);",
  },
  {
    tailwind: "text-red-500",
    css: "color: rgb(239 68 68);",
  },
  {
    tailwind: "text-red-600",
    css: "color: rgb(220 38 38);",
  },
  {
    tailwind: "text-red-700",
    css: "color: rgb(185 28 28);",
  },
  {
    tailwind: "text-red-800",
    css: "color: rgb(153 27 27);",
  },
  {
    tailwind: "text-red-900",
    css: "color: rgb(127 29 29);",
  },
  {
    tailwind: "text-red-950",
    css: "color: rgb(69 10 10);",
  },
  {
    tailwind: "text-orange-50",
    css: "color: rgb(255 247 237);",
  },
  {
    tailwind: "text-orange-100",
    css: "color: rgb(255 237 213);",
  },
  {
    tailwind: "text-orange-200",
    css: "color: rgb(254 215 170);",
  },
  {
    tailwind: "text-orange-300",
    css: "color: rgb(253 186 116);",
  },
  {
    tailwind: "text-orange-400",
    css: "color: rgb(251 146 60);",
  },
  {
    tailwind: "text-orange-500",
    css: "color: rgb(249 115 22);",
  },
  {
    tailwind: "text-orange-600",
    css: "color: rgb(234 88 12);",
  },
  {
    tailwind: "text-orange-700",
    css: "color: rgb(194 65 12);",
  },
  {
    tailwind: "text-orange-800",
    css: "color: rgb(154 52 18);",
  },
  {
    tailwind: "text-orange-900",
    css: "color: rgb(124 45 18);",
  },
  {
    tailwind: "text-orange-950",
    css: "color: rgb(67 20 7);",
  },
  {
    tailwind: "text-amber-50",
    css: "color: rgb(255 251 235);",
  },
  {
    tailwind: "text-amber-100",
    css: "color: rgb(254 243 199);",
  },
  {
    tailwind: "text-amber-200",
    css: "color: rgb(253 230 138);",
  },
  {
    tailwind: "text-amber-300",
    css: "color: rgb(252 211 77);",
  },
  {
    tailwind: "text-amber-400",
    css: "color: rgb(251 191 36);",
  },
  {
    tailwind: "text-amber-500",
    css: "color: rgb(245 158 11);",
  },
  {
    tailwind: "text-amber-600",
    css: "color: rgb(217 119 6);",
  },
  {
    tailwind: "text-amber-700",
    css: "color: rgb(180 83 9);",
  },
  {
    tailwind: "text-amber-800",
    css: "color: rgb(146 64 14);",
  },
  {
    tailwind: "text-amber-900",
    css: "color: rgb(120 53 15);",
  },
  {
    tailwind: "text-amber-950",
    css: "color: rgb(69 26 3);",
  },
  {
    tailwind: "text-yellow-50",
    css: "color: rgb(254 252 232);",
  },
  {
    tailwind: "text-yellow-100",
    css: "color: rgb(254 249 195);",
  },
  {
    tailwind: "text-yellow-200",
    css: "color: rgb(254 240 138);",
  },
  {
    tailwind: "text-yellow-300",
    css: "color: rgb(253 224 71);",
  },
  {
    tailwind: "text-yellow-400",
    css: "color: rgb(250 204 21);",
  },
  {
    tailwind: "text-yellow-500",
    css: "color: rgb(234 179 8);",
  },
  {
    tailwind: "text-yellow-600",
    css: "color: rgb(202 138 4);",
  },
  {
    tailwind: "text-yellow-700",
    css: "color: rgb(161 98 7);",
  },
  {
    tailwind: "text-yellow-800",
    css: "color: rgb(133 77 14);",
  },
  {
    tailwind: "text-yellow-900",
    css: "color: rgb(113 63 18);",
  },
  {
    tailwind: "text-yellow-950",
    css: "color: rgb(66 32 6);",
  },
  {
    tailwind: "text-lime-50",
    css: "color: rgb(247 254 231);",
  },
  {
    tailwind: "text-lime-100",
    css: "color: rgb(236 252 203);",
  },
  {
    tailwind: "text-lime-200",
    css: "color: rgb(217 249 157);",
  },
  {
    tailwind: "text-lime-300",
    css: "color: rgb(190 242 100);",
  },
  {
    tailwind: "text-lime-400",
    css: "color: rgb(163 230 53);",
  },
  {
    tailwind: "text-lime-500",
    css: "color: rgb(132 204 22);",
  },
  {
    tailwind: "text-lime-600",
    css: "color: rgb(101 163 13);",
  },
  {
    tailwind: "text-lime-700",
    css: "color: rgb(77 124 15);",
  },
  {
    tailwind: "text-lime-800",
    css: "color: rgb(63 98 18);",
  },
  {
    tailwind: "text-lime-900",
    css: "color: rgb(54 83 20);",
  },
  {
    tailwind: "text-lime-950",
    css: "color: rgb(26 46 5);",
  },
  {
    tailwind: "text-green-50",
    css: "color: rgb(240 253 244);",
  },
  {
    tailwind: "text-green-100",
    css: "color: rgb(220 252 231);",
  },
  {
    tailwind: "text-green-200",
    css: "color: rgb(187 247 208);",
  },
  {
    tailwind: "text-green-300",
    css: "color: rgb(134 239 172);",
  },
  {
    tailwind: "text-green-400",
    css: "color: rgb(74 222 128);",
  },
  {
    tailwind: "text-green-500",
    css: "color: rgb(34 197 94);",
  },
  {
    tailwind: "text-green-600",
    css: "color: rgb(22 163 74);",
  },
  {
    tailwind: "text-green-700",
    css: "color: rgb(21 128 61);",
  },
  {
    tailwind: "text-green-800",
    css: "color: rgb(22 101 52);",
  },
  {
    tailwind: "text-green-900",
    css: "color: rgb(20 83 45);",
  },
  {
    tailwind: "text-green-950",
    css: "color: rgb(5 46 22);",
  },
  {
    tailwind: "text-emerald-50",
    css: "color: rgb(236 253 245);",
  },
  {
    tailwind: "text-emerald-100",
    css: "color: rgb(209 250 229);",
  },
  {
    tailwind: "text-emerald-200",
    css: "color: rgb(167 243 208);",
  },
  {
    tailwind: "text-emerald-300",
    css: "color: rgb(110 231 183);",
  },
  {
    tailwind: "text-emerald-400",
    css: "color: rgb(52 211 153);",
  },
  {
    tailwind: "text-emerald-500",
    css: "color: rgb(16 185 129);",
  },
  {
    tailwind: "text-emerald-600",
    css: "color: rgb(5 150 105);",
  },
  {
    tailwind: "text-emerald-700",
    css: "color: rgb(4 120 87);",
  },
  {
    tailwind: "text-emerald-800",
    css: "color: rgb(6 95 70);",
  },
  {
    tailwind: "text-emerald-900",
    css: "color: rgb(6 78 59);",
  },
  {
    tailwind: "text-emerald-950",
    css: "color: rgb(2 44 34);",
  },
  {
    tailwind: "text-teal-50",
    css: "color: rgb(240 253 250);",
  },
  {
    tailwind: "text-teal-100",
    css: "color: rgb(204 251 241);",
  },
  {
    tailwind: "text-teal-200",
    css: "color: rgb(153 246 228);",
  },
  {
    tailwind: "text-teal-300",
    css: "color: rgb(94 234 212);",
  },
  {
    tailwind: "text-teal-400",
    css: "color: rgb(45 212 191);",
  },
  {
    tailwind: "text-teal-500",
    css: "color: rgb(20 184 166);",
  },
  {
    tailwind: "text-teal-600",
    css: "color: rgb(13 148 136);",
  },
  {
    tailwind: "text-teal-700",
    css: "color: rgb(15 118 110);",
  },
  {
    tailwind: "text-teal-800",
    css: "color: rgb(17 94 89);",
  },
  {
    tailwind: "text-teal-900",
    css: "color: rgb(19 78 74);",
  },
  {
    tailwind: "text-teal-950",
    css: "color: rgb(4 47 46);",
  },
  {
    tailwind: "text-cyan-50",
    css: "color: rgb(236 254 255);",
  },
  {
    tailwind: "text-cyan-100",
    css: "color: rgb(207 250 254);",
  },
  {
    tailwind: "text-cyan-200",
    css: "color: rgb(165 243 252);",
  },
  {
    tailwind: "text-cyan-300",
    css: "color: rgb(103 232 249);",
  },
  {
    tailwind: "text-cyan-400",
    css: "color: rgb(34 211 238);",
  },
  {
    tailwind: "text-cyan-500",
    css: "color: rgb(6 182 212);",
  },
  {
    tailwind: "text-cyan-600",
    css: "color: rgb(8 145 178);",
  },
  {
    tailwind: "text-cyan-700",
    css: "color: rgb(14 116 144);",
  },
  {
    tailwind: "text-cyan-800",
    css: "color: rgb(21 94 117);",
  },
  {
    tailwind: "text-cyan-900",
    css: "color: rgb(22 78 99);",
  },
  {
    tailwind: "text-cyan-950",
    css: "color: rgb(8 51 68);",
  },
  {
    tailwind: "text-sky-50",
    css: "color: rgb(240 249 255);",
  },
  {
    tailwind: "text-sky-100",
    css: "color: rgb(224 242 254);",
  },
  {
    tailwind: "text-sky-200",
    css: "color: rgb(186 230 253);",
  },
  {
    tailwind: "text-sky-300",
    css: "color: rgb(125 211 252);",
  },
  {
    tailwind: "text-sky-400",
    css: "color: rgb(56 189 248);",
  },
  {
    tailwind: "text-sky-500",
    css: "color: rgb(14 165 233);",
  },
  {
    tailwind: "text-sky-600",
    css: "color: rgb(2 132 199);",
  },
  {
    tailwind: "text-sky-700",
    css: "color: rgb(3 105 161);",
  },
  {
    tailwind: "text-sky-800",
    css: "color: rgb(7 89 133);",
  },
  {
    tailwind: "text-sky-900",
    css: "color: rgb(12 74 110);",
  },
  {
    tailwind: "text-sky-950",
    css: "color: rgb(8 47 73);",
  },
  {
    tailwind: "text-blue-50",
    css: "color: rgb(239 246 255);",
  },
  {
    tailwind: "text-blue-100",
    css: "color: rgb(219 234 254);",
  },
  {
    tailwind: "text-blue-200",
    css: "color: rgb(191 219 254);",
  },
  {
    tailwind: "text-blue-300",
    css: "color: rgb(147 197 253);",
  },
  {
    tailwind: "text-blue-400",
    css: "color: rgb(96 165 250);",
  },
  {
    tailwind: "text-blue-500",
    css: "color: rgb(59 130 246);",
  },
  {
    tailwind: "text-blue-600",
    css: "color: rgb(37 99 235);",
  },
  {
    tailwind: "text-blue-700",
    css: "color: rgb(29 78 216);",
  },
  {
    tailwind: "text-blue-800",
    css: "color: rgb(30 64 175);",
  },
  {
    tailwind: "text-blue-900",
    css: "color: rgb(30 58 138);",
  },
  {
    tailwind: "text-blue-950",
    css: "color: rgb(23 37 84);",
  },
  {
    tailwind: "text-indigo-50",
    css: "color: rgb(238 242 255);",
  },
  {
    tailwind: "text-indigo-100",
    css: "color: rgb(224 231 255);",
  },
  {
    tailwind: "text-indigo-200",
    css: "color: rgb(199 210 254);",
  },
  {
    tailwind: "text-indigo-300",
    css: "color: rgb(165 180 252);",
  },
  {
    tailwind: "text-indigo-400",
    css: "color: rgb(129 140 248);",
  },
  {
    tailwind: "text-indigo-500",
    css: "color: rgb(99 102 241);",
  },
  {
    tailwind: "text-indigo-600",
    css: "color: rgb(79 70 229);",
  },
  {
    tailwind: "text-indigo-700",
    css: "color: rgb(67 56 202);",
  },
  {
    tailwind: "text-indigo-800",
    css: "color: rgb(55 48 163);",
  },
  {
    tailwind: "text-indigo-900",
    css: "color: rgb(49 46 129);",
  },
  {
    tailwind: "text-indigo-950",
    css: "color: rgb(30 27 75);",
  },
  {
    tailwind: "text-violet-50",
    css: "color: rgb(245 243 255);",
  },
  {
    tailwind: "text-violet-100",
    css: "color: rgb(237 233 254);",
  },
  {
    tailwind: "text-violet-200",
    css: "color: rgb(221 214 254);",
  },
  {
    tailwind: "text-violet-300",
    css: "color: rgb(196 181 253);",
  },
  {
    tailwind: "text-violet-400",
    css: "color: rgb(167 139 250);",
  },
  {
    tailwind: "text-violet-500",
    css: "color: rgb(139 92 246);",
  },
  {
    tailwind: "text-violet-600",
    css: "color: rgb(124 58 237);",
  },
  {
    tailwind: "text-violet-700",
    css: "color: rgb(109 40 217);",
  },
  {
    tailwind: "text-violet-800",
    css: "color: rgb(91 33 182);",
  },
  {
    tailwind: "text-violet-900",
    css: "color: rgb(76 29 149);",
  },
  {
    tailwind: "text-violet-950",
    css: "color: rgb(46 16 101);",
  },
  {
    tailwind: "text-purple-50",
    css: "color: rgb(250 245 255);",
  },
  {
    tailwind: "text-purple-100",
    css: "color: rgb(243 232 255);",
  },
  {
    tailwind: "text-purple-200",
    css: "color: rgb(233 213 255);",
  },
  {
    tailwind: "text-purple-300",
    css: "color: rgb(216 180 254);",
  },
  {
    tailwind: "text-purple-400",
    css: "color: rgb(192 132 252);",
  },
  {
    tailwind: "text-purple-500",
    css: "color: rgb(168 85 247);",
  },
  {
    tailwind: "text-purple-600",
    css: "color: rgb(147 51 234);",
  },
  {
    tailwind: "text-purple-700",
    css: "color: rgb(126 34 206);",
  },
  {
    tailwind: "text-purple-800",
    css: "color: rgb(107 33 168);",
  },
  {
    tailwind: "text-purple-900",
    css: "color: rgb(88 28 135);",
  },
  {
    tailwind: "text-purple-950",
    css: "color: rgb(59 7 100);",
  },
  {
    tailwind: "text-fuchsia-50",
    css: "color: rgb(253 244 255);",
  },
  {
    tailwind: "text-fuchsia-100",
    css: "color: rgb(250 232 255);",
  },
  {
    tailwind: "text-fuchsia-200",
    css: "color: rgb(245 208 254);",
  },
  {
    tailwind: "text-fuchsia-300",
    css: "color: rgb(240 171 252);",
  },
  {
    tailwind: "text-fuchsia-400",
    css: "color: rgb(232 121 249);",
  },
  {
    tailwind: "text-fuchsia-500",
    css: "color: rgb(217 70 239);",
  },
  {
    tailwind: "text-fuchsia-600",
    css: "color: rgb(192 38 211);",
  },
  {
    tailwind: "text-fuchsia-700",
    css: "color: rgb(162 28 175);",
  },
  {
    tailwind: "text-fuchsia-800",
    css: "color: rgb(134 25 143);",
  },
  {
    tailwind: "text-fuchsia-900",
    css: "color: rgb(112 26 117);",
  },
  {
    tailwind: "text-fuchsia-950",
    css: "color: rgb(74 4 78);",
  },
  {
    tailwind: "text-pink-50",
    css: "color: rgb(253 242 248);",
  },
  {
    tailwind: "text-pink-100",
    css: "color: rgb(252 231 243);",
  },
  {
    tailwind: "text-pink-200",
    css: "color: rgb(251 207 232);",
  },
  {
    tailwind: "text-pink-300",
    css: "color: rgb(249 168 212);",
  },
  {
    tailwind: "text-pink-400",
    css: "color: rgb(244 114 182);",
  },
  {
    tailwind: "text-pink-500",
    css: "color: rgb(236 72 153);",
  },
  {
    tailwind: "text-pink-600",
    css: "color: rgb(219 39 119);",
  },
  {
    tailwind: "text-pink-700",
    css: "color: rgb(190 24 93);",
  },
  {
    tailwind: "text-pink-800",
    css: "color: rgb(157 23 77);",
  },
  {
    tailwind: "text-pink-900",
    css: "color: rgb(131 24 67);",
  },
  {
    tailwind: "text-pink-950",
    css: "color: rgb(80 7 36);",
  },
  {
    tailwind: "text-rose-50",
    css: "color: rgb(255 241 242);",
  },
  {
    tailwind: "text-rose-100",
    css: "color: rgb(255 228 230);",
  },
  {
    tailwind: "text-rose-200",
    css: "color: rgb(254 205 211);",
  },
  {
    tailwind: "text-rose-300",
    css: "color: rgb(253 164 175);",
  },
  {
    tailwind: "text-rose-400",
    css: "color: rgb(251 113 133);",
  },
  {
    tailwind: "text-rose-500",
    css: "color: rgb(244 63 94);",
  },
  {
    tailwind: "text-rose-600",
    css: "color: rgb(225 29 72);",
  },
  {
    tailwind: "text-rose-700",
    css: "color: rgb(190 18 60);",
  },
  {
    tailwind: "text-rose-800",
    css: "color: rgb(159 18 57);",
  },
  {
    tailwind: "text-rose-900",
    css: "color: rgb(136 19 55);",
  },
  {
    tailwind: "text-rose-950",
    css: "color: rgb(76 5 25);",
  },
  {
    tailwind: "underline",
    css: "text-decoration-line: underline;",
  },
  {
    tailwind: "overline",
    css: "text-decoration-line: overline;",
  },
  {
    tailwind: "line-through",
    css: "text-decoration-line: line-through;",
  },
  {
    tailwind: "no-underline",
    css: "text-decoration-line: none;",
  },
  {
    tailwind: "decoration-inherit",
    css: "text-decoration-color: inherit;",
  },
  {
    tailwind: "decoration-current",
    css: "text-decoration-color: currentColor;",
  },
  {
    tailwind: "decoration-transparent",
    css: "text-decoration-color: transparent;",
  },
  {
    tailwind: "decoration-black",
    css: "text-decoration-color: #000;",
  },
  {
    tailwind: "decoration-white",
    css: "text-decoration-color: #fff;",
  },
  {
    tailwind: "decoration-slate-50",
    css: "text-decoration-color: #f8fafc;",
  },
  {
    tailwind: "decoration-slate-100",
    css: "text-decoration-color: #f1f5f9;",
  },
  {
    tailwind: "decoration-slate-200",
    css: "text-decoration-color: #e2e8f0;",
  },
  {
    tailwind: "decoration-slate-300",
    css: "text-decoration-color: #cbd5e1;",
  },
  {
    tailwind: "decoration-slate-400",
    css: "text-decoration-color: #94a3b8;",
  },
  {
    tailwind: "decoration-slate-500",
    css: "text-decoration-color: #64748b;",
  },
  {
    tailwind: "decoration-slate-600",
    css: "text-decoration-color: #475569;",
  },
  {
    tailwind: "decoration-slate-700",
    css: "text-decoration-color: #334155;",
  },
  {
    tailwind: "decoration-slate-800",
    css: "text-decoration-color: #1e293b;",
  },
  {
    tailwind: "decoration-slate-900",
    css: "text-decoration-color: #0f172a;",
  },
  {
    tailwind: "decoration-slate-950",
    css: "text-decoration-color: #020617;",
  },
  {
    tailwind: "decoration-gray-50",
    css: "text-decoration-color: #f9fafb;",
  },
  {
    tailwind: "decoration-gray-100",
    css: "text-decoration-color: #f3f4f6;",
  },
  {
    tailwind: "decoration-gray-200",
    css: "text-decoration-color: #e5e7eb;",
  },
  {
    tailwind: "decoration-gray-300",
    css: "text-decoration-color: #d1d5db;",
  },
  {
    tailwind: "decoration-gray-400",
    css: "text-decoration-color: #9ca3af;",
  },
  {
    tailwind: "decoration-gray-500",
    css: "text-decoration-color: #6b7280;",
  },
  {
    tailwind: "decoration-gray-600",
    css: "text-decoration-color: #4b5563;",
  },
  {
    tailwind: "decoration-gray-700",
    css: "text-decoration-color: #374151;",
  },
  {
    tailwind: "decoration-gray-800",
    css: "text-decoration-color: #1f2937;",
  },
  {
    tailwind: "decoration-gray-900",
    css: "text-decoration-color: #111827;",
  },
  {
    tailwind: "decoration-gray-950",
    css: "text-decoration-color: #030712;",
  },
  {
    tailwind: "decoration-zinc-50",
    css: "text-decoration-color: #fafafa;",
  },
  {
    tailwind: "decoration-zinc-100",
    css: "text-decoration-color: #f4f4f5;",
  },
  {
    tailwind: "decoration-zinc-200",
    css: "text-decoration-color: #e4e4e7;",
  },
  {
    tailwind: "decoration-zinc-300",
    css: "text-decoration-color: #d4d4d8;",
  },
  {
    tailwind: "decoration-zinc-400",
    css: "text-decoration-color: #a1a1aa;",
  },
  {
    tailwind: "decoration-zinc-500",
    css: "text-decoration-color: #71717a;",
  },
  {
    tailwind: "decoration-zinc-600",
    css: "text-decoration-color: #52525b;",
  },
  {
    tailwind: "decoration-zinc-700",
    css: "text-decoration-color: #3f3f46;",
  },
  {
    tailwind: "decoration-zinc-800",
    css: "text-decoration-color: #27272a;",
  },
  {
    tailwind: "decoration-zinc-900",
    css: "text-decoration-color: #18181b;",
  },
  {
    tailwind: "decoration-zinc-950",
    css: "text-decoration-color: #09090b;",
  },
  {
    tailwind: "decoration-neutral-50",
    css: "text-decoration-color: #fafafa;",
  },
  {
    tailwind: "decoration-neutral-100",
    css: "text-decoration-color: #f5f5f5;",
  },
  {
    tailwind: "decoration-neutral-200",
    css: "text-decoration-color: #e5e5e5;",
  },
  {
    tailwind: "decoration-neutral-300",
    css: "text-decoration-color: #d4d4d4;",
  },
  {
    tailwind: "decoration-neutral-400",
    css: "text-decoration-color: #a3a3a3;",
  },
  {
    tailwind: "decoration-neutral-500",
    css: "text-decoration-color: #737373;",
  },
  {
    tailwind: "decoration-neutral-600",
    css: "text-decoration-color: #525252;",
  },
  {
    tailwind: "decoration-neutral-700",
    css: "text-decoration-color: #404040;",
  },
  {
    tailwind: "decoration-neutral-800",
    css: "text-decoration-color: #262626;",
  },
  {
    tailwind: "decoration-neutral-900",
    css: "text-decoration-color: #171717;",
  },
  {
    tailwind: "decoration-neutral-950",
    css: "text-decoration-color: #0a0a0a;",
  },
  {
    tailwind: "decoration-stone-50",
    css: "text-decoration-color: #fafaf9;",
  },
  {
    tailwind: "decoration-stone-100",
    css: "text-decoration-color: #f5f5f4;",
  },
  {
    tailwind: "decoration-stone-200",
    css: "text-decoration-color: #e7e5e4;",
  },
  {
    tailwind: "decoration-stone-300",
    css: "text-decoration-color: #d6d3d1;",
  },
  {
    tailwind: "decoration-stone-400",
    css: "text-decoration-color: #a8a29e;",
  },
  {
    tailwind: "decoration-stone-500",
    css: "text-decoration-color: #78716c;",
  },
  {
    tailwind: "decoration-stone-600",
    css: "text-decoration-color: #57534e;",
  },
  {
    tailwind: "decoration-stone-700",
    css: "text-decoration-color: #44403c;",
  },
  {
    tailwind: "decoration-stone-800",
    css: "text-decoration-color: #292524;",
  },
  {
    tailwind: "decoration-stone-900",
    css: "text-decoration-color: #1c1917;",
  },
  {
    tailwind: "decoration-stone-950",
    css: "text-decoration-color: #0c0a09;",
  },
  {
    tailwind: "decoration-red-50",
    css: "text-decoration-color: #fef2f2;",
  },
  {
    tailwind: "decoration-red-100",
    css: "text-decoration-color: #fee2e2;",
  },
  {
    tailwind: "decoration-red-200",
    css: "text-decoration-color: #fecaca;",
  },
  {
    tailwind: "decoration-red-300",
    css: "text-decoration-color: #fca5a5;",
  },
  {
    tailwind: "decoration-red-400",
    css: "text-decoration-color: #f87171;",
  },
  {
    tailwind: "decoration-red-500",
    css: "text-decoration-color: #ef4444;",
  },
  {
    tailwind: "decoration-red-600",
    css: "text-decoration-color: #dc2626;",
  },
  {
    tailwind: "decoration-red-700",
    css: "text-decoration-color: #b91c1c;",
  },
  {
    tailwind: "decoration-red-800",
    css: "text-decoration-color: #991b1b;",
  },
  {
    tailwind: "decoration-red-900",
    css: "text-decoration-color: #7f1d1d;",
  },
  {
    tailwind: "decoration-red-950",
    css: "text-decoration-color: #450a0a;",
  },
  {
    tailwind: "decoration-orange-50",
    css: "text-decoration-color: #fff7ed;",
  },
  {
    tailwind: "decoration-orange-100",
    css: "text-decoration-color: #ffedd5;",
  },
  {
    tailwind: "decoration-orange-200",
    css: "text-decoration-color: #fed7aa;",
  },
  {
    tailwind: "decoration-orange-300",
    css: "text-decoration-color: #fdba74;",
  },
  {
    tailwind: "decoration-orange-400",
    css: "text-decoration-color: #fb923c;",
  },
  {
    tailwind: "decoration-orange-500",
    css: "text-decoration-color: #f97316;",
  },
  {
    tailwind: "decoration-orange-600",
    css: "text-decoration-color: #ea580c;",
  },
  {
    tailwind: "decoration-orange-700",
    css: "text-decoration-color: #c2410c;",
  },
  {
    tailwind: "decoration-orange-800",
    css: "text-decoration-color: #9a3412;",
  },
  {
    tailwind: "decoration-orange-900",
    css: "text-decoration-color: #7c2d12;",
  },
  {
    tailwind: "decoration-orange-950",
    css: "text-decoration-color: #431407;",
  },
  {
    tailwind: "decoration-amber-50",
    css: "text-decoration-color: #fffbeb;",
  },
  {
    tailwind: "decoration-amber-100",
    css: "text-decoration-color: #fef3c7;",
  },
  {
    tailwind: "decoration-amber-200",
    css: "text-decoration-color: #fde68a;",
  },
  {
    tailwind: "decoration-amber-300",
    css: "text-decoration-color: #fcd34d;",
  },
  {
    tailwind: "decoration-amber-400",
    css: "text-decoration-color: #fbbf24;",
  },
  {
    tailwind: "decoration-amber-500",
    css: "text-decoration-color: #f59e0b;",
  },
  {
    tailwind: "decoration-amber-600",
    css: "text-decoration-color: #d97706;",
  },
  {
    tailwind: "decoration-amber-700",
    css: "text-decoration-color: #b45309;",
  },
  {
    tailwind: "decoration-amber-800",
    css: "text-decoration-color: #92400e;",
  },
  {
    tailwind: "decoration-amber-900",
    css: "text-decoration-color: #78350f;",
  },
  {
    tailwind: "decoration-amber-950",
    css: "text-decoration-color: #451a03;",
  },
  {
    tailwind: "decoration-yellow-50",
    css: "text-decoration-color: #fefce8;",
  },
  {
    tailwind: "decoration-yellow-100",
    css: "text-decoration-color: #fef9c3;",
  },
  {
    tailwind: "decoration-yellow-200",
    css: "text-decoration-color: #fef08a;",
  },
  {
    tailwind: "decoration-yellow-300",
    css: "text-decoration-color: #fde047;",
  },
  {
    tailwind: "decoration-yellow-400",
    css: "text-decoration-color: #facc15;",
  },
  {
    tailwind: "decoration-yellow-500",
    css: "text-decoration-color: #eab308;",
  },
  {
    tailwind: "decoration-yellow-600",
    css: "text-decoration-color: #ca8a04;",
  },
  {
    tailwind: "decoration-yellow-700",
    css: "text-decoration-color: #a16207;",
  },
  {
    tailwind: "decoration-yellow-800",
    css: "text-decoration-color: #854d0e;",
  },
  {
    tailwind: "decoration-yellow-900",
    css: "text-decoration-color: #713f12;",
  },
  {
    tailwind: "decoration-yellow-950",
    css: "text-decoration-color: #422006;",
  },
  {
    tailwind: "decoration-lime-50",
    css: "text-decoration-color: #f7fee7;",
  },
  {
    tailwind: "decoration-lime-100",
    css: "text-decoration-color: #ecfccb;",
  },
  {
    tailwind: "decoration-lime-200",
    css: "text-decoration-color: #d9f99d;",
  },
  {
    tailwind: "decoration-lime-300",
    css: "text-decoration-color: #bef264;",
  },
  {
    tailwind: "decoration-lime-400",
    css: "text-decoration-color: #a3e635;",
  },
  {
    tailwind: "decoration-lime-500",
    css: "text-decoration-color: #84cc16;",
  },
  {
    tailwind: "decoration-lime-600",
    css: "text-decoration-color: #65a30d;",
  },
  {
    tailwind: "decoration-lime-700",
    css: "text-decoration-color: #4d7c0f;",
  },
  {
    tailwind: "decoration-lime-800",
    css: "text-decoration-color: #3f6212;",
  },
  {
    tailwind: "decoration-lime-900",
    css: "text-decoration-color: #365314;",
  },
  {
    tailwind: "decoration-lime-950",
    css: "text-decoration-color: #1a2e05;",
  },
  {
    tailwind: "decoration-green-50",
    css: "text-decoration-color: #f0fdf4;",
  },
  {
    tailwind: "decoration-green-100",
    css: "text-decoration-color: #dcfce7;",
  },
  {
    tailwind: "decoration-green-200",
    css: "text-decoration-color: #bbf7d0;",
  },
  {
    tailwind: "decoration-green-300",
    css: "text-decoration-color: #86efac;",
  },
  {
    tailwind: "decoration-green-400",
    css: "text-decoration-color: #4ade80;",
  },
  {
    tailwind: "decoration-green-500",
    css: "text-decoration-color: #22c55e;",
  },
  {
    tailwind: "decoration-green-600",
    css: "text-decoration-color: #16a34a;",
  },
  {
    tailwind: "decoration-green-700",
    css: "text-decoration-color: #15803d;",
  },
  {
    tailwind: "decoration-green-800",
    css: "text-decoration-color: #166534;",
  },
  {
    tailwind: "decoration-green-900",
    css: "text-decoration-color: #14532d;",
  },
  {
    tailwind: "decoration-green-950",
    css: "text-decoration-color: #052e16;",
  },
  {
    tailwind: "decoration-emerald-50",
    css: "text-decoration-color: #ecfdf5;",
  },
  {
    tailwind: "decoration-emerald-100",
    css: "text-decoration-color: #d1fae5;",
  },
  {
    tailwind: "decoration-emerald-200",
    css: "text-decoration-color: #a7f3d0;",
  },
  {
    tailwind: "decoration-emerald-300",
    css: "text-decoration-color: #6ee7b7;",
  },
  {
    tailwind: "decoration-emerald-400",
    css: "text-decoration-color: #34d399;",
  },
  {
    tailwind: "decoration-emerald-500",
    css: "text-decoration-color: #10b981;",
  },
  {
    tailwind: "decoration-emerald-600",
    css: "text-decoration-color: #059669;",
  },
  {
    tailwind: "decoration-emerald-700",
    css: "text-decoration-color: #047857;",
  },
  {
    tailwind: "decoration-emerald-800",
    css: "text-decoration-color: #065f46;",
  },
  {
    tailwind: "decoration-emerald-900",
    css: "text-decoration-color: #064e3b;",
  },
  {
    tailwind: "decoration-emerald-950",
    css: "text-decoration-color: #022c22;",
  },
  {
    tailwind: "decoration-teal-50",
    css: "text-decoration-color: #f0fdfa;",
  },
  {
    tailwind: "decoration-teal-100",
    css: "text-decoration-color: #ccfbf1;",
  },
  {
    tailwind: "decoration-teal-200",
    css: "text-decoration-color: #99f6e4;",
  },
  {
    tailwind: "decoration-teal-300",
    css: "text-decoration-color: #5eead4;",
  },
  {
    tailwind: "decoration-teal-400",
    css: "text-decoration-color: #2dd4bf;",
  },
  {
    tailwind: "decoration-teal-500",
    css: "text-decoration-color: #14b8a6;",
  },
  {
    tailwind: "decoration-teal-600",
    css: "text-decoration-color: #0d9488;",
  },
  {
    tailwind: "decoration-teal-700",
    css: "text-decoration-color: #0f766e;",
  },
  {
    tailwind: "decoration-teal-800",
    css: "text-decoration-color: #115e59;",
  },
  {
    tailwind: "decoration-teal-900",
    css: "text-decoration-color: #134e4a;",
  },
  {
    tailwind: "decoration-teal-950",
    css: "text-decoration-color: #042f2e;",
  },
  {
    tailwind: "decoration-cyan-50",
    css: "text-decoration-color: #ecfeff;",
  },
  {
    tailwind: "decoration-cyan-100",
    css: "text-decoration-color: #cffafe;",
  },
  {
    tailwind: "decoration-cyan-200",
    css: "text-decoration-color: #a5f3fc;",
  },
  {
    tailwind: "decoration-cyan-300",
    css: "text-decoration-color: #67e8f9;",
  },
  {
    tailwind: "decoration-cyan-400",
    css: "text-decoration-color: #22d3ee;",
  },
  {
    tailwind: "decoration-cyan-500",
    css: "text-decoration-color: #06b6d4;",
  },
  {
    tailwind: "decoration-cyan-600",
    css: "text-decoration-color: #0891b2;",
  },
  {
    tailwind: "decoration-cyan-700",
    css: "text-decoration-color: #0e7490;",
  },
  {
    tailwind: "decoration-cyan-800",
    css: "text-decoration-color: #155e75;",
  },
  {
    tailwind: "decoration-cyan-900",
    css: "text-decoration-color: #164e63;",
  },
  {
    tailwind: "decoration-cyan-950",
    css: "text-decoration-color: #083344;",
  },
  {
    tailwind: "decoration-sky-50",
    css: "text-decoration-color: #f0f9ff;",
  },
  {
    tailwind: "decoration-sky-100",
    css: "text-decoration-color: #e0f2fe;",
  },
  {
    tailwind: "decoration-sky-200",
    css: "text-decoration-color: #bae6fd;",
  },
  {
    tailwind: "decoration-sky-300",
    css: "text-decoration-color: #7dd3fc;",
  },
  {
    tailwind: "decoration-sky-400",
    css: "text-decoration-color: #38bdf8;",
  },
  {
    tailwind: "decoration-sky-500",
    css: "text-decoration-color: #0ea5e9;",
  },
  {
    tailwind: "decoration-sky-600",
    css: "text-decoration-color: #0284c7;",
  },
  {
    tailwind: "decoration-sky-700",
    css: "text-decoration-color: #0369a1;",
  },
  {
    tailwind: "decoration-sky-800",
    css: "text-decoration-color: #075985;",
  },
  {
    tailwind: "decoration-sky-900",
    css: "text-decoration-color: #0c4a6e;",
  },
  {
    tailwind: "decoration-sky-950",
    css: "text-decoration-color: #082f49;",
  },
  {
    tailwind: "decoration-blue-50",
    css: "text-decoration-color: #eff6ff;",
  },
  {
    tailwind: "decoration-blue-100",
    css: "text-decoration-color: #dbeafe;",
  },
  {
    tailwind: "decoration-blue-200",
    css: "text-decoration-color: #bfdbfe;",
  },
  {
    tailwind: "decoration-blue-300",
    css: "text-decoration-color: #93c5fd;",
  },
  {
    tailwind: "decoration-blue-400",
    css: "text-decoration-color: #60a5fa;",
  },
  {
    tailwind: "decoration-blue-500",
    css: "text-decoration-color: #3b82f6;",
  },
  {
    tailwind: "decoration-blue-600",
    css: "text-decoration-color: #2563eb;",
  },
  {
    tailwind: "decoration-blue-700",
    css: "text-decoration-color: #1d4ed8;",
  },
  {
    tailwind: "decoration-blue-800",
    css: "text-decoration-color: #1e40af;",
  },
  {
    tailwind: "decoration-blue-900",
    css: "text-decoration-color: #1e3a8a;",
  },
  {
    tailwind: "decoration-blue-950",
    css: "text-decoration-color: #172554;",
  },
  {
    tailwind: "decoration-indigo-50",
    css: "text-decoration-color: #eef2ff;",
  },
  {
    tailwind: "decoration-indigo-100",
    css: "text-decoration-color: #e0e7ff;",
  },
  {
    tailwind: "decoration-indigo-200",
    css: "text-decoration-color: #c7d2fe;",
  },
  {
    tailwind: "decoration-indigo-300",
    css: "text-decoration-color: #a5b4fc;",
  },
  {
    tailwind: "decoration-indigo-400",
    css: "text-decoration-color: #818cf8;",
  },
  {
    tailwind: "decoration-indigo-500",
    css: "text-decoration-color: #6366f1;",
  },
  {
    tailwind: "decoration-indigo-600",
    css: "text-decoration-color: #4f46e5;",
  },
  {
    tailwind: "decoration-indigo-700",
    css: "text-decoration-color: #4338ca;",
  },
  {
    tailwind: "decoration-indigo-800",
    css: "text-decoration-color: #3730a3;",
  },
  {
    tailwind: "decoration-indigo-900",
    css: "text-decoration-color: #312e81;",
  },
  {
    tailwind: "decoration-indigo-950",
    css: "text-decoration-color: #1e1b4b;",
  },
  {
    tailwind: "decoration-violet-50",
    css: "text-decoration-color: #f5f3ff;",
  },
  {
    tailwind: "decoration-violet-100",
    css: "text-decoration-color: #ede9fe;",
  },
  {
    tailwind: "decoration-violet-200",
    css: "text-decoration-color: #ddd6fe;",
  },
  {
    tailwind: "decoration-violet-300",
    css: "text-decoration-color: #c4b5fd;",
  },
  {
    tailwind: "decoration-violet-400",
    css: "text-decoration-color: #a78bfa;",
  },
  {
    tailwind: "decoration-violet-500",
    css: "text-decoration-color: #8b5cf6;",
  },
  {
    tailwind: "decoration-violet-600",
    css: "text-decoration-color: #7c3aed;",
  },
  {
    tailwind: "decoration-violet-700",
    css: "text-decoration-color: #6d28d9;",
  },
  {
    tailwind: "decoration-violet-800",
    css: "text-decoration-color: #5b21b6;",
  },
  {
    tailwind: "decoration-violet-900",
    css: "text-decoration-color: #4c1d95;",
  },
  {
    tailwind: "decoration-violet-950",
    css: "text-decoration-color: #2e1065;",
  },
  {
    tailwind: "decoration-purple-50",
    css: "text-decoration-color: #faf5ff;",
  },
  {
    tailwind: "decoration-purple-100",
    css: "text-decoration-color: #f3e8ff;",
  },
  {
    tailwind: "decoration-purple-200",
    css: "text-decoration-color: #e9d5ff;",
  },
  {
    tailwind: "decoration-purple-300",
    css: "text-decoration-color: #d8b4fe;",
  },
  {
    tailwind: "decoration-purple-400",
    css: "text-decoration-color: #c084fc;",
  },
  {
    tailwind: "decoration-purple-500",
    css: "text-decoration-color: #a855f7;",
  },
  {
    tailwind: "decoration-purple-600",
    css: "text-decoration-color: #9333ea;",
  },
  {
    tailwind: "decoration-purple-700",
    css: "text-decoration-color: #7e22ce;",
  },
  {
    tailwind: "decoration-purple-800",
    css: "text-decoration-color: #6b21a8;",
  },
  {
    tailwind: "decoration-purple-900",
    css: "text-decoration-color: #581c87;",
  },
  {
    tailwind: "decoration-purple-950",
    css: "text-decoration-color: #3b0764;",
  },
  {
    tailwind: "decoration-fuchsia-50",
    css: "text-decoration-color: #fdf4ff;",
  },
  {
    tailwind: "decoration-fuchsia-100",
    css: "text-decoration-color: #fae8ff;",
  },
  {
    tailwind: "decoration-fuchsia-200",
    css: "text-decoration-color: #f5d0fe;",
  },
  {
    tailwind: "decoration-fuchsia-300",
    css: "text-decoration-color: #f0abfc;",
  },
  {
    tailwind: "decoration-fuchsia-400",
    css: "text-decoration-color: #e879f9;",
  },
  {
    tailwind: "decoration-fuchsia-500",
    css: "text-decoration-color: #d946ef;",
  },
  {
    tailwind: "decoration-fuchsia-600",
    css: "text-decoration-color: #c026d3;",
  },
  {
    tailwind: "decoration-fuchsia-700",
    css: "text-decoration-color: #a21caf;",
  },
  {
    tailwind: "decoration-fuchsia-800",
    css: "text-decoration-color: #86198f;",
  },
  {
    tailwind: "decoration-fuchsia-900",
    css: "text-decoration-color: #701a75;",
  },
  {
    tailwind: "decoration-fuchsia-950",
    css: "text-decoration-color: #4a044e;",
  },
  {
    tailwind: "decoration-pink-50",
    css: "text-decoration-color: #fdf2f8;",
  },
  {
    tailwind: "decoration-pink-100",
    css: "text-decoration-color: #fce7f3;",
  },
  {
    tailwind: "decoration-pink-200",
    css: "text-decoration-color: #fbcfe8;",
  },
  {
    tailwind: "decoration-pink-300",
    css: "text-decoration-color: #f9a8d4;",
  },
  {
    tailwind: "decoration-pink-400",
    css: "text-decoration-color: #f472b6;",
  },
  {
    tailwind: "decoration-pink-500",
    css: "text-decoration-color: #ec4899;",
  },
  {
    tailwind: "decoration-pink-600",
    css: "text-decoration-color: #db2777;",
  },
  {
    tailwind: "decoration-pink-700",
    css: "text-decoration-color: #be185d;",
  },
  {
    tailwind: "decoration-pink-800",
    css: "text-decoration-color: #9d174d;",
  },
  {
    tailwind: "decoration-pink-900",
    css: "text-decoration-color: #831843;",
  },
  {
    tailwind: "decoration-pink-950",
    css: "text-decoration-color: #500724;",
  },
  {
    tailwind: "decoration-rose-50",
    css: "text-decoration-color: #fff1f2;",
  },
  {
    tailwind: "decoration-rose-100",
    css: "text-decoration-color: #ffe4e6;",
  },
  {
    tailwind: "decoration-rose-200",
    css: "text-decoration-color: #fecdd3;",
  },
  {
    tailwind: "decoration-rose-300",
    css: "text-decoration-color: #fda4af;",
  },
  {
    tailwind: "decoration-rose-400",
    css: "text-decoration-color: #fb7185;",
  },
  {
    tailwind: "decoration-rose-500",
    css: "text-decoration-color: #f43f5e;",
  },
  {
    tailwind: "decoration-rose-600",
    css: "text-decoration-color: #e11d48;",
  },
  {
    tailwind: "decoration-rose-700",
    css: "text-decoration-color: #be123c;",
  },
  {
    tailwind: "decoration-rose-800",
    css: "text-decoration-color: #9f1239;",
  },
  {
    tailwind: "decoration-rose-900",
    css: "text-decoration-color: #881337;",
  },
  {
    tailwind: "decoration-rose-950",
    css: "text-decoration-color: #4c0519;",
  },
  {
    tailwind: "decoration-solid",
    css: "text-decoration-style: solid;",
  },
  {
    tailwind: "decoration-double",
    css: "text-decoration-style: double;",
  },
  {
    tailwind: "decoration-dotted",
    css: "text-decoration-style: dotted;",
  },
  {
    tailwind: "decoration-dashed",
    css: "text-decoration-style: dashed;",
  },
  {
    tailwind: "decoration-wavy",
    css: "text-decoration-style: wavy;",
  },
  {
    tailwind: "decoration-auto",
    css: "text-decoration-thickness: auto;",
  },
  {
    tailwind: "decoration-from-font",
    css: "text-decoration-thickness: from-font;",
  },
  {
    tailwind: "decoration-0",
    css: "text-decoration-thickness: 0px;",
  },
  {
    tailwind: "decoration-1",
    css: "text-decoration-thickness: 1px;",
  },
  {
    tailwind: "decoration-2",
    css: "text-decoration-thickness: 2px;",
  },
  {
    tailwind: "decoration-4",
    css: "text-decoration-thickness: 4px;",
  },
  {
    tailwind: "decoration-8",
    css: "text-decoration-thickness: 8px;",
  },
  {
    tailwind: "underline-offset-auto",
    css: "text-underline-offset: auto;",
  },
  {
    tailwind: "underline-offset-0",
    css: "text-underline-offset: 0px;",
  },
  {
    tailwind: "underline-offset-1",
    css: "text-underline-offset: 1px;",
  },
  {
    tailwind: "underline-offset-2",
    css: "text-underline-offset: 2px;",
  },
  {
    tailwind: "underline-offset-4",
    css: "text-underline-offset: 4px;",
  },
  {
    tailwind: "underline-offset-8",
    css: "text-underline-offset: 8px;",
  },
  {
    tailwind: "uppercase",
    css: "text-transform: uppercase;",
  },
  {
    tailwind: "lowercase",
    css: "text-transform: lowercase;",
  },
  {
    tailwind: "capitalize",
    css: "text-transform: capitalize;",
  },
  {
    tailwind: "normal-case",
    css: "text-transform: none;",
  },
  {
    tailwind: "truncate",
    css: "overflow: hidden;\ntext-overflow: ellipsis;\nwhite-space: nowrap;",
  },
  {
    tailwind: "text-ellipsis",
    css: "text-overflow: ellipsis;",
  },
  {
    tailwind: "text-clip",
    css: "text-overflow: clip;",
  },
  {
    tailwind: "indent-0",
    css: "text-indent: 0px;",
  },
  {
    tailwind: "indent-px",
    css: "text-indent: 1px;",
  },
  {
    tailwind: "indent-0.5",
    css: "text-indent: 0.125rem; /* 2px */",
  },
  {
    tailwind: "indent-1",
    css: "text-indent: 0.25rem; /* 4px */",
  },
  {
    tailwind: "indent-1.5",
    css: "text-indent: 0.375rem; /* 6px */",
  },
  {
    tailwind: "indent-2",
    css: "text-indent: 0.5rem; /* 8px */",
  },
  {
    tailwind: "indent-2.5",
    css: "text-indent: 0.625rem; /* 10px */",
  },
  {
    tailwind: "indent-3",
    css: "text-indent: 0.75rem; /* 12px */",
  },
  {
    tailwind: "indent-3.5",
    css: "text-indent: 0.875rem; /* 14px */",
  },
  {
    tailwind: "indent-4",
    css: "text-indent: 1rem; /* 16px */",
  },
  {
    tailwind: "indent-5",
    css: "text-indent: 1.25rem; /* 20px */",
  },
  {
    tailwind: "indent-6",
    css: "text-indent: 1.5rem; /* 24px */",
  },
  {
    tailwind: "indent-7",
    css: "text-indent: 1.75rem; /* 28px */",
  },
  {
    tailwind: "indent-8",
    css: "text-indent: 2rem; /* 32px */",
  },
  {
    tailwind: "indent-9",
    css: "text-indent: 2.25rem; /* 36px */",
  },
  {
    tailwind: "indent-10",
    css: "text-indent: 2.5rem; /* 40px */",
  },
  {
    tailwind: "indent-11",
    css: "text-indent: 2.75rem; /* 44px */",
  },
  {
    tailwind: "indent-12",
    css: "text-indent: 3rem; /* 48px */",
  },
  {
    tailwind: "indent-14",
    css: "text-indent: 3.5rem; /* 56px */",
  },
  {
    tailwind: "indent-16",
    css: "text-indent: 4rem; /* 64px */",
  },
  {
    tailwind: "indent-20",
    css: "text-indent: 5rem; /* 80px */",
  },
  {
    tailwind: "indent-24",
    css: "text-indent: 6rem; /* 96px */",
  },
  {
    tailwind: "indent-28",
    css: "text-indent: 7rem; /* 112px */",
  },
  {
    tailwind: "indent-32",
    css: "text-indent: 8rem; /* 128px */",
  },
  {
    tailwind: "indent-36",
    css: "text-indent: 9rem; /* 144px */",
  },
  {
    tailwind: "indent-40",
    css: "text-indent: 10rem; /* 160px */",
  },
  {
    tailwind: "indent-44",
    css: "text-indent: 11rem; /* 176px */",
  },
  {
    tailwind: "indent-48",
    css: "text-indent: 12rem; /* 192px */",
  },
  {
    tailwind: "indent-52",
    css: "text-indent: 13rem; /* 208px */",
  },
  {
    tailwind: "indent-56",
    css: "text-indent: 14rem; /* 224px */",
  },
  {
    tailwind: "indent-60",
    css: "text-indent: 15rem; /* 240px */",
  },
  {
    tailwind: "indent-64",
    css: "text-indent: 16rem; /* 256px */",
  },
  {
    tailwind: "indent-72",
    css: "text-indent: 18rem; /* 288px */",
  },
  {
    tailwind: "indent-80",
    css: "text-indent: 20rem; /* 320px */",
  },
  {
    tailwind: "indent-96",
    css: "text-indent: 24rem; /* 384px */",
  },
  {
    tailwind: "align-baseline",
    css: "vertical-align: baseline;",
  },
  {
    tailwind: "align-top",
    css: "vertical-align: top;",
  },
  {
    tailwind: "align-middle",
    css: "vertical-align: middle;",
  },
  {
    tailwind: "align-bottom",
    css: "vertical-align: bottom;",
  },
  {
    tailwind: "align-text-top",
    css: "vertical-align: text-top;",
  },
  {
    tailwind: "align-text-bottom",
    css: "vertical-align: text-bottom;",
  },
  {
    tailwind: "align-sub",
    css: "vertical-align: sub;",
  },
  {
    tailwind: "align-super",
    css: "vertical-align: super;",
  },
  {
    tailwind: "whitespace-normal",
    css: "white-space: normal;",
  },
  {
    tailwind: "whitespace-nowrap",
    css: "white-space: nowrap;",
  },
  {
    tailwind: "whitespace-pre",
    css: "white-space: pre;",
  },
  {
    tailwind: "whitespace-pre-line",
    css: "white-space: pre-line;",
  },
  {
    tailwind: "whitespace-pre-wrap",
    css: "white-space: pre-wrap;",
  },
  {
    tailwind: "whitespace-break-spaces",
    css: "white-space: break-spaces;",
  },
  {
    tailwind: "break-normal",
    css: "overflow-wrap: normal;\nword-break: normal;",
  },
  {
    tailwind: "break-words",
    css: "overflow-wrap: break-word;",
  },
  {
    tailwind: "break-all",
    css: "word-break: break-all;",
  },
  {
    tailwind: "break-keep",
    css: "word-break: keep-all;",
  },
  {
    tailwind: "hyphens-none",
    css: "hyphens: none;",
  },
  {
    tailwind: "hyphens-manual",
    css: "hyphens: manual;",
  },
  {
    tailwind: "hyphens-auto",
    css: "hyphens: auto;",
  },
  {
    tailwind: "content-none",
    css: "content: none;",
  },
  {
    tailwind: "bg-fixed",
    css: "background-attachment: fixed;",
  },
  {
    tailwind: "bg-local",
    css: "background-attachment: local;",
  },
  {
    tailwind: "bg-scroll",
    css: "background-attachment: scroll;",
  },
  {
    tailwind: "bg-clip-border",
    css: "background-clip: border-box;",
  },
  {
    tailwind: "bg-clip-padding",
    css: "background-clip: padding-box;",
  },
  {
    tailwind: "bg-clip-content",
    css: "background-clip: content-box;",
  },
  {
    tailwind: "bg-clip-text",
    css: "background-clip: text;",
  },
  {
    tailwind: "bg-inherit",
    css: "background-color: inherit;",
  },
  {
    tailwind: "bg-current",
    css: "background-color: currentColor;",
  },
  {
    tailwind: "bg-transparent",
    css: "background-color: transparent;",
  },
  {
    tailwind: "bg-black",
    css: "background-color: rgb(0 0 0);",
  },
  {
    tailwind: "bg-white",
    css: "background-color: rgb(255 255 255);",
  },
  {
    tailwind: "bg-slate-50",
    css: "background-color: rgb(248 250 252);",
  },
  {
    tailwind: "bg-slate-100",
    css: "background-color: rgb(241 245 249);",
  },
  {
    tailwind: "bg-slate-200",
    css: "background-color: rgb(226 232 240);",
  },
  {
    tailwind: "bg-slate-300",
    css: "background-color: rgb(203 213 225);",
  },
  {
    tailwind: "bg-slate-400",
    css: "background-color: rgb(148 163 184);",
  },
  {
    tailwind: "bg-slate-500",
    css: "background-color: rgb(100 116 139);",
  },
  {
    tailwind: "bg-slate-600",
    css: "background-color: rgb(71 85 105);",
  },
  {
    tailwind: "bg-slate-700",
    css: "background-color: rgb(51 65 85);",
  },
  {
    tailwind: "bg-slate-800",
    css: "background-color: rgb(30 41 59);",
  },
  {
    tailwind: "bg-slate-900",
    css: "background-color: rgb(15 23 42);",
  },
  {
    tailwind: "bg-slate-950",
    css: "background-color: rgb(2 6 23);",
  },
  {
    tailwind: "bg-gray-50",
    css: "background-color: rgb(249 250 251);",
  },
  {
    tailwind: "bg-gray-100",
    css: "background-color: rgb(243 244 246);",
  },
  {
    tailwind: "bg-gray-200",
    css: "background-color: rgb(229 231 235);",
  },
  {
    tailwind: "bg-gray-300",
    css: "background-color: rgb(209 213 219);",
  },
  {
    tailwind: "bg-gray-400",
    css: "background-color: rgb(156 163 175);",
  },
  {
    tailwind: "bg-gray-500",
    css: "background-color: rgb(107 114 128);",
  },
  {
    tailwind: "bg-gray-600",
    css: "background-color: rgb(75 85 99);",
  },
  {
    tailwind: "bg-gray-700",
    css: "background-color: rgb(55 65 81);",
  },
  {
    tailwind: "bg-gray-800",
    css: "background-color: rgb(31 41 55);",
  },
  {
    tailwind: "bg-gray-900",
    css: "background-color: rgb(17 24 39);",
  },
  {
    tailwind: "bg-gray-950",
    css: "background-color: rgb(3 7 18);",
  },
  {
    tailwind: "bg-zinc-50",
    css: "background-color: rgb(250 250 250);",
  },
  {
    tailwind: "bg-zinc-100",
    css: "background-color: rgb(244 244 245);",
  },
  {
    tailwind: "bg-zinc-200",
    css: "background-color: rgb(228 228 231);",
  },
  {
    tailwind: "bg-zinc-300",
    css: "background-color: rgb(212 212 216);",
  },
  {
    tailwind: "bg-zinc-400",
    css: "background-color: rgb(161 161 170);",
  },
  {
    tailwind: "bg-zinc-500",
    css: "background-color: rgb(113 113 122);",
  },
  {
    tailwind: "bg-zinc-600",
    css: "background-color: rgb(82 82 91);",
  },
  {
    tailwind: "bg-zinc-700",
    css: "background-color: rgb(63 63 70);",
  },
  {
    tailwind: "bg-zinc-800",
    css: "background-color: rgb(39 39 42);",
  },
  {
    tailwind: "bg-zinc-900",
    css: "background-color: rgb(24 24 27);",
  },
  {
    tailwind: "bg-zinc-950",
    css: "background-color: rgb(9 9 11);",
  },
  {
    tailwind: "bg-neutral-50",
    css: "background-color: rgb(250 250 250);",
  },
  {
    tailwind: "bg-neutral-100",
    css: "background-color: rgb(245 245 245);",
  },
  {
    tailwind: "bg-neutral-200",
    css: "background-color: rgb(229 229 229);",
  },
  {
    tailwind: "bg-neutral-300",
    css: "background-color: rgb(212 212 212);",
  },
  {
    tailwind: "bg-neutral-400",
    css: "background-color: rgb(163 163 163);",
  },
  {
    tailwind: "bg-neutral-500",
    css: "background-color: rgb(115 115 115);",
  },
  {
    tailwind: "bg-neutral-600",
    css: "background-color: rgb(82 82 82);",
  },
  {
    tailwind: "bg-neutral-700",
    css: "background-color: rgb(64 64 64);",
  },
  {
    tailwind: "bg-neutral-800",
    css: "background-color: rgb(38 38 38);",
  },
  {
    tailwind: "bg-neutral-900",
    css: "background-color: rgb(23 23 23);",
  },
  {
    tailwind: "bg-neutral-950",
    css: "background-color: rgb(10 10 10);",
  },
  {
    tailwind: "bg-stone-50",
    css: "background-color: rgb(250 250 249);",
  },
  {
    tailwind: "bg-stone-100",
    css: "background-color: rgb(245 245 244);",
  },
  {
    tailwind: "bg-stone-200",
    css: "background-color: rgb(231 229 228);",
  },
  {
    tailwind: "bg-stone-300",
    css: "background-color: rgb(214 211 209);",
  },
  {
    tailwind: "bg-stone-400",
    css: "background-color: rgb(168 162 158);",
  },
  {
    tailwind: "bg-stone-500",
    css: "background-color: rgb(120 113 108);",
  },
  {
    tailwind: "bg-stone-600",
    css: "background-color: rgb(87 83 78);",
  },
  {
    tailwind: "bg-stone-700",
    css: "background-color: rgb(68 64 60);",
  },
  {
    tailwind: "bg-stone-800",
    css: "background-color: rgb(41 37 36);",
  },
  {
    tailwind: "bg-stone-900",
    css: "background-color: rgb(28 25 23);",
  },
  {
    tailwind: "bg-stone-950",
    css: "background-color: rgb(12 10 9);",
  },
  {
    tailwind: "bg-red-50",
    css: "background-color: rgb(254 242 242);",
  },
  {
    tailwind: "bg-red-100",
    css: "background-color: rgb(254 226 226);",
  },
  {
    tailwind: "bg-red-200",
    css: "background-color: rgb(254 202 202);",
  },
  {
    tailwind: "bg-red-300",
    css: "background-color: rgb(252 165 165);",
  },
  {
    tailwind: "bg-red-400",
    css: "background-color: rgb(248 113 113);",
  },
  {
    tailwind: "bg-red-500",
    css: "background-color: rgb(239 68 68);",
  },
  {
    tailwind: "bg-red-600",
    css: "background-color: rgb(220 38 38);",
  },
  {
    tailwind: "bg-red-700",
    css: "background-color: rgb(185 28 28);",
  },
  {
    tailwind: "bg-red-800",
    css: "background-color: rgb(153 27 27);",
  },
  {
    tailwind: "bg-red-900",
    css: "background-color: rgb(127 29 29);",
  },
  {
    tailwind: "bg-red-950",
    css: "background-color: rgb(69 10 10);",
  },
  {
    tailwind: "bg-orange-50",
    css: "background-color: rgb(255 247 237);",
  },
  {
    tailwind: "bg-orange-100",
    css: "background-color: rgb(255 237 213);",
  },
  {
    tailwind: "bg-orange-200",
    css: "background-color: rgb(254 215 170);",
  },
  {
    tailwind: "bg-orange-300",
    css: "background-color: rgb(253 186 116);",
  },
  {
    tailwind: "bg-orange-400",
    css: "background-color: rgb(251 146 60);",
  },
  {
    tailwind: "bg-orange-500",
    css: "background-color: rgb(249 115 22);",
  },
  {
    tailwind: "bg-orange-600",
    css: "background-color: rgb(234 88 12);",
  },
  {
    tailwind: "bg-orange-700",
    css: "background-color: rgb(194 65 12);",
  },
  {
    tailwind: "bg-orange-800",
    css: "background-color: rgb(154 52 18);",
  },
  {
    tailwind: "bg-orange-900",
    css: "background-color: rgb(124 45 18);",
  },
  {
    tailwind: "bg-orange-950",
    css: "background-color: rgb(67 20 7);",
  },
  {
    tailwind: "bg-amber-50",
    css: "background-color: rgb(255 251 235);",
  },
  {
    tailwind: "bg-amber-100",
    css: "background-color: rgb(254 243 199);",
  },
  {
    tailwind: "bg-amber-200",
    css: "background-color: rgb(253 230 138);",
  },
  {
    tailwind: "bg-amber-300",
    css: "background-color: rgb(252 211 77);",
  },
  {
    tailwind: "bg-amber-400",
    css: "background-color: rgb(251 191 36);",
  },
  {
    tailwind: "bg-amber-500",
    css: "background-color: rgb(245 158 11);",
  },
  {
    tailwind: "bg-amber-600",
    css: "background-color: rgb(217 119 6);",
  },
  {
    tailwind: "bg-amber-700",
    css: "background-color: rgb(180 83 9);",
  },
  {
    tailwind: "bg-amber-800",
    css: "background-color: rgb(146 64 14);",
  },
  {
    tailwind: "bg-amber-900",
    css: "background-color: rgb(120 53 15);",
  },
  {
    tailwind: "bg-amber-950",
    css: "background-color: rgb(69 26 3);",
  },
  {
    tailwind: "bg-yellow-50",
    css: "background-color: rgb(254 252 232);",
  },
  {
    tailwind: "bg-yellow-100",
    css: "background-color: rgb(254 249 195);",
  },
  {
    tailwind: "bg-yellow-200",
    css: "background-color: rgb(254 240 138);",
  },
  {
    tailwind: "bg-yellow-300",
    css: "background-color: rgb(253 224 71);",
  },
  {
    tailwind: "bg-yellow-400",
    css: "background-color: rgb(250 204 21);",
  },
  {
    tailwind: "bg-yellow-500",
    css: "background-color: rgb(234 179 8);",
  },
  {
    tailwind: "bg-yellow-600",
    css: "background-color: rgb(202 138 4);",
  },
  {
    tailwind: "bg-yellow-700",
    css: "background-color: rgb(161 98 7);",
  },
  {
    tailwind: "bg-yellow-800",
    css: "background-color: rgb(133 77 14);",
  },
  {
    tailwind: "bg-yellow-900",
    css: "background-color: rgb(113 63 18);",
  },
  {
    tailwind: "bg-yellow-950",
    css: "background-color: rgb(66 32 6);",
  },
  {
    tailwind: "bg-lime-50",
    css: "background-color: rgb(247 254 231);",
  },
  {
    tailwind: "bg-lime-100",
    css: "background-color: rgb(236 252 203);",
  },
  {
    tailwind: "bg-lime-200",
    css: "background-color: rgb(217 249 157);",
  },
  {
    tailwind: "bg-lime-300",
    css: "background-color: rgb(190 242 100);",
  },
  {
    tailwind: "bg-lime-400",
    css: "background-color: rgb(163 230 53);",
  },
  {
    tailwind: "bg-lime-500",
    css: "background-color: rgb(132 204 22);",
  },
  {
    tailwind: "bg-lime-600",
    css: "background-color: rgb(101 163 13);",
  },
  {
    tailwind: "bg-lime-700",
    css: "background-color: rgb(77 124 15);",
  },
  {
    tailwind: "bg-lime-800",
    css: "background-color: rgb(63 98 18);",
  },
  {
    tailwind: "bg-lime-900",
    css: "background-color: rgb(54 83 20);",
  },
  {
    tailwind: "bg-lime-950",
    css: "background-color: rgb(26 46 5);",
  },
  {
    tailwind: "bg-green-50",
    css: "background-color: rgb(240 253 244);",
  },
  {
    tailwind: "bg-green-100",
    css: "background-color: rgb(220 252 231);",
  },
  {
    tailwind: "bg-green-200",
    css: "background-color: rgb(187 247 208);",
  },
  {
    tailwind: "bg-green-300",
    css: "background-color: rgb(134 239 172);",
  },
  {
    tailwind: "bg-green-400",
    css: "background-color: rgb(74 222 128);",
  },
  {
    tailwind: "bg-green-500",
    css: "background-color: rgb(34 197 94);",
  },
  {
    tailwind: "bg-green-600",
    css: "background-color: rgb(22 163 74);",
  },
  {
    tailwind: "bg-green-700",
    css: "background-color: rgb(21 128 61);",
  },
  {
    tailwind: "bg-green-800",
    css: "background-color: rgb(22 101 52);",
  },
  {
    tailwind: "bg-green-900",
    css: "background-color: rgb(20 83 45);",
  },
  {
    tailwind: "bg-green-950",
    css: "background-color: rgb(5 46 22);",
  },
  {
    tailwind: "bg-emerald-50",
    css: "background-color: rgb(236 253 245);",
  },
  {
    tailwind: "bg-emerald-100",
    css: "background-color: rgb(209 250 229);",
  },
  {
    tailwind: "bg-emerald-200",
    css: "background-color: rgb(167 243 208);",
  },
  {
    tailwind: "bg-emerald-300",
    css: "background-color: rgb(110 231 183);",
  },
  {
    tailwind: "bg-emerald-400",
    css: "background-color: rgb(52 211 153);",
  },
  {
    tailwind: "bg-emerald-500",
    css: "background-color: rgb(16 185 129);",
  },
  {
    tailwind: "bg-emerald-600",
    css: "background-color: rgb(5 150 105);",
  },
  {
    tailwind: "bg-emerald-700",
    css: "background-color: rgb(4 120 87);",
  },
  {
    tailwind: "bg-emerald-800",
    css: "background-color: rgb(6 95 70);",
  },
  {
    tailwind: "bg-emerald-900",
    css: "background-color: rgb(6 78 59);",
  },
  {
    tailwind: "bg-emerald-950",
    css: "background-color: rgb(2 44 34);",
  },
  {
    tailwind: "bg-teal-50",
    css: "background-color: rgb(240 253 250);",
  },
  {
    tailwind: "bg-teal-100",
    css: "background-color: rgb(204 251 241);",
  },
  {
    tailwind: "bg-teal-200",
    css: "background-color: rgb(153 246 228);",
  },
  {
    tailwind: "bg-teal-300",
    css: "background-color: rgb(94 234 212);",
  },
  {
    tailwind: "bg-teal-400",
    css: "background-color: rgb(45 212 191);",
  },
  {
    tailwind: "bg-teal-500",
    css: "background-color: rgb(20 184 166);",
  },
  {
    tailwind: "bg-teal-600",
    css: "background-color: rgb(13 148 136);",
  },
  {
    tailwind: "bg-teal-700",
    css: "background-color: rgb(15 118 110);",
  },
  {
    tailwind: "bg-teal-800",
    css: "background-color: rgb(17 94 89);",
  },
  {
    tailwind: "bg-teal-900",
    css: "background-color: rgb(19 78 74);",
  },
  {
    tailwind: "bg-teal-950",
    css: "background-color: rgb(4 47 46);",
  },
  {
    tailwind: "bg-cyan-50",
    css: "background-color: rgb(236 254 255);",
  },
  {
    tailwind: "bg-cyan-100",
    css: "background-color: rgb(207 250 254);",
  },
  {
    tailwind: "bg-cyan-200",
    css: "background-color: rgb(165 243 252);",
  },
  {
    tailwind: "bg-cyan-300",
    css: "background-color: rgb(103 232 249);",
  },
  {
    tailwind: "bg-cyan-400",
    css: "background-color: rgb(34 211 238);",
  },
  {
    tailwind: "bg-cyan-500",
    css: "background-color: rgb(6 182 212);",
  },
  {
    tailwind: "bg-cyan-600",
    css: "background-color: rgb(8 145 178);",
  },
  {
    tailwind: "bg-cyan-700",
    css: "background-color: rgb(14 116 144);",
  },
  {
    tailwind: "bg-cyan-800",
    css: "background-color: rgb(21 94 117);",
  },
  {
    tailwind: "bg-cyan-900",
    css: "background-color: rgb(22 78 99);",
  },
  {
    tailwind: "bg-cyan-950",
    css: "background-color: rgb(8 51 68);",
  },
  {
    tailwind: "bg-sky-50",
    css: "background-color: rgb(240 249 255);",
  },
  {
    tailwind: "bg-sky-100",
    css: "background-color: rgb(224 242 254);",
  },
  {
    tailwind: "bg-sky-200",
    css: "background-color: rgb(186 230 253);",
  },
  {
    tailwind: "bg-sky-300",
    css: "background-color: rgb(125 211 252);",
  },
  {
    tailwind: "bg-sky-400",
    css: "background-color: rgb(56 189 248);",
  },
  {
    tailwind: "bg-sky-500",
    css: "background-color: rgb(14 165 233);",
  },
  {
    tailwind: "bg-sky-600",
    css: "background-color: rgb(2 132 199);",
  },
  {
    tailwind: "bg-sky-700",
    css: "background-color: rgb(3 105 161);",
  },
  {
    tailwind: "bg-sky-800",
    css: "background-color: rgb(7 89 133);",
  },
  {
    tailwind: "bg-sky-900",
    css: "background-color: rgb(12 74 110);",
  },
  {
    tailwind: "bg-sky-950",
    css: "background-color: rgb(8 47 73);",
  },
  {
    tailwind: "bg-blue-50",
    css: "background-color: rgb(239 246 255);",
  },
  {
    tailwind: "bg-blue-100",
    css: "background-color: rgb(219 234 254);",
  },
  {
    tailwind: "bg-blue-200",
    css: "background-color: rgb(191 219 254);",
  },
  {
    tailwind: "bg-blue-300",
    css: "background-color: rgb(147 197 253);",
  },
  {
    tailwind: "bg-blue-400",
    css: "background-color: rgb(96 165 250);",
  },
  {
    tailwind: "bg-blue-500",
    css: "background-color: rgb(59 130 246);",
  },
  {
    tailwind: "bg-blue-600",
    css: "background-color: rgb(37 99 235);",
  },
  {
    tailwind: "bg-blue-700",
    css: "background-color: rgb(29 78 216);",
  },
  {
    tailwind: "bg-blue-800",
    css: "background-color: rgb(30 64 175);",
  },
  {
    tailwind: "bg-blue-900",
    css: "background-color: rgb(30 58 138);",
  },
  {
    tailwind: "bg-blue-950",
    css: "background-color: rgb(23 37 84);",
  },
  {
    tailwind: "bg-indigo-50",
    css: "background-color: rgb(238 242 255);",
  },
  {
    tailwind: "bg-indigo-100",
    css: "background-color: rgb(224 231 255);",
  },
  {
    tailwind: "bg-indigo-200",
    css: "background-color: rgb(199 210 254);",
  },
  {
    tailwind: "bg-indigo-300",
    css: "background-color: rgb(165 180 252);",
  },
  {
    tailwind: "bg-indigo-400",
    css: "background-color: rgb(129 140 248);",
  },
  {
    tailwind: "bg-indigo-500",
    css: "background-color: rgb(99 102 241);",
  },
  {
    tailwind: "bg-indigo-600",
    css: "background-color: rgb(79 70 229);",
  },
  {
    tailwind: "bg-indigo-700",
    css: "background-color: rgb(67 56 202);",
  },
  {
    tailwind: "bg-indigo-800",
    css: "background-color: rgb(55 48 163);",
  },
  {
    tailwind: "bg-indigo-900",
    css: "background-color: rgb(49 46 129);",
  },
  {
    tailwind: "bg-indigo-950",
    css: "background-color: rgb(30 27 75);",
  },
  {
    tailwind: "bg-violet-50",
    css: "background-color: rgb(245 243 255);",
  },
  {
    tailwind: "bg-violet-100",
    css: "background-color: rgb(237 233 254);",
  },
  {
    tailwind: "bg-violet-200",
    css: "background-color: rgb(221 214 254);",
  },
  {
    tailwind: "bg-violet-300",
    css: "background-color: rgb(196 181 253);",
  },
  {
    tailwind: "bg-violet-400",
    css: "background-color: rgb(167 139 250);",
  },
  {
    tailwind: "bg-violet-500",
    css: "background-color: rgb(139 92 246);",
  },
  {
    tailwind: "bg-violet-600",
    css: "background-color: rgb(124 58 237);",
  },
  {
    tailwind: "bg-violet-700",
    css: "background-color: rgb(109 40 217);",
  },
  {
    tailwind: "bg-violet-800",
    css: "background-color: rgb(91 33 182);",
  },
  {
    tailwind: "bg-violet-900",
    css: "background-color: rgb(76 29 149);",
  },
  {
    tailwind: "bg-violet-950",
    css: "background-color: rgb(46 16 101);",
  },
  {
    tailwind: "bg-purple-50",
    css: "background-color: rgb(250 245 255);",
  },
  {
    tailwind: "bg-purple-100",
    css: "background-color: rgb(243 232 255);",
  },
  {
    tailwind: "bg-purple-200",
    css: "background-color: rgb(233 213 255);",
  },
  {
    tailwind: "bg-purple-300",
    css: "background-color: rgb(216 180 254);",
  },
  {
    tailwind: "bg-purple-400",
    css: "background-color: rgb(192 132 252);",
  },
  {
    tailwind: "bg-purple-500",
    css: "background-color: rgb(168 85 247);",
  },
  {
    tailwind: "bg-purple-600",
    css: "background-color: rgb(147 51 234);",
  },
  {
    tailwind: "bg-purple-700",
    css: "background-color: rgb(126 34 206);",
  },
  {
    tailwind: "bg-purple-800",
    css: "background-color: rgb(107 33 168);",
  },
  {
    tailwind: "bg-purple-900",
    css: "background-color: rgb(88 28 135);",
  },
  {
    tailwind: "bg-purple-950",
    css: "background-color: rgb(59 7 100);",
  },
  {
    tailwind: "bg-fuchsia-50",
    css: "background-color: rgb(253 244 255);",
  },
  {
    tailwind: "bg-fuchsia-100",
    css: "background-color: rgb(250 232 255);",
  },
  {
    tailwind: "bg-fuchsia-200",
    css: "background-color: rgb(245 208 254);",
  },
  {
    tailwind: "bg-fuchsia-300",
    css: "background-color: rgb(240 171 252);",
  },
  {
    tailwind: "bg-fuchsia-400",
    css: "background-color: rgb(232 121 249);",
  },
  {
    tailwind: "bg-fuchsia-500",
    css: "background-color: rgb(217 70 239);",
  },
  {
    tailwind: "bg-fuchsia-600",
    css: "background-color: rgb(192 38 211);",
  },
  {
    tailwind: "bg-fuchsia-700",
    css: "background-color: rgb(162 28 175);",
  },
  {
    tailwind: "bg-fuchsia-800",
    css: "background-color: rgb(134 25 143);",
  },
  {
    tailwind: "bg-fuchsia-900",
    css: "background-color: rgb(112 26 117);",
  },
  {
    tailwind: "bg-fuchsia-950",
    css: "background-color: rgb(74 4 78);",
  },
  {
    tailwind: "bg-pink-50",
    css: "background-color: rgb(253 242 248);",
  },
  {
    tailwind: "bg-pink-100",
    css: "background-color: rgb(252 231 243);",
  },
  {
    tailwind: "bg-pink-200",
    css: "background-color: rgb(251 207 232);",
  },
  {
    tailwind: "bg-pink-300",
    css: "background-color: rgb(249 168 212);",
  },
  {
    tailwind: "bg-pink-400",
    css: "background-color: rgb(244 114 182);",
  },
  {
    tailwind: "bg-pink-500",
    css: "background-color: rgb(236 72 153);",
  },
  {
    tailwind: "bg-pink-600",
    css: "background-color: rgb(219 39 119);",
  },
  {
    tailwind: "bg-pink-700",
    css: "background-color: rgb(190 24 93);",
  },
  {
    tailwind: "bg-pink-800",
    css: "background-color: rgb(157 23 77);",
  },
  {
    tailwind: "bg-pink-900",
    css: "background-color: rgb(131 24 67);",
  },
  {
    tailwind: "bg-pink-950",
    css: "background-color: rgb(80 7 36);",
  },
  {
    tailwind: "bg-rose-50",
    css: "background-color: rgb(255 241 242);",
  },
  {
    tailwind: "bg-rose-100",
    css: "background-color: rgb(255 228 230);",
  },
  {
    tailwind: "bg-rose-200",
    css: "background-color: rgb(254 205 211);",
  },
  {
    tailwind: "bg-rose-300",
    css: "background-color: rgb(253 164 175);",
  },
  {
    tailwind: "bg-rose-400",
    css: "background-color: rgb(251 113 133);",
  },
  {
    tailwind: "bg-rose-500",
    css: "background-color: rgb(244 63 94);",
  },
  {
    tailwind: "bg-rose-600",
    css: "background-color: rgb(225 29 72);",
  },
  {
    tailwind: "bg-rose-700",
    css: "background-color: rgb(190 18 60);",
  },
  {
    tailwind: "bg-rose-800",
    css: "background-color: rgb(159 18 57);",
  },
  {
    tailwind: "bg-rose-900",
    css: "background-color: rgb(136 19 55);",
  },
  {
    tailwind: "bg-rose-950",
    css: "background-color: rgb(76 5 25);",
  },
  {
    tailwind: "bg-origin-border",
    css: "background-origin: border-box;",
  },
  {
    tailwind: "bg-origin-padding",
    css: "background-origin: padding-box;",
  },
  {
    tailwind: "bg-origin-content",
    css: "background-origin: content-box;",
  },
  {
    tailwind: "bg-bottom",
    css: "background-position: bottom;",
  },
  {
    tailwind: "bg-center",
    css: "background-position: center;",
  },
  {
    tailwind: "bg-left",
    css: "background-position: left;",
  },
  {
    tailwind: "bg-left-bottom",
    css: "background-position: left bottom;",
  },
  {
    tailwind: "bg-left-top",
    css: "background-position: left top;",
  },
  {
    tailwind: "bg-right",
    css: "background-position: right;",
  },
  {
    tailwind: "bg-right-bottom",
    css: "background-position: right bottom;",
  },
  {
    tailwind: "bg-right-top",
    css: "background-position: right top;",
  },
  {
    tailwind: "bg-top",
    css: "background-position: top;",
  },
  {
    tailwind: "bg-repeat",
    css: "background-repeat: repeat;",
  },
  {
    tailwind: "bg-no-repeat",
    css: "background-repeat: no-repeat;",
  },
  {
    tailwind: "bg-repeat-x",
    css: "background-repeat: repeat-x;",
  },
  {
    tailwind: "bg-repeat-y",
    css: "background-repeat: repeat-y;",
  },
  {
    tailwind: "bg-repeat-round",
    css: "background-repeat: round;",
  },
  {
    tailwind: "bg-repeat-space",
    css: "background-repeat: space;",
  },
  {
    tailwind: "bg-auto",
    css: "background-size: auto;",
  },
  {
    tailwind: "bg-cover",
    css: "background-size: cover;",
  },
  {
    tailwind: "bg-contain",
    css: "background-size: contain;",
  },
  {
    tailwind: "bg-none",
    css: "background-image: none;",
  },
  {
    tailwind: "bg-gradient-to-t",
    css: "background-image: linear-gradient(to top, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-tr",
    css: "background-image: linear-gradient(to top right, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-r",
    css: "background-image: linear-gradient(to right, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-br",
    css: "background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-b",
    css: "background-image: linear-gradient(to bottom, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-bl",
    css: "background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-l",
    css: "background-image: linear-gradient(to left, var(--tw-gradient-stops));",
  },
  {
    tailwind: "bg-gradient-to-tl",
    css: "background-image: linear-gradient(to top left, var(--tw-gradient-stops));",
  },
  {
    tailwind: "from-inherit",
    css: "--tw-gradient-from: inherit var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-current",
    css: "--tw-gradient-from: currentColor var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-transparent",
    css: "--tw-gradient-from: transparent var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-black",
    css: "--tw-gradient-from: #000 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-white",
    css: "--tw-gradient-from: #fff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-50",
    css: "--tw-gradient-from: #f8fafc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-100",
    css: "--tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-200",
    css: "--tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-300",
    css: "--tw-gradient-from: #cbd5e1 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(203 213 225 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-400",
    css: "--tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(148 163 184 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-500",
    css: "--tw-gradient-from: #64748b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-600",
    css: "--tw-gradient-from: #475569 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(71 85 105 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-700",
    css: "--tw-gradient-from: #334155 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(51 65 85 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-800",
    css: "--tw-gradient-from: #1e293b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(30 41 59 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-900",
    css: "--tw-gradient-from: #0f172a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-slate-950",
    css: "--tw-gradient-from: #020617 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-50",
    css: "--tw-gradient-from: #f9fafb var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-100",
    css: "--tw-gradient-from: #f3f4f6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(243 244 246 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-200",
    css: "--tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(229 231 235 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-300",
    css: "--tw-gradient-from: #d1d5db var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-400",
    css: "--tw-gradient-from: #9ca3af var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(156 163 175 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-500",
    css: "--tw-gradient-from: #6b7280 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(107 114 128 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-600",
    css: "--tw-gradient-from: #4b5563 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(75 85 99 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-700",
    css: "--tw-gradient-from: #374151 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-800",
    css: "--tw-gradient-from: #1f2937 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-900",
    css: "--tw-gradient-from: #111827 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-gray-950",
    css: "--tw-gradient-from: #030712 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(3 7 18 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-50",
    css: "--tw-gradient-from: #fafafa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 250 250 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-100",
    css: "--tw-gradient-from: #f4f4f5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(244 244 245 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-200",
    css: "--tw-gradient-from: #e4e4e7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(228 228 231 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-300",
    css: "--tw-gradient-from: #d4d4d8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(212 212 216 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-400",
    css: "--tw-gradient-from: #a1a1aa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(161 161 170 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-500",
    css: "--tw-gradient-from: #71717a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(113 113 122 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-600",
    css: "--tw-gradient-from: #52525b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(82 82 91 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-700",
    css: "--tw-gradient-from: #3f3f46 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(63 63 70 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-800",
    css: "--tw-gradient-from: #27272a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(39 39 42 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-900",
    css: "--tw-gradient-from: #18181b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(24 24 27 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-zinc-950",
    css: "--tw-gradient-from: #09090b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(9 9 11 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-50",
    css: "--tw-gradient-from: #fafafa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 250 250 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-100",
    css: "--tw-gradient-from: #f5f5f5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(245 245 245 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-200",
    css: "--tw-gradient-from: #e5e5e5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(229 229 229 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-300",
    css: "--tw-gradient-from: #d4d4d4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(212 212 212 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-400",
    css: "--tw-gradient-from: #a3a3a3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(163 163 163 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-500",
    css: "--tw-gradient-from: #737373 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(115 115 115 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-600",
    css: "--tw-gradient-from: #525252 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(82 82 82 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-700",
    css: "--tw-gradient-from: #404040 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(64 64 64 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-800",
    css: "--tw-gradient-from: #262626 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(38 38 38 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-900",
    css: "--tw-gradient-from: #171717 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(23 23 23 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-neutral-950",
    css: "--tw-gradient-from: #0a0a0a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(10 10 10 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-50",
    css: "--tw-gradient-from: #fafaf9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 250 249 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-100",
    css: "--tw-gradient-from: #f5f5f4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(245 245 244 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-200",
    css: "--tw-gradient-from: #e7e5e4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(231 229 228 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-300",
    css: "--tw-gradient-from: #d6d3d1 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(214 211 209 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-400",
    css: "--tw-gradient-from: #a8a29e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(168 162 158 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-500",
    css: "--tw-gradient-from: #78716c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(120 113 108 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-600",
    css: "--tw-gradient-from: #57534e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(87 83 78 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-700",
    css: "--tw-gradient-from: #44403c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(68 64 60 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-800",
    css: "--tw-gradient-from: #292524 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(41 37 36 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-900",
    css: "--tw-gradient-from: #1c1917 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(28 25 23 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-stone-950",
    css: "--tw-gradient-from: #0c0a09 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(12 10 9 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-50",
    css: "--tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-100",
    css: "--tw-gradient-from: #fee2e2 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 226 226 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-200",
    css: "--tw-gradient-from: #fecaca var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 202 202 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-300",
    css: "--tw-gradient-from: #fca5a5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(252 165 165 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-400",
    css: "--tw-gradient-from: #f87171 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(248 113 113 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-500",
    css: "--tw-gradient-from: #ef4444 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-600",
    css: "--tw-gradient-from: #dc2626 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(220 38 38 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-700",
    css: "--tw-gradient-from: #b91c1c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(185 28 28 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-800",
    css: "--tw-gradient-from: #991b1b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(153 27 27 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-900",
    css: "--tw-gradient-from: #7f1d1d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(127 29 29 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-red-950",
    css: "--tw-gradient-from: #450a0a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(69 10 10 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-50",
    css: "--tw-gradient-from: #fff7ed var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-100",
    css: "--tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-200",
    css: "--tw-gradient-from: #fed7aa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 215 170 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-300",
    css: "--tw-gradient-from: #fdba74 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 186 116 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-400",
    css: "--tw-gradient-from: #fb923c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-500",
    css: "--tw-gradient-from: #f97316 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-600",
    css: "--tw-gradient-from: #ea580c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(234 88 12 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-700",
    css: "--tw-gradient-from: #c2410c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(194 65 12 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-800",
    css: "--tw-gradient-from: #9a3412 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(154 52 18 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-900",
    css: "--tw-gradient-from: #7c2d12 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-orange-950",
    css: "--tw-gradient-from: #431407 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(67 20 7 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-50",
    css: "--tw-gradient-from: #fffbeb var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-100",
    css: "--tw-gradient-from: #fef3c7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 243 199 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-200",
    css: "--tw-gradient-from: #fde68a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 230 138 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-300",
    css: "--tw-gradient-from: #fcd34d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(252 211 77 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-400",
    css: "--tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-500",
    css: "--tw-gradient-from: #f59e0b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-600",
    css: "--tw-gradient-from: #d97706 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(217 119 6 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-700",
    css: "--tw-gradient-from: #b45309 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(180 83 9 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-800",
    css: "--tw-gradient-from: #92400e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(146 64 14 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-900",
    css: "--tw-gradient-from: #78350f var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(120 53 15 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-amber-950",
    css: "--tw-gradient-from: #451a03 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(69 26 3 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-50",
    css: "--tw-gradient-from: #fefce8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 252 232 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-100",
    css: "--tw-gradient-from: #fef9c3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 249 195 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-200",
    css: "--tw-gradient-from: #fef08a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 240 138 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-300",
    css: "--tw-gradient-from: #fde047 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 224 71 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-400",
    css: "--tw-gradient-from: #facc15 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-500",
    css: "--tw-gradient-from: #eab308 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-600",
    css: "--tw-gradient-from: #ca8a04 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(202 138 4 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-700",
    css: "--tw-gradient-from: #a16207 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(161 98 7 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-800",
    css: "--tw-gradient-from: #854d0e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(133 77 14 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-900",
    css: "--tw-gradient-from: #713f12 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(113 63 18 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-yellow-950",
    css: "--tw-gradient-from: #422006 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(66 32 6 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-50",
    css: "--tw-gradient-from: #f7fee7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(247 254 231 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-100",
    css: "--tw-gradient-from: #ecfccb var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(236 252 203 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-200",
    css: "--tw-gradient-from: #d9f99d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(217 249 157 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-300",
    css: "--tw-gradient-from: #bef264 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(190 242 100 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-400",
    css: "--tw-gradient-from: #a3e635 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(163 230 53 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-500",
    css: "--tw-gradient-from: #84cc16 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(132 204 22 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-600",
    css: "--tw-gradient-from: #65a30d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(101 163 13 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-700",
    css: "--tw-gradient-from: #4d7c0f var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(77 124 15 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-800",
    css: "--tw-gradient-from: #3f6212 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(63 98 18 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-900",
    css: "--tw-gradient-from: #365314 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(54 83 20 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-lime-950",
    css: "--tw-gradient-from: #1a2e05 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(26 46 5 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-50",
    css: "--tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-100",
    css: "--tw-gradient-from: #dcfce7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(220 252 231 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-200",
    css: "--tw-gradient-from: #bbf7d0 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(187 247 208 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-300",
    css: "--tw-gradient-from: #86efac var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(134 239 172 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-400",
    css: "--tw-gradient-from: #4ade80 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-500",
    css: "--tw-gradient-from: #22c55e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-600",
    css: "--tw-gradient-from: #16a34a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-700",
    css: "--tw-gradient-from: #15803d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-800",
    css: "--tw-gradient-from: #166534 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(22 101 52 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-900",
    css: "--tw-gradient-from: #14532d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(20 83 45 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-green-950",
    css: "--tw-gradient-from: #052e16 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(5 46 22 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-50",
    css: "--tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-100",
    css: "--tw-gradient-from: #d1fae5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(209 250 229 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-200",
    css: "--tw-gradient-from: #a7f3d0 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(167 243 208 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-300",
    css: "--tw-gradient-from: #6ee7b7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(110 231 183 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-400",
    css: "--tw-gradient-from: #34d399 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-500",
    css: "--tw-gradient-from: #10b981 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-600",
    css: "--tw-gradient-from: #059669 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-700",
    css: "--tw-gradient-from: #047857 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-800",
    css: "--tw-gradient-from: #065f46 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(6 95 70 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-900",
    css: "--tw-gradient-from: #064e3b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(6 78 59 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-emerald-950",
    css: "--tw-gradient-from: #022c22 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(2 44 34 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-50",
    css: "--tw-gradient-from: #f0fdfa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(240 253 250 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-100",
    css: "--tw-gradient-from: #ccfbf1 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(204 251 241 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-200",
    css: "--tw-gradient-from: #99f6e4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(153 246 228 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-300",
    css: "--tw-gradient-from: #5eead4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(94 234 212 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-400",
    css: "--tw-gradient-from: #2dd4bf var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(45 212 191 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-500",
    css: "--tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-600",
    css: "--tw-gradient-from: #0d9488 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(13 148 136 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-700",
    css: "--tw-gradient-from: #0f766e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(15 118 110 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-800",
    css: "--tw-gradient-from: #115e59 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(17 94 89 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-900",
    css: "--tw-gradient-from: #134e4a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(19 78 74 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-teal-950",
    css: "--tw-gradient-from: #042f2e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(4 47 46 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-50",
    css: "--tw-gradient-from: #ecfeff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-100",
    css: "--tw-gradient-from: #cffafe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(207 250 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-200",
    css: "--tw-gradient-from: #a5f3fc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(165 243 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-300",
    css: "--tw-gradient-from: #67e8f9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(103 232 249 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-400",
    css: "--tw-gradient-from: #22d3ee var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-500",
    css: "--tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-600",
    css: "--tw-gradient-from: #0891b2 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(8 145 178 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-700",
    css: "--tw-gradient-from: #0e7490 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(14 116 144 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-800",
    css: "--tw-gradient-from: #155e75 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(21 94 117 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-900",
    css: "--tw-gradient-from: #164e63 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(22 78 99 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-cyan-950",
    css: "--tw-gradient-from: #083344 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(8 51 68 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-50",
    css: "--tw-gradient-from: #f0f9ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-100",
    css: "--tw-gradient-from: #e0f2fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(224 242 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-200",
    css: "--tw-gradient-from: #bae6fd var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(186 230 253 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-300",
    css: "--tw-gradient-from: #7dd3fc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(125 211 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-400",
    css: "--tw-gradient-from: #38bdf8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(56 189 248 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-500",
    css: "--tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-600",
    css: "--tw-gradient-from: #0284c7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(2 132 199 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-700",
    css: "--tw-gradient-from: #0369a1 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(3 105 161 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-800",
    css: "--tw-gradient-from: #075985 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(7 89 133 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-900",
    css: "--tw-gradient-from: #0c4a6e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(12 74 110 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-sky-950",
    css: "--tw-gradient-from: #082f49 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(8 47 73 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-50",
    css: "--tw-gradient-from: #eff6ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-100",
    css: "--tw-gradient-from: #dbeafe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-200",
    css: "--tw-gradient-from: #bfdbfe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(191 219 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-300",
    css: "--tw-gradient-from: #93c5fd var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(147 197 253 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-400",
    css: "--tw-gradient-from: #60a5fa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-500",
    css: "--tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-600",
    css: "--tw-gradient-from: #2563eb var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-700",
    css: "--tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-800",
    css: "--tw-gradient-from: #1e40af var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-900",
    css: "--tw-gradient-from: #1e3a8a var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-blue-950",
    css: "--tw-gradient-from: #172554 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(23 37 84 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-50",
    css: "--tw-gradient-from: #eef2ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-100",
    css: "--tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-200",
    css: "--tw-gradient-from: #c7d2fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(199 210 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-300",
    css: "--tw-gradient-from: #a5b4fc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(165 180 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-400",
    css: "--tw-gradient-from: #818cf8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-500",
    css: "--tw-gradient-from: #6366f1 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-600",
    css: "--tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-700",
    css: "--tw-gradient-from: #4338ca var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-800",
    css: "--tw-gradient-from: #3730a3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(55 48 163 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-900",
    css: "--tw-gradient-from: #312e81 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-indigo-950",
    css: "--tw-gradient-from: #1e1b4b var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(30 27 75 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-50",
    css: "--tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-100",
    css: "--tw-gradient-from: #ede9fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(237 233 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-200",
    css: "--tw-gradient-from: #ddd6fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(221 214 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-300",
    css: "--tw-gradient-from: #c4b5fd var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(196 181 253 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-400",
    css: "--tw-gradient-from: #a78bfa var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(167 139 250 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-500",
    css: "--tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-600",
    css: "--tw-gradient-from: #7c3aed var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-700",
    css: "--tw-gradient-from: #6d28d9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(109 40 217 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-800",
    css: "--tw-gradient-from: #5b21b6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(91 33 182 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-900",
    css: "--tw-gradient-from: #4c1d95 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(76 29 149 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-violet-950",
    css: "--tw-gradient-from: #2e1065 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(46 16 101 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-50",
    css: "--tw-gradient-from: #faf5ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-100",
    css: "--tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-200",
    css: "--tw-gradient-from: #e9d5ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(233 213 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-300",
    css: "--tw-gradient-from: #d8b4fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(216 180 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-400",
    css: "--tw-gradient-from: #c084fc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-500",
    css: "--tw-gradient-from: #a855f7 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-600",
    css: "--tw-gradient-from: #9333ea var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-700",
    css: "--tw-gradient-from: #7e22ce var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-800",
    css: "--tw-gradient-from: #6b21a8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(107 33 168 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-900",
    css: "--tw-gradient-from: #581c87 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-purple-950",
    css: "--tw-gradient-from: #3b0764 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(59 7 100 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-50",
    css: "--tw-gradient-from: #fdf4ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 244 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-100",
    css: "--tw-gradient-from: #fae8ff var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(250 232 255 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-200",
    css: "--tw-gradient-from: #f5d0fe var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(245 208 254 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-300",
    css: "--tw-gradient-from: #f0abfc var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(240 171 252 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-400",
    css: "--tw-gradient-from: #e879f9 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(232 121 249 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-500",
    css: "--tw-gradient-from: #d946ef var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(217 70 239 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-600",
    css: "--tw-gradient-from: #c026d3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(192 38 211 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-700",
    css: "--tw-gradient-from: #a21caf var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(162 28 175 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-800",
    css: "--tw-gradient-from: #86198f var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(134 25 143 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-900",
    css: "--tw-gradient-from: #701a75 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(112 26 117 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-fuchsia-950",
    css: "--tw-gradient-from: #4a044e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(74 4 78 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-50",
    css: "--tw-gradient-from: #fdf2f8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-100",
    css: "--tw-gradient-from: #fce7f3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(252 231 243 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-200",
    css: "--tw-gradient-from: #fbcfe8 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(251 207 232 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-300",
    css: "--tw-gradient-from: #f9a8d4 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(249 168 212 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-400",
    css: "--tw-gradient-from: #f472b6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-500",
    css: "--tw-gradient-from: #ec4899 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-600",
    css: "--tw-gradient-from: #db2777 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-700",
    css: "--tw-gradient-from: #be185d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(190 24 93 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-800",
    css: "--tw-gradient-from: #9d174d var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(157 23 77 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-900",
    css: "--tw-gradient-from: #831843 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(131 24 67 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-pink-950",
    css: "--tw-gradient-from: #500724 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(80 7 36 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-50",
    css: "--tw-gradient-from: #fff1f2 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-100",
    css: "--tw-gradient-from: #ffe4e6 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(255 228 230 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-200",
    css: "--tw-gradient-from: #fecdd3 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(254 205 211 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-300",
    css: "--tw-gradient-from: #fda4af var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(253 164 175 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-400",
    css: "--tw-gradient-from: #fb7185 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(251 113 133 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-500",
    css: "--tw-gradient-from: #f43f5e var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-600",
    css: "--tw-gradient-from: #e11d48 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(225 29 72 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-700",
    css: "--tw-gradient-from: #be123c var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(190 18 60 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-800",
    css: "--tw-gradient-from: #9f1239 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(159 18 57 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-900",
    css: "--tw-gradient-from: #881337 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(136 19 55 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-rose-950",
    css: "--tw-gradient-from: #4c0519 var(--tw-gradient-from-position);\n--tw-gradient-to: rgb(76 5 25 / 0) var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);",
  },
  {
    tailwind: "from-0%",
    css: "--tw-gradient-from-position: 0%;",
  },
  {
    tailwind: "from-5%",
    css: "--tw-gradient-from-position: 5%;",
  },
  {
    tailwind: "from-10%",
    css: "--tw-gradient-from-position: 10%;",
  },
  {
    tailwind: "from-15%",
    css: "--tw-gradient-from-position: 15%;",
  },
  {
    tailwind: "from-20%",
    css: "--tw-gradient-from-position: 20%;",
  },
  {
    tailwind: "from-25%",
    css: "--tw-gradient-from-position: 25%;",
  },
  {
    tailwind: "from-30%",
    css: "--tw-gradient-from-position: 30%;",
  },
  {
    tailwind: "from-35%",
    css: "--tw-gradient-from-position: 35%;",
  },
  {
    tailwind: "from-40%",
    css: "--tw-gradient-from-position: 40%;",
  },
  {
    tailwind: "from-45%",
    css: "--tw-gradient-from-position: 45%;",
  },
  {
    tailwind: "from-50%",
    css: "--tw-gradient-from-position: 50%;",
  },
  {
    tailwind: "from-55%",
    css: "--tw-gradient-from-position: 55%;",
  },
  {
    tailwind: "from-60%",
    css: "--tw-gradient-from-position: 60%;",
  },
  {
    tailwind: "from-65%",
    css: "--tw-gradient-from-position: 65%;",
  },
  {
    tailwind: "from-70%",
    css: "--tw-gradient-from-position: 70%;",
  },
  {
    tailwind: "from-75%",
    css: "--tw-gradient-from-position: 75%;",
  },
  {
    tailwind: "from-80%",
    css: "--tw-gradient-from-position: 80%;",
  },
  {
    tailwind: "from-85%",
    css: "--tw-gradient-from-position: 85%;",
  },
  {
    tailwind: "from-90%",
    css: "--tw-gradient-from-position: 90%;",
  },
  {
    tailwind: "from-95%",
    css: "--tw-gradient-from-position: 95%;",
  },
  {
    tailwind: "from-100%",
    css: "--tw-gradient-from-position: 100%;",
  },
  {
    tailwind: "via-inherit",
    css: "--tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), inherit var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-current",
    css: "--tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), currentColor var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-transparent",
    css: "--tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-black",
    css: "--tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #000 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-white",
    css: "--tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-50",
    css: "--tw-gradient-to: rgb(248 250 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f8fafc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-100",
    css: "--tw-gradient-to: rgb(241 245 249 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f1f5f9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-200",
    css: "--tw-gradient-to: rgb(226 232 240 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e2e8f0 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-300",
    css: "--tw-gradient-to: rgb(203 213 225 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #cbd5e1 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-400",
    css: "--tw-gradient-to: rgb(148 163 184 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #94a3b8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-500",
    css: "--tw-gradient-to: rgb(100 116 139 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #64748b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-600",
    css: "--tw-gradient-to: rgb(71 85 105 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #475569 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-700",
    css: "--tw-gradient-to: rgb(51 65 85 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #334155 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-800",
    css: "--tw-gradient-to: rgb(30 41 59 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1e293b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-900",
    css: "--tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0f172a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-slate-950",
    css: "--tw-gradient-to: rgb(2 6 23 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #020617 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-50",
    css: "--tw-gradient-to: rgb(249 250 251 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f9fafb var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-100",
    css: "--tw-gradient-to: rgb(243 244 246 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f3f4f6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-200",
    css: "--tw-gradient-to: rgb(229 231 235 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e5e7eb var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-300",
    css: "--tw-gradient-to: rgb(209 213 219 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d1d5db var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-400",
    css: "--tw-gradient-to: rgb(156 163 175 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #9ca3af var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-500",
    css: "--tw-gradient-to: rgb(107 114 128 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #6b7280 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-600",
    css: "--tw-gradient-to: rgb(75 85 99 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4b5563 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-700",
    css: "--tw-gradient-to: rgb(55 65 81 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #374151 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-800",
    css: "--tw-gradient-to: rgb(31 41 55 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1f2937 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-900",
    css: "--tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-gray-950",
    css: "--tw-gradient-to: rgb(3 7 18 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #030712 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-50",
    css: "--tw-gradient-to: rgb(250 250 250 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fafafa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-100",
    css: "--tw-gradient-to: rgb(244 244 245 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f4f4f5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-200",
    css: "--tw-gradient-to: rgb(228 228 231 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e4e4e7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-300",
    css: "--tw-gradient-to: rgb(212 212 216 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d4d4d8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-400",
    css: "--tw-gradient-to: rgb(161 161 170 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a1a1aa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-500",
    css: "--tw-gradient-to: rgb(113 113 122 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #71717a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-600",
    css: "--tw-gradient-to: rgb(82 82 91 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #52525b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-700",
    css: "--tw-gradient-to: rgb(63 63 70 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #3f3f46 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-800",
    css: "--tw-gradient-to: rgb(39 39 42 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #27272a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-900",
    css: "--tw-gradient-to: rgb(24 24 27 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #18181b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-zinc-950",
    css: "--tw-gradient-to: rgb(9 9 11 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #09090b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-50",
    css: "--tw-gradient-to: rgb(250 250 250 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fafafa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-100",
    css: "--tw-gradient-to: rgb(245 245 245 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f5f5f5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-200",
    css: "--tw-gradient-to: rgb(229 229 229 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e5e5e5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-300",
    css: "--tw-gradient-to: rgb(212 212 212 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d4d4d4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-400",
    css: "--tw-gradient-to: rgb(163 163 163 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a3a3a3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-500",
    css: "--tw-gradient-to: rgb(115 115 115 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #737373 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-600",
    css: "--tw-gradient-to: rgb(82 82 82 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #525252 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-700",
    css: "--tw-gradient-to: rgb(64 64 64 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #404040 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-800",
    css: "--tw-gradient-to: rgb(38 38 38 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #262626 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-900",
    css: "--tw-gradient-to: rgb(23 23 23 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #171717 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-neutral-950",
    css: "--tw-gradient-to: rgb(10 10 10 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0a0a0a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-50",
    css: "--tw-gradient-to: rgb(250 250 249 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fafaf9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-100",
    css: "--tw-gradient-to: rgb(245 245 244 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f5f5f4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-200",
    css: "--tw-gradient-to: rgb(231 229 228 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e7e5e4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-300",
    css: "--tw-gradient-to: rgb(214 211 209 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d6d3d1 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-400",
    css: "--tw-gradient-to: rgb(168 162 158 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a8a29e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-500",
    css: "--tw-gradient-to: rgb(120 113 108 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #78716c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-600",
    css: "--tw-gradient-to: rgb(87 83 78 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #57534e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-700",
    css: "--tw-gradient-to: rgb(68 64 60 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #44403c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-800",
    css: "--tw-gradient-to: rgb(41 37 36 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #292524 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-900",
    css: "--tw-gradient-to: rgb(28 25 23 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1c1917 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-stone-950",
    css: "--tw-gradient-to: rgb(12 10 9 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0c0a09 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-50",
    css: "--tw-gradient-to: rgb(254 242 242 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fef2f2 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-100",
    css: "--tw-gradient-to: rgb(254 226 226 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fee2e2 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-200",
    css: "--tw-gradient-to: rgb(254 202 202 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fecaca var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-300",
    css: "--tw-gradient-to: rgb(252 165 165 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fca5a5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-400",
    css: "--tw-gradient-to: rgb(248 113 113 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f87171 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-500",
    css: "--tw-gradient-to: rgb(239 68 68 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ef4444 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-600",
    css: "--tw-gradient-to: rgb(220 38 38 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #dc2626 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-700",
    css: "--tw-gradient-to: rgb(185 28 28 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #b91c1c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-800",
    css: "--tw-gradient-to: rgb(153 27 27 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #991b1b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-900",
    css: "--tw-gradient-to: rgb(127 29 29 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #7f1d1d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-red-950",
    css: "--tw-gradient-to: rgb(69 10 10 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #450a0a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-50",
    css: "--tw-gradient-to: rgb(255 247 237 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fff7ed var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-100",
    css: "--tw-gradient-to: rgb(255 237 213 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ffedd5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-200",
    css: "--tw-gradient-to: rgb(254 215 170 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fed7aa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-300",
    css: "--tw-gradient-to: rgb(253 186 116 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fdba74 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-400",
    css: "--tw-gradient-to: rgb(251 146 60 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fb923c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-500",
    css: "--tw-gradient-to: rgb(249 115 22 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f97316 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-600",
    css: "--tw-gradient-to: rgb(234 88 12 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ea580c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-700",
    css: "--tw-gradient-to: rgb(194 65 12 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #c2410c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-800",
    css: "--tw-gradient-to: rgb(154 52 18 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #9a3412 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-900",
    css: "--tw-gradient-to: rgb(124 45 18 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #7c2d12 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-orange-950",
    css: "--tw-gradient-to: rgb(67 20 7 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #431407 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-50",
    css: "--tw-gradient-to: rgb(255 251 235 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fffbeb var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-100",
    css: "--tw-gradient-to: rgb(254 243 199 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fef3c7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-200",
    css: "--tw-gradient-to: rgb(253 230 138 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fde68a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-300",
    css: "--tw-gradient-to: rgb(252 211 77 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fcd34d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-400",
    css: "--tw-gradient-to: rgb(251 191 36 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fbbf24 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-500",
    css: "--tw-gradient-to: rgb(245 158 11 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f59e0b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-600",
    css: "--tw-gradient-to: rgb(217 119 6 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d97706 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-700",
    css: "--tw-gradient-to: rgb(180 83 9 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #b45309 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-800",
    css: "--tw-gradient-to: rgb(146 64 14 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #92400e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-900",
    css: "--tw-gradient-to: rgb(120 53 15 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #78350f var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-amber-950",
    css: "--tw-gradient-to: rgb(69 26 3 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #451a03 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-50",
    css: "--tw-gradient-to: rgb(254 252 232 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fefce8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-100",
    css: "--tw-gradient-to: rgb(254 249 195 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fef9c3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-200",
    css: "--tw-gradient-to: rgb(254 240 138 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fef08a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-300",
    css: "--tw-gradient-to: rgb(253 224 71 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fde047 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-400",
    css: "--tw-gradient-to: rgb(250 204 21 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #facc15 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-500",
    css: "--tw-gradient-to: rgb(234 179 8 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #eab308 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-600",
    css: "--tw-gradient-to: rgb(202 138 4 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ca8a04 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-700",
    css: "--tw-gradient-to: rgb(161 98 7 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a16207 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-800",
    css: "--tw-gradient-to: rgb(133 77 14 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #854d0e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-900",
    css: "--tw-gradient-to: rgb(113 63 18 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #713f12 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-yellow-950",
    css: "--tw-gradient-to: rgb(66 32 6 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #422006 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-50",
    css: "--tw-gradient-to: rgb(247 254 231 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f7fee7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-100",
    css: "--tw-gradient-to: rgb(236 252 203 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ecfccb var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-200",
    css: "--tw-gradient-to: rgb(217 249 157 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d9f99d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-300",
    css: "--tw-gradient-to: rgb(190 242 100 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #bef264 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-400",
    css: "--tw-gradient-to: rgb(163 230 53 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a3e635 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-500",
    css: "--tw-gradient-to: rgb(132 204 22 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #84cc16 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-600",
    css: "--tw-gradient-to: rgb(101 163 13 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #65a30d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-700",
    css: "--tw-gradient-to: rgb(77 124 15 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4d7c0f var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-800",
    css: "--tw-gradient-to: rgb(63 98 18 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #3f6212 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-900",
    css: "--tw-gradient-to: rgb(54 83 20 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #365314 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-lime-950",
    css: "--tw-gradient-to: rgb(26 46 5 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1a2e05 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-50",
    css: "--tw-gradient-to: rgb(240 253 244 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f0fdf4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-100",
    css: "--tw-gradient-to: rgb(220 252 231 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #dcfce7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-200",
    css: "--tw-gradient-to: rgb(187 247 208 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #bbf7d0 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-300",
    css: "--tw-gradient-to: rgb(134 239 172 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #86efac var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-400",
    css: "--tw-gradient-to: rgb(74 222 128 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4ade80 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-500",
    css: "--tw-gradient-to: rgb(34 197 94 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #22c55e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-600",
    css: "--tw-gradient-to: rgb(22 163 74 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #16a34a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-700",
    css: "--tw-gradient-to: rgb(21 128 61 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #15803d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-800",
    css: "--tw-gradient-to: rgb(22 101 52 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #166534 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-900",
    css: "--tw-gradient-to: rgb(20 83 45 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #14532d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-green-950",
    css: "--tw-gradient-to: rgb(5 46 22 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #052e16 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-50",
    css: "--tw-gradient-to: rgb(236 253 245 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ecfdf5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-100",
    css: "--tw-gradient-to: rgb(209 250 229 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d1fae5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-200",
    css: "--tw-gradient-to: rgb(167 243 208 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a7f3d0 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-300",
    css: "--tw-gradient-to: rgb(110 231 183 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #6ee7b7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-400",
    css: "--tw-gradient-to: rgb(52 211 153 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #34d399 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-500",
    css: "--tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-600",
    css: "--tw-gradient-to: rgb(5 150 105 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #059669 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-700",
    css: "--tw-gradient-to: rgb(4 120 87 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #047857 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-800",
    css: "--tw-gradient-to: rgb(6 95 70 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #065f46 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-900",
    css: "--tw-gradient-to: rgb(6 78 59 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #064e3b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-emerald-950",
    css: "--tw-gradient-to: rgb(2 44 34 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #022c22 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-50",
    css: "--tw-gradient-to: rgb(240 253 250 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f0fdfa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-100",
    css: "--tw-gradient-to: rgb(204 251 241 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ccfbf1 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-200",
    css: "--tw-gradient-to: rgb(153 246 228 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #99f6e4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-300",
    css: "--tw-gradient-to: rgb(94 234 212 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #5eead4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-400",
    css: "--tw-gradient-to: rgb(45 212 191 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #2dd4bf var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-500",
    css: "--tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #14b8a6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-600",
    css: "--tw-gradient-to: rgb(13 148 136 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0d9488 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-700",
    css: "--tw-gradient-to: rgb(15 118 110 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0f766e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-800",
    css: "--tw-gradient-to: rgb(17 94 89 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #115e59 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-900",
    css: "--tw-gradient-to: rgb(19 78 74 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #134e4a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-teal-950",
    css: "--tw-gradient-to: rgb(4 47 46 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #042f2e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-50",
    css: "--tw-gradient-to: rgb(236 254 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ecfeff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-100",
    css: "--tw-gradient-to: rgb(207 250 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #cffafe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-200",
    css: "--tw-gradient-to: rgb(165 243 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a5f3fc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-300",
    css: "--tw-gradient-to: rgb(103 232 249 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #67e8f9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-400",
    css: "--tw-gradient-to: rgb(34 211 238 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #22d3ee var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-500",
    css: "--tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-600",
    css: "--tw-gradient-to: rgb(8 145 178 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0891b2 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-700",
    css: "--tw-gradient-to: rgb(14 116 144 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0e7490 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-800",
    css: "--tw-gradient-to: rgb(21 94 117 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #155e75 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-900",
    css: "--tw-gradient-to: rgb(22 78 99 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #164e63 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-cyan-950",
    css: "--tw-gradient-to: rgb(8 51 68 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #083344 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-50",
    css: "--tw-gradient-to: rgb(240 249 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f0f9ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-100",
    css: "--tw-gradient-to: rgb(224 242 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e0f2fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-200",
    css: "--tw-gradient-to: rgb(186 230 253 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #bae6fd var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-300",
    css: "--tw-gradient-to: rgb(125 211 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #7dd3fc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-400",
    css: "--tw-gradient-to: rgb(56 189 248 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #38bdf8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-500",
    css: "--tw-gradient-to: rgb(14 165 233 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0ea5e9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-600",
    css: "--tw-gradient-to: rgb(2 132 199 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0284c7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-700",
    css: "--tw-gradient-to: rgb(3 105 161 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0369a1 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-800",
    css: "--tw-gradient-to: rgb(7 89 133 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #075985 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-900",
    css: "--tw-gradient-to: rgb(12 74 110 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #0c4a6e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-sky-950",
    css: "--tw-gradient-to: rgb(8 47 73 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #082f49 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-50",
    css: "--tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #eff6ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-100",
    css: "--tw-gradient-to: rgb(219 234 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #dbeafe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-200",
    css: "--tw-gradient-to: rgb(191 219 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #bfdbfe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-300",
    css: "--tw-gradient-to: rgb(147 197 253 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #93c5fd var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-400",
    css: "--tw-gradient-to: rgb(96 165 250 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #60a5fa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-500",
    css: "--tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #3b82f6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-600",
    css: "--tw-gradient-to: rgb(37 99 235 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #2563eb var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-700",
    css: "--tw-gradient-to: rgb(29 78 216 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1d4ed8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-800",
    css: "--tw-gradient-to: rgb(30 64 175 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1e40af var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-900",
    css: "--tw-gradient-to: rgb(30 58 138 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1e3a8a var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-blue-950",
    css: "--tw-gradient-to: rgb(23 37 84 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #172554 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-50",
    css: "--tw-gradient-to: rgb(238 242 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #eef2ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-100",
    css: "--tw-gradient-to: rgb(224 231 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e0e7ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-200",
    css: "--tw-gradient-to: rgb(199 210 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #c7d2fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-300",
    css: "--tw-gradient-to: rgb(165 180 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a5b4fc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-400",
    css: "--tw-gradient-to: rgb(129 140 248 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #818cf8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-500",
    css: "--tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #6366f1 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-600",
    css: "--tw-gradient-to: rgb(79 70 229 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4f46e5 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-700",
    css: "--tw-gradient-to: rgb(67 56 202 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4338ca var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-800",
    css: "--tw-gradient-to: rgb(55 48 163 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #3730a3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-900",
    css: "--tw-gradient-to: rgb(49 46 129 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #312e81 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-indigo-950",
    css: "--tw-gradient-to: rgb(30 27 75 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #1e1b4b var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-50",
    css: "--tw-gradient-to: rgb(245 243 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f5f3ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-100",
    css: "--tw-gradient-to: rgb(237 233 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ede9fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-200",
    css: "--tw-gradient-to: rgb(221 214 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ddd6fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-300",
    css: "--tw-gradient-to: rgb(196 181 253 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #c4b5fd var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-400",
    css: "--tw-gradient-to: rgb(167 139 250 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a78bfa var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-500",
    css: "--tw-gradient-to: rgb(139 92 246 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #8b5cf6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-600",
    css: "--tw-gradient-to: rgb(124 58 237 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #7c3aed var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-700",
    css: "--tw-gradient-to: rgb(109 40 217 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #6d28d9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-800",
    css: "--tw-gradient-to: rgb(91 33 182 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #5b21b6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-900",
    css: "--tw-gradient-to: rgb(76 29 149 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4c1d95 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-violet-950",
    css: "--tw-gradient-to: rgb(46 16 101 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #2e1065 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-50",
    css: "--tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #faf5ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-100",
    css: "--tw-gradient-to: rgb(243 232 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f3e8ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-200",
    css: "--tw-gradient-to: rgb(233 213 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e9d5ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-300",
    css: "--tw-gradient-to: rgb(216 180 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d8b4fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-400",
    css: "--tw-gradient-to: rgb(192 132 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #c084fc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-500",
    css: "--tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-600",
    css: "--tw-gradient-to: rgb(147 51 234 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #9333ea var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-700",
    css: "--tw-gradient-to: rgb(126 34 206 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #7e22ce var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-800",
    css: "--tw-gradient-to: rgb(107 33 168 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #6b21a8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-900",
    css: "--tw-gradient-to: rgb(88 28 135 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #581c87 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-purple-950",
    css: "--tw-gradient-to: rgb(59 7 100 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #3b0764 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-50",
    css: "--tw-gradient-to: rgb(253 244 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fdf4ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-100",
    css: "--tw-gradient-to: rgb(250 232 255 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fae8ff var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-200",
    css: "--tw-gradient-to: rgb(245 208 254 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f5d0fe var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-300",
    css: "--tw-gradient-to: rgb(240 171 252 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f0abfc var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-400",
    css: "--tw-gradient-to: rgb(232 121 249 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e879f9 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-500",
    css: "--tw-gradient-to: rgb(217 70 239 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #d946ef var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-600",
    css: "--tw-gradient-to: rgb(192 38 211 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #c026d3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-700",
    css: "--tw-gradient-to: rgb(162 28 175 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #a21caf var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-800",
    css: "--tw-gradient-to: rgb(134 25 143 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #86198f var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-900",
    css: "--tw-gradient-to: rgb(112 26 117 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #701a75 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-fuchsia-950",
    css: "--tw-gradient-to: rgb(74 4 78 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4a044e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-50",
    css: "--tw-gradient-to: rgb(253 242 248 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fdf2f8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-100",
    css: "--tw-gradient-to: rgb(252 231 243 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fce7f3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-200",
    css: "--tw-gradient-to: rgb(251 207 232 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fbcfe8 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-300",
    css: "--tw-gradient-to: rgb(249 168 212 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f9a8d4 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-400",
    css: "--tw-gradient-to: rgb(244 114 182 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f472b6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-500",
    css: "--tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-600",
    css: "--tw-gradient-to: rgb(219 39 119 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #db2777 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-700",
    css: "--tw-gradient-to: rgb(190 24 93 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #be185d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-800",
    css: "--tw-gradient-to: rgb(157 23 77 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #9d174d var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-900",
    css: "--tw-gradient-to: rgb(131 24 67 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #831843 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-pink-950",
    css: "--tw-gradient-to: rgb(80 7 36 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #500724 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-50",
    css: "--tw-gradient-to: rgb(255 241 242 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fff1f2 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-100",
    css: "--tw-gradient-to: rgb(255 228 230 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #ffe4e6 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-200",
    css: "--tw-gradient-to: rgb(254 205 211 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fecdd3 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-300",
    css: "--tw-gradient-to: rgb(253 164 175 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fda4af var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-400",
    css: "--tw-gradient-to: rgb(251 113 133 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #fb7185 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-500",
    css: "--tw-gradient-to: rgb(244 63 94 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #f43f5e var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-600",
    css: "--tw-gradient-to: rgb(225 29 72 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #e11d48 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-700",
    css: "--tw-gradient-to: rgb(190 18 60 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #be123c var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-800",
    css: "--tw-gradient-to: rgb(159 18 57 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #9f1239 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-900",
    css: "--tw-gradient-to: rgb(136 19 55 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #881337 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-rose-950",
    css: "--tw-gradient-to: rgb(76 5 25 / 0)  var(--tw-gradient-to-position);\n--tw-gradient-stops: var(--tw-gradient-from), #4c0519 var(--tw-gradient-via-position), var(--tw-gradient-to);",
  },
  {
    tailwind: "via-0%",
    css: "--tw-gradient-via-position: 0%;",
  },
  {
    tailwind: "via-5%",
    css: "--tw-gradient-via-position: 5%;",
  },
  {
    tailwind: "via-10%",
    css: "--tw-gradient-via-position: 10%;",
  },
  {
    tailwind: "via-15%",
    css: "--tw-gradient-via-position: 15%;",
  },
  {
    tailwind: "via-20%",
    css: "--tw-gradient-via-position: 20%;",
  },
  {
    tailwind: "via-25%",
    css: "--tw-gradient-via-position: 25%;",
  },
  {
    tailwind: "via-30%",
    css: "--tw-gradient-via-position: 30%;",
  },
  {
    tailwind: "via-35%",
    css: "--tw-gradient-via-position: 35%;",
  },
  {
    tailwind: "via-40%",
    css: "--tw-gradient-via-position: 40%;",
  },
  {
    tailwind: "via-45%",
    css: "--tw-gradient-via-position: 45%;",
  },
  {
    tailwind: "via-50%",
    css: "--tw-gradient-via-position: 50%;",
  },
  {
    tailwind: "via-55%",
    css: "--tw-gradient-via-position: 55%;",
  },
  {
    tailwind: "via-60%",
    css: "--tw-gradient-via-position: 60%;",
  },
  {
    tailwind: "via-65%",
    css: "--tw-gradient-via-position: 65%;",
  },
  {
    tailwind: "via-70%",
    css: "--tw-gradient-via-position: 70%;",
  },
  {
    tailwind: "via-75%",
    css: "--tw-gradient-via-position: 75%;",
  },
  {
    tailwind: "via-80%",
    css: "--tw-gradient-via-position: 80%;",
  },
  {
    tailwind: "via-85%",
    css: "--tw-gradient-via-position: 85%;",
  },
  {
    tailwind: "via-90%",
    css: "--tw-gradient-via-position: 90%;",
  },
  {
    tailwind: "via-95%",
    css: "--tw-gradient-via-position: 95%;",
  },
  {
    tailwind: "via-100%",
    css: "--tw-gradient-via-position: 100%;",
  },
  {
    tailwind: "to-inherit",
    css: "--tw-gradient-to: inherit var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-current",
    css: "--tw-gradient-to: currentColor var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-transparent",
    css: "--tw-gradient-to: transparent var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-black",
    css: "--tw-gradient-to: #000 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-white",
    css: "--tw-gradient-to: #fff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-50",
    css: "--tw-gradient-to: #f8fafc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-100",
    css: "--tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-200",
    css: "--tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-300",
    css: "--tw-gradient-to: #cbd5e1 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-400",
    css: "--tw-gradient-to: #94a3b8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-500",
    css: "--tw-gradient-to: #64748b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-600",
    css: "--tw-gradient-to: #475569 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-700",
    css: "--tw-gradient-to: #334155 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-800",
    css: "--tw-gradient-to: #1e293b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-900",
    css: "--tw-gradient-to: #0f172a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-slate-950",
    css: "--tw-gradient-to: #020617 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-50",
    css: "--tw-gradient-to: #f9fafb var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-100",
    css: "--tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-200",
    css: "--tw-gradient-to: #e5e7eb var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-300",
    css: "--tw-gradient-to: #d1d5db var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-400",
    css: "--tw-gradient-to: #9ca3af var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-500",
    css: "--tw-gradient-to: #6b7280 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-600",
    css: "--tw-gradient-to: #4b5563 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-700",
    css: "--tw-gradient-to: #374151 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-800",
    css: "--tw-gradient-to: #1f2937 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-900",
    css: "--tw-gradient-to: #111827 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-gray-950",
    css: "--tw-gradient-to: #030712 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-50",
    css: "--tw-gradient-to: #fafafa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-100",
    css: "--tw-gradient-to: #f4f4f5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-200",
    css: "--tw-gradient-to: #e4e4e7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-300",
    css: "--tw-gradient-to: #d4d4d8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-400",
    css: "--tw-gradient-to: #a1a1aa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-500",
    css: "--tw-gradient-to: #71717a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-600",
    css: "--tw-gradient-to: #52525b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-700",
    css: "--tw-gradient-to: #3f3f46 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-800",
    css: "--tw-gradient-to: #27272a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-900",
    css: "--tw-gradient-to: #18181b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-zinc-950",
    css: "--tw-gradient-to: #09090b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-50",
    css: "--tw-gradient-to: #fafafa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-100",
    css: "--tw-gradient-to: #f5f5f5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-200",
    css: "--tw-gradient-to: #e5e5e5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-300",
    css: "--tw-gradient-to: #d4d4d4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-400",
    css: "--tw-gradient-to: #a3a3a3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-500",
    css: "--tw-gradient-to: #737373 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-600",
    css: "--tw-gradient-to: #525252 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-700",
    css: "--tw-gradient-to: #404040 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-800",
    css: "--tw-gradient-to: #262626 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-900",
    css: "--tw-gradient-to: #171717 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-neutral-950",
    css: "--tw-gradient-to: #0a0a0a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-50",
    css: "--tw-gradient-to: #fafaf9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-100",
    css: "--tw-gradient-to: #f5f5f4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-200",
    css: "--tw-gradient-to: #e7e5e4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-300",
    css: "--tw-gradient-to: #d6d3d1 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-400",
    css: "--tw-gradient-to: #a8a29e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-500",
    css: "--tw-gradient-to: #78716c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-600",
    css: "--tw-gradient-to: #57534e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-700",
    css: "--tw-gradient-to: #44403c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-800",
    css: "--tw-gradient-to: #292524 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-900",
    css: "--tw-gradient-to: #1c1917 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-stone-950",
    css: "--tw-gradient-to: #0c0a09 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-50",
    css: "--tw-gradient-to: #fef2f2 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-100",
    css: "--tw-gradient-to: #fee2e2 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-200",
    css: "--tw-gradient-to: #fecaca var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-300",
    css: "--tw-gradient-to: #fca5a5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-400",
    css: "--tw-gradient-to: #f87171 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-500",
    css: "--tw-gradient-to: #ef4444 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-600",
    css: "--tw-gradient-to: #dc2626 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-700",
    css: "--tw-gradient-to: #b91c1c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-800",
    css: "--tw-gradient-to: #991b1b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-900",
    css: "--tw-gradient-to: #7f1d1d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-red-950",
    css: "--tw-gradient-to: #450a0a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-50",
    css: "--tw-gradient-to: #fff7ed var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-100",
    css: "--tw-gradient-to: #ffedd5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-200",
    css: "--tw-gradient-to: #fed7aa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-300",
    css: "--tw-gradient-to: #fdba74 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-400",
    css: "--tw-gradient-to: #fb923c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-500",
    css: "--tw-gradient-to: #f97316 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-600",
    css: "--tw-gradient-to: #ea580c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-700",
    css: "--tw-gradient-to: #c2410c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-800",
    css: "--tw-gradient-to: #9a3412 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-900",
    css: "--tw-gradient-to: #7c2d12 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-orange-950",
    css: "--tw-gradient-to: #431407 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-50",
    css: "--tw-gradient-to: #fffbeb var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-100",
    css: "--tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-200",
    css: "--tw-gradient-to: #fde68a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-300",
    css: "--tw-gradient-to: #fcd34d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-400",
    css: "--tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-500",
    css: "--tw-gradient-to: #f59e0b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-600",
    css: "--tw-gradient-to: #d97706 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-700",
    css: "--tw-gradient-to: #b45309 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-800",
    css: "--tw-gradient-to: #92400e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-900",
    css: "--tw-gradient-to: #78350f var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-amber-950",
    css: "--tw-gradient-to: #451a03 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-50",
    css: "--tw-gradient-to: #fefce8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-100",
    css: "--tw-gradient-to: #fef9c3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-200",
    css: "--tw-gradient-to: #fef08a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-300",
    css: "--tw-gradient-to: #fde047 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-400",
    css: "--tw-gradient-to: #facc15 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-500",
    css: "--tw-gradient-to: #eab308 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-600",
    css: "--tw-gradient-to: #ca8a04 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-700",
    css: "--tw-gradient-to: #a16207 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-800",
    css: "--tw-gradient-to: #854d0e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-900",
    css: "--tw-gradient-to: #713f12 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-yellow-950",
    css: "--tw-gradient-to: #422006 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-50",
    css: "--tw-gradient-to: #f7fee7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-100",
    css: "--tw-gradient-to: #ecfccb var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-200",
    css: "--tw-gradient-to: #d9f99d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-300",
    css: "--tw-gradient-to: #bef264 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-400",
    css: "--tw-gradient-to: #a3e635 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-500",
    css: "--tw-gradient-to: #84cc16 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-600",
    css: "--tw-gradient-to: #65a30d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-700",
    css: "--tw-gradient-to: #4d7c0f var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-800",
    css: "--tw-gradient-to: #3f6212 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-900",
    css: "--tw-gradient-to: #365314 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-lime-950",
    css: "--tw-gradient-to: #1a2e05 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-50",
    css: "--tw-gradient-to: #f0fdf4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-100",
    css: "--tw-gradient-to: #dcfce7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-200",
    css: "--tw-gradient-to: #bbf7d0 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-300",
    css: "--tw-gradient-to: #86efac var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-400",
    css: "--tw-gradient-to: #4ade80 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-500",
    css: "--tw-gradient-to: #22c55e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-600",
    css: "--tw-gradient-to: #16a34a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-700",
    css: "--tw-gradient-to: #15803d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-800",
    css: "--tw-gradient-to: #166534 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-900",
    css: "--tw-gradient-to: #14532d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-green-950",
    css: "--tw-gradient-to: #052e16 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-50",
    css: "--tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-100",
    css: "--tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-200",
    css: "--tw-gradient-to: #a7f3d0 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-300",
    css: "--tw-gradient-to: #6ee7b7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-400",
    css: "--tw-gradient-to: #34d399 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-500",
    css: "--tw-gradient-to: #10b981 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-600",
    css: "--tw-gradient-to: #059669 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-700",
    css: "--tw-gradient-to: #047857 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-800",
    css: "--tw-gradient-to: #065f46 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-900",
    css: "--tw-gradient-to: #064e3b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-emerald-950",
    css: "--tw-gradient-to: #022c22 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-50",
    css: "--tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-100",
    css: "--tw-gradient-to: #ccfbf1 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-200",
    css: "--tw-gradient-to: #99f6e4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-300",
    css: "--tw-gradient-to: #5eead4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-400",
    css: "--tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-500",
    css: "--tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-600",
    css: "--tw-gradient-to: #0d9488 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-700",
    css: "--tw-gradient-to: #0f766e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-800",
    css: "--tw-gradient-to: #115e59 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-900",
    css: "--tw-gradient-to: #134e4a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-teal-950",
    css: "--tw-gradient-to: #042f2e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-50",
    css: "--tw-gradient-to: #ecfeff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-100",
    css: "--tw-gradient-to: #cffafe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-200",
    css: "--tw-gradient-to: #a5f3fc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-300",
    css: "--tw-gradient-to: #67e8f9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-400",
    css: "--tw-gradient-to: #22d3ee var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-500",
    css: "--tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-600",
    css: "--tw-gradient-to: #0891b2 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-700",
    css: "--tw-gradient-to: #0e7490 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-800",
    css: "--tw-gradient-to: #155e75 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-900",
    css: "--tw-gradient-to: #164e63 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-cyan-950",
    css: "--tw-gradient-to: #083344 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-50",
    css: "--tw-gradient-to: #f0f9ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-100",
    css: "--tw-gradient-to: #e0f2fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-200",
    css: "--tw-gradient-to: #bae6fd var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-300",
    css: "--tw-gradient-to: #7dd3fc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-400",
    css: "--tw-gradient-to: #38bdf8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-500",
    css: "--tw-gradient-to: #0ea5e9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-600",
    css: "--tw-gradient-to: #0284c7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-700",
    css: "--tw-gradient-to: #0369a1 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-800",
    css: "--tw-gradient-to: #075985 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-900",
    css: "--tw-gradient-to: #0c4a6e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-sky-950",
    css: "--tw-gradient-to: #082f49 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-50",
    css: "--tw-gradient-to: #eff6ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-100",
    css: "--tw-gradient-to: #dbeafe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-200",
    css: "--tw-gradient-to: #bfdbfe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-300",
    css: "--tw-gradient-to: #93c5fd var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-400",
    css: "--tw-gradient-to: #60a5fa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-500",
    css: "--tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-600",
    css: "--tw-gradient-to: #2563eb var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-700",
    css: "--tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-800",
    css: "--tw-gradient-to: #1e40af var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-900",
    css: "--tw-gradient-to: #1e3a8a var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-blue-950",
    css: "--tw-gradient-to: #172554 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-50",
    css: "--tw-gradient-to: #eef2ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-100",
    css: "--tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-200",
    css: "--tw-gradient-to: #c7d2fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-300",
    css: "--tw-gradient-to: #a5b4fc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-400",
    css: "--tw-gradient-to: #818cf8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-500",
    css: "--tw-gradient-to: #6366f1 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-600",
    css: "--tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-700",
    css: "--tw-gradient-to: #4338ca var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-800",
    css: "--tw-gradient-to: #3730a3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-900",
    css: "--tw-gradient-to: #312e81 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-indigo-950",
    css: "--tw-gradient-to: #1e1b4b var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-50",
    css: "--tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-100",
    css: "--tw-gradient-to: #ede9fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-200",
    css: "--tw-gradient-to: #ddd6fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-300",
    css: "--tw-gradient-to: #c4b5fd var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-400",
    css: "--tw-gradient-to: #a78bfa var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-500",
    css: "--tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-600",
    css: "--tw-gradient-to: #7c3aed var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-700",
    css: "--tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-800",
    css: "--tw-gradient-to: #5b21b6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-900",
    css: "--tw-gradient-to: #4c1d95 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-violet-950",
    css: "--tw-gradient-to: #2e1065 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-50",
    css: "--tw-gradient-to: #faf5ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-100",
    css: "--tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-200",
    css: "--tw-gradient-to: #e9d5ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-300",
    css: "--tw-gradient-to: #d8b4fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-400",
    css: "--tw-gradient-to: #c084fc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-500",
    css: "--tw-gradient-to: #a855f7 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-600",
    css: "--tw-gradient-to: #9333ea var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-700",
    css: "--tw-gradient-to: #7e22ce var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-800",
    css: "--tw-gradient-to: #6b21a8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-900",
    css: "--tw-gradient-to: #581c87 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-purple-950",
    css: "--tw-gradient-to: #3b0764 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-50",
    css: "--tw-gradient-to: #fdf4ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-100",
    css: "--tw-gradient-to: #fae8ff var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-200",
    css: "--tw-gradient-to: #f5d0fe var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-300",
    css: "--tw-gradient-to: #f0abfc var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-400",
    css: "--tw-gradient-to: #e879f9 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-500",
    css: "--tw-gradient-to: #d946ef var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-600",
    css: "--tw-gradient-to: #c026d3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-700",
    css: "--tw-gradient-to: #a21caf var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-800",
    css: "--tw-gradient-to: #86198f var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-900",
    css: "--tw-gradient-to: #701a75 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-fuchsia-950",
    css: "--tw-gradient-to: #4a044e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-50",
    css: "--tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-100",
    css: "--tw-gradient-to: #fce7f3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-200",
    css: "--tw-gradient-to: #fbcfe8 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-300",
    css: "--tw-gradient-to: #f9a8d4 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-400",
    css: "--tw-gradient-to: #f472b6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-500",
    css: "--tw-gradient-to: #ec4899 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-600",
    css: "--tw-gradient-to: #db2777 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-700",
    css: "--tw-gradient-to: #be185d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-800",
    css: "--tw-gradient-to: #9d174d var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-900",
    css: "--tw-gradient-to: #831843 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-pink-950",
    css: "--tw-gradient-to: #500724 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-50",
    css: "--tw-gradient-to: #fff1f2 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-100",
    css: "--tw-gradient-to: #ffe4e6 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-200",
    css: "--tw-gradient-to: #fecdd3 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-300",
    css: "--tw-gradient-to: #fda4af var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-400",
    css: "--tw-gradient-to: #fb7185 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-500",
    css: "--tw-gradient-to: #f43f5e var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-600",
    css: "--tw-gradient-to: #e11d48 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-700",
    css: "--tw-gradient-to: #be123c var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-800",
    css: "--tw-gradient-to: #9f1239 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-900",
    css: "--tw-gradient-to: #881337 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-rose-950",
    css: "--tw-gradient-to: #4c0519 var(--tw-gradient-to-position);",
  },
  {
    tailwind: "to-0%",
    css: "--tw-gradient-to-position: 0%;",
  },
  {
    tailwind: "to-5%",
    css: "--tw-gradient-to-position: 5%;",
  },
  {
    tailwind: "to-10%",
    css: "--tw-gradient-to-position: 10%;",
  },
  {
    tailwind: "to-15%",
    css: "--tw-gradient-to-position: 15%;",
  },
  {
    tailwind: "to-20%",
    css: "--tw-gradient-to-position: 20%;",
  },
  {
    tailwind: "to-25%",
    css: "--tw-gradient-to-position: 25%;",
  },
  {
    tailwind: "to-30%",
    css: "--tw-gradient-to-position: 30%;",
  },
  {
    tailwind: "to-35%",
    css: "--tw-gradient-to-position: 35%;",
  },
  {
    tailwind: "to-40%",
    css: "--tw-gradient-to-position: 40%;",
  },
  {
    tailwind: "to-45%",
    css: "--tw-gradient-to-position: 45%;",
  },
  {
    tailwind: "to-50%",
    css: "--tw-gradient-to-position: 50%;",
  },
  {
    tailwind: "to-55%",
    css: "--tw-gradient-to-position: 55%;",
  },
  {
    tailwind: "to-60%",
    css: "--tw-gradient-to-position: 60%;",
  },
  {
    tailwind: "to-65%",
    css: "--tw-gradient-to-position: 65%;",
  },
  {
    tailwind: "to-70%",
    css: "--tw-gradient-to-position: 70%;",
  },
  {
    tailwind: "to-75%",
    css: "--tw-gradient-to-position: 75%;",
  },
  {
    tailwind: "to-80%",
    css: "--tw-gradient-to-position: 80%;",
  },
  {
    tailwind: "to-85%",
    css: "--tw-gradient-to-position: 85%;",
  },
  {
    tailwind: "to-90%",
    css: "--tw-gradient-to-position: 90%;",
  },
  {
    tailwind: "to-95%",
    css: "--tw-gradient-to-position: 95%;",
  },
  {
    tailwind: "to-100%",
    css: "--tw-gradient-to-position: 100%;",
  },
  {
    tailwind: "rounded-none",
    css: "border-radius: 0px;",
  },
  {
    tailwind: "rounded-sm",
    css: "border-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded",
    css: "border-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-md",
    css: "border-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-lg",
    css: "border-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-xl",
    css: "border-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-2xl",
    css: "border-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-3xl",
    css: "border-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-full",
    css: "border-radius: 9999px;",
  },
  {
    tailwind: "rounded-s-none",
    css: "border-start-start-radius: 0px;\nborder-end-start-radius: 0px;",
  },
  {
    tailwind: "rounded-s-sm",
    css: "border-start-start-radius: 0.125rem; /* 2px */\nborder-end-start-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-s",
    css: "border-start-start-radius: 0.25rem; /* 4px */\nborder-end-start-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-s-md",
    css: "border-start-start-radius: 0.375rem; /* 6px */\nborder-end-start-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-s-lg",
    css: "border-start-start-radius: 0.5rem; /* 8px */\nborder-end-start-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-s-xl",
    css: "border-start-start-radius: 0.75rem; /* 12px */\nborder-end-start-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-s-2xl",
    css: "border-start-start-radius: 1rem; /* 16px */\nborder-end-start-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-s-3xl",
    css: "border-start-start-radius: 1.5rem; /* 24px */\nborder-end-start-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-s-full",
    css: "border-start-start-radius: 9999px;\nborder-end-start-radius: 9999px;",
  },
  {
    tailwind: "rounded-e-none",
    css: "border-start-end-radius: 0px;\nborder-end-end-radius: 0px;",
  },
  {
    tailwind: "rounded-e-sm",
    css: "border-start-end-radius: 0.125rem; /* 2px */\nborder-end-end-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-e",
    css: "border-start-end-radius: 0.25rem; /* 4px */\nborder-end-end-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-e-md",
    css: "border-start-end-radius: 0.375rem; /* 6px */\nborder-end-end-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-e-lg",
    css: "border-start-end-radius: 0.5rem; /* 8px */\nborder-end-end-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-e-xl",
    css: "border-start-end-radius: 0.75rem; /* 12px */\nborder-end-end-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-e-2xl",
    css: "border-start-end-radius: 1rem; /* 16px */\nborder-end-end-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-e-3xl",
    css: "border-start-end-radius: 1.5rem; /* 24px */\nborder-end-end-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-e-full",
    css: "border-start-end-radius: 9999px;\nborder-end-end-radius: 9999px;",
  },
  {
    tailwind: "rounded-t-none",
    css: "border-top-left-radius: 0px;\nborder-top-right-radius: 0px;",
  },
  {
    tailwind: "rounded-t-sm",
    css: "border-top-left-radius: 0.125rem; /* 2px */\nborder-top-right-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-t",
    css: "border-top-left-radius: 0.25rem; /* 4px */\nborder-top-right-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-t-md",
    css: "border-top-left-radius: 0.375rem; /* 6px */\nborder-top-right-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-t-lg",
    css: "border-top-left-radius: 0.5rem; /* 8px */\nborder-top-right-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-t-xl",
    css: "border-top-left-radius: 0.75rem; /* 12px */\nborder-top-right-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-t-2xl",
    css: "border-top-left-radius: 1rem; /* 16px */\nborder-top-right-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-t-3xl",
    css: "border-top-left-radius: 1.5rem; /* 24px */\nborder-top-right-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-t-full",
    css: "border-top-left-radius: 9999px;\nborder-top-right-radius: 9999px;",
  },
  {
    tailwind: "rounded-r-none",
    css: "border-top-right-radius: 0px;\nborder-bottom-right-radius: 0px;",
  },
  {
    tailwind: "rounded-r-sm",
    css: "border-top-right-radius: 0.125rem; /* 2px */\nborder-bottom-right-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-r",
    css: "border-top-right-radius: 0.25rem; /* 4px */\nborder-bottom-right-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-r-md",
    css: "border-top-right-radius: 0.375rem; /* 6px */\nborder-bottom-right-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-r-lg",
    css: "border-top-right-radius: 0.5rem; /* 8px */\nborder-bottom-right-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-r-xl",
    css: "border-top-right-radius: 0.75rem; /* 12px */\nborder-bottom-right-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-r-2xl",
    css: "border-top-right-radius: 1rem; /* 16px */\nborder-bottom-right-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-r-3xl",
    css: "border-top-right-radius: 1.5rem; /* 24px */\nborder-bottom-right-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-r-full",
    css: "border-top-right-radius: 9999px;\nborder-bottom-right-radius: 9999px;",
  },
  {
    tailwind: "rounded-b-none",
    css: "border-bottom-right-radius: 0px;\nborder-bottom-left-radius: 0px;",
  },
  {
    tailwind: "rounded-b-sm",
    css: "border-bottom-right-radius: 0.125rem; /* 2px */\nborder-bottom-left-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-b",
    css: "border-bottom-right-radius: 0.25rem; /* 4px */\nborder-bottom-left-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-b-md",
    css: "border-bottom-right-radius: 0.375rem; /* 6px */\nborder-bottom-left-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-b-lg",
    css: "border-bottom-right-radius: 0.5rem; /* 8px */\nborder-bottom-left-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-b-xl",
    css: "border-bottom-right-radius: 0.75rem; /* 12px */\nborder-bottom-left-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-b-2xl",
    css: "border-bottom-right-radius: 1rem; /* 16px */\nborder-bottom-left-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-b-3xl",
    css: "border-bottom-right-radius: 1.5rem; /* 24px */\nborder-bottom-left-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-b-full",
    css: "border-bottom-right-radius: 9999px;\nborder-bottom-left-radius: 9999px;",
  },
  {
    tailwind: "rounded-l-none",
    css: "border-top-left-radius: 0px;\nborder-bottom-left-radius: 0px;",
  },
  {
    tailwind: "rounded-l-sm",
    css: "border-top-left-radius: 0.125rem; /* 2px */\nborder-bottom-left-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-l",
    css: "border-top-left-radius: 0.25rem; /* 4px */\nborder-bottom-left-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-l-md",
    css: "border-top-left-radius: 0.375rem; /* 6px */\nborder-bottom-left-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-l-lg",
    css: "border-top-left-radius: 0.5rem; /* 8px */\nborder-bottom-left-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-l-xl",
    css: "border-top-left-radius: 0.75rem; /* 12px */\nborder-bottom-left-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-l-2xl",
    css: "border-top-left-radius: 1rem; /* 16px */\nborder-bottom-left-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-l-3xl",
    css: "border-top-left-radius: 1.5rem; /* 24px */\nborder-bottom-left-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-l-full",
    css: "border-top-left-radius: 9999px;\nborder-bottom-left-radius: 9999px;",
  },
  {
    tailwind: "rounded-ss-none",
    css: "border-start-start-radius: 0px;",
  },
  {
    tailwind: "rounded-ss-sm",
    css: "border-start-start-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-ss",
    css: "border-start-start-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-ss-md",
    css: "border-start-start-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-ss-lg",
    css: "border-start-start-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-ss-xl",
    css: "border-start-start-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-ss-2xl",
    css: "border-start-start-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-ss-3xl",
    css: "border-start-start-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-ss-full",
    css: "border-start-start-radius: 9999px;",
  },
  {
    tailwind: "rounded-se-none",
    css: "border-start-end-radius: 0px;",
  },
  {
    tailwind: "rounded-se-sm",
    css: "border-start-end-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-se",
    css: "border-start-end-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-se-md",
    css: "border-start-end-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-se-lg",
    css: "border-start-end-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-se-xl",
    css: "border-start-end-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-se-2xl",
    css: "border-start-end-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-se-3xl",
    css: "border-start-end-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-se-full",
    css: "border-start-end-radius: 9999px;",
  },
  {
    tailwind: "rounded-ee-none",
    css: "border-end-end-radius: 0px;",
  },
  {
    tailwind: "rounded-ee-sm",
    css: "border-end-end-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-ee",
    css: "border-end-end-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-ee-md",
    css: "border-end-end-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-ee-lg",
    css: "border-end-end-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-ee-xl",
    css: "border-end-end-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-ee-2xl",
    css: "border-end-end-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-ee-3xl",
    css: "border-end-end-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-ee-full",
    css: "border-end-end-radius: 9999px;",
  },
  {
    tailwind: "rounded-es-none",
    css: "border-end-start-radius: 0px;",
  },
  {
    tailwind: "rounded-es-sm",
    css: "border-end-start-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-es",
    css: "border-end-start-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-es-md",
    css: "border-end-start-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-es-lg",
    css: "border-end-start-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-es-xl",
    css: "border-end-start-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-es-2xl",
    css: "border-end-start-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-es-3xl",
    css: "border-end-start-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-es-full",
    css: "border-end-start-radius: 9999px;",
  },
  {
    tailwind: "rounded-tl-none",
    css: "border-top-left-radius: 0px;",
  },
  {
    tailwind: "rounded-tl-sm",
    css: "border-top-left-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-tl",
    css: "border-top-left-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-tl-md",
    css: "border-top-left-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-tl-lg",
    css: "border-top-left-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-tl-xl",
    css: "border-top-left-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-tl-2xl",
    css: "border-top-left-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-tl-3xl",
    css: "border-top-left-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-tl-full",
    css: "border-top-left-radius: 9999px;",
  },
  {
    tailwind: "rounded-tr-none",
    css: "border-top-right-radius: 0px;",
  },
  {
    tailwind: "rounded-tr-sm",
    css: "border-top-right-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-tr",
    css: "border-top-right-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-tr-md",
    css: "border-top-right-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-tr-lg",
    css: "border-top-right-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-tr-xl",
    css: "border-top-right-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-tr-2xl",
    css: "border-top-right-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-tr-3xl",
    css: "border-top-right-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-tr-full",
    css: "border-top-right-radius: 9999px;",
  },
  {
    tailwind: "rounded-br-none",
    css: "border-bottom-right-radius: 0px;",
  },
  {
    tailwind: "rounded-br-sm",
    css: "border-bottom-right-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-br",
    css: "border-bottom-right-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-br-md",
    css: "border-bottom-right-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-br-lg",
    css: "border-bottom-right-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-br-xl",
    css: "border-bottom-right-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-br-2xl",
    css: "border-bottom-right-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-br-3xl",
    css: "border-bottom-right-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-br-full",
    css: "border-bottom-right-radius: 9999px;",
  },
  {
    tailwind: "rounded-bl-none",
    css: "border-bottom-left-radius: 0px;",
  },
  {
    tailwind: "rounded-bl-sm",
    css: "border-bottom-left-radius: 0.125rem; /* 2px */",
  },
  {
    tailwind: "rounded-bl",
    css: "border-bottom-left-radius: 0.25rem; /* 4px */",
  },
  {
    tailwind: "rounded-bl-md",
    css: "border-bottom-left-radius: 0.375rem; /* 6px */",
  },
  {
    tailwind: "rounded-bl-lg",
    css: "border-bottom-left-radius: 0.5rem; /* 8px */",
  },
  {
    tailwind: "rounded-bl-xl",
    css: "border-bottom-left-radius: 0.75rem; /* 12px */",
  },
  {
    tailwind: "rounded-bl-2xl",
    css: "border-bottom-left-radius: 1rem; /* 16px */",
  },
  {
    tailwind: "rounded-bl-3xl",
    css: "border-bottom-left-radius: 1.5rem; /* 24px */",
  },
  {
    tailwind: "rounded-bl-full",
    css: "border-bottom-left-radius: 9999px;",
  },
  {
    tailwind: "border-0",
    css: "border-width: 0px;",
  },
  {
    tailwind: "border-2",
    css: "border-width: 2px;",
  },
  {
    tailwind: "border-4",
    css: "border-width: 4px;",
  },
  {
    tailwind: "border-8",
    css: "border-width: 8px;",
  },
  {
    tailwind: "border",
    css: "border-width: 1px;",
  },
  {
    tailwind: "border-x-0",
    css: "border-left-width: 0px;\nborder-right-width: 0px;",
  },
  {
    tailwind: "border-x-2",
    css: "border-left-width: 2px;\nborder-right-width: 2px;",
  },
  {
    tailwind: "border-x-4",
    css: "border-left-width: 4px;\nborder-right-width: 4px;",
  },
  {
    tailwind: "border-x-8",
    css: "border-left-width: 8px;\nborder-right-width: 8px;",
  },
  {
    tailwind: "border-x",
    css: "border-left-width: 1px;\nborder-right-width: 1px;",
  },
  {
    tailwind: "border-y-0",
    css: "border-top-width: 0px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "border-y-2",
    css: "border-top-width: 2px;\nborder-bottom-width: 2px;",
  },
  {
    tailwind: "border-y-4",
    css: "border-top-width: 4px;\nborder-bottom-width: 4px;",
  },
  {
    tailwind: "border-y-8",
    css: "border-top-width: 8px;\nborder-bottom-width: 8px;",
  },
  {
    tailwind: "border-y",
    css: "border-top-width: 1px;\nborder-bottom-width: 1px;",
  },
  {
    tailwind: "border-s-0",
    css: "border-inline-start-width: 0px;",
  },
  {
    tailwind: "border-s-2",
    css: "border-inline-start-width: 2px;",
  },
  {
    tailwind: "border-s-4",
    css: "border-inline-start-width: 4px;",
  },
  {
    tailwind: "border-s-8",
    css: "border-inline-start-width: 8px;",
  },
  {
    tailwind: "border-s",
    css: "border-inline-start-width: 1px;",
  },
  {
    tailwind: "border-e-0",
    css: "border-inline-end-width: 0px;",
  },
  {
    tailwind: "border-e-2",
    css: "border-inline-end-width: 2px;",
  },
  {
    tailwind: "border-e-4",
    css: "border-inline-end-width: 4px;",
  },
  {
    tailwind: "border-e-8",
    css: "border-inline-end-width: 8px;",
  },
  {
    tailwind: "border-e",
    css: "border-inline-end-width: 1px;",
  },
  {
    tailwind: "border-t-0",
    css: "border-top-width: 0px;",
  },
  {
    tailwind: "border-t-2",
    css: "border-top-width: 2px;",
  },
  {
    tailwind: "border-t-4",
    css: "border-top-width: 4px;",
  },
  {
    tailwind: "border-t-8",
    css: "border-top-width: 8px;",
  },
  {
    tailwind: "border-t",
    css: "border-top-width: 1px;",
  },
  {
    tailwind: "border-r-0",
    css: "border-right-width: 0px;",
  },
  {
    tailwind: "border-r-2",
    css: "border-right-width: 2px;",
  },
  {
    tailwind: "border-r-4",
    css: "border-right-width: 4px;",
  },
  {
    tailwind: "border-r-8",
    css: "border-right-width: 8px;",
  },
  {
    tailwind: "border-r",
    css: "border-right-width: 1px;",
  },
  {
    tailwind: "border-b-0",
    css: "border-bottom-width: 0px;",
  },
  {
    tailwind: "border-b-2",
    css: "border-bottom-width: 2px;",
  },
  {
    tailwind: "border-b-4",
    css: "border-bottom-width: 4px;",
  },
  {
    tailwind: "border-b-8",
    css: "border-bottom-width: 8px;",
  },
  {
    tailwind: "border-b",
    css: "border-bottom-width: 1px;",
  },
  {
    tailwind: "border-l-0",
    css: "border-left-width: 0px;",
  },
  {
    tailwind: "border-l-2",
    css: "border-left-width: 2px;",
  },
  {
    tailwind: "border-l-4",
    css: "border-left-width: 4px;",
  },
  {
    tailwind: "border-l-8",
    css: "border-left-width: 8px;",
  },
  {
    tailwind: "border-l",
    css: "border-left-width: 1px;",
  },
  {
    tailwind: "border-inherit",
    css: "border-color: inherit;",
  },
  {
    tailwind: "border-current",
    css: "border-color: currentColor;",
  },
  {
    tailwind: "border-transparent",
    css: "border-color: transparent;",
  },
  {
    tailwind: "border-black",
    css: "border-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-white",
    css: "border-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-slate-50",
    css: "border-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-slate-100",
    css: "border-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-slate-200",
    css: "border-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-slate-300",
    css: "border-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-slate-400",
    css: "border-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-slate-500",
    css: "border-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-slate-600",
    css: "border-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-slate-700",
    css: "border-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-slate-800",
    css: "border-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-slate-900",
    css: "border-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-slate-950",
    css: "border-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-gray-50",
    css: "border-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-gray-100",
    css: "border-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-gray-200",
    css: "border-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-gray-300",
    css: "border-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-gray-400",
    css: "border-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-gray-500",
    css: "border-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-gray-600",
    css: "border-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-gray-700",
    css: "border-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-gray-800",
    css: "border-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-gray-900",
    css: "border-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-gray-950",
    css: "border-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-zinc-50",
    css: "border-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-zinc-100",
    css: "border-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-zinc-200",
    css: "border-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-zinc-300",
    css: "border-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-zinc-400",
    css: "border-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-zinc-500",
    css: "border-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-zinc-600",
    css: "border-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-zinc-700",
    css: "border-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-zinc-800",
    css: "border-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-zinc-900",
    css: "border-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-zinc-950",
    css: "border-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-neutral-50",
    css: "border-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-neutral-100",
    css: "border-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-neutral-200",
    css: "border-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-neutral-300",
    css: "border-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-neutral-400",
    css: "border-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-neutral-500",
    css: "border-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-neutral-600",
    css: "border-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-neutral-700",
    css: "border-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-neutral-800",
    css: "border-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-neutral-900",
    css: "border-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-neutral-950",
    css: "border-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-stone-50",
    css: "border-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-stone-100",
    css: "border-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-stone-200",
    css: "border-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-stone-300",
    css: "border-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-stone-400",
    css: "border-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-stone-500",
    css: "border-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-stone-600",
    css: "border-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-stone-700",
    css: "border-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-stone-800",
    css: "border-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-stone-900",
    css: "border-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-stone-950",
    css: "border-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-red-50",
    css: "border-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-red-100",
    css: "border-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-red-200",
    css: "border-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-red-300",
    css: "border-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-red-400",
    css: "border-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-red-500",
    css: "border-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-red-600",
    css: "border-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-red-700",
    css: "border-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-red-800",
    css: "border-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-red-900",
    css: "border-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-red-950",
    css: "border-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-orange-50",
    css: "border-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-orange-100",
    css: "border-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-orange-200",
    css: "border-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-orange-300",
    css: "border-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-orange-400",
    css: "border-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-orange-500",
    css: "border-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-orange-600",
    css: "border-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-orange-700",
    css: "border-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-orange-800",
    css: "border-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-orange-900",
    css: "border-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-orange-950",
    css: "border-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-amber-50",
    css: "border-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-amber-100",
    css: "border-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-amber-200",
    css: "border-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-amber-300",
    css: "border-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-amber-400",
    css: "border-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-amber-500",
    css: "border-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-amber-600",
    css: "border-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-amber-700",
    css: "border-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-amber-800",
    css: "border-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-amber-900",
    css: "border-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-amber-950",
    css: "border-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-yellow-50",
    css: "border-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-yellow-100",
    css: "border-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-yellow-200",
    css: "border-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-yellow-300",
    css: "border-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-yellow-400",
    css: "border-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-yellow-500",
    css: "border-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-yellow-600",
    css: "border-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-yellow-700",
    css: "border-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-yellow-800",
    css: "border-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-yellow-900",
    css: "border-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-yellow-950",
    css: "border-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-lime-50",
    css: "border-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-lime-100",
    css: "border-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-lime-200",
    css: "border-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-lime-300",
    css: "border-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-lime-400",
    css: "border-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-lime-500",
    css: "border-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-lime-600",
    css: "border-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-lime-700",
    css: "border-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-lime-800",
    css: "border-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-lime-900",
    css: "border-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-lime-950",
    css: "border-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-green-50",
    css: "border-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-green-100",
    css: "border-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-green-200",
    css: "border-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-green-300",
    css: "border-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-green-400",
    css: "border-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-green-500",
    css: "border-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-green-600",
    css: "border-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-green-700",
    css: "border-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-green-800",
    css: "border-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-green-900",
    css: "border-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-green-950",
    css: "border-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-emerald-50",
    css: "border-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-emerald-100",
    css: "border-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-emerald-200",
    css: "border-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-emerald-300",
    css: "border-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-emerald-400",
    css: "border-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-emerald-500",
    css: "border-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-emerald-600",
    css: "border-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-emerald-700",
    css: "border-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-emerald-800",
    css: "border-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-emerald-900",
    css: "border-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-emerald-950",
    css: "border-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-teal-50",
    css: "border-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-teal-100",
    css: "border-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-teal-200",
    css: "border-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-teal-300",
    css: "border-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-teal-400",
    css: "border-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-teal-500",
    css: "border-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-teal-600",
    css: "border-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-teal-700",
    css: "border-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-teal-800",
    css: "border-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-teal-900",
    css: "border-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-teal-950",
    css: "border-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-cyan-50",
    css: "border-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-cyan-100",
    css: "border-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-cyan-200",
    css: "border-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-cyan-300",
    css: "border-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-cyan-400",
    css: "border-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-cyan-500",
    css: "border-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-cyan-600",
    css: "border-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-cyan-700",
    css: "border-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-cyan-800",
    css: "border-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-cyan-900",
    css: "border-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-cyan-950",
    css: "border-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-sky-50",
    css: "border-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-sky-100",
    css: "border-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-sky-200",
    css: "border-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-sky-300",
    css: "border-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-sky-400",
    css: "border-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-sky-500",
    css: "border-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-sky-600",
    css: "border-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-sky-700",
    css: "border-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-sky-800",
    css: "border-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-sky-900",
    css: "border-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-sky-950",
    css: "border-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-blue-50",
    css: "border-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-blue-100",
    css: "border-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-blue-200",
    css: "border-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-blue-300",
    css: "border-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-blue-400",
    css: "border-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-blue-500",
    css: "border-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-blue-600",
    css: "border-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-blue-700",
    css: "border-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-blue-800",
    css: "border-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-blue-900",
    css: "border-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-blue-950",
    css: "border-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-indigo-50",
    css: "border-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-indigo-100",
    css: "border-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-indigo-200",
    css: "border-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-indigo-300",
    css: "border-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-indigo-400",
    css: "border-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-indigo-500",
    css: "border-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-indigo-600",
    css: "border-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-indigo-700",
    css: "border-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-indigo-800",
    css: "border-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-indigo-900",
    css: "border-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-indigo-950",
    css: "border-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-violet-50",
    css: "border-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-violet-100",
    css: "border-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-violet-200",
    css: "border-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-violet-300",
    css: "border-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-violet-400",
    css: "border-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-violet-500",
    css: "border-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-violet-600",
    css: "border-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-violet-700",
    css: "border-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-violet-800",
    css: "border-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-violet-900",
    css: "border-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-violet-950",
    css: "border-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-purple-50",
    css: "border-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-purple-100",
    css: "border-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-purple-200",
    css: "border-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-purple-300",
    css: "border-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-purple-400",
    css: "border-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-purple-500",
    css: "border-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-purple-600",
    css: "border-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-purple-700",
    css: "border-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-purple-800",
    css: "border-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-purple-900",
    css: "border-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-purple-950",
    css: "border-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-fuchsia-50",
    css: "border-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-fuchsia-100",
    css: "border-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-fuchsia-200",
    css: "border-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-fuchsia-300",
    css: "border-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-fuchsia-400",
    css: "border-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-fuchsia-500",
    css: "border-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-fuchsia-600",
    css: "border-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-fuchsia-700",
    css: "border-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-fuchsia-800",
    css: "border-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-fuchsia-900",
    css: "border-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-fuchsia-950",
    css: "border-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-pink-50",
    css: "border-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-pink-100",
    css: "border-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-pink-200",
    css: "border-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-pink-300",
    css: "border-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-pink-400",
    css: "border-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-pink-500",
    css: "border-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-pink-600",
    css: "border-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-pink-700",
    css: "border-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-pink-800",
    css: "border-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-pink-900",
    css: "border-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-pink-950",
    css: "border-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-rose-50",
    css: "border-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-rose-100",
    css: "border-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-rose-200",
    css: "border-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-rose-300",
    css: "border-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-rose-400",
    css: "border-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-rose-500",
    css: "border-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-rose-600",
    css: "border-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-rose-700",
    css: "border-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-rose-800",
    css: "border-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-rose-900",
    css: "border-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-rose-950",
    css: "border-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-x-inherit",
    css: "border-left-color: inherit;\nborder-right-color: inherit;",
  },
  {
    tailwind: "border-x-current",
    css: "border-left-color: currentColor;\nborder-right-color: currentColor;",
  },
  {
    tailwind: "border-x-transparent",
    css: "border-left-color: transparent;\nborder-right-color: transparent;",
  },
  {
    tailwind: "border-x-black",
    css: "border-left-color: rgb(0 0 0);\nborder-right-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-x-white",
    css: "border-left-color: rgb(255 255 255);\nborder-right-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-x-slate-50",
    css: "border-left-color: rgb(248 250 252);\nborder-right-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-x-slate-100",
    css: "border-left-color: rgb(241 245 249);\nborder-right-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-x-slate-200",
    css: "border-left-color: rgb(226 232 240);\nborder-right-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-x-slate-300",
    css: "border-left-color: rgb(203 213 225);\nborder-right-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-x-slate-400",
    css: "border-left-color: rgb(148 163 184);\nborder-right-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-x-slate-500",
    css: "border-left-color: rgb(100 116 139);\nborder-right-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-x-slate-600",
    css: "border-left-color: rgb(71 85 105);\nborder-right-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-x-slate-700",
    css: "border-left-color: rgb(51 65 85);\nborder-right-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-x-slate-800",
    css: "border-left-color: rgb(30 41 59);\nborder-right-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-x-slate-900",
    css: "border-left-color: rgb(15 23 42);\nborder-right-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-x-slate-950",
    css: "border-left-color: rgb(2 6 23);\nborder-right-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-x-gray-50",
    css: "border-left-color: rgb(249 250 251);\nborder-right-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-x-gray-100",
    css: "border-left-color: rgb(243 244 246);\nborder-right-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-x-gray-200",
    css: "border-left-color: rgb(229 231 235);\nborder-right-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-x-gray-300",
    css: "border-left-color: rgb(209 213 219);\nborder-right-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-x-gray-400",
    css: "border-left-color: rgb(156 163 175);\nborder-right-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-x-gray-500",
    css: "border-left-color: rgb(107 114 128);\nborder-right-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-x-gray-600",
    css: "border-left-color: rgb(75 85 99);\nborder-right-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-x-gray-700",
    css: "border-left-color: rgb(55 65 81);\nborder-right-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-x-gray-800",
    css: "border-left-color: rgb(31 41 55);\nborder-right-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-x-gray-900",
    css: "border-left-color: rgb(17 24 39);\nborder-right-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-x-gray-950",
    css: "border-left-color: rgb(3 7 18);\nborder-right-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-x-zinc-50",
    css: "border-left-color: rgb(250 250 250);\nborder-right-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-x-zinc-100",
    css: "border-left-color: rgb(244 244 245);\nborder-right-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-x-zinc-200",
    css: "border-left-color: rgb(228 228 231);\nborder-right-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-x-zinc-300",
    css: "border-left-color: rgb(212 212 216);\nborder-right-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-x-zinc-400",
    css: "border-left-color: rgb(161 161 170);\nborder-right-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-x-zinc-500",
    css: "border-left-color: rgb(113 113 122);\nborder-right-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-x-zinc-600",
    css: "border-left-color: rgb(82 82 91);\nborder-right-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-x-zinc-700",
    css: "border-left-color: rgb(63 63 70);\nborder-right-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-x-zinc-800",
    css: "border-left-color: rgb(39 39 42);\nborder-right-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-x-zinc-900",
    css: "border-left-color: rgb(24 24 27);\nborder-right-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-x-zinc-950",
    css: "border-left-color: rgb(9 9 11);\nborder-right-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-x-neutral-50",
    css: "border-left-color: rgb(250 250 250);\nborder-right-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-x-neutral-100",
    css: "border-left-color: rgb(245 245 245);\nborder-right-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-x-neutral-200",
    css: "border-left-color: rgb(229 229 229);\nborder-right-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-x-neutral-300",
    css: "border-left-color: rgb(212 212 212);\nborder-right-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-x-neutral-400",
    css: "border-left-color: rgb(163 163 163);\nborder-right-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-x-neutral-500",
    css: "border-left-color: rgb(115 115 115);\nborder-right-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-x-neutral-600",
    css: "border-left-color: rgb(82 82 82);\nborder-right-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-x-neutral-700",
    css: "border-left-color: rgb(64 64 64);\nborder-right-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-x-neutral-800",
    css: "border-left-color: rgb(38 38 38);\nborder-right-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-x-neutral-900",
    css: "border-left-color: rgb(23 23 23);\nborder-right-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-x-neutral-950",
    css: "border-left-color: rgb(10 10 10);\nborder-right-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-x-stone-50",
    css: "border-left-color: rgb(250 250 249);\nborder-right-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-x-stone-100",
    css: "border-left-color: rgb(245 245 244);\nborder-right-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-x-stone-200",
    css: "border-left-color: rgb(231 229 228);\nborder-right-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-x-stone-300",
    css: "border-left-color: rgb(214 211 209);\nborder-right-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-x-stone-400",
    css: "border-left-color: rgb(168 162 158);\nborder-right-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-x-stone-500",
    css: "border-left-color: rgb(120 113 108);\nborder-right-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-x-stone-600",
    css: "border-left-color: rgb(87 83 78);\nborder-right-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-x-stone-700",
    css: "border-left-color: rgb(68 64 60);\nborder-right-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-x-stone-800",
    css: "border-left-color: rgb(41 37 36);\nborder-right-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-x-stone-900",
    css: "border-left-color: rgb(28 25 23);\nborder-right-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-x-stone-950",
    css: "border-left-color: rgb(12 10 9);\nborder-right-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-x-red-50",
    css: "border-left-color: rgb(254 242 242);\nborder-right-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-x-red-100",
    css: "border-left-color: rgb(254 226 226);\nborder-right-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-x-red-200",
    css: "border-left-color: rgb(254 202 202);\nborder-right-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-x-red-300",
    css: "border-left-color: rgb(252 165 165);\nborder-right-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-x-red-400",
    css: "border-left-color: rgb(248 113 113);\nborder-right-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-x-red-500",
    css: "border-left-color: rgb(239 68 68);\nborder-right-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-x-red-600",
    css: "border-left-color: rgb(220 38 38);\nborder-right-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-x-red-700",
    css: "border-left-color: rgb(185 28 28);\nborder-right-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-x-red-800",
    css: "border-left-color: rgb(153 27 27);\nborder-right-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-x-red-900",
    css: "border-left-color: rgb(127 29 29);\nborder-right-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-x-red-950",
    css: "border-left-color: rgb(69 10 10);\nborder-right-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-x-orange-50",
    css: "border-left-color: rgb(255 247 237);\nborder-right-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-x-orange-100",
    css: "border-left-color: rgb(255 237 213);\nborder-right-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-x-orange-200",
    css: "border-left-color: rgb(254 215 170);\nborder-right-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-x-orange-300",
    css: "border-left-color: rgb(253 186 116);\nborder-right-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-x-orange-400",
    css: "border-left-color: rgb(251 146 60);\nborder-right-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-x-orange-500",
    css: "border-left-color: rgb(249 115 22);\nborder-right-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-x-orange-600",
    css: "border-left-color: rgb(234 88 12);\nborder-right-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-x-orange-700",
    css: "border-left-color: rgb(194 65 12);\nborder-right-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-x-orange-800",
    css: "border-left-color: rgb(154 52 18);\nborder-right-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-x-orange-900",
    css: "border-left-color: rgb(124 45 18);\nborder-right-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-x-orange-950",
    css: "border-left-color: rgb(67 20 7);\nborder-right-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-x-amber-50",
    css: "border-left-color: rgb(255 251 235);\nborder-right-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-x-amber-100",
    css: "border-left-color: rgb(254 243 199);\nborder-right-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-x-amber-200",
    css: "border-left-color: rgb(253 230 138);\nborder-right-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-x-amber-300",
    css: "border-left-color: rgb(252 211 77);\nborder-right-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-x-amber-400",
    css: "border-left-color: rgb(251 191 36);\nborder-right-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-x-amber-500",
    css: "border-left-color: rgb(245 158 11);\nborder-right-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-x-amber-600",
    css: "border-left-color: rgb(217 119 6);\nborder-right-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-x-amber-700",
    css: "border-left-color: rgb(180 83 9);\nborder-right-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-x-amber-800",
    css: "border-left-color: rgb(146 64 14);\nborder-right-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-x-amber-900",
    css: "border-left-color: rgb(120 53 15);\nborder-right-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-x-amber-950",
    css: "border-left-color: rgb(69 26 3);\nborder-right-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-x-yellow-50",
    css: "border-left-color: rgb(254 252 232);\nborder-right-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-x-yellow-100",
    css: "border-left-color: rgb(254 249 195);\nborder-right-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-x-yellow-200",
    css: "border-left-color: rgb(254 240 138);\nborder-right-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-x-yellow-300",
    css: "border-left-color: rgb(253 224 71);\nborder-right-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-x-yellow-400",
    css: "border-left-color: rgb(250 204 21);\nborder-right-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-x-yellow-500",
    css: "border-left-color: rgb(234 179 8);\nborder-right-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-x-yellow-600",
    css: "border-left-color: rgb(202 138 4);\nborder-right-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-x-yellow-700",
    css: "border-left-color: rgb(161 98 7);\nborder-right-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-x-yellow-800",
    css: "border-left-color: rgb(133 77 14);\nborder-right-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-x-yellow-900",
    css: "border-left-color: rgb(113 63 18);\nborder-right-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-x-yellow-950",
    css: "border-left-color: rgb(66 32 6);\nborder-right-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-x-lime-50",
    css: "border-left-color: rgb(247 254 231);\nborder-right-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-x-lime-100",
    css: "border-left-color: rgb(236 252 203);\nborder-right-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-x-lime-200",
    css: "border-left-color: rgb(217 249 157);\nborder-right-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-x-lime-300",
    css: "border-left-color: rgb(190 242 100);\nborder-right-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-x-lime-400",
    css: "border-left-color: rgb(163 230 53);\nborder-right-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-x-lime-500",
    css: "border-left-color: rgb(132 204 22);\nborder-right-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-x-lime-600",
    css: "border-left-color: rgb(101 163 13);\nborder-right-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-x-lime-700",
    css: "border-left-color: rgb(77 124 15);\nborder-right-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-x-lime-800",
    css: "border-left-color: rgb(63 98 18);\nborder-right-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-x-lime-900",
    css: "border-left-color: rgb(54 83 20);\nborder-right-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-x-lime-950",
    css: "border-left-color: rgb(26 46 5);\nborder-right-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-x-green-50",
    css: "border-left-color: rgb(240 253 244);\nborder-right-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-x-green-100",
    css: "border-left-color: rgb(220 252 231);\nborder-right-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-x-green-200",
    css: "border-left-color: rgb(187 247 208);\nborder-right-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-x-green-300",
    css: "border-left-color: rgb(134 239 172);\nborder-right-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-x-green-400",
    css: "border-left-color: rgb(74 222 128);\nborder-right-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-x-green-500",
    css: "border-left-color: rgb(34 197 94);\nborder-right-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-x-green-600",
    css: "border-left-color: rgb(22 163 74);\nborder-right-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-x-green-700",
    css: "border-left-color: rgb(21 128 61);\nborder-right-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-x-green-800",
    css: "border-left-color: rgb(22 101 52);\nborder-right-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-x-green-900",
    css: "border-left-color: rgb(20 83 45);\nborder-right-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-x-green-950",
    css: "border-left-color: rgb(5 46 22);\nborder-right-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-x-emerald-50",
    css: "border-left-color: rgb(236 253 245);\nborder-right-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-x-emerald-100",
    css: "border-left-color: rgb(209 250 229);\nborder-right-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-x-emerald-200",
    css: "border-left-color: rgb(167 243 208);\nborder-right-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-x-emerald-300",
    css: "border-left-color: rgb(110 231 183);\nborder-right-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-x-emerald-400",
    css: "border-left-color: rgb(52 211 153);\nborder-right-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-x-emerald-500",
    css: "border-left-color: rgb(16 185 129);\nborder-right-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-x-emerald-600",
    css: "border-left-color: rgb(5 150 105);\nborder-right-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-x-emerald-700",
    css: "border-left-color: rgb(4 120 87);\nborder-right-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-x-emerald-800",
    css: "border-left-color: rgb(6 95 70);\nborder-right-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-x-emerald-900",
    css: "border-left-color: rgb(6 78 59);\nborder-right-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-x-emerald-950",
    css: "border-left-color: rgb(2 44 34);\nborder-right-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-x-teal-50",
    css: "border-left-color: rgb(240 253 250);\nborder-right-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-x-teal-100",
    css: "border-left-color: rgb(204 251 241);\nborder-right-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-x-teal-200",
    css: "border-left-color: rgb(153 246 228);\nborder-right-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-x-teal-300",
    css: "border-left-color: rgb(94 234 212);\nborder-right-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-x-teal-400",
    css: "border-left-color: rgb(45 212 191);\nborder-right-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-x-teal-500",
    css: "border-left-color: rgb(20 184 166);\nborder-right-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-x-teal-600",
    css: "border-left-color: rgb(13 148 136);\nborder-right-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-x-teal-700",
    css: "border-left-color: rgb(15 118 110);\nborder-right-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-x-teal-800",
    css: "border-left-color: rgb(17 94 89);\nborder-right-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-x-teal-900",
    css: "border-left-color: rgb(19 78 74);\nborder-right-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-x-teal-950",
    css: "border-left-color: rgb(4 47 46);\nborder-right-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-x-cyan-50",
    css: "border-left-color: rgb(236 254 255);\nborder-right-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-x-cyan-100",
    css: "border-left-color: rgb(207 250 254);\nborder-right-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-x-cyan-200",
    css: "border-left-color: rgb(165 243 252);\nborder-right-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-x-cyan-300",
    css: "border-left-color: rgb(103 232 249);\nborder-right-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-x-cyan-400",
    css: "border-left-color: rgb(34 211 238);\nborder-right-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-x-cyan-500",
    css: "border-left-color: rgb(6 182 212);\nborder-right-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-x-cyan-600",
    css: "border-left-color: rgb(8 145 178);\nborder-right-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-x-cyan-700",
    css: "border-left-color: rgb(14 116 144);\nborder-right-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-x-cyan-800",
    css: "border-left-color: rgb(21 94 117);\nborder-right-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-x-cyan-900",
    css: "border-left-color: rgb(22 78 99);\nborder-right-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-x-cyan-950",
    css: "border-left-color: rgb(8 51 68);\nborder-right-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-x-sky-50",
    css: "border-left-color: rgb(240 249 255);\nborder-right-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-x-sky-100",
    css: "border-left-color: rgb(224 242 254);\nborder-right-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-x-sky-200",
    css: "border-left-color: rgb(186 230 253);\nborder-right-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-x-sky-300",
    css: "border-left-color: rgb(125 211 252);\nborder-right-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-x-sky-400",
    css: "border-left-color: rgb(56 189 248);\nborder-right-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-x-sky-500",
    css: "border-left-color: rgb(14 165 233);\nborder-right-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-x-sky-600",
    css: "border-left-color: rgb(2 132 199);\nborder-right-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-x-sky-700",
    css: "border-left-color: rgb(3 105 161);\nborder-right-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-x-sky-800",
    css: "border-left-color: rgb(7 89 133);\nborder-right-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-x-sky-900",
    css: "border-left-color: rgb(12 74 110);\nborder-right-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-x-sky-950",
    css: "border-left-color: rgb(8 47 73);\nborder-right-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-x-blue-50",
    css: "border-left-color: rgb(239 246 255);\nborder-right-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-x-blue-100",
    css: "border-left-color: rgb(219 234 254);\nborder-right-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-x-blue-200",
    css: "border-left-color: rgb(191 219 254);\nborder-right-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-x-blue-300",
    css: "border-left-color: rgb(147 197 253);\nborder-right-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-x-blue-400",
    css: "border-left-color: rgb(96 165 250);\nborder-right-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-x-blue-500",
    css: "border-left-color: rgb(59 130 246);\nborder-right-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-x-blue-600",
    css: "border-left-color: rgb(37 99 235);\nborder-right-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-x-blue-700",
    css: "border-left-color: rgb(29 78 216);\nborder-right-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-x-blue-800",
    css: "border-left-color: rgb(30 64 175);\nborder-right-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-x-blue-900",
    css: "border-left-color: rgb(30 58 138);\nborder-right-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-x-blue-950",
    css: "border-left-color: rgb(23 37 84);\nborder-right-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-x-indigo-50",
    css: "border-left-color: rgb(238 242 255);\nborder-right-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-x-indigo-100",
    css: "border-left-color: rgb(224 231 255);\nborder-right-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-x-indigo-200",
    css: "border-left-color: rgb(199 210 254);\nborder-right-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-x-indigo-300",
    css: "border-left-color: rgb(165 180 252);\nborder-right-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-x-indigo-400",
    css: "border-left-color: rgb(129 140 248);\nborder-right-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-x-indigo-500",
    css: "border-left-color: rgb(99 102 241);\nborder-right-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-x-indigo-600",
    css: "border-left-color: rgb(79 70 229);\nborder-right-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-x-indigo-700",
    css: "border-left-color: rgb(67 56 202);\nborder-right-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-x-indigo-800",
    css: "border-left-color: rgb(55 48 163);\nborder-right-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-x-indigo-900",
    css: "border-left-color: rgb(49 46 129);\nborder-right-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-x-indigo-950",
    css: "border-left-color: rgb(30 27 75);\nborder-right-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-x-violet-50",
    css: "border-left-color: rgb(245 243 255);\nborder-right-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-x-violet-100",
    css: "border-left-color: rgb(237 233 254);\nborder-right-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-x-violet-200",
    css: "border-left-color: rgb(221 214 254);\nborder-right-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-x-violet-300",
    css: "border-left-color: rgb(196 181 253);\nborder-right-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-x-violet-400",
    css: "border-left-color: rgb(167 139 250);\nborder-right-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-x-violet-500",
    css: "border-left-color: rgb(139 92 246);\nborder-right-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-x-violet-600",
    css: "border-left-color: rgb(124 58 237);\nborder-right-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-x-violet-700",
    css: "border-left-color: rgb(109 40 217);\nborder-right-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-x-violet-800",
    css: "border-left-color: rgb(91 33 182);\nborder-right-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-x-violet-900",
    css: "border-left-color: rgb(76 29 149);\nborder-right-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-x-violet-950",
    css: "border-left-color: rgb(46 16 101);\nborder-right-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-x-purple-50",
    css: "border-left-color: rgb(250 245 255);\nborder-right-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-x-purple-100",
    css: "border-left-color: rgb(243 232 255);\nborder-right-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-x-purple-200",
    css: "border-left-color: rgb(233 213 255);\nborder-right-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-x-purple-300",
    css: "border-left-color: rgb(216 180 254);\nborder-right-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-x-purple-400",
    css: "border-left-color: rgb(192 132 252);\nborder-right-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-x-purple-500",
    css: "border-left-color: rgb(168 85 247);\nborder-right-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-x-purple-600",
    css: "border-left-color: rgb(147 51 234);\nborder-right-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-x-purple-700",
    css: "border-left-color: rgb(126 34 206);\nborder-right-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-x-purple-800",
    css: "border-left-color: rgb(107 33 168);\nborder-right-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-x-purple-900",
    css: "border-left-color: rgb(88 28 135);\nborder-right-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-x-purple-950",
    css: "border-left-color: rgb(59 7 100);\nborder-right-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-x-fuchsia-50",
    css: "border-left-color: rgb(253 244 255);\nborder-right-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-x-fuchsia-100",
    css: "border-left-color: rgb(250 232 255);\nborder-right-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-x-fuchsia-200",
    css: "border-left-color: rgb(245 208 254);\nborder-right-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-x-fuchsia-300",
    css: "border-left-color: rgb(240 171 252);\nborder-right-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-x-fuchsia-400",
    css: "border-left-color: rgb(232 121 249);\nborder-right-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-x-fuchsia-500",
    css: "border-left-color: rgb(217 70 239);\nborder-right-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-x-fuchsia-600",
    css: "border-left-color: rgb(192 38 211);\nborder-right-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-x-fuchsia-700",
    css: "border-left-color: rgb(162 28 175);\nborder-right-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-x-fuchsia-800",
    css: "border-left-color: rgb(134 25 143);\nborder-right-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-x-fuchsia-900",
    css: "border-left-color: rgb(112 26 117);\nborder-right-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-x-fuchsia-950",
    css: "border-left-color: rgb(74 4 78);\nborder-right-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-x-pink-50",
    css: "border-left-color: rgb(253 242 248);\nborder-right-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-x-pink-100",
    css: "border-left-color: rgb(252 231 243);\nborder-right-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-x-pink-200",
    css: "border-left-color: rgb(251 207 232);\nborder-right-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-x-pink-300",
    css: "border-left-color: rgb(249 168 212);\nborder-right-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-x-pink-400",
    css: "border-left-color: rgb(244 114 182);\nborder-right-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-x-pink-500",
    css: "border-left-color: rgb(236 72 153);\nborder-right-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-x-pink-600",
    css: "border-left-color: rgb(219 39 119);\nborder-right-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-x-pink-700",
    css: "border-left-color: rgb(190 24 93);\nborder-right-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-x-pink-800",
    css: "border-left-color: rgb(157 23 77);\nborder-right-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-x-pink-900",
    css: "border-left-color: rgb(131 24 67);\nborder-right-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-x-pink-950",
    css: "border-left-color: rgb(80 7 36);\nborder-right-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-x-rose-50",
    css: "border-left-color: rgb(255 241 242);\nborder-right-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-x-rose-100",
    css: "border-left-color: rgb(255 228 230);\nborder-right-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-x-rose-200",
    css: "border-left-color: rgb(254 205 211);\nborder-right-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-x-rose-300",
    css: "border-left-color: rgb(253 164 175);\nborder-right-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-x-rose-400",
    css: "border-left-color: rgb(251 113 133);\nborder-right-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-x-rose-500",
    css: "border-left-color: rgb(244 63 94);\nborder-right-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-x-rose-600",
    css: "border-left-color: rgb(225 29 72);\nborder-right-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-x-rose-700",
    css: "border-left-color: rgb(190 18 60);\nborder-right-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-x-rose-800",
    css: "border-left-color: rgb(159 18 57);\nborder-right-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-x-rose-900",
    css: "border-left-color: rgb(136 19 55);\nborder-right-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-x-rose-950",
    css: "border-left-color: rgb(76 5 25);\nborder-right-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-y-inherit",
    css: "border-top-color: inherit;\nborder-bottom-color: inherit;",
  },
  {
    tailwind: "border-y-current",
    css: "border-top-color: currentColor;\nborder-bottom-color: currentColor;",
  },
  {
    tailwind: "border-y-transparent",
    css: "border-top-color: transparent;\nborder-bottom-color: transparent;",
  },
  {
    tailwind: "border-y-black",
    css: "border-top-color: rgb(0 0 0);\nborder-bottom-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-y-white",
    css: "border-top-color: rgb(255 255 255);\nborder-bottom-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-y-slate-50",
    css: "border-top-color: rgb(248 250 252);\nborder-bottom-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-y-slate-100",
    css: "border-top-color: rgb(241 245 249);\nborder-bottom-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-y-slate-200",
    css: "border-top-color: rgb(226 232 240);\nborder-bottom-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-y-slate-300",
    css: "border-top-color: rgb(203 213 225);\nborder-bottom-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-y-slate-400",
    css: "border-top-color: rgb(148 163 184);\nborder-bottom-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-y-slate-500",
    css: "border-top-color: rgb(100 116 139);\nborder-bottom-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-y-slate-600",
    css: "border-top-color: rgb(71 85 105);\nborder-bottom-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-y-slate-700",
    css: "border-top-color: rgb(51 65 85);\nborder-bottom-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-y-slate-800",
    css: "border-top-color: rgb(30 41 59);\nborder-bottom-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-y-slate-900",
    css: "border-top-color: rgb(15 23 42);\nborder-bottom-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-y-slate-950",
    css: "border-top-color: rgb(2 6 23);\nborder-bottom-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-y-gray-50",
    css: "border-top-color: rgb(249 250 251);\nborder-bottom-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-y-gray-100",
    css: "border-top-color: rgb(243 244 246);\nborder-bottom-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-y-gray-200",
    css: "border-top-color: rgb(229 231 235);\nborder-bottom-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-y-gray-300",
    css: "border-top-color: rgb(209 213 219);\nborder-bottom-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-y-gray-400",
    css: "border-top-color: rgb(156 163 175);\nborder-bottom-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-y-gray-500",
    css: "border-top-color: rgb(107 114 128);\nborder-bottom-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-y-gray-600",
    css: "border-top-color: rgb(75 85 99);\nborder-bottom-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-y-gray-700",
    css: "border-top-color: rgb(55 65 81);\nborder-bottom-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-y-gray-800",
    css: "border-top-color: rgb(31 41 55);\nborder-bottom-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-y-gray-900",
    css: "border-top-color: rgb(17 24 39);\nborder-bottom-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-y-gray-950",
    css: "border-top-color: rgb(3 7 18);\nborder-bottom-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-y-zinc-50",
    css: "border-top-color: rgb(250 250 250);\nborder-bottom-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-y-zinc-100",
    css: "border-top-color: rgb(244 244 245);\nborder-bottom-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-y-zinc-200",
    css: "border-top-color: rgb(228 228 231);\nborder-bottom-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-y-zinc-300",
    css: "border-top-color: rgb(212 212 216);\nborder-bottom-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-y-zinc-400",
    css: "border-top-color: rgb(161 161 170);\nborder-bottom-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-y-zinc-500",
    css: "border-top-color: rgb(113 113 122);\nborder-bottom-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-y-zinc-600",
    css: "border-top-color: rgb(82 82 91);\nborder-bottom-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-y-zinc-700",
    css: "border-top-color: rgb(63 63 70);\nborder-bottom-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-y-zinc-800",
    css: "border-top-color: rgb(39 39 42);\nborder-bottom-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-y-zinc-900",
    css: "border-top-color: rgb(24 24 27);\nborder-bottom-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-y-zinc-950",
    css: "border-top-color: rgb(9 9 11);\nborder-bottom-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-y-neutral-50",
    css: "border-top-color: rgb(250 250 250);\nborder-bottom-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-y-neutral-100",
    css: "border-top-color: rgb(245 245 245);\nborder-bottom-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-y-neutral-200",
    css: "border-top-color: rgb(229 229 229);\nborder-bottom-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-y-neutral-300",
    css: "border-top-color: rgb(212 212 212);\nborder-bottom-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-y-neutral-400",
    css: "border-top-color: rgb(163 163 163);\nborder-bottom-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-y-neutral-500",
    css: "border-top-color: rgb(115 115 115);\nborder-bottom-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-y-neutral-600",
    css: "border-top-color: rgb(82 82 82);\nborder-bottom-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-y-neutral-700",
    css: "border-top-color: rgb(64 64 64);\nborder-bottom-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-y-neutral-800",
    css: "border-top-color: rgb(38 38 38);\nborder-bottom-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-y-neutral-900",
    css: "border-top-color: rgb(23 23 23);\nborder-bottom-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-y-neutral-950",
    css: "border-top-color: rgb(10 10 10);\nborder-bottom-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-y-stone-50",
    css: "border-top-color: rgb(250 250 249);\nborder-bottom-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-y-stone-100",
    css: "border-top-color: rgb(245 245 244);\nborder-bottom-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-y-stone-200",
    css: "border-top-color: rgb(231 229 228);\nborder-bottom-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-y-stone-300",
    css: "border-top-color: rgb(214 211 209);\nborder-bottom-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-y-stone-400",
    css: "border-top-color: rgb(168 162 158);\nborder-bottom-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-y-stone-500",
    css: "border-top-color: rgb(120 113 108);\nborder-bottom-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-y-stone-600",
    css: "border-top-color: rgb(87 83 78);\nborder-bottom-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-y-stone-700",
    css: "border-top-color: rgb(68 64 60);\nborder-bottom-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-y-stone-800",
    css: "border-top-color: rgb(41 37 36);\nborder-bottom-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-y-stone-900",
    css: "border-top-color: rgb(28 25 23);\nborder-bottom-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-y-stone-950",
    css: "border-top-color: rgb(12 10 9);\nborder-bottom-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-y-red-50",
    css: "border-top-color: rgb(254 242 242);\nborder-bottom-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-y-red-100",
    css: "border-top-color: rgb(254 226 226);\nborder-bottom-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-y-red-200",
    css: "border-top-color: rgb(254 202 202);\nborder-bottom-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-y-red-300",
    css: "border-top-color: rgb(252 165 165);\nborder-bottom-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-y-red-400",
    css: "border-top-color: rgb(248 113 113);\nborder-bottom-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-y-red-500",
    css: "border-top-color: rgb(239 68 68);\nborder-bottom-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-y-red-600",
    css: "border-top-color: rgb(220 38 38);\nborder-bottom-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-y-red-700",
    css: "border-top-color: rgb(185 28 28);\nborder-bottom-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-y-red-800",
    css: "border-top-color: rgb(153 27 27);\nborder-bottom-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-y-red-900",
    css: "border-top-color: rgb(127 29 29);\nborder-bottom-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-y-red-950",
    css: "border-top-color: rgb(69 10 10);\nborder-bottom-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-y-orange-50",
    css: "border-top-color: rgb(255 247 237);\nborder-bottom-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-y-orange-100",
    css: "border-top-color: rgb(255 237 213);\nborder-bottom-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-y-orange-200",
    css: "border-top-color: rgb(254 215 170);\nborder-bottom-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-y-orange-300",
    css: "border-top-color: rgb(253 186 116);\nborder-bottom-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-y-orange-400",
    css: "border-top-color: rgb(251 146 60);\nborder-bottom-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-y-orange-500",
    css: "border-top-color: rgb(249 115 22);\nborder-bottom-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-y-orange-600",
    css: "border-top-color: rgb(234 88 12);\nborder-bottom-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-y-orange-700",
    css: "border-top-color: rgb(194 65 12);\nborder-bottom-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-y-orange-800",
    css: "border-top-color: rgb(154 52 18);\nborder-bottom-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-y-orange-900",
    css: "border-top-color: rgb(124 45 18);\nborder-bottom-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-y-orange-950",
    css: "border-top-color: rgb(67 20 7);\nborder-bottom-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-y-amber-50",
    css: "border-top-color: rgb(255 251 235);\nborder-bottom-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-y-amber-100",
    css: "border-top-color: rgb(254 243 199);\nborder-bottom-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-y-amber-200",
    css: "border-top-color: rgb(253 230 138);\nborder-bottom-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-y-amber-300",
    css: "border-top-color: rgb(252 211 77);\nborder-bottom-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-y-amber-400",
    css: "border-top-color: rgb(251 191 36);\nborder-bottom-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-y-amber-500",
    css: "border-top-color: rgb(245 158 11);\nborder-bottom-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-y-amber-600",
    css: "border-top-color: rgb(217 119 6);\nborder-bottom-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-y-amber-700",
    css: "border-top-color: rgb(180 83 9);\nborder-bottom-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-y-amber-800",
    css: "border-top-color: rgb(146 64 14);\nborder-bottom-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-y-amber-900",
    css: "border-top-color: rgb(120 53 15);\nborder-bottom-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-y-amber-950",
    css: "border-top-color: rgb(69 26 3);\nborder-bottom-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-y-yellow-50",
    css: "border-top-color: rgb(254 252 232);\nborder-bottom-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-y-yellow-100",
    css: "border-top-color: rgb(254 249 195);\nborder-bottom-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-y-yellow-200",
    css: "border-top-color: rgb(254 240 138);\nborder-bottom-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-y-yellow-300",
    css: "border-top-color: rgb(253 224 71);\nborder-bottom-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-y-yellow-400",
    css: "border-top-color: rgb(250 204 21);\nborder-bottom-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-y-yellow-500",
    css: "border-top-color: rgb(234 179 8);\nborder-bottom-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-y-yellow-600",
    css: "border-top-color: rgb(202 138 4);\nborder-bottom-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-y-yellow-700",
    css: "border-top-color: rgb(161 98 7);\nborder-bottom-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-y-yellow-800",
    css: "border-top-color: rgb(133 77 14);\nborder-bottom-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-y-yellow-900",
    css: "border-top-color: rgb(113 63 18);\nborder-bottom-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-y-yellow-950",
    css: "border-top-color: rgb(66 32 6);\nborder-bottom-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-y-lime-50",
    css: "border-top-color: rgb(247 254 231);\nborder-bottom-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-y-lime-100",
    css: "border-top-color: rgb(236 252 203);\nborder-bottom-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-y-lime-200",
    css: "border-top-color: rgb(217 249 157);\nborder-bottom-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-y-lime-300",
    css: "border-top-color: rgb(190 242 100);\nborder-bottom-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-y-lime-400",
    css: "border-top-color: rgb(163 230 53);\nborder-bottom-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-y-lime-500",
    css: "border-top-color: rgb(132 204 22);\nborder-bottom-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-y-lime-600",
    css: "border-top-color: rgb(101 163 13);\nborder-bottom-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-y-lime-700",
    css: "border-top-color: rgb(77 124 15);\nborder-bottom-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-y-lime-800",
    css: "border-top-color: rgb(63 98 18);\nborder-bottom-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-y-lime-900",
    css: "border-top-color: rgb(54 83 20);\nborder-bottom-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-y-lime-950",
    css: "border-top-color: rgb(26 46 5);\nborder-bottom-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-y-green-50",
    css: "border-top-color: rgb(240 253 244);\nborder-bottom-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-y-green-100",
    css: "border-top-color: rgb(220 252 231);\nborder-bottom-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-y-green-200",
    css: "border-top-color: rgb(187 247 208);\nborder-bottom-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-y-green-300",
    css: "border-top-color: rgb(134 239 172);\nborder-bottom-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-y-green-400",
    css: "border-top-color: rgb(74 222 128);\nborder-bottom-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-y-green-500",
    css: "border-top-color: rgb(34 197 94);\nborder-bottom-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-y-green-600",
    css: "border-top-color: rgb(22 163 74);\nborder-bottom-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-y-green-700",
    css: "border-top-color: rgb(21 128 61);\nborder-bottom-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-y-green-800",
    css: "border-top-color: rgb(22 101 52);\nborder-bottom-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-y-green-900",
    css: "border-top-color: rgb(20 83 45);\nborder-bottom-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-y-green-950",
    css: "border-top-color: rgb(5 46 22);\nborder-bottom-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-y-emerald-50",
    css: "border-top-color: rgb(236 253 245);\nborder-bottom-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-y-emerald-100",
    css: "border-top-color: rgb(209 250 229);\nborder-bottom-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-y-emerald-200",
    css: "border-top-color: rgb(167 243 208);\nborder-bottom-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-y-emerald-300",
    css: "border-top-color: rgb(110 231 183);\nborder-bottom-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-y-emerald-400",
    css: "border-top-color: rgb(52 211 153);\nborder-bottom-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-y-emerald-500",
    css: "border-top-color: rgb(16 185 129);\nborder-bottom-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-y-emerald-600",
    css: "border-top-color: rgb(5 150 105);\nborder-bottom-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-y-emerald-700",
    css: "border-top-color: rgb(4 120 87);\nborder-bottom-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-y-emerald-800",
    css: "border-top-color: rgb(6 95 70);\nborder-bottom-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-y-emerald-900",
    css: "border-top-color: rgb(6 78 59);\nborder-bottom-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-y-emerald-950",
    css: "border-top-color: rgb(2 44 34);\nborder-bottom-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-y-teal-50",
    css: "border-top-color: rgb(240 253 250);\nborder-bottom-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-y-teal-100",
    css: "border-top-color: rgb(204 251 241);\nborder-bottom-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-y-teal-200",
    css: "border-top-color: rgb(153 246 228);\nborder-bottom-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-y-teal-300",
    css: "border-top-color: rgb(94 234 212);\nborder-bottom-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-y-teal-400",
    css: "border-top-color: rgb(45 212 191);\nborder-bottom-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-y-teal-500",
    css: "border-top-color: rgb(20 184 166);\nborder-bottom-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-y-teal-600",
    css: "border-top-color: rgb(13 148 136);\nborder-bottom-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-y-teal-700",
    css: "border-top-color: rgb(15 118 110);\nborder-bottom-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-y-teal-800",
    css: "border-top-color: rgb(17 94 89);\nborder-bottom-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-y-teal-900",
    css: "border-top-color: rgb(19 78 74);\nborder-bottom-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-y-teal-950",
    css: "border-top-color: rgb(4 47 46);\nborder-bottom-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-y-cyan-50",
    css: "border-top-color: rgb(236 254 255);\nborder-bottom-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-y-cyan-100",
    css: "border-top-color: rgb(207 250 254);\nborder-bottom-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-y-cyan-200",
    css: "border-top-color: rgb(165 243 252);\nborder-bottom-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-y-cyan-300",
    css: "border-top-color: rgb(103 232 249);\nborder-bottom-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-y-cyan-400",
    css: "border-top-color: rgb(34 211 238);\nborder-bottom-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-y-cyan-500",
    css: "border-top-color: rgb(6 182 212);\nborder-bottom-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-y-cyan-600",
    css: "border-top-color: rgb(8 145 178);\nborder-bottom-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-y-cyan-700",
    css: "border-top-color: rgb(14 116 144);\nborder-bottom-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-y-cyan-800",
    css: "border-top-color: rgb(21 94 117);\nborder-bottom-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-y-cyan-900",
    css: "border-top-color: rgb(22 78 99);\nborder-bottom-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-y-cyan-950",
    css: "border-top-color: rgb(8 51 68);\nborder-bottom-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-y-sky-50",
    css: "border-top-color: rgb(240 249 255);\nborder-bottom-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-y-sky-100",
    css: "border-top-color: rgb(224 242 254);\nborder-bottom-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-y-sky-200",
    css: "border-top-color: rgb(186 230 253);\nborder-bottom-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-y-sky-300",
    css: "border-top-color: rgb(125 211 252);\nborder-bottom-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-y-sky-400",
    css: "border-top-color: rgb(56 189 248);\nborder-bottom-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-y-sky-500",
    css: "border-top-color: rgb(14 165 233);\nborder-bottom-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-y-sky-600",
    css: "border-top-color: rgb(2 132 199);\nborder-bottom-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-y-sky-700",
    css: "border-top-color: rgb(3 105 161);\nborder-bottom-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-y-sky-800",
    css: "border-top-color: rgb(7 89 133);\nborder-bottom-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-y-sky-900",
    css: "border-top-color: rgb(12 74 110);\nborder-bottom-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-y-sky-950",
    css: "border-top-color: rgb(8 47 73);\nborder-bottom-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-y-blue-50",
    css: "border-top-color: rgb(239 246 255);\nborder-bottom-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-y-blue-100",
    css: "border-top-color: rgb(219 234 254);\nborder-bottom-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-y-blue-200",
    css: "border-top-color: rgb(191 219 254);\nborder-bottom-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-y-blue-300",
    css: "border-top-color: rgb(147 197 253);\nborder-bottom-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-y-blue-400",
    css: "border-top-color: rgb(96 165 250);\nborder-bottom-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-y-blue-500",
    css: "border-top-color: rgb(59 130 246);\nborder-bottom-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-y-blue-600",
    css: "border-top-color: rgb(37 99 235);\nborder-bottom-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-y-blue-700",
    css: "border-top-color: rgb(29 78 216);\nborder-bottom-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-y-blue-800",
    css: "border-top-color: rgb(30 64 175);\nborder-bottom-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-y-blue-900",
    css: "border-top-color: rgb(30 58 138);\nborder-bottom-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-y-blue-950",
    css: "border-top-color: rgb(23 37 84);\nborder-bottom-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-y-indigo-50",
    css: "border-top-color: rgb(238 242 255);\nborder-bottom-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-y-indigo-100",
    css: "border-top-color: rgb(224 231 255);\nborder-bottom-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-y-indigo-200",
    css: "border-top-color: rgb(199 210 254);\nborder-bottom-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-y-indigo-300",
    css: "border-top-color: rgb(165 180 252);\nborder-bottom-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-y-indigo-400",
    css: "border-top-color: rgb(129 140 248);\nborder-bottom-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-y-indigo-500",
    css: "border-top-color: rgb(99 102 241);\nborder-bottom-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-y-indigo-600",
    css: "border-top-color: rgb(79 70 229);\nborder-bottom-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-y-indigo-700",
    css: "border-top-color: rgb(67 56 202);\nborder-bottom-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-y-indigo-800",
    css: "border-top-color: rgb(55 48 163);\nborder-bottom-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-y-indigo-900",
    css: "border-top-color: rgb(49 46 129);\nborder-bottom-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-y-indigo-950",
    css: "border-top-color: rgb(30 27 75);\nborder-bottom-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-y-violet-50",
    css: "border-top-color: rgb(245 243 255);\nborder-bottom-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-y-violet-100",
    css: "border-top-color: rgb(237 233 254);\nborder-bottom-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-y-violet-200",
    css: "border-top-color: rgb(221 214 254);\nborder-bottom-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-y-violet-300",
    css: "border-top-color: rgb(196 181 253);\nborder-bottom-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-y-violet-400",
    css: "border-top-color: rgb(167 139 250);\nborder-bottom-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-y-violet-500",
    css: "border-top-color: rgb(139 92 246);\nborder-bottom-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-y-violet-600",
    css: "border-top-color: rgb(124 58 237);\nborder-bottom-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-y-violet-700",
    css: "border-top-color: rgb(109 40 217);\nborder-bottom-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-y-violet-800",
    css: "border-top-color: rgb(91 33 182);\nborder-bottom-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-y-violet-900",
    css: "border-top-color: rgb(76 29 149);\nborder-bottom-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-y-violet-950",
    css: "border-top-color: rgb(46 16 101);\nborder-bottom-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-y-purple-50",
    css: "border-top-color: rgb(250 245 255);\nborder-bottom-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-y-purple-100",
    css: "border-top-color: rgb(243 232 255);\nborder-bottom-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-y-purple-200",
    css: "border-top-color: rgb(233 213 255);\nborder-bottom-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-y-purple-300",
    css: "border-top-color: rgb(216 180 254);\nborder-bottom-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-y-purple-400",
    css: "border-top-color: rgb(192 132 252);\nborder-bottom-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-y-purple-500",
    css: "border-top-color: rgb(168 85 247);\nborder-bottom-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-y-purple-600",
    css: "border-top-color: rgb(147 51 234);\nborder-bottom-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-y-purple-700",
    css: "border-top-color: rgb(126 34 206);\nborder-bottom-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-y-purple-800",
    css: "border-top-color: rgb(107 33 168);\nborder-bottom-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-y-purple-900",
    css: "border-top-color: rgb(88 28 135);\nborder-bottom-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-y-purple-950",
    css: "border-top-color: rgb(59 7 100);\nborder-bottom-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-y-fuchsia-50",
    css: "border-top-color: rgb(253 244 255);\nborder-bottom-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-y-fuchsia-100",
    css: "border-top-color: rgb(250 232 255);\nborder-bottom-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-y-fuchsia-200",
    css: "border-top-color: rgb(245 208 254);\nborder-bottom-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-y-fuchsia-300",
    css: "border-top-color: rgb(240 171 252);\nborder-bottom-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-y-fuchsia-400",
    css: "border-top-color: rgb(232 121 249);\nborder-bottom-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-y-fuchsia-500",
    css: "border-top-color: rgb(217 70 239);\nborder-bottom-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-y-fuchsia-600",
    css: "border-top-color: rgb(192 38 211);\nborder-bottom-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-y-fuchsia-700",
    css: "border-top-color: rgb(162 28 175);\nborder-bottom-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-y-fuchsia-800",
    css: "border-top-color: rgb(134 25 143);\nborder-bottom-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-y-fuchsia-900",
    css: "border-top-color: rgb(112 26 117);\nborder-bottom-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-y-fuchsia-950",
    css: "border-top-color: rgb(74 4 78);\nborder-bottom-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-y-pink-50",
    css: "border-top-color: rgb(253 242 248);\nborder-bottom-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-y-pink-100",
    css: "border-top-color: rgb(252 231 243);\nborder-bottom-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-y-pink-200",
    css: "border-top-color: rgb(251 207 232);\nborder-bottom-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-y-pink-300",
    css: "border-top-color: rgb(249 168 212);\nborder-bottom-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-y-pink-400",
    css: "border-top-color: rgb(244 114 182);\nborder-bottom-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-y-pink-500",
    css: "border-top-color: rgb(236 72 153);\nborder-bottom-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-y-pink-600",
    css: "border-top-color: rgb(219 39 119);\nborder-bottom-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-y-pink-700",
    css: "border-top-color: rgb(190 24 93);\nborder-bottom-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-y-pink-800",
    css: "border-top-color: rgb(157 23 77);\nborder-bottom-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-y-pink-900",
    css: "border-top-color: rgb(131 24 67);\nborder-bottom-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-y-pink-950",
    css: "border-top-color: rgb(80 7 36);\nborder-bottom-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-y-rose-50",
    css: "border-top-color: rgb(255 241 242);\nborder-bottom-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-y-rose-100",
    css: "border-top-color: rgb(255 228 230);\nborder-bottom-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-y-rose-200",
    css: "border-top-color: rgb(254 205 211);\nborder-bottom-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-y-rose-300",
    css: "border-top-color: rgb(253 164 175);\nborder-bottom-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-y-rose-400",
    css: "border-top-color: rgb(251 113 133);\nborder-bottom-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-y-rose-500",
    css: "border-top-color: rgb(244 63 94);\nborder-bottom-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-y-rose-600",
    css: "border-top-color: rgb(225 29 72);\nborder-bottom-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-y-rose-700",
    css: "border-top-color: rgb(190 18 60);\nborder-bottom-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-y-rose-800",
    css: "border-top-color: rgb(159 18 57);\nborder-bottom-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-y-rose-900",
    css: "border-top-color: rgb(136 19 55);\nborder-bottom-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-y-rose-950",
    css: "border-top-color: rgb(76 5 25);\nborder-bottom-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-s-inherit",
    css: "border-inline-start-color: inherit;",
  },
  {
    tailwind: "border-s-current",
    css: "border-inline-start-color: currentColor;",
  },
  {
    tailwind: "border-s-transparent",
    css: "border-inline-start-color: transparent;",
  },
  {
    tailwind: "border-s-black",
    css: "border-inline-start-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-s-white",
    css: "border-inline-start-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-s-slate-50",
    css: "border-inline-start-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-s-slate-100",
    css: "border-inline-start-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-s-slate-200",
    css: "border-inline-start-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-s-slate-300",
    css: "border-inline-start-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-s-slate-400",
    css: "border-inline-start-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-s-slate-500",
    css: "border-inline-start-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-s-slate-600",
    css: "border-inline-start-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-s-slate-700",
    css: "border-inline-start-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-s-slate-800",
    css: "border-inline-start-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-s-slate-900",
    css: "border-inline-start-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-s-slate-950",
    css: "border-inline-start-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-s-gray-50",
    css: "border-inline-start-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-s-gray-100",
    css: "border-inline-start-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-s-gray-200",
    css: "border-inline-start-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-s-gray-300",
    css: "border-inline-start-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-s-gray-400",
    css: "border-inline-start-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-s-gray-500",
    css: "border-inline-start-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-s-gray-600",
    css: "border-inline-start-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-s-gray-700",
    css: "border-inline-start-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-s-gray-800",
    css: "border-inline-start-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-s-gray-900",
    css: "border-inline-start-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-s-gray-950",
    css: "border-inline-start-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-s-zinc-50",
    css: "border-inline-start-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-s-zinc-100",
    css: "border-inline-start-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-s-zinc-200",
    css: "border-inline-start-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-s-zinc-300",
    css: "border-inline-start-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-s-zinc-400",
    css: "border-inline-start-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-s-zinc-500",
    css: "border-inline-start-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-s-zinc-600",
    css: "border-inline-start-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-s-zinc-700",
    css: "border-inline-start-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-s-zinc-800",
    css: "border-inline-start-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-s-zinc-900",
    css: "border-inline-start-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-s-zinc-950",
    css: "border-inline-start-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-s-neutral-50",
    css: "border-inline-start-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-s-neutral-100",
    css: "border-inline-start-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-s-neutral-200",
    css: "border-inline-start-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-s-neutral-300",
    css: "border-inline-start-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-s-neutral-400",
    css: "border-inline-start-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-s-neutral-500",
    css: "border-inline-start-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-s-neutral-600",
    css: "border-inline-start-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-s-neutral-700",
    css: "border-inline-start-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-s-neutral-800",
    css: "border-inline-start-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-s-neutral-900",
    css: "border-inline-start-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-s-neutral-950",
    css: "border-inline-start-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-s-stone-50",
    css: "border-inline-start-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-s-stone-100",
    css: "border-inline-start-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-s-stone-200",
    css: "border-inline-start-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-s-stone-300",
    css: "border-inline-start-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-s-stone-400",
    css: "border-inline-start-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-s-stone-500",
    css: "border-inline-start-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-s-stone-600",
    css: "border-inline-start-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-s-stone-700",
    css: "border-inline-start-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-s-stone-800",
    css: "border-inline-start-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-s-stone-900",
    css: "border-inline-start-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-s-stone-950",
    css: "border-inline-start-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-s-red-50",
    css: "border-inline-start-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-s-red-100",
    css: "border-inline-start-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-s-red-200",
    css: "border-inline-start-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-s-red-300",
    css: "border-inline-start-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-s-red-400",
    css: "border-inline-start-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-s-red-500",
    css: "border-inline-start-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-s-red-600",
    css: "border-inline-start-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-s-red-700",
    css: "border-inline-start-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-s-red-800",
    css: "border-inline-start-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-s-red-900",
    css: "border-inline-start-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-s-red-950",
    css: "border-inline-start-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-s-orange-50",
    css: "border-inline-start-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-s-orange-100",
    css: "border-inline-start-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-s-orange-200",
    css: "border-inline-start-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-s-orange-300",
    css: "border-inline-start-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-s-orange-400",
    css: "border-inline-start-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-s-orange-500",
    css: "border-inline-start-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-s-orange-600",
    css: "border-inline-start-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-s-orange-700",
    css: "border-inline-start-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-s-orange-800",
    css: "border-inline-start-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-s-orange-900",
    css: "border-inline-start-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-s-orange-950",
    css: "border-inline-start-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-s-amber-50",
    css: "border-inline-start-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-s-amber-100",
    css: "border-inline-start-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-s-amber-200",
    css: "border-inline-start-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-s-amber-300",
    css: "border-inline-start-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-s-amber-400",
    css: "border-inline-start-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-s-amber-500",
    css: "border-inline-start-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-s-amber-600",
    css: "border-inline-start-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-s-amber-700",
    css: "border-inline-start-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-s-amber-800",
    css: "border-inline-start-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-s-amber-900",
    css: "border-inline-start-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-s-amber-950",
    css: "border-inline-start-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-s-yellow-50",
    css: "border-inline-start-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-s-yellow-100",
    css: "border-inline-start-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-s-yellow-200",
    css: "border-inline-start-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-s-yellow-300",
    css: "border-inline-start-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-s-yellow-400",
    css: "border-inline-start-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-s-yellow-500",
    css: "border-inline-start-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-s-yellow-600",
    css: "border-inline-start-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-s-yellow-700",
    css: "border-inline-start-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-s-yellow-800",
    css: "border-inline-start-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-s-yellow-900",
    css: "border-inline-start-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-s-yellow-950",
    css: "border-inline-start-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-s-lime-50",
    css: "border-inline-start-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-s-lime-100",
    css: "border-inline-start-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-s-lime-200",
    css: "border-inline-start-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-s-lime-300",
    css: "border-inline-start-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-s-lime-400",
    css: "border-inline-start-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-s-lime-500",
    css: "border-inline-start-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-s-lime-600",
    css: "border-inline-start-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-s-lime-700",
    css: "border-inline-start-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-s-lime-800",
    css: "border-inline-start-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-s-lime-900",
    css: "border-inline-start-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-s-lime-950",
    css: "border-inline-start-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-s-green-50",
    css: "border-inline-start-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-s-green-100",
    css: "border-inline-start-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-s-green-200",
    css: "border-inline-start-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-s-green-300",
    css: "border-inline-start-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-s-green-400",
    css: "border-inline-start-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-s-green-500",
    css: "border-inline-start-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-s-green-600",
    css: "border-inline-start-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-s-green-700",
    css: "border-inline-start-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-s-green-800",
    css: "border-inline-start-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-s-green-900",
    css: "border-inline-start-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-s-green-950",
    css: "border-inline-start-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-s-emerald-50",
    css: "border-inline-start-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-s-emerald-100",
    css: "border-inline-start-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-s-emerald-200",
    css: "border-inline-start-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-s-emerald-300",
    css: "border-inline-start-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-s-emerald-400",
    css: "border-inline-start-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-s-emerald-500",
    css: "border-inline-start-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-s-emerald-600",
    css: "border-inline-start-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-s-emerald-700",
    css: "border-inline-start-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-s-emerald-800",
    css: "border-inline-start-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-s-emerald-900",
    css: "border-inline-start-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-s-emerald-950",
    css: "border-inline-start-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-s-teal-50",
    css: "border-inline-start-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-s-teal-100",
    css: "border-inline-start-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-s-teal-200",
    css: "border-inline-start-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-s-teal-300",
    css: "border-inline-start-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-s-teal-400",
    css: "border-inline-start-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-s-teal-500",
    css: "border-inline-start-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-s-teal-600",
    css: "border-inline-start-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-s-teal-700",
    css: "border-inline-start-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-s-teal-800",
    css: "border-inline-start-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-s-teal-900",
    css: "border-inline-start-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-s-teal-950",
    css: "border-inline-start-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-s-cyan-50",
    css: "border-inline-start-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-s-cyan-100",
    css: "border-inline-start-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-s-cyan-200",
    css: "border-inline-start-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-s-cyan-300",
    css: "border-inline-start-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-s-cyan-400",
    css: "border-inline-start-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-s-cyan-500",
    css: "border-inline-start-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-s-cyan-600",
    css: "border-inline-start-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-s-cyan-700",
    css: "border-inline-start-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-s-cyan-800",
    css: "border-inline-start-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-s-cyan-900",
    css: "border-inline-start-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-s-cyan-950",
    css: "border-inline-start-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-s-sky-50",
    css: "border-inline-start-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-s-sky-100",
    css: "border-inline-start-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-s-sky-200",
    css: "border-inline-start-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-s-sky-300",
    css: "border-inline-start-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-s-sky-400",
    css: "border-inline-start-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-s-sky-500",
    css: "border-inline-start-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-s-sky-600",
    css: "border-inline-start-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-s-sky-700",
    css: "border-inline-start-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-s-sky-800",
    css: "border-inline-start-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-s-sky-900",
    css: "border-inline-start-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-s-sky-950",
    css: "border-inline-start-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-s-blue-50",
    css: "border-inline-start-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-s-blue-100",
    css: "border-inline-start-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-s-blue-200",
    css: "border-inline-start-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-s-blue-300",
    css: "border-inline-start-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-s-blue-400",
    css: "border-inline-start-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-s-blue-500",
    css: "border-inline-start-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-s-blue-600",
    css: "border-inline-start-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-s-blue-700",
    css: "border-inline-start-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-s-blue-800",
    css: "border-inline-start-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-s-blue-900",
    css: "border-inline-start-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-s-blue-950",
    css: "border-inline-start-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-s-indigo-50",
    css: "border-inline-start-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-s-indigo-100",
    css: "border-inline-start-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-s-indigo-200",
    css: "border-inline-start-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-s-indigo-300",
    css: "border-inline-start-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-s-indigo-400",
    css: "border-inline-start-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-s-indigo-500",
    css: "border-inline-start-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-s-indigo-600",
    css: "border-inline-start-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-s-indigo-700",
    css: "border-inline-start-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-s-indigo-800",
    css: "border-inline-start-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-s-indigo-900",
    css: "border-inline-start-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-s-indigo-950",
    css: "border-inline-start-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-s-violet-50",
    css: "border-inline-start-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-s-violet-100",
    css: "border-inline-start-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-s-violet-200",
    css: "border-inline-start-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-s-violet-300",
    css: "border-inline-start-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-s-violet-400",
    css: "border-inline-start-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-s-violet-500",
    css: "border-inline-start-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-s-violet-600",
    css: "border-inline-start-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-s-violet-700",
    css: "border-inline-start-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-s-violet-800",
    css: "border-inline-start-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-s-violet-900",
    css: "border-inline-start-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-s-violet-950",
    css: "border-inline-start-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-s-purple-50",
    css: "border-inline-start-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-s-purple-100",
    css: "border-inline-start-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-s-purple-200",
    css: "border-inline-start-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-s-purple-300",
    css: "border-inline-start-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-s-purple-400",
    css: "border-inline-start-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-s-purple-500",
    css: "border-inline-start-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-s-purple-600",
    css: "border-inline-start-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-s-purple-700",
    css: "border-inline-start-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-s-purple-800",
    css: "border-inline-start-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-s-purple-900",
    css: "border-inline-start-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-s-purple-950",
    css: "border-inline-start-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-s-fuchsia-50",
    css: "border-inline-start-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-s-fuchsia-100",
    css: "border-inline-start-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-s-fuchsia-200",
    css: "border-inline-start-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-s-fuchsia-300",
    css: "border-inline-start-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-s-fuchsia-400",
    css: "border-inline-start-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-s-fuchsia-500",
    css: "border-inline-start-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-s-fuchsia-600",
    css: "border-inline-start-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-s-fuchsia-700",
    css: "border-inline-start-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-s-fuchsia-800",
    css: "border-inline-start-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-s-fuchsia-900",
    css: "border-inline-start-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-s-fuchsia-950",
    css: "border-inline-start-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-s-pink-50",
    css: "border-inline-start-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-s-pink-100",
    css: "border-inline-start-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-s-pink-200",
    css: "border-inline-start-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-s-pink-300",
    css: "border-inline-start-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-s-pink-400",
    css: "border-inline-start-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-s-pink-500",
    css: "border-inline-start-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-s-pink-600",
    css: "border-inline-start-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-s-pink-700",
    css: "border-inline-start-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-s-pink-800",
    css: "border-inline-start-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-s-pink-900",
    css: "border-inline-start-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-s-pink-950",
    css: "border-inline-start-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-s-rose-50",
    css: "border-inline-start-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-s-rose-100",
    css: "border-inline-start-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-s-rose-200",
    css: "border-inline-start-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-s-rose-300",
    css: "border-inline-start-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-s-rose-400",
    css: "border-inline-start-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-s-rose-500",
    css: "border-inline-start-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-s-rose-600",
    css: "border-inline-start-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-s-rose-700",
    css: "border-inline-start-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-s-rose-800",
    css: "border-inline-start-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-s-rose-900",
    css: "border-inline-start-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-s-rose-950",
    css: "border-inline-start-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-e-inherit",
    css: "border-inline-end-color: inherit;",
  },
  {
    tailwind: "border-e-current",
    css: "border-inline-end-color: currentColor;",
  },
  {
    tailwind: "border-e-transparent",
    css: "border-inline-end-color: transparent;",
  },
  {
    tailwind: "border-e-black",
    css: "border-inline-end-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-e-white",
    css: "border-inline-end-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-e-slate-50",
    css: "border-inline-end-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-e-slate-100",
    css: "border-inline-end-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-e-slate-200",
    css: "border-inline-end-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-e-slate-300",
    css: "border-inline-end-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-e-slate-400",
    css: "border-inline-end-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-e-slate-500",
    css: "border-inline-end-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-e-slate-600",
    css: "border-inline-end-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-e-slate-700",
    css: "border-inline-end-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-e-slate-800",
    css: "border-inline-end-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-e-slate-900",
    css: "border-inline-end-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-e-slate-950",
    css: "border-inline-end-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-e-gray-50",
    css: "border-inline-end-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-e-gray-100",
    css: "border-inline-end-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-e-gray-200",
    css: "border-inline-end-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-e-gray-300",
    css: "border-inline-end-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-e-gray-400",
    css: "border-inline-end-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-e-gray-500",
    css: "border-inline-end-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-e-gray-600",
    css: "border-inline-end-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-e-gray-700",
    css: "border-inline-end-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-e-gray-800",
    css: "border-inline-end-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-e-gray-900",
    css: "border-inline-end-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-e-gray-950",
    css: "border-inline-end-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-e-zinc-50",
    css: "border-inline-end-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-e-zinc-100",
    css: "border-inline-end-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-e-zinc-200",
    css: "border-inline-end-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-e-zinc-300",
    css: "border-inline-end-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-e-zinc-400",
    css: "border-inline-end-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-e-zinc-500",
    css: "border-inline-end-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-e-zinc-600",
    css: "border-inline-end-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-e-zinc-700",
    css: "border-inline-end-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-e-zinc-800",
    css: "border-inline-end-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-e-zinc-900",
    css: "border-inline-end-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-e-zinc-950",
    css: "border-inline-end-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-e-neutral-50",
    css: "border-inline-end-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-e-neutral-100",
    css: "border-inline-end-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-e-neutral-200",
    css: "border-inline-end-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-e-neutral-300",
    css: "border-inline-end-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-e-neutral-400",
    css: "border-inline-end-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-e-neutral-500",
    css: "border-inline-end-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-e-neutral-600",
    css: "border-inline-end-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-e-neutral-700",
    css: "border-inline-end-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-e-neutral-800",
    css: "border-inline-end-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-e-neutral-900",
    css: "border-inline-end-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-e-neutral-950",
    css: "border-inline-end-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-e-stone-50",
    css: "border-inline-end-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-e-stone-100",
    css: "border-inline-end-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-e-stone-200",
    css: "border-inline-end-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-e-stone-300",
    css: "border-inline-end-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-e-stone-400",
    css: "border-inline-end-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-e-stone-500",
    css: "border-inline-end-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-e-stone-600",
    css: "border-inline-end-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-e-stone-700",
    css: "border-inline-end-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-e-stone-800",
    css: "border-inline-end-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-e-stone-900",
    css: "border-inline-end-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-e-stone-950",
    css: "border-inline-end-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-e-red-50",
    css: "border-inline-end-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-e-red-100",
    css: "border-inline-end-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-e-red-200",
    css: "border-inline-end-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-e-red-300",
    css: "border-inline-end-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-e-red-400",
    css: "border-inline-end-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-e-red-500",
    css: "border-inline-end-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-e-red-600",
    css: "border-inline-end-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-e-red-700",
    css: "border-inline-end-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-e-red-800",
    css: "border-inline-end-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-e-red-900",
    css: "border-inline-end-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-e-red-950",
    css: "border-inline-end-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-e-orange-50",
    css: "border-inline-end-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-e-orange-100",
    css: "border-inline-end-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-e-orange-200",
    css: "border-inline-end-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-e-orange-300",
    css: "border-inline-end-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-e-orange-400",
    css: "border-inline-end-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-e-orange-500",
    css: "border-inline-end-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-e-orange-600",
    css: "border-inline-end-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-e-orange-700",
    css: "border-inline-end-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-e-orange-800",
    css: "border-inline-end-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-e-orange-900",
    css: "border-inline-end-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-e-orange-950",
    css: "border-inline-end-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-e-amber-50",
    css: "border-inline-end-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-e-amber-100",
    css: "border-inline-end-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-e-amber-200",
    css: "border-inline-end-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-e-amber-300",
    css: "border-inline-end-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-e-amber-400",
    css: "border-inline-end-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-e-amber-500",
    css: "border-inline-end-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-e-amber-600",
    css: "border-inline-end-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-e-amber-700",
    css: "border-inline-end-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-e-amber-800",
    css: "border-inline-end-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-e-amber-900",
    css: "border-inline-end-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-e-amber-950",
    css: "border-inline-end-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-e-yellow-50",
    css: "border-inline-end-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-e-yellow-100",
    css: "border-inline-end-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-e-yellow-200",
    css: "border-inline-end-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-e-yellow-300",
    css: "border-inline-end-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-e-yellow-400",
    css: "border-inline-end-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-e-yellow-500",
    css: "border-inline-end-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-e-yellow-600",
    css: "border-inline-end-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-e-yellow-700",
    css: "border-inline-end-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-e-yellow-800",
    css: "border-inline-end-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-e-yellow-900",
    css: "border-inline-end-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-e-yellow-950",
    css: "border-inline-end-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-e-lime-50",
    css: "border-inline-end-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-e-lime-100",
    css: "border-inline-end-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-e-lime-200",
    css: "border-inline-end-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-e-lime-300",
    css: "border-inline-end-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-e-lime-400",
    css: "border-inline-end-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-e-lime-500",
    css: "border-inline-end-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-e-lime-600",
    css: "border-inline-end-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-e-lime-700",
    css: "border-inline-end-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-e-lime-800",
    css: "border-inline-end-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-e-lime-900",
    css: "border-inline-end-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-e-lime-950",
    css: "border-inline-end-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-e-green-50",
    css: "border-inline-end-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-e-green-100",
    css: "border-inline-end-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-e-green-200",
    css: "border-inline-end-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-e-green-300",
    css: "border-inline-end-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-e-green-400",
    css: "border-inline-end-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-e-green-500",
    css: "border-inline-end-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-e-green-600",
    css: "border-inline-end-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-e-green-700",
    css: "border-inline-end-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-e-green-800",
    css: "border-inline-end-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-e-green-900",
    css: "border-inline-end-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-e-green-950",
    css: "border-inline-end-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-e-emerald-50",
    css: "border-inline-end-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-e-emerald-100",
    css: "border-inline-end-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-e-emerald-200",
    css: "border-inline-end-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-e-emerald-300",
    css: "border-inline-end-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-e-emerald-400",
    css: "border-inline-end-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-e-emerald-500",
    css: "border-inline-end-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-e-emerald-600",
    css: "border-inline-end-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-e-emerald-700",
    css: "border-inline-end-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-e-emerald-800",
    css: "border-inline-end-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-e-emerald-900",
    css: "border-inline-end-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-e-emerald-950",
    css: "border-inline-end-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-e-teal-50",
    css: "border-inline-end-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-e-teal-100",
    css: "border-inline-end-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-e-teal-200",
    css: "border-inline-end-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-e-teal-300",
    css: "border-inline-end-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-e-teal-400",
    css: "border-inline-end-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-e-teal-500",
    css: "border-inline-end-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-e-teal-600",
    css: "border-inline-end-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-e-teal-700",
    css: "border-inline-end-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-e-teal-800",
    css: "border-inline-end-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-e-teal-900",
    css: "border-inline-end-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-e-teal-950",
    css: "border-inline-end-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-e-cyan-50",
    css: "border-inline-end-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-e-cyan-100",
    css: "border-inline-end-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-e-cyan-200",
    css: "border-inline-end-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-e-cyan-300",
    css: "border-inline-end-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-e-cyan-400",
    css: "border-inline-end-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-e-cyan-500",
    css: "border-inline-end-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-e-cyan-600",
    css: "border-inline-end-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-e-cyan-700",
    css: "border-inline-end-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-e-cyan-800",
    css: "border-inline-end-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-e-cyan-900",
    css: "border-inline-end-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-e-cyan-950",
    css: "border-inline-end-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-e-sky-50",
    css: "border-inline-end-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-e-sky-100",
    css: "border-inline-end-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-e-sky-200",
    css: "border-inline-end-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-e-sky-300",
    css: "border-inline-end-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-e-sky-400",
    css: "border-inline-end-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-e-sky-500",
    css: "border-inline-end-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-e-sky-600",
    css: "border-inline-end-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-e-sky-700",
    css: "border-inline-end-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-e-sky-800",
    css: "border-inline-end-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-e-sky-900",
    css: "border-inline-end-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-e-sky-950",
    css: "border-inline-end-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-e-blue-50",
    css: "border-inline-end-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-e-blue-100",
    css: "border-inline-end-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-e-blue-200",
    css: "border-inline-end-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-e-blue-300",
    css: "border-inline-end-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-e-blue-400",
    css: "border-inline-end-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-e-blue-500",
    css: "border-inline-end-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-e-blue-600",
    css: "border-inline-end-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-e-blue-700",
    css: "border-inline-end-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-e-blue-800",
    css: "border-inline-end-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-e-blue-900",
    css: "border-inline-end-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-e-blue-950",
    css: "border-inline-end-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-e-indigo-50",
    css: "border-inline-end-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-e-indigo-100",
    css: "border-inline-end-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-e-indigo-200",
    css: "border-inline-end-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-e-indigo-300",
    css: "border-inline-end-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-e-indigo-400",
    css: "border-inline-end-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-e-indigo-500",
    css: "border-inline-end-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-e-indigo-600",
    css: "border-inline-end-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-e-indigo-700",
    css: "border-inline-end-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-e-indigo-800",
    css: "border-inline-end-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-e-indigo-900",
    css: "border-inline-end-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-e-indigo-950",
    css: "border-inline-end-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-e-violet-50",
    css: "border-inline-end-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-e-violet-100",
    css: "border-inline-end-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-e-violet-200",
    css: "border-inline-end-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-e-violet-300",
    css: "border-inline-end-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-e-violet-400",
    css: "border-inline-end-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-e-violet-500",
    css: "border-inline-end-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-e-violet-600",
    css: "border-inline-end-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-e-violet-700",
    css: "border-inline-end-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-e-violet-800",
    css: "border-inline-end-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-e-violet-900",
    css: "border-inline-end-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-e-violet-950",
    css: "border-inline-end-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-e-purple-50",
    css: "border-inline-end-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-e-purple-100",
    css: "border-inline-end-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-e-purple-200",
    css: "border-inline-end-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-e-purple-300",
    css: "border-inline-end-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-e-purple-400",
    css: "border-inline-end-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-e-purple-500",
    css: "border-inline-end-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-e-purple-600",
    css: "border-inline-end-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-e-purple-700",
    css: "border-inline-end-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-e-purple-800",
    css: "border-inline-end-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-e-purple-900",
    css: "border-inline-end-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-e-purple-950",
    css: "border-inline-end-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-e-fuchsia-50",
    css: "border-inline-end-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-e-fuchsia-100",
    css: "border-inline-end-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-e-fuchsia-200",
    css: "border-inline-end-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-e-fuchsia-300",
    css: "border-inline-end-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-e-fuchsia-400",
    css: "border-inline-end-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-e-fuchsia-500",
    css: "border-inline-end-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-e-fuchsia-600",
    css: "border-inline-end-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-e-fuchsia-700",
    css: "border-inline-end-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-e-fuchsia-800",
    css: "border-inline-end-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-e-fuchsia-900",
    css: "border-inline-end-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-e-fuchsia-950",
    css: "border-inline-end-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-e-pink-50",
    css: "border-inline-end-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-e-pink-100",
    css: "border-inline-end-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-e-pink-200",
    css: "border-inline-end-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-e-pink-300",
    css: "border-inline-end-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-e-pink-400",
    css: "border-inline-end-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-e-pink-500",
    css: "border-inline-end-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-e-pink-600",
    css: "border-inline-end-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-e-pink-700",
    css: "border-inline-end-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-e-pink-800",
    css: "border-inline-end-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-e-pink-900",
    css: "border-inline-end-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-e-pink-950",
    css: "border-inline-end-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-e-rose-50",
    css: "border-inline-end-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-e-rose-100",
    css: "border-inline-end-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-e-rose-200",
    css: "border-inline-end-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-e-rose-300",
    css: "border-inline-end-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-e-rose-400",
    css: "border-inline-end-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-e-rose-500",
    css: "border-inline-end-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-e-rose-600",
    css: "border-inline-end-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-e-rose-700",
    css: "border-inline-end-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-e-rose-800",
    css: "border-inline-end-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-e-rose-900",
    css: "border-inline-end-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-e-rose-950",
    css: "border-inline-end-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-t-inherit",
    css: "border-top-color: inherit;",
  },
  {
    tailwind: "border-t-current",
    css: "border-top-color: currentColor;",
  },
  {
    tailwind: "border-t-transparent",
    css: "border-top-color: transparent;",
  },
  {
    tailwind: "border-t-black",
    css: "border-top-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-t-white",
    css: "border-top-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-t-slate-50",
    css: "border-top-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-t-slate-100",
    css: "border-top-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-t-slate-200",
    css: "border-top-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-t-slate-300",
    css: "border-top-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-t-slate-400",
    css: "border-top-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-t-slate-500",
    css: "border-top-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-t-slate-600",
    css: "border-top-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-t-slate-700",
    css: "border-top-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-t-slate-800",
    css: "border-top-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-t-slate-900",
    css: "border-top-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-t-slate-950",
    css: "border-top-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-t-gray-50",
    css: "border-top-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-t-gray-100",
    css: "border-top-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-t-gray-200",
    css: "border-top-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-t-gray-300",
    css: "border-top-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-t-gray-400",
    css: "border-top-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-t-gray-500",
    css: "border-top-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-t-gray-600",
    css: "border-top-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-t-gray-700",
    css: "border-top-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-t-gray-800",
    css: "border-top-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-t-gray-900",
    css: "border-top-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-t-gray-950",
    css: "border-top-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-t-zinc-50",
    css: "border-top-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-t-zinc-100",
    css: "border-top-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-t-zinc-200",
    css: "border-top-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-t-zinc-300",
    css: "border-top-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-t-zinc-400",
    css: "border-top-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-t-zinc-500",
    css: "border-top-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-t-zinc-600",
    css: "border-top-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-t-zinc-700",
    css: "border-top-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-t-zinc-800",
    css: "border-top-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-t-zinc-900",
    css: "border-top-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-t-zinc-950",
    css: "border-top-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-t-neutral-50",
    css: "border-top-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-t-neutral-100",
    css: "border-top-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-t-neutral-200",
    css: "border-top-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-t-neutral-300",
    css: "border-top-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-t-neutral-400",
    css: "border-top-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-t-neutral-500",
    css: "border-top-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-t-neutral-600",
    css: "border-top-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-t-neutral-700",
    css: "border-top-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-t-neutral-800",
    css: "border-top-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-t-neutral-900",
    css: "border-top-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-t-neutral-950",
    css: "border-top-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-t-stone-50",
    css: "border-top-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-t-stone-100",
    css: "border-top-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-t-stone-200",
    css: "border-top-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-t-stone-300",
    css: "border-top-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-t-stone-400",
    css: "border-top-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-t-stone-500",
    css: "border-top-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-t-stone-600",
    css: "border-top-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-t-stone-700",
    css: "border-top-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-t-stone-800",
    css: "border-top-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-t-stone-900",
    css: "border-top-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-t-stone-950",
    css: "border-top-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-t-red-50",
    css: "border-top-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-t-red-100",
    css: "border-top-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-t-red-200",
    css: "border-top-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-t-red-300",
    css: "border-top-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-t-red-400",
    css: "border-top-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-t-red-500",
    css: "border-top-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-t-red-600",
    css: "border-top-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-t-red-700",
    css: "border-top-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-t-red-800",
    css: "border-top-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-t-red-900",
    css: "border-top-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-t-red-950",
    css: "border-top-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-t-orange-50",
    css: "border-top-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-t-orange-100",
    css: "border-top-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-t-orange-200",
    css: "border-top-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-t-orange-300",
    css: "border-top-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-t-orange-400",
    css: "border-top-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-t-orange-500",
    css: "border-top-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-t-orange-600",
    css: "border-top-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-t-orange-700",
    css: "border-top-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-t-orange-800",
    css: "border-top-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-t-orange-900",
    css: "border-top-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-t-orange-950",
    css: "border-top-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-t-amber-50",
    css: "border-top-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-t-amber-100",
    css: "border-top-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-t-amber-200",
    css: "border-top-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-t-amber-300",
    css: "border-top-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-t-amber-400",
    css: "border-top-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-t-amber-500",
    css: "border-top-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-t-amber-600",
    css: "border-top-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-t-amber-700",
    css: "border-top-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-t-amber-800",
    css: "border-top-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-t-amber-900",
    css: "border-top-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-t-amber-950",
    css: "border-top-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-t-yellow-50",
    css: "border-top-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-t-yellow-100",
    css: "border-top-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-t-yellow-200",
    css: "border-top-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-t-yellow-300",
    css: "border-top-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-t-yellow-400",
    css: "border-top-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-t-yellow-500",
    css: "border-top-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-t-yellow-600",
    css: "border-top-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-t-yellow-700",
    css: "border-top-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-t-yellow-800",
    css: "border-top-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-t-yellow-900",
    css: "border-top-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-t-yellow-950",
    css: "border-top-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-t-lime-50",
    css: "border-top-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-t-lime-100",
    css: "border-top-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-t-lime-200",
    css: "border-top-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-t-lime-300",
    css: "border-top-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-t-lime-400",
    css: "border-top-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-t-lime-500",
    css: "border-top-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-t-lime-600",
    css: "border-top-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-t-lime-700",
    css: "border-top-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-t-lime-800",
    css: "border-top-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-t-lime-900",
    css: "border-top-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-t-lime-950",
    css: "border-top-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-t-green-50",
    css: "border-top-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-t-green-100",
    css: "border-top-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-t-green-200",
    css: "border-top-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-t-green-300",
    css: "border-top-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-t-green-400",
    css: "border-top-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-t-green-500",
    css: "border-top-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-t-green-600",
    css: "border-top-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-t-green-700",
    css: "border-top-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-t-green-800",
    css: "border-top-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-t-green-900",
    css: "border-top-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-t-green-950",
    css: "border-top-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-t-emerald-50",
    css: "border-top-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-t-emerald-100",
    css: "border-top-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-t-emerald-200",
    css: "border-top-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-t-emerald-300",
    css: "border-top-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-t-emerald-400",
    css: "border-top-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-t-emerald-500",
    css: "border-top-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-t-emerald-600",
    css: "border-top-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-t-emerald-700",
    css: "border-top-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-t-emerald-800",
    css: "border-top-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-t-emerald-900",
    css: "border-top-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-t-emerald-950",
    css: "border-top-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-t-teal-50",
    css: "border-top-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-t-teal-100",
    css: "border-top-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-t-teal-200",
    css: "border-top-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-t-teal-300",
    css: "border-top-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-t-teal-400",
    css: "border-top-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-t-teal-500",
    css: "border-top-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-t-teal-600",
    css: "border-top-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-t-teal-700",
    css: "border-top-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-t-teal-800",
    css: "border-top-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-t-teal-900",
    css: "border-top-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-t-teal-950",
    css: "border-top-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-t-cyan-50",
    css: "border-top-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-t-cyan-100",
    css: "border-top-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-t-cyan-200",
    css: "border-top-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-t-cyan-300",
    css: "border-top-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-t-cyan-400",
    css: "border-top-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-t-cyan-500",
    css: "border-top-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-t-cyan-600",
    css: "border-top-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-t-cyan-700",
    css: "border-top-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-t-cyan-800",
    css: "border-top-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-t-cyan-900",
    css: "border-top-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-t-cyan-950",
    css: "border-top-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-t-sky-50",
    css: "border-top-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-t-sky-100",
    css: "border-top-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-t-sky-200",
    css: "border-top-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-t-sky-300",
    css: "border-top-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-t-sky-400",
    css: "border-top-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-t-sky-500",
    css: "border-top-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-t-sky-600",
    css: "border-top-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-t-sky-700",
    css: "border-top-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-t-sky-800",
    css: "border-top-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-t-sky-900",
    css: "border-top-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-t-sky-950",
    css: "border-top-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-t-blue-50",
    css: "border-top-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-t-blue-100",
    css: "border-top-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-t-blue-200",
    css: "border-top-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-t-blue-300",
    css: "border-top-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-t-blue-400",
    css: "border-top-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-t-blue-500",
    css: "border-top-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-t-blue-600",
    css: "border-top-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-t-blue-700",
    css: "border-top-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-t-blue-800",
    css: "border-top-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-t-blue-900",
    css: "border-top-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-t-blue-950",
    css: "border-top-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-t-indigo-50",
    css: "border-top-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-t-indigo-100",
    css: "border-top-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-t-indigo-200",
    css: "border-top-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-t-indigo-300",
    css: "border-top-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-t-indigo-400",
    css: "border-top-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-t-indigo-500",
    css: "border-top-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-t-indigo-600",
    css: "border-top-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-t-indigo-700",
    css: "border-top-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-t-indigo-800",
    css: "border-top-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-t-indigo-900",
    css: "border-top-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-t-indigo-950",
    css: "border-top-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-t-violet-50",
    css: "border-top-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-t-violet-100",
    css: "border-top-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-t-violet-200",
    css: "border-top-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-t-violet-300",
    css: "border-top-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-t-violet-400",
    css: "border-top-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-t-violet-500",
    css: "border-top-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-t-violet-600",
    css: "border-top-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-t-violet-700",
    css: "border-top-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-t-violet-800",
    css: "border-top-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-t-violet-900",
    css: "border-top-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-t-violet-950",
    css: "border-top-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-t-purple-50",
    css: "border-top-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-t-purple-100",
    css: "border-top-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-t-purple-200",
    css: "border-top-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-t-purple-300",
    css: "border-top-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-t-purple-400",
    css: "border-top-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-t-purple-500",
    css: "border-top-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-t-purple-600",
    css: "border-top-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-t-purple-700",
    css: "border-top-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-t-purple-800",
    css: "border-top-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-t-purple-900",
    css: "border-top-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-t-purple-950",
    css: "border-top-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-t-fuchsia-50",
    css: "border-top-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-t-fuchsia-100",
    css: "border-top-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-t-fuchsia-200",
    css: "border-top-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-t-fuchsia-300",
    css: "border-top-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-t-fuchsia-400",
    css: "border-top-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-t-fuchsia-500",
    css: "border-top-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-t-fuchsia-600",
    css: "border-top-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-t-fuchsia-700",
    css: "border-top-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-t-fuchsia-800",
    css: "border-top-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-t-fuchsia-900",
    css: "border-top-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-t-fuchsia-950",
    css: "border-top-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-t-pink-50",
    css: "border-top-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-t-pink-100",
    css: "border-top-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-t-pink-200",
    css: "border-top-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-t-pink-300",
    css: "border-top-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-t-pink-400",
    css: "border-top-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-t-pink-500",
    css: "border-top-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-t-pink-600",
    css: "border-top-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-t-pink-700",
    css: "border-top-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-t-pink-800",
    css: "border-top-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-t-pink-900",
    css: "border-top-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-t-pink-950",
    css: "border-top-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-t-rose-50",
    css: "border-top-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-t-rose-100",
    css: "border-top-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-t-rose-200",
    css: "border-top-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-t-rose-300",
    css: "border-top-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-t-rose-400",
    css: "border-top-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-t-rose-500",
    css: "border-top-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-t-rose-600",
    css: "border-top-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-t-rose-700",
    css: "border-top-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-t-rose-800",
    css: "border-top-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-t-rose-900",
    css: "border-top-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-t-rose-950",
    css: "border-top-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-r-inherit",
    css: "border-right-color: inherit;",
  },
  {
    tailwind: "border-r-current",
    css: "border-right-color: currentColor;",
  },
  {
    tailwind: "border-r-transparent",
    css: "border-right-color: transparent;",
  },
  {
    tailwind: "border-r-black",
    css: "border-right-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-r-white",
    css: "border-right-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-r-slate-50",
    css: "border-right-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-r-slate-100",
    css: "border-right-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-r-slate-200",
    css: "border-right-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-r-slate-300",
    css: "border-right-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-r-slate-400",
    css: "border-right-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-r-slate-500",
    css: "border-right-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-r-slate-600",
    css: "border-right-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-r-slate-700",
    css: "border-right-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-r-slate-800",
    css: "border-right-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-r-slate-900",
    css: "border-right-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-r-slate-950",
    css: "border-right-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-r-gray-50",
    css: "border-right-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-r-gray-100",
    css: "border-right-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-r-gray-200",
    css: "border-right-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-r-gray-300",
    css: "border-right-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-r-gray-400",
    css: "border-right-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-r-gray-500",
    css: "border-right-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-r-gray-600",
    css: "border-right-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-r-gray-700",
    css: "border-right-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-r-gray-800",
    css: "border-right-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-r-gray-900",
    css: "border-right-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-r-gray-950",
    css: "border-right-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-r-zinc-50",
    css: "border-right-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-r-zinc-100",
    css: "border-right-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-r-zinc-200",
    css: "border-right-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-r-zinc-300",
    css: "border-right-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-r-zinc-400",
    css: "border-right-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-r-zinc-500",
    css: "border-right-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-r-zinc-600",
    css: "border-right-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-r-zinc-700",
    css: "border-right-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-r-zinc-800",
    css: "border-right-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-r-zinc-900",
    css: "border-right-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-r-zinc-950",
    css: "border-right-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-r-neutral-50",
    css: "border-right-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-r-neutral-100",
    css: "border-right-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-r-neutral-200",
    css: "border-right-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-r-neutral-300",
    css: "border-right-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-r-neutral-400",
    css: "border-right-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-r-neutral-500",
    css: "border-right-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-r-neutral-600",
    css: "border-right-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-r-neutral-700",
    css: "border-right-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-r-neutral-800",
    css: "border-right-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-r-neutral-900",
    css: "border-right-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-r-neutral-950",
    css: "border-right-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-r-stone-50",
    css: "border-right-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-r-stone-100",
    css: "border-right-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-r-stone-200",
    css: "border-right-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-r-stone-300",
    css: "border-right-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-r-stone-400",
    css: "border-right-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-r-stone-500",
    css: "border-right-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-r-stone-600",
    css: "border-right-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-r-stone-700",
    css: "border-right-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-r-stone-800",
    css: "border-right-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-r-stone-900",
    css: "border-right-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-r-stone-950",
    css: "border-right-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-r-red-50",
    css: "border-right-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-r-red-100",
    css: "border-right-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-r-red-200",
    css: "border-right-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-r-red-300",
    css: "border-right-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-r-red-400",
    css: "border-right-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-r-red-500",
    css: "border-right-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-r-red-600",
    css: "border-right-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-r-red-700",
    css: "border-right-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-r-red-800",
    css: "border-right-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-r-red-900",
    css: "border-right-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-r-red-950",
    css: "border-right-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-r-orange-50",
    css: "border-right-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-r-orange-100",
    css: "border-right-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-r-orange-200",
    css: "border-right-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-r-orange-300",
    css: "border-right-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-r-orange-400",
    css: "border-right-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-r-orange-500",
    css: "border-right-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-r-orange-600",
    css: "border-right-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-r-orange-700",
    css: "border-right-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-r-orange-800",
    css: "border-right-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-r-orange-900",
    css: "border-right-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-r-orange-950",
    css: "border-right-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-r-amber-50",
    css: "border-right-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-r-amber-100",
    css: "border-right-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-r-amber-200",
    css: "border-right-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-r-amber-300",
    css: "border-right-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-r-amber-400",
    css: "border-right-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-r-amber-500",
    css: "border-right-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-r-amber-600",
    css: "border-right-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-r-amber-700",
    css: "border-right-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-r-amber-800",
    css: "border-right-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-r-amber-900",
    css: "border-right-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-r-amber-950",
    css: "border-right-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-r-yellow-50",
    css: "border-right-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-r-yellow-100",
    css: "border-right-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-r-yellow-200",
    css: "border-right-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-r-yellow-300",
    css: "border-right-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-r-yellow-400",
    css: "border-right-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-r-yellow-500",
    css: "border-right-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-r-yellow-600",
    css: "border-right-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-r-yellow-700",
    css: "border-right-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-r-yellow-800",
    css: "border-right-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-r-yellow-900",
    css: "border-right-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-r-yellow-950",
    css: "border-right-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-r-lime-50",
    css: "border-right-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-r-lime-100",
    css: "border-right-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-r-lime-200",
    css: "border-right-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-r-lime-300",
    css: "border-right-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-r-lime-400",
    css: "border-right-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-r-lime-500",
    css: "border-right-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-r-lime-600",
    css: "border-right-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-r-lime-700",
    css: "border-right-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-r-lime-800",
    css: "border-right-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-r-lime-900",
    css: "border-right-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-r-lime-950",
    css: "border-right-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-r-green-50",
    css: "border-right-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-r-green-100",
    css: "border-right-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-r-green-200",
    css: "border-right-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-r-green-300",
    css: "border-right-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-r-green-400",
    css: "border-right-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-r-green-500",
    css: "border-right-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-r-green-600",
    css: "border-right-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-r-green-700",
    css: "border-right-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-r-green-800",
    css: "border-right-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-r-green-900",
    css: "border-right-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-r-green-950",
    css: "border-right-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-r-emerald-50",
    css: "border-right-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-r-emerald-100",
    css: "border-right-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-r-emerald-200",
    css: "border-right-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-r-emerald-300",
    css: "border-right-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-r-emerald-400",
    css: "border-right-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-r-emerald-500",
    css: "border-right-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-r-emerald-600",
    css: "border-right-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-r-emerald-700",
    css: "border-right-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-r-emerald-800",
    css: "border-right-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-r-emerald-900",
    css: "border-right-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-r-emerald-950",
    css: "border-right-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-r-teal-50",
    css: "border-right-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-r-teal-100",
    css: "border-right-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-r-teal-200",
    css: "border-right-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-r-teal-300",
    css: "border-right-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-r-teal-400",
    css: "border-right-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-r-teal-500",
    css: "border-right-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-r-teal-600",
    css: "border-right-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-r-teal-700",
    css: "border-right-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-r-teal-800",
    css: "border-right-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-r-teal-900",
    css: "border-right-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-r-teal-950",
    css: "border-right-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-r-cyan-50",
    css: "border-right-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-r-cyan-100",
    css: "border-right-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-r-cyan-200",
    css: "border-right-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-r-cyan-300",
    css: "border-right-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-r-cyan-400",
    css: "border-right-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-r-cyan-500",
    css: "border-right-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-r-cyan-600",
    css: "border-right-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-r-cyan-700",
    css: "border-right-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-r-cyan-800",
    css: "border-right-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-r-cyan-900",
    css: "border-right-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-r-cyan-950",
    css: "border-right-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-r-sky-50",
    css: "border-right-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-r-sky-100",
    css: "border-right-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-r-sky-200",
    css: "border-right-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-r-sky-300",
    css: "border-right-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-r-sky-400",
    css: "border-right-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-r-sky-500",
    css: "border-right-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-r-sky-600",
    css: "border-right-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-r-sky-700",
    css: "border-right-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-r-sky-800",
    css: "border-right-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-r-sky-900",
    css: "border-right-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-r-sky-950",
    css: "border-right-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-r-blue-50",
    css: "border-right-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-r-blue-100",
    css: "border-right-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-r-blue-200",
    css: "border-right-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-r-blue-300",
    css: "border-right-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-r-blue-400",
    css: "border-right-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-r-blue-500",
    css: "border-right-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-r-blue-600",
    css: "border-right-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-r-blue-700",
    css: "border-right-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-r-blue-800",
    css: "border-right-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-r-blue-900",
    css: "border-right-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-r-blue-950",
    css: "border-right-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-r-indigo-50",
    css: "border-right-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-r-indigo-100",
    css: "border-right-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-r-indigo-200",
    css: "border-right-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-r-indigo-300",
    css: "border-right-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-r-indigo-400",
    css: "border-right-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-r-indigo-500",
    css: "border-right-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-r-indigo-600",
    css: "border-right-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-r-indigo-700",
    css: "border-right-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-r-indigo-800",
    css: "border-right-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-r-indigo-900",
    css: "border-right-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-r-indigo-950",
    css: "border-right-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-r-violet-50",
    css: "border-right-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-r-violet-100",
    css: "border-right-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-r-violet-200",
    css: "border-right-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-r-violet-300",
    css: "border-right-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-r-violet-400",
    css: "border-right-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-r-violet-500",
    css: "border-right-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-r-violet-600",
    css: "border-right-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-r-violet-700",
    css: "border-right-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-r-violet-800",
    css: "border-right-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-r-violet-900",
    css: "border-right-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-r-violet-950",
    css: "border-right-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-r-purple-50",
    css: "border-right-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-r-purple-100",
    css: "border-right-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-r-purple-200",
    css: "border-right-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-r-purple-300",
    css: "border-right-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-r-purple-400",
    css: "border-right-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-r-purple-500",
    css: "border-right-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-r-purple-600",
    css: "border-right-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-r-purple-700",
    css: "border-right-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-r-purple-800",
    css: "border-right-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-r-purple-900",
    css: "border-right-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-r-purple-950",
    css: "border-right-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-r-fuchsia-50",
    css: "border-right-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-r-fuchsia-100",
    css: "border-right-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-r-fuchsia-200",
    css: "border-right-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-r-fuchsia-300",
    css: "border-right-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-r-fuchsia-400",
    css: "border-right-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-r-fuchsia-500",
    css: "border-right-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-r-fuchsia-600",
    css: "border-right-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-r-fuchsia-700",
    css: "border-right-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-r-fuchsia-800",
    css: "border-right-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-r-fuchsia-900",
    css: "border-right-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-r-fuchsia-950",
    css: "border-right-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-r-pink-50",
    css: "border-right-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-r-pink-100",
    css: "border-right-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-r-pink-200",
    css: "border-right-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-r-pink-300",
    css: "border-right-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-r-pink-400",
    css: "border-right-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-r-pink-500",
    css: "border-right-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-r-pink-600",
    css: "border-right-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-r-pink-700",
    css: "border-right-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-r-pink-800",
    css: "border-right-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-r-pink-900",
    css: "border-right-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-r-pink-950",
    css: "border-right-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-r-rose-50",
    css: "border-right-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-r-rose-100",
    css: "border-right-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-r-rose-200",
    css: "border-right-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-r-rose-300",
    css: "border-right-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-r-rose-400",
    css: "border-right-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-r-rose-500",
    css: "border-right-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-r-rose-600",
    css: "border-right-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-r-rose-700",
    css: "border-right-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-r-rose-800",
    css: "border-right-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-r-rose-900",
    css: "border-right-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-r-rose-950",
    css: "border-right-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-b-inherit",
    css: "border-bottom-color: inherit;",
  },
  {
    tailwind: "border-b-current",
    css: "border-bottom-color: currentColor;",
  },
  {
    tailwind: "border-b-transparent",
    css: "border-bottom-color: transparent;",
  },
  {
    tailwind: "border-b-black",
    css: "border-bottom-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-b-white",
    css: "border-bottom-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-b-slate-50",
    css: "border-bottom-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-b-slate-100",
    css: "border-bottom-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-b-slate-200",
    css: "border-bottom-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-b-slate-300",
    css: "border-bottom-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-b-slate-400",
    css: "border-bottom-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-b-slate-500",
    css: "border-bottom-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-b-slate-600",
    css: "border-bottom-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-b-slate-700",
    css: "border-bottom-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-b-slate-800",
    css: "border-bottom-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-b-slate-900",
    css: "border-bottom-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-b-slate-950",
    css: "border-bottom-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-b-gray-50",
    css: "border-bottom-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-b-gray-100",
    css: "border-bottom-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-b-gray-200",
    css: "border-bottom-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-b-gray-300",
    css: "border-bottom-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-b-gray-400",
    css: "border-bottom-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-b-gray-500",
    css: "border-bottom-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-b-gray-600",
    css: "border-bottom-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-b-gray-700",
    css: "border-bottom-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-b-gray-800",
    css: "border-bottom-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-b-gray-900",
    css: "border-bottom-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-b-gray-950",
    css: "border-bottom-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-b-zinc-50",
    css: "border-bottom-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-b-zinc-100",
    css: "border-bottom-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-b-zinc-200",
    css: "border-bottom-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-b-zinc-300",
    css: "border-bottom-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-b-zinc-400",
    css: "border-bottom-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-b-zinc-500",
    css: "border-bottom-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-b-zinc-600",
    css: "border-bottom-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-b-zinc-700",
    css: "border-bottom-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-b-zinc-800",
    css: "border-bottom-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-b-zinc-900",
    css: "border-bottom-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-b-zinc-950",
    css: "border-bottom-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-b-neutral-50",
    css: "border-bottom-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-b-neutral-100",
    css: "border-bottom-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-b-neutral-200",
    css: "border-bottom-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-b-neutral-300",
    css: "border-bottom-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-b-neutral-400",
    css: "border-bottom-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-b-neutral-500",
    css: "border-bottom-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-b-neutral-600",
    css: "border-bottom-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-b-neutral-700",
    css: "border-bottom-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-b-neutral-800",
    css: "border-bottom-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-b-neutral-900",
    css: "border-bottom-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-b-neutral-950",
    css: "border-bottom-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-b-stone-50",
    css: "border-bottom-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-b-stone-100",
    css: "border-bottom-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-b-stone-200",
    css: "border-bottom-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-b-stone-300",
    css: "border-bottom-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-b-stone-400",
    css: "border-bottom-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-b-stone-500",
    css: "border-bottom-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-b-stone-600",
    css: "border-bottom-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-b-stone-700",
    css: "border-bottom-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-b-stone-800",
    css: "border-bottom-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-b-stone-900",
    css: "border-bottom-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-b-stone-950",
    css: "border-bottom-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-b-red-50",
    css: "border-bottom-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-b-red-100",
    css: "border-bottom-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-b-red-200",
    css: "border-bottom-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-b-red-300",
    css: "border-bottom-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-b-red-400",
    css: "border-bottom-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-b-red-500",
    css: "border-bottom-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-b-red-600",
    css: "border-bottom-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-b-red-700",
    css: "border-bottom-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-b-red-800",
    css: "border-bottom-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-b-red-900",
    css: "border-bottom-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-b-red-950",
    css: "border-bottom-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-b-orange-50",
    css: "border-bottom-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-b-orange-100",
    css: "border-bottom-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-b-orange-200",
    css: "border-bottom-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-b-orange-300",
    css: "border-bottom-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-b-orange-400",
    css: "border-bottom-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-b-orange-500",
    css: "border-bottom-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-b-orange-600",
    css: "border-bottom-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-b-orange-700",
    css: "border-bottom-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-b-orange-800",
    css: "border-bottom-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-b-orange-900",
    css: "border-bottom-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-b-orange-950",
    css: "border-bottom-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-b-amber-50",
    css: "border-bottom-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-b-amber-100",
    css: "border-bottom-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-b-amber-200",
    css: "border-bottom-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-b-amber-300",
    css: "border-bottom-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-b-amber-400",
    css: "border-bottom-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-b-amber-500",
    css: "border-bottom-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-b-amber-600",
    css: "border-bottom-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-b-amber-700",
    css: "border-bottom-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-b-amber-800",
    css: "border-bottom-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-b-amber-900",
    css: "border-bottom-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-b-amber-950",
    css: "border-bottom-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-b-yellow-50",
    css: "border-bottom-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-b-yellow-100",
    css: "border-bottom-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-b-yellow-200",
    css: "border-bottom-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-b-yellow-300",
    css: "border-bottom-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-b-yellow-400",
    css: "border-bottom-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-b-yellow-500",
    css: "border-bottom-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-b-yellow-600",
    css: "border-bottom-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-b-yellow-700",
    css: "border-bottom-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-b-yellow-800",
    css: "border-bottom-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-b-yellow-900",
    css: "border-bottom-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-b-yellow-950",
    css: "border-bottom-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-b-lime-50",
    css: "border-bottom-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-b-lime-100",
    css: "border-bottom-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-b-lime-200",
    css: "border-bottom-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-b-lime-300",
    css: "border-bottom-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-b-lime-400",
    css: "border-bottom-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-b-lime-500",
    css: "border-bottom-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-b-lime-600",
    css: "border-bottom-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-b-lime-700",
    css: "border-bottom-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-b-lime-800",
    css: "border-bottom-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-b-lime-900",
    css: "border-bottom-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-b-lime-950",
    css: "border-bottom-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-b-green-50",
    css: "border-bottom-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-b-green-100",
    css: "border-bottom-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-b-green-200",
    css: "border-bottom-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-b-green-300",
    css: "border-bottom-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-b-green-400",
    css: "border-bottom-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-b-green-500",
    css: "border-bottom-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-b-green-600",
    css: "border-bottom-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-b-green-700",
    css: "border-bottom-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-b-green-800",
    css: "border-bottom-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-b-green-900",
    css: "border-bottom-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-b-green-950",
    css: "border-bottom-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-b-emerald-50",
    css: "border-bottom-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-b-emerald-100",
    css: "border-bottom-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-b-emerald-200",
    css: "border-bottom-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-b-emerald-300",
    css: "border-bottom-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-b-emerald-400",
    css: "border-bottom-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-b-emerald-500",
    css: "border-bottom-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-b-emerald-600",
    css: "border-bottom-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-b-emerald-700",
    css: "border-bottom-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-b-emerald-800",
    css: "border-bottom-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-b-emerald-900",
    css: "border-bottom-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-b-emerald-950",
    css: "border-bottom-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-b-teal-50",
    css: "border-bottom-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-b-teal-100",
    css: "border-bottom-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-b-teal-200",
    css: "border-bottom-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-b-teal-300",
    css: "border-bottom-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-b-teal-400",
    css: "border-bottom-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-b-teal-500",
    css: "border-bottom-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-b-teal-600",
    css: "border-bottom-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-b-teal-700",
    css: "border-bottom-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-b-teal-800",
    css: "border-bottom-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-b-teal-900",
    css: "border-bottom-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-b-teal-950",
    css: "border-bottom-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-b-cyan-50",
    css: "border-bottom-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-b-cyan-100",
    css: "border-bottom-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-b-cyan-200",
    css: "border-bottom-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-b-cyan-300",
    css: "border-bottom-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-b-cyan-400",
    css: "border-bottom-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-b-cyan-500",
    css: "border-bottom-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-b-cyan-600",
    css: "border-bottom-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-b-cyan-700",
    css: "border-bottom-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-b-cyan-800",
    css: "border-bottom-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-b-cyan-900",
    css: "border-bottom-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-b-cyan-950",
    css: "border-bottom-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-b-sky-50",
    css: "border-bottom-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-b-sky-100",
    css: "border-bottom-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-b-sky-200",
    css: "border-bottom-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-b-sky-300",
    css: "border-bottom-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-b-sky-400",
    css: "border-bottom-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-b-sky-500",
    css: "border-bottom-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-b-sky-600",
    css: "border-bottom-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-b-sky-700",
    css: "border-bottom-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-b-sky-800",
    css: "border-bottom-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-b-sky-900",
    css: "border-bottom-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-b-sky-950",
    css: "border-bottom-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-b-blue-50",
    css: "border-bottom-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-b-blue-100",
    css: "border-bottom-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-b-blue-200",
    css: "border-bottom-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-b-blue-300",
    css: "border-bottom-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-b-blue-400",
    css: "border-bottom-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-b-blue-500",
    css: "border-bottom-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-b-blue-600",
    css: "border-bottom-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-b-blue-700",
    css: "border-bottom-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-b-blue-800",
    css: "border-bottom-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-b-blue-900",
    css: "border-bottom-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-b-blue-950",
    css: "border-bottom-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-b-indigo-50",
    css: "border-bottom-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-b-indigo-100",
    css: "border-bottom-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-b-indigo-200",
    css: "border-bottom-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-b-indigo-300",
    css: "border-bottom-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-b-indigo-400",
    css: "border-bottom-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-b-indigo-500",
    css: "border-bottom-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-b-indigo-600",
    css: "border-bottom-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-b-indigo-700",
    css: "border-bottom-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-b-indigo-800",
    css: "border-bottom-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-b-indigo-900",
    css: "border-bottom-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-b-indigo-950",
    css: "border-bottom-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-b-violet-50",
    css: "border-bottom-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-b-violet-100",
    css: "border-bottom-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-b-violet-200",
    css: "border-bottom-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-b-violet-300",
    css: "border-bottom-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-b-violet-400",
    css: "border-bottom-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-b-violet-500",
    css: "border-bottom-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-b-violet-600",
    css: "border-bottom-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-b-violet-700",
    css: "border-bottom-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-b-violet-800",
    css: "border-bottom-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-b-violet-900",
    css: "border-bottom-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-b-violet-950",
    css: "border-bottom-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-b-purple-50",
    css: "border-bottom-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-b-purple-100",
    css: "border-bottom-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-b-purple-200",
    css: "border-bottom-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-b-purple-300",
    css: "border-bottom-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-b-purple-400",
    css: "border-bottom-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-b-purple-500",
    css: "border-bottom-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-b-purple-600",
    css: "border-bottom-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-b-purple-700",
    css: "border-bottom-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-b-purple-800",
    css: "border-bottom-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-b-purple-900",
    css: "border-bottom-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-b-purple-950",
    css: "border-bottom-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-b-fuchsia-50",
    css: "border-bottom-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-b-fuchsia-100",
    css: "border-bottom-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-b-fuchsia-200",
    css: "border-bottom-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-b-fuchsia-300",
    css: "border-bottom-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-b-fuchsia-400",
    css: "border-bottom-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-b-fuchsia-500",
    css: "border-bottom-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-b-fuchsia-600",
    css: "border-bottom-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-b-fuchsia-700",
    css: "border-bottom-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-b-fuchsia-800",
    css: "border-bottom-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-b-fuchsia-900",
    css: "border-bottom-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-b-fuchsia-950",
    css: "border-bottom-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-b-pink-50",
    css: "border-bottom-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-b-pink-100",
    css: "border-bottom-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-b-pink-200",
    css: "border-bottom-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-b-pink-300",
    css: "border-bottom-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-b-pink-400",
    css: "border-bottom-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-b-pink-500",
    css: "border-bottom-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-b-pink-600",
    css: "border-bottom-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-b-pink-700",
    css: "border-bottom-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-b-pink-800",
    css: "border-bottom-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-b-pink-900",
    css: "border-bottom-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-b-pink-950",
    css: "border-bottom-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-b-rose-50",
    css: "border-bottom-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-b-rose-100",
    css: "border-bottom-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-b-rose-200",
    css: "border-bottom-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-b-rose-300",
    css: "border-bottom-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-b-rose-400",
    css: "border-bottom-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-b-rose-500",
    css: "border-bottom-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-b-rose-600",
    css: "border-bottom-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-b-rose-700",
    css: "border-bottom-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-b-rose-800",
    css: "border-bottom-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-b-rose-900",
    css: "border-bottom-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-b-rose-950",
    css: "border-bottom-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-l-inherit",
    css: "border-left-color: inherit;",
  },
  {
    tailwind: "border-l-current",
    css: "border-left-color: currentColor;",
  },
  {
    tailwind: "border-l-transparent",
    css: "border-left-color: transparent;",
  },
  {
    tailwind: "border-l-black",
    css: "border-left-color: rgb(0 0 0);",
  },
  {
    tailwind: "border-l-white",
    css: "border-left-color: rgb(255 255 255);",
  },
  {
    tailwind: "border-l-slate-50",
    css: "border-left-color: rgb(248 250 252);",
  },
  {
    tailwind: "border-l-slate-100",
    css: "border-left-color: rgb(241 245 249);",
  },
  {
    tailwind: "border-l-slate-200",
    css: "border-left-color: rgb(226 232 240);",
  },
  {
    tailwind: "border-l-slate-300",
    css: "border-left-color: rgb(203 213 225);",
  },
  {
    tailwind: "border-l-slate-400",
    css: "border-left-color: rgb(148 163 184);",
  },
  {
    tailwind: "border-l-slate-500",
    css: "border-left-color: rgb(100 116 139);",
  },
  {
    tailwind: "border-l-slate-600",
    css: "border-left-color: rgb(71 85 105);",
  },
  {
    tailwind: "border-l-slate-700",
    css: "border-left-color: rgb(51 65 85);",
  },
  {
    tailwind: "border-l-slate-800",
    css: "border-left-color: rgb(30 41 59);",
  },
  {
    tailwind: "border-l-slate-900",
    css: "border-left-color: rgb(15 23 42);",
  },
  {
    tailwind: "border-l-slate-950",
    css: "border-left-color: rgb(2 6 23);",
  },
  {
    tailwind: "border-l-gray-50",
    css: "border-left-color: rgb(249 250 251);",
  },
  {
    tailwind: "border-l-gray-100",
    css: "border-left-color: rgb(243 244 246);",
  },
  {
    tailwind: "border-l-gray-200",
    css: "border-left-color: rgb(229 231 235);",
  },
  {
    tailwind: "border-l-gray-300",
    css: "border-left-color: rgb(209 213 219);",
  },
  {
    tailwind: "border-l-gray-400",
    css: "border-left-color: rgb(156 163 175);",
  },
  {
    tailwind: "border-l-gray-500",
    css: "border-left-color: rgb(107 114 128);",
  },
  {
    tailwind: "border-l-gray-600",
    css: "border-left-color: rgb(75 85 99);",
  },
  {
    tailwind: "border-l-gray-700",
    css: "border-left-color: rgb(55 65 81);",
  },
  {
    tailwind: "border-l-gray-800",
    css: "border-left-color: rgb(31 41 55);",
  },
  {
    tailwind: "border-l-gray-900",
    css: "border-left-color: rgb(17 24 39);",
  },
  {
    tailwind: "border-l-gray-950",
    css: "border-left-color: rgb(3 7 18);",
  },
  {
    tailwind: "border-l-zinc-50",
    css: "border-left-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-l-zinc-100",
    css: "border-left-color: rgb(244 244 245);",
  },
  {
    tailwind: "border-l-zinc-200",
    css: "border-left-color: rgb(228 228 231);",
  },
  {
    tailwind: "border-l-zinc-300",
    css: "border-left-color: rgb(212 212 216);",
  },
  {
    tailwind: "border-l-zinc-400",
    css: "border-left-color: rgb(161 161 170);",
  },
  {
    tailwind: "border-l-zinc-500",
    css: "border-left-color: rgb(113 113 122);",
  },
  {
    tailwind: "border-l-zinc-600",
    css: "border-left-color: rgb(82 82 91);",
  },
  {
    tailwind: "border-l-zinc-700",
    css: "border-left-color: rgb(63 63 70);",
  },
  {
    tailwind: "border-l-zinc-800",
    css: "border-left-color: rgb(39 39 42);",
  },
  {
    tailwind: "border-l-zinc-900",
    css: "border-left-color: rgb(24 24 27);",
  },
  {
    tailwind: "border-l-zinc-950",
    css: "border-left-color: rgb(9 9 11);",
  },
  {
    tailwind: "border-l-neutral-50",
    css: "border-left-color: rgb(250 250 250);",
  },
  {
    tailwind: "border-l-neutral-100",
    css: "border-left-color: rgb(245 245 245);",
  },
  {
    tailwind: "border-l-neutral-200",
    css: "border-left-color: rgb(229 229 229);",
  },
  {
    tailwind: "border-l-neutral-300",
    css: "border-left-color: rgb(212 212 212);",
  },
  {
    tailwind: "border-l-neutral-400",
    css: "border-left-color: rgb(163 163 163);",
  },
  {
    tailwind: "border-l-neutral-500",
    css: "border-left-color: rgb(115 115 115);",
  },
  {
    tailwind: "border-l-neutral-600",
    css: "border-left-color: rgb(82 82 82);",
  },
  {
    tailwind: "border-l-neutral-700",
    css: "border-left-color: rgb(64 64 64);",
  },
  {
    tailwind: "border-l-neutral-800",
    css: "border-left-color: rgb(38 38 38);",
  },
  {
    tailwind: "border-l-neutral-900",
    css: "border-left-color: rgb(23 23 23);",
  },
  {
    tailwind: "border-l-neutral-950",
    css: "border-left-color: rgb(10 10 10);",
  },
  {
    tailwind: "border-l-stone-50",
    css: "border-left-color: rgb(250 250 249);",
  },
  {
    tailwind: "border-l-stone-100",
    css: "border-left-color: rgb(245 245 244);",
  },
  {
    tailwind: "border-l-stone-200",
    css: "border-left-color: rgb(231 229 228);",
  },
  {
    tailwind: "border-l-stone-300",
    css: "border-left-color: rgb(214 211 209);",
  },
  {
    tailwind: "border-l-stone-400",
    css: "border-left-color: rgb(168 162 158);",
  },
  {
    tailwind: "border-l-stone-500",
    css: "border-left-color: rgb(120 113 108);",
  },
  {
    tailwind: "border-l-stone-600",
    css: "border-left-color: rgb(87 83 78);",
  },
  {
    tailwind: "border-l-stone-700",
    css: "border-left-color: rgb(68 64 60);",
  },
  {
    tailwind: "border-l-stone-800",
    css: "border-left-color: rgb(41 37 36);",
  },
  {
    tailwind: "border-l-stone-900",
    css: "border-left-color: rgb(28 25 23);",
  },
  {
    tailwind: "border-l-stone-950",
    css: "border-left-color: rgb(12 10 9);",
  },
  {
    tailwind: "border-l-red-50",
    css: "border-left-color: rgb(254 242 242);",
  },
  {
    tailwind: "border-l-red-100",
    css: "border-left-color: rgb(254 226 226);",
  },
  {
    tailwind: "border-l-red-200",
    css: "border-left-color: rgb(254 202 202);",
  },
  {
    tailwind: "border-l-red-300",
    css: "border-left-color: rgb(252 165 165);",
  },
  {
    tailwind: "border-l-red-400",
    css: "border-left-color: rgb(248 113 113);",
  },
  {
    tailwind: "border-l-red-500",
    css: "border-left-color: rgb(239 68 68);",
  },
  {
    tailwind: "border-l-red-600",
    css: "border-left-color: rgb(220 38 38);",
  },
  {
    tailwind: "border-l-red-700",
    css: "border-left-color: rgb(185 28 28);",
  },
  {
    tailwind: "border-l-red-800",
    css: "border-left-color: rgb(153 27 27);",
  },
  {
    tailwind: "border-l-red-900",
    css: "border-left-color: rgb(127 29 29);",
  },
  {
    tailwind: "border-l-red-950",
    css: "border-left-color: rgb(69 10 10);",
  },
  {
    tailwind: "border-l-orange-50",
    css: "border-left-color: rgb(255 247 237);",
  },
  {
    tailwind: "border-l-orange-100",
    css: "border-left-color: rgb(255 237 213);",
  },
  {
    tailwind: "border-l-orange-200",
    css: "border-left-color: rgb(254 215 170);",
  },
  {
    tailwind: "border-l-orange-300",
    css: "border-left-color: rgb(253 186 116);",
  },
  {
    tailwind: "border-l-orange-400",
    css: "border-left-color: rgb(251 146 60);",
  },
  {
    tailwind: "border-l-orange-500",
    css: "border-left-color: rgb(249 115 22);",
  },
  {
    tailwind: "border-l-orange-600",
    css: "border-left-color: rgb(234 88 12);",
  },
  {
    tailwind: "border-l-orange-700",
    css: "border-left-color: rgb(194 65 12);",
  },
  {
    tailwind: "border-l-orange-800",
    css: "border-left-color: rgb(154 52 18);",
  },
  {
    tailwind: "border-l-orange-900",
    css: "border-left-color: rgb(124 45 18);",
  },
  {
    tailwind: "border-l-orange-950",
    css: "border-left-color: rgb(67 20 7);",
  },
  {
    tailwind: "border-l-amber-50",
    css: "border-left-color: rgb(255 251 235);",
  },
  {
    tailwind: "border-l-amber-100",
    css: "border-left-color: rgb(254 243 199);",
  },
  {
    tailwind: "border-l-amber-200",
    css: "border-left-color: rgb(253 230 138);",
  },
  {
    tailwind: "border-l-amber-300",
    css: "border-left-color: rgb(252 211 77);",
  },
  {
    tailwind: "border-l-amber-400",
    css: "border-left-color: rgb(251 191 36);",
  },
  {
    tailwind: "border-l-amber-500",
    css: "border-left-color: rgb(245 158 11);",
  },
  {
    tailwind: "border-l-amber-600",
    css: "border-left-color: rgb(217 119 6);",
  },
  {
    tailwind: "border-l-amber-700",
    css: "border-left-color: rgb(180 83 9);",
  },
  {
    tailwind: "border-l-amber-800",
    css: "border-left-color: rgb(146 64 14);",
  },
  {
    tailwind: "border-l-amber-900",
    css: "border-left-color: rgb(120 53 15);",
  },
  {
    tailwind: "border-l-amber-950",
    css: "border-left-color: rgb(69 26 3);",
  },
  {
    tailwind: "border-l-yellow-50",
    css: "border-left-color: rgb(254 252 232);",
  },
  {
    tailwind: "border-l-yellow-100",
    css: "border-left-color: rgb(254 249 195);",
  },
  {
    tailwind: "border-l-yellow-200",
    css: "border-left-color: rgb(254 240 138);",
  },
  {
    tailwind: "border-l-yellow-300",
    css: "border-left-color: rgb(253 224 71);",
  },
  {
    tailwind: "border-l-yellow-400",
    css: "border-left-color: rgb(250 204 21);",
  },
  {
    tailwind: "border-l-yellow-500",
    css: "border-left-color: rgb(234 179 8);",
  },
  {
    tailwind: "border-l-yellow-600",
    css: "border-left-color: rgb(202 138 4);",
  },
  {
    tailwind: "border-l-yellow-700",
    css: "border-left-color: rgb(161 98 7);",
  },
  {
    tailwind: "border-l-yellow-800",
    css: "border-left-color: rgb(133 77 14);",
  },
  {
    tailwind: "border-l-yellow-900",
    css: "border-left-color: rgb(113 63 18);",
  },
  {
    tailwind: "border-l-yellow-950",
    css: "border-left-color: rgb(66 32 6);",
  },
  {
    tailwind: "border-l-lime-50",
    css: "border-left-color: rgb(247 254 231);",
  },
  {
    tailwind: "border-l-lime-100",
    css: "border-left-color: rgb(236 252 203);",
  },
  {
    tailwind: "border-l-lime-200",
    css: "border-left-color: rgb(217 249 157);",
  },
  {
    tailwind: "border-l-lime-300",
    css: "border-left-color: rgb(190 242 100);",
  },
  {
    tailwind: "border-l-lime-400",
    css: "border-left-color: rgb(163 230 53);",
  },
  {
    tailwind: "border-l-lime-500",
    css: "border-left-color: rgb(132 204 22);",
  },
  {
    tailwind: "border-l-lime-600",
    css: "border-left-color: rgb(101 163 13);",
  },
  {
    tailwind: "border-l-lime-700",
    css: "border-left-color: rgb(77 124 15);",
  },
  {
    tailwind: "border-l-lime-800",
    css: "border-left-color: rgb(63 98 18);",
  },
  {
    tailwind: "border-l-lime-900",
    css: "border-left-color: rgb(54 83 20);",
  },
  {
    tailwind: "border-l-lime-950",
    css: "border-left-color: rgb(26 46 5);",
  },
  {
    tailwind: "border-l-green-50",
    css: "border-left-color: rgb(240 253 244);",
  },
  {
    tailwind: "border-l-green-100",
    css: "border-left-color: rgb(220 252 231);",
  },
  {
    tailwind: "border-l-green-200",
    css: "border-left-color: rgb(187 247 208);",
  },
  {
    tailwind: "border-l-green-300",
    css: "border-left-color: rgb(134 239 172);",
  },
  {
    tailwind: "border-l-green-400",
    css: "border-left-color: rgb(74 222 128);",
  },
  {
    tailwind: "border-l-green-500",
    css: "border-left-color: rgb(34 197 94);",
  },
  {
    tailwind: "border-l-green-600",
    css: "border-left-color: rgb(22 163 74);",
  },
  {
    tailwind: "border-l-green-700",
    css: "border-left-color: rgb(21 128 61);",
  },
  {
    tailwind: "border-l-green-800",
    css: "border-left-color: rgb(22 101 52);",
  },
  {
    tailwind: "border-l-green-900",
    css: "border-left-color: rgb(20 83 45);",
  },
  {
    tailwind: "border-l-green-950",
    css: "border-left-color: rgb(5 46 22);",
  },
  {
    tailwind: "border-l-emerald-50",
    css: "border-left-color: rgb(236 253 245);",
  },
  {
    tailwind: "border-l-emerald-100",
    css: "border-left-color: rgb(209 250 229);",
  },
  {
    tailwind: "border-l-emerald-200",
    css: "border-left-color: rgb(167 243 208);",
  },
  {
    tailwind: "border-l-emerald-300",
    css: "border-left-color: rgb(110 231 183);",
  },
  {
    tailwind: "border-l-emerald-400",
    css: "border-left-color: rgb(52 211 153);",
  },
  {
    tailwind: "border-l-emerald-500",
    css: "border-left-color: rgb(16 185 129);",
  },
  {
    tailwind: "border-l-emerald-600",
    css: "border-left-color: rgb(5 150 105);",
  },
  {
    tailwind: "border-l-emerald-700",
    css: "border-left-color: rgb(4 120 87);",
  },
  {
    tailwind: "border-l-emerald-800",
    css: "border-left-color: rgb(6 95 70);",
  },
  {
    tailwind: "border-l-emerald-900",
    css: "border-left-color: rgb(6 78 59);",
  },
  {
    tailwind: "border-l-emerald-950",
    css: "border-left-color: rgb(2 44 34);",
  },
  {
    tailwind: "border-l-teal-50",
    css: "border-left-color: rgb(240 253 250);",
  },
  {
    tailwind: "border-l-teal-100",
    css: "border-left-color: rgb(204 251 241);",
  },
  {
    tailwind: "border-l-teal-200",
    css: "border-left-color: rgb(153 246 228);",
  },
  {
    tailwind: "border-l-teal-300",
    css: "border-left-color: rgb(94 234 212);",
  },
  {
    tailwind: "border-l-teal-400",
    css: "border-left-color: rgb(45 212 191);",
  },
  {
    tailwind: "border-l-teal-500",
    css: "border-left-color: rgb(20 184 166);",
  },
  {
    tailwind: "border-l-teal-600",
    css: "border-left-color: rgb(13 148 136);",
  },
  {
    tailwind: "border-l-teal-700",
    css: "border-left-color: rgb(15 118 110);",
  },
  {
    tailwind: "border-l-teal-800",
    css: "border-left-color: rgb(17 94 89);",
  },
  {
    tailwind: "border-l-teal-900",
    css: "border-left-color: rgb(19 78 74);",
  },
  {
    tailwind: "border-l-teal-950",
    css: "border-left-color: rgb(4 47 46);",
  },
  {
    tailwind: "border-l-cyan-50",
    css: "border-left-color: rgb(236 254 255);",
  },
  {
    tailwind: "border-l-cyan-100",
    css: "border-left-color: rgb(207 250 254);",
  },
  {
    tailwind: "border-l-cyan-200",
    css: "border-left-color: rgb(165 243 252);",
  },
  {
    tailwind: "border-l-cyan-300",
    css: "border-left-color: rgb(103 232 249);",
  },
  {
    tailwind: "border-l-cyan-400",
    css: "border-left-color: rgb(34 211 238);",
  },
  {
    tailwind: "border-l-cyan-500",
    css: "border-left-color: rgb(6 182 212);",
  },
  {
    tailwind: "border-l-cyan-600",
    css: "border-left-color: rgb(8 145 178);",
  },
  {
    tailwind: "border-l-cyan-700",
    css: "border-left-color: rgb(14 116 144);",
  },
  {
    tailwind: "border-l-cyan-800",
    css: "border-left-color: rgb(21 94 117);",
  },
  {
    tailwind: "border-l-cyan-900",
    css: "border-left-color: rgb(22 78 99);",
  },
  {
    tailwind: "border-l-cyan-950",
    css: "border-left-color: rgb(8 51 68);",
  },
  {
    tailwind: "border-l-sky-50",
    css: "border-left-color: rgb(240 249 255);",
  },
  {
    tailwind: "border-l-sky-100",
    css: "border-left-color: rgb(224 242 254);",
  },
  {
    tailwind: "border-l-sky-200",
    css: "border-left-color: rgb(186 230 253);",
  },
  {
    tailwind: "border-l-sky-300",
    css: "border-left-color: rgb(125 211 252);",
  },
  {
    tailwind: "border-l-sky-400",
    css: "border-left-color: rgb(56 189 248);",
  },
  {
    tailwind: "border-l-sky-500",
    css: "border-left-color: rgb(14 165 233);",
  },
  {
    tailwind: "border-l-sky-600",
    css: "border-left-color: rgb(2 132 199);",
  },
  {
    tailwind: "border-l-sky-700",
    css: "border-left-color: rgb(3 105 161);",
  },
  {
    tailwind: "border-l-sky-800",
    css: "border-left-color: rgb(7 89 133);",
  },
  {
    tailwind: "border-l-sky-900",
    css: "border-left-color: rgb(12 74 110);",
  },
  {
    tailwind: "border-l-sky-950",
    css: "border-left-color: rgb(8 47 73);",
  },
  {
    tailwind: "border-l-blue-50",
    css: "border-left-color: rgb(239 246 255);",
  },
  {
    tailwind: "border-l-blue-100",
    css: "border-left-color: rgb(219 234 254);",
  },
  {
    tailwind: "border-l-blue-200",
    css: "border-left-color: rgb(191 219 254);",
  },
  {
    tailwind: "border-l-blue-300",
    css: "border-left-color: rgb(147 197 253);",
  },
  {
    tailwind: "border-l-blue-400",
    css: "border-left-color: rgb(96 165 250);",
  },
  {
    tailwind: "border-l-blue-500",
    css: "border-left-color: rgb(59 130 246);",
  },
  {
    tailwind: "border-l-blue-600",
    css: "border-left-color: rgb(37 99 235);",
  },
  {
    tailwind: "border-l-blue-700",
    css: "border-left-color: rgb(29 78 216);",
  },
  {
    tailwind: "border-l-blue-800",
    css: "border-left-color: rgb(30 64 175);",
  },
  {
    tailwind: "border-l-blue-900",
    css: "border-left-color: rgb(30 58 138);",
  },
  {
    tailwind: "border-l-blue-950",
    css: "border-left-color: rgb(23 37 84);",
  },
  {
    tailwind: "border-l-indigo-50",
    css: "border-left-color: rgb(238 242 255);",
  },
  {
    tailwind: "border-l-indigo-100",
    css: "border-left-color: rgb(224 231 255);",
  },
  {
    tailwind: "border-l-indigo-200",
    css: "border-left-color: rgb(199 210 254);",
  },
  {
    tailwind: "border-l-indigo-300",
    css: "border-left-color: rgb(165 180 252);",
  },
  {
    tailwind: "border-l-indigo-400",
    css: "border-left-color: rgb(129 140 248);",
  },
  {
    tailwind: "border-l-indigo-500",
    css: "border-left-color: rgb(99 102 241);",
  },
  {
    tailwind: "border-l-indigo-600",
    css: "border-left-color: rgb(79 70 229);",
  },
  {
    tailwind: "border-l-indigo-700",
    css: "border-left-color: rgb(67 56 202);",
  },
  {
    tailwind: "border-l-indigo-800",
    css: "border-left-color: rgb(55 48 163);",
  },
  {
    tailwind: "border-l-indigo-900",
    css: "border-left-color: rgb(49 46 129);",
  },
  {
    tailwind: "border-l-indigo-950",
    css: "border-left-color: rgb(30 27 75);",
  },
  {
    tailwind: "border-l-violet-50",
    css: "border-left-color: rgb(245 243 255);",
  },
  {
    tailwind: "border-l-violet-100",
    css: "border-left-color: rgb(237 233 254);",
  },
  {
    tailwind: "border-l-violet-200",
    css: "border-left-color: rgb(221 214 254);",
  },
  {
    tailwind: "border-l-violet-300",
    css: "border-left-color: rgb(196 181 253);",
  },
  {
    tailwind: "border-l-violet-400",
    css: "border-left-color: rgb(167 139 250);",
  },
  {
    tailwind: "border-l-violet-500",
    css: "border-left-color: rgb(139 92 246);",
  },
  {
    tailwind: "border-l-violet-600",
    css: "border-left-color: rgb(124 58 237);",
  },
  {
    tailwind: "border-l-violet-700",
    css: "border-left-color: rgb(109 40 217);",
  },
  {
    tailwind: "border-l-violet-800",
    css: "border-left-color: rgb(91 33 182);",
  },
  {
    tailwind: "border-l-violet-900",
    css: "border-left-color: rgb(76 29 149);",
  },
  {
    tailwind: "border-l-violet-950",
    css: "border-left-color: rgb(46 16 101);",
  },
  {
    tailwind: "border-l-purple-50",
    css: "border-left-color: rgb(250 245 255);",
  },
  {
    tailwind: "border-l-purple-100",
    css: "border-left-color: rgb(243 232 255);",
  },
  {
    tailwind: "border-l-purple-200",
    css: "border-left-color: rgb(233 213 255);",
  },
  {
    tailwind: "border-l-purple-300",
    css: "border-left-color: rgb(216 180 254);",
  },
  {
    tailwind: "border-l-purple-400",
    css: "border-left-color: rgb(192 132 252);",
  },
  {
    tailwind: "border-l-purple-500",
    css: "border-left-color: rgb(168 85 247);",
  },
  {
    tailwind: "border-l-purple-600",
    css: "border-left-color: rgb(147 51 234);",
  },
  {
    tailwind: "border-l-purple-700",
    css: "border-left-color: rgb(126 34 206);",
  },
  {
    tailwind: "border-l-purple-800",
    css: "border-left-color: rgb(107 33 168);",
  },
  {
    tailwind: "border-l-purple-900",
    css: "border-left-color: rgb(88 28 135);",
  },
  {
    tailwind: "border-l-purple-950",
    css: "border-left-color: rgb(59 7 100);",
  },
  {
    tailwind: "border-l-fuchsia-50",
    css: "border-left-color: rgb(253 244 255);",
  },
  {
    tailwind: "border-l-fuchsia-100",
    css: "border-left-color: rgb(250 232 255);",
  },
  {
    tailwind: "border-l-fuchsia-200",
    css: "border-left-color: rgb(245 208 254);",
  },
  {
    tailwind: "border-l-fuchsia-300",
    css: "border-left-color: rgb(240 171 252);",
  },
  {
    tailwind: "border-l-fuchsia-400",
    css: "border-left-color: rgb(232 121 249);",
  },
  {
    tailwind: "border-l-fuchsia-500",
    css: "border-left-color: rgb(217 70 239);",
  },
  {
    tailwind: "border-l-fuchsia-600",
    css: "border-left-color: rgb(192 38 211);",
  },
  {
    tailwind: "border-l-fuchsia-700",
    css: "border-left-color: rgb(162 28 175);",
  },
  {
    tailwind: "border-l-fuchsia-800",
    css: "border-left-color: rgb(134 25 143);",
  },
  {
    tailwind: "border-l-fuchsia-900",
    css: "border-left-color: rgb(112 26 117);",
  },
  {
    tailwind: "border-l-fuchsia-950",
    css: "border-left-color: rgb(74 4 78);",
  },
  {
    tailwind: "border-l-pink-50",
    css: "border-left-color: rgb(253 242 248);",
  },
  {
    tailwind: "border-l-pink-100",
    css: "border-left-color: rgb(252 231 243);",
  },
  {
    tailwind: "border-l-pink-200",
    css: "border-left-color: rgb(251 207 232);",
  },
  {
    tailwind: "border-l-pink-300",
    css: "border-left-color: rgb(249 168 212);",
  },
  {
    tailwind: "border-l-pink-400",
    css: "border-left-color: rgb(244 114 182);",
  },
  {
    tailwind: "border-l-pink-500",
    css: "border-left-color: rgb(236 72 153);",
  },
  {
    tailwind: "border-l-pink-600",
    css: "border-left-color: rgb(219 39 119);",
  },
  {
    tailwind: "border-l-pink-700",
    css: "border-left-color: rgb(190 24 93);",
  },
  {
    tailwind: "border-l-pink-800",
    css: "border-left-color: rgb(157 23 77);",
  },
  {
    tailwind: "border-l-pink-900",
    css: "border-left-color: rgb(131 24 67);",
  },
  {
    tailwind: "border-l-pink-950",
    css: "border-left-color: rgb(80 7 36);",
  },
  {
    tailwind: "border-l-rose-50",
    css: "border-left-color: rgb(255 241 242);",
  },
  {
    tailwind: "border-l-rose-100",
    css: "border-left-color: rgb(255 228 230);",
  },
  {
    tailwind: "border-l-rose-200",
    css: "border-left-color: rgb(254 205 211);",
  },
  {
    tailwind: "border-l-rose-300",
    css: "border-left-color: rgb(253 164 175);",
  },
  {
    tailwind: "border-l-rose-400",
    css: "border-left-color: rgb(251 113 133);",
  },
  {
    tailwind: "border-l-rose-500",
    css: "border-left-color: rgb(244 63 94);",
  },
  {
    tailwind: "border-l-rose-600",
    css: "border-left-color: rgb(225 29 72);",
  },
  {
    tailwind: "border-l-rose-700",
    css: "border-left-color: rgb(190 18 60);",
  },
  {
    tailwind: "border-l-rose-800",
    css: "border-left-color: rgb(159 18 57);",
  },
  {
    tailwind: "border-l-rose-900",
    css: "border-left-color: rgb(136 19 55);",
  },
  {
    tailwind: "border-l-rose-950",
    css: "border-left-color: rgb(76 5 25);",
  },
  {
    tailwind: "border-solid",
    css: "border-style: solid;",
  },
  {
    tailwind: "border-dashed",
    css: "border-style: dashed;",
  },
  {
    tailwind: "border-dotted",
    css: "border-style: dotted;",
  },
  {
    tailwind: "border-double",
    css: "border-style: double;",
  },
  {
    tailwind: "border-hidden",
    css: "border-style: hidden;",
  },
  {
    tailwind: "border-none",
    css: "border-style: none;",
  },
  {
    tailwind: "divide-x-0",
    css: "border-right-width: 0px;\nborder-left-width: 0px;",
  },
  {
    tailwind: "divide-x-2",
    css: "border-right-width: 0px;\nborder-left-width: 2px;",
  },
  {
    tailwind: "divide-x-4",
    css: "border-right-width: 0px;\nborder-left-width: 4px;",
  },
  {
    tailwind: "divide-x-8",
    css: "border-right-width: 0px;\nborder-left-width: 8px;",
  },
  {
    tailwind: "divide-x",
    css: "border-right-width: 0px;\nborder-left-width: 1px;",
  },
  {
    tailwind: "divide-y-0",
    css: "border-top-width: 0px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "divide-y-2",
    css: "border-top-width: 2px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "divide-y-4",
    css: "border-top-width: 4px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "divide-y-8",
    css: "border-top-width: 8px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "divide-y",
    css: "border-top-width: 1px;\nborder-bottom-width: 0px;",
  },
  {
    tailwind: "divide-y-reverse",
    css: "--tw-divide-y-reverse: 1;",
  },
  {
    tailwind: "divide-x-reverse",
    css: "--tw-divide-x-reverse: 1;",
  },
  {
    tailwind: "divide-inherit",
    css: "border-color: inherit;",
  },
  {
    tailwind: "divide-current",
    css: "border-color: currentColor;",
  },
  {
    tailwind: "divide-transparent",
    css: "border-color: transparent;",
  },
  {
    tailwind: "divide-black",
    css: "border-color: rgb(0 0 0);",
  },
  {
    tailwind: "divide-white",
    css: "border-color: rgb(255 255 255);",
  },
  {
    tailwind: "divide-slate-50",
    css: "border-color: rgb(248 250 252);",
  },
  {
    tailwind: "divide-slate-100",
    css: "border-color: rgb(241 245 249);",
  },
  {
    tailwind: "divide-slate-200",
    css: "border-color: rgb(226 232 240);",
  },
  {
    tailwind: "divide-slate-300",
    css: "border-color: rgb(203 213 225);",
  },
  {
    tailwind: "divide-slate-400",
    css: "border-color: rgb(148 163 184);",
  },
  {
    tailwind: "divide-slate-500",
    css: "border-color: rgb(100 116 139);",
  },
  {
    tailwind: "divide-slate-600",
    css: "border-color: rgb(71 85 105);",
  },
  {
    tailwind: "divide-slate-700",
    css: "border-color: rgb(51 65 85);",
  },
  {
    tailwind: "divide-slate-800",
    css: "border-color: rgb(30 41 59);",
  },
  {
    tailwind: "divide-slate-900",
    css: "border-color: rgb(15 23 42);",
  },
  {
    tailwind: "divide-slate-950",
    css: "border-color: rgb(2 6 23);",
  },
  {
    tailwind: "divide-gray-50",
    css: "border-color: rgb(249 250 251);",
  },
  {
    tailwind: "divide-gray-100",
    css: "border-color: rgb(243 244 246);",
  },
  {
    tailwind: "divide-gray-200",
    css: "border-color: rgb(229 231 235);",
  },
  {
    tailwind: "divide-gray-300",
    css: "border-color: rgb(209 213 219);",
  },
  {
    tailwind: "divide-gray-400",
    css: "border-color: rgb(156 163 175);",
  },
  {
    tailwind: "divide-gray-500",
    css: "border-color: rgb(107 114 128);",
  },
  {
    tailwind: "divide-gray-600",
    css: "border-color: rgb(75 85 99);",
  },
  {
    tailwind: "divide-gray-700",
    css: "border-color: rgb(55 65 81);",
  },
  {
    tailwind: "divide-gray-800",
    css: "border-color: rgb(31 41 55);",
  },
  {
    tailwind: "divide-gray-900",
    css: "border-color: rgb(17 24 39);",
  },
  {
    tailwind: "divide-gray-950",
    css: "border-color: rgb(3 7 18);",
  },
  {
    tailwind: "divide-zinc-50",
    css: "border-color: rgb(250 250 250);",
  },
  {
    tailwind: "divide-zinc-100",
    css: "border-color: rgb(244 244 245);",
  },
  {
    tailwind: "divide-zinc-200",
    css: "border-color: rgb(228 228 231);",
  },
  {
    tailwind: "divide-zinc-300",
    css: "border-color: rgb(212 212 216);",
  },
  {
    tailwind: "divide-zinc-400",
    css: "border-color: rgb(161 161 170);",
  },
  {
    tailwind: "divide-zinc-500",
    css: "border-color: rgb(113 113 122);",
  },
  {
    tailwind: "divide-zinc-600",
    css: "border-color: rgb(82 82 91);",
  },
  {
    tailwind: "divide-zinc-700",
    css: "border-color: rgb(63 63 70);",
  },
  {
    tailwind: "divide-zinc-800",
    css: "border-color: rgb(39 39 42);",
  },
  {
    tailwind: "divide-zinc-900",
    css: "border-color: rgb(24 24 27);",
  },
  {
    tailwind: "divide-zinc-950",
    css: "border-color: rgb(9 9 11);",
  },
  {
    tailwind: "divide-neutral-50",
    css: "border-color: rgb(250 250 250);",
  },
  {
    tailwind: "divide-neutral-100",
    css: "border-color: rgb(245 245 245);",
  },
  {
    tailwind: "divide-neutral-200",
    css: "border-color: rgb(229 229 229);",
  },
  {
    tailwind: "divide-neutral-300",
    css: "border-color: rgb(212 212 212);",
  },
  {
    tailwind: "divide-neutral-400",
    css: "border-color: rgb(163 163 163);",
  },
  {
    tailwind: "divide-neutral-500",
    css: "border-color: rgb(115 115 115);",
  },
  {
    tailwind: "divide-neutral-600",
    css: "border-color: rgb(82 82 82);",
  },
  {
    tailwind: "divide-neutral-700",
    css: "border-color: rgb(64 64 64);",
  },
  {
    tailwind: "divide-neutral-800",
    css: "border-color: rgb(38 38 38);",
  },
  {
    tailwind: "divide-neutral-900",
    css: "border-color: rgb(23 23 23);",
  },
  {
    tailwind: "divide-neutral-950",
    css: "border-color: rgb(10 10 10);",
  },
  {
    tailwind: "divide-stone-50",
    css: "border-color: rgb(250 250 249);",
  },
  {
    tailwind: "divide-stone-100",
    css: "border-color: rgb(245 245 244);",
  },
  {
    tailwind: "divide-stone-200",
    css: "border-color: rgb(231 229 228);",
  },
  {
    tailwind: "divide-stone-300",
    css: "border-color: rgb(214 211 209);",
  },
  {
    tailwind: "divide-stone-400",
    css: "border-color: rgb(168 162 158);",
  },
  {
    tailwind: "divide-stone-500",
    css: "border-color: rgb(120 113 108);",
  },
  {
    tailwind: "divide-stone-600",
    css: "border-color: rgb(87 83 78);",
  },
  {
    tailwind: "divide-stone-700",
    css: "border-color: rgb(68 64 60);",
  },
  {
    tailwind: "divide-stone-800",
    css: "border-color: rgb(41 37 36);",
  },
  {
    tailwind: "divide-stone-900",
    css: "border-color: rgb(28 25 23);",
  },
  {
    tailwind: "divide-stone-950",
    css: "border-color: rgb(12 10 9);",
  },
  {
    tailwind: "divide-red-50",
    css: "border-color: rgb(254 242 242);",
  },
  {
    tailwind: "divide-red-100",
    css: "border-color: rgb(254 226 226);",
  },
  {
    tailwind: "divide-red-200",
    css: "border-color: rgb(254 202 202);",
  },
  {
    tailwind: "divide-red-300",
    css: "border-color: rgb(252 165 165);",
  },
  {
    tailwind: "divide-red-400",
    css: "border-color: rgb(248 113 113);",
  },
  {
    tailwind: "divide-red-500",
    css: "border-color: rgb(239 68 68);",
  },
  {
    tailwind: "divide-red-600",
    css: "border-color: rgb(220 38 38);",
  },
  {
    tailwind: "divide-red-700",
    css: "border-color: rgb(185 28 28);",
  },
  {
    tailwind: "divide-red-800",
    css: "border-color: rgb(153 27 27);",
  },
  {
    tailwind: "divide-red-900",
    css: "border-color: rgb(127 29 29);",
  },
  {
    tailwind: "divide-red-950",
    css: "border-color: rgb(69 10 10);",
  },
  {
    tailwind: "divide-orange-50",
    css: "border-color: rgb(255 247 237);",
  },
  {
    tailwind: "divide-orange-100",
    css: "border-color: rgb(255 237 213);",
  },
  {
    tailwind: "divide-orange-200",
    css: "border-color: rgb(254 215 170);",
  },
  {
    tailwind: "divide-orange-300",
    css: "border-color: rgb(253 186 116);",
  },
  {
    tailwind: "divide-orange-400",
    css: "border-color: rgb(251 146 60);",
  },
  {
    tailwind: "divide-orange-500",
    css: "border-color: rgb(249 115 22);",
  },
  {
    tailwind: "divide-orange-600",
    css: "border-color: rgb(234 88 12);",
  },
  {
    tailwind: "divide-orange-700",
    css: "border-color: rgb(194 65 12);",
  },
  {
    tailwind: "divide-orange-800",
    css: "border-color: rgb(154 52 18);",
  },
  {
    tailwind: "divide-orange-900",
    css: "border-color: rgb(124 45 18);",
  },
  {
    tailwind: "divide-orange-950",
    css: "border-color: rgb(67 20 7);",
  },
  {
    tailwind: "divide-amber-50",
    css: "border-color: rgb(255 251 235);",
  },
  {
    tailwind: "divide-amber-100",
    css: "border-color: rgb(254 243 199);",
  },
  {
    tailwind: "divide-amber-200",
    css: "border-color: rgb(253 230 138);",
  },
  {
    tailwind: "divide-amber-300",
    css: "border-color: rgb(252 211 77);",
  },
  {
    tailwind: "divide-amber-400",
    css: "border-color: rgb(251 191 36);",
  },
  {
    tailwind: "divide-amber-500",
    css: "border-color: rgb(245 158 11);",
  },
  {
    tailwind: "divide-amber-600",
    css: "border-color: rgb(217 119 6);",
  },
  {
    tailwind: "divide-amber-700",
    css: "border-color: rgb(180 83 9);",
  },
  {
    tailwind: "divide-amber-800",
    css: "border-color: rgb(146 64 14);",
  },
  {
    tailwind: "divide-amber-900",
    css: "border-color: rgb(120 53 15);",
  },
  {
    tailwind: "divide-amber-950",
    css: "border-color: rgb(69 26 3);",
  },
  {
    tailwind: "divide-yellow-50",
    css: "border-color: rgb(254 252 232);",
  },
  {
    tailwind: "divide-yellow-100",
    css: "border-color: rgb(254 249 195);",
  },
  {
    tailwind: "divide-yellow-200",
    css: "border-color: rgb(254 240 138);",
  },
  {
    tailwind: "divide-yellow-300",
    css: "border-color: rgb(253 224 71);",
  },
  {
    tailwind: "divide-yellow-400",
    css: "border-color: rgb(250 204 21);",
  },
  {
    tailwind: "divide-yellow-500",
    css: "border-color: rgb(234 179 8);",
  },
  {
    tailwind: "divide-yellow-600",
    css: "border-color: rgb(202 138 4);",
  },
  {
    tailwind: "divide-yellow-700",
    css: "border-color: rgb(161 98 7);",
  },
  {
    tailwind: "divide-yellow-800",
    css: "border-color: rgb(133 77 14);",
  },
  {
    tailwind: "divide-yellow-900",
    css: "border-color: rgb(113 63 18);",
  },
  {
    tailwind: "divide-yellow-950",
    css: "border-color: rgb(66 32 6);",
  },
  {
    tailwind: "divide-lime-50",
    css: "border-color: rgb(247 254 231);",
  },
  {
    tailwind: "divide-lime-100",
    css: "border-color: rgb(236 252 203);",
  },
  {
    tailwind: "divide-lime-200",
    css: "border-color: rgb(217 249 157);",
  },
  {
    tailwind: "divide-lime-300",
    css: "border-color: rgb(190 242 100);",
  },
  {
    tailwind: "divide-lime-400",
    css: "border-color: rgb(163 230 53);",
  },
  {
    tailwind: "divide-lime-500",
    css: "border-color: rgb(132 204 22);",
  },
  {
    tailwind: "divide-lime-600",
    css: "border-color: rgb(101 163 13);",
  },
  {
    tailwind: "divide-lime-700",
    css: "border-color: rgb(77 124 15);",
  },
  {
    tailwind: "divide-lime-800",
    css: "border-color: rgb(63 98 18);",
  },
  {
    tailwind: "divide-lime-900",
    css: "border-color: rgb(54 83 20);",
  },
  {
    tailwind: "divide-lime-950",
    css: "border-color: rgb(26 46 5);",
  },
  {
    tailwind: "divide-green-50",
    css: "border-color: rgb(240 253 244);",
  },
  {
    tailwind: "divide-green-100",
    css: "border-color: rgb(220 252 231);",
  },
  {
    tailwind: "divide-green-200",
    css: "border-color: rgb(187 247 208);",
  },
  {
    tailwind: "divide-green-300",
    css: "border-color: rgb(134 239 172);",
  },
  {
    tailwind: "divide-green-400",
    css: "border-color: rgb(74 222 128);",
  },
  {
    tailwind: "divide-green-500",
    css: "border-color: rgb(34 197 94);",
  },
  {
    tailwind: "divide-green-600",
    css: "border-color: rgb(22 163 74);",
  },
  {
    tailwind: "divide-green-700",
    css: "border-color: rgb(21 128 61);",
  },
  {
    tailwind: "divide-green-800",
    css: "border-color: rgb(22 101 52);",
  },
  {
    tailwind: "divide-green-900",
    css: "border-color: rgb(20 83 45);",
  },
  {
    tailwind: "divide-green-950",
    css: "border-color: rgb(5 46 22);",
  },
  {
    tailwind: "divide-emerald-50",
    css: "border-color: rgb(236 253 245);",
  },
  {
    tailwind: "divide-emerald-100",
    css: "border-color: rgb(209 250 229);",
  },
  {
    tailwind: "divide-emerald-200",
    css: "border-color: rgb(167 243 208);",
  },
  {
    tailwind: "divide-emerald-300",
    css: "border-color: rgb(110 231 183);",
  },
  {
    tailwind: "divide-emerald-400",
    css: "border-color: rgb(52 211 153);",
  },
  {
    tailwind: "divide-emerald-500",
    css: "border-color: rgb(16 185 129);",
  },
  {
    tailwind: "divide-emerald-600",
    css: "border-color: rgb(5 150 105);",
  },
  {
    tailwind: "divide-emerald-700",
    css: "border-color: rgb(4 120 87);",
  },
  {
    tailwind: "divide-emerald-800",
    css: "border-color: rgb(6 95 70);",
  },
  {
    tailwind: "divide-emerald-900",
    css: "border-color: rgb(6 78 59);",
  },
  {
    tailwind: "divide-emerald-950",
    css: "border-color: rgb(2 44 34);",
  },
  {
    tailwind: "divide-teal-50",
    css: "border-color: rgb(240 253 250);",
  },
  {
    tailwind: "divide-teal-100",
    css: "border-color: rgb(204 251 241);",
  },
  {
    tailwind: "divide-teal-200",
    css: "border-color: rgb(153 246 228);",
  },
  {
    tailwind: "divide-teal-300",
    css: "border-color: rgb(94 234 212);",
  },
  {
    tailwind: "divide-teal-400",
    css: "border-color: rgb(45 212 191);",
  },
  {
    tailwind: "divide-teal-500",
    css: "border-color: rgb(20 184 166);",
  },
  {
    tailwind: "divide-teal-600",
    css: "border-color: rgb(13 148 136);",
  },
  {
    tailwind: "divide-teal-700",
    css: "border-color: rgb(15 118 110);",
  },
  {
    tailwind: "divide-teal-800",
    css: "border-color: rgb(17 94 89);",
  },
  {
    tailwind: "divide-teal-900",
    css: "border-color: rgb(19 78 74);",
  },
  {
    tailwind: "divide-teal-950",
    css: "border-color: rgb(4 47 46);",
  },
  {
    tailwind: "divide-cyan-50",
    css: "border-color: rgb(236 254 255);",
  },
  {
    tailwind: "divide-cyan-100",
    css: "border-color: rgb(207 250 254);",
  },
  {
    tailwind: "divide-cyan-200",
    css: "border-color: rgb(165 243 252);",
  },
  {
    tailwind: "divide-cyan-300",
    css: "border-color: rgb(103 232 249);",
  },
  {
    tailwind: "divide-cyan-400",
    css: "border-color: rgb(34 211 238);",
  },
  {
    tailwind: "divide-cyan-500",
    css: "border-color: rgb(6 182 212);",
  },
  {
    tailwind: "divide-cyan-600",
    css: "border-color: rgb(8 145 178);",
  },
  {
    tailwind: "divide-cyan-700",
    css: "border-color: rgb(14 116 144);",
  },
  {
    tailwind: "divide-cyan-800",
    css: "border-color: rgb(21 94 117);",
  },
  {
    tailwind: "divide-cyan-900",
    css: "border-color: rgb(22 78 99);",
  },
  {
    tailwind: "divide-cyan-950",
    css: "border-color: rgb(8 51 68);",
  },
  {
    tailwind: "divide-sky-50",
    css: "border-color: rgb(240 249 255);",
  },
  {
    tailwind: "divide-sky-100",
    css: "border-color: rgb(224 242 254);",
  },
  {
    tailwind: "divide-sky-200",
    css: "border-color: rgb(186 230 253);",
  },
  {
    tailwind: "divide-sky-300",
    css: "border-color: rgb(125 211 252);",
  },
  {
    tailwind: "divide-sky-400",
    css: "border-color: rgb(56 189 248);",
  },
  {
    tailwind: "divide-sky-500",
    css: "border-color: rgb(14 165 233);",
  },
  {
    tailwind: "divide-sky-600",
    css: "border-color: rgb(2 132 199);",
  },
  {
    tailwind: "divide-sky-700",
    css: "border-color: rgb(3 105 161);",
  },
  {
    tailwind: "divide-sky-800",
    css: "border-color: rgb(7 89 133);",
  },
  {
    tailwind: "divide-sky-900",
    css: "border-color: rgb(12 74 110);",
  },
  {
    tailwind: "divide-sky-950",
    css: "border-color: rgb(8 47 73);",
  },
  {
    tailwind: "divide-blue-50",
    css: "border-color: rgb(239 246 255);",
  },
  {
    tailwind: "divide-blue-100",
    css: "border-color: rgb(219 234 254);",
  },
  {
    tailwind: "divide-blue-200",
    css: "border-color: rgb(191 219 254);",
  },
  {
    tailwind: "divide-blue-300",
    css: "border-color: rgb(147 197 253);",
  },
  {
    tailwind: "divide-blue-400",
    css: "border-color: rgb(96 165 250);",
  },
  {
    tailwind: "divide-blue-500",
    css: "border-color: rgb(59 130 246);",
  },
  {
    tailwind: "divide-blue-600",
    css: "border-color: rgb(37 99 235);",
  },
  {
    tailwind: "divide-blue-700",
    css: "border-color: rgb(29 78 216);",
  },
  {
    tailwind: "divide-blue-800",
    css: "border-color: rgb(30 64 175);",
  },
  {
    tailwind: "divide-blue-900",
    css: "border-color: rgb(30 58 138);",
  },
  {
    tailwind: "divide-blue-950",
    css: "border-color: rgb(23 37 84);",
  },
  {
    tailwind: "divide-indigo-50",
    css: "border-color: rgb(238 242 255);",
  },
  {
    tailwind: "divide-indigo-100",
    css: "border-color: rgb(224 231 255);",
  },
  {
    tailwind: "divide-indigo-200",
    css: "border-color: rgb(199 210 254);",
  },
  {
    tailwind: "divide-indigo-300",
    css: "border-color: rgb(165 180 252);",
  },
  {
    tailwind: "divide-indigo-400",
    css: "border-color: rgb(129 140 248);",
  },
  {
    tailwind: "divide-indigo-500",
    css: "border-color: rgb(99 102 241);",
  },
  {
    tailwind: "divide-indigo-600",
    css: "border-color: rgb(79 70 229);",
  },
  {
    tailwind: "divide-indigo-700",
    css: "border-color: rgb(67 56 202);",
  },
  {
    tailwind: "divide-indigo-800",
    css: "border-color: rgb(55 48 163);",
  },
  {
    tailwind: "divide-indigo-900",
    css: "border-color: rgb(49 46 129);",
  },
  {
    tailwind: "divide-indigo-950",
    css: "border-color: rgb(30 27 75);",
  },
  {
    tailwind: "divide-violet-50",
    css: "border-color: rgb(245 243 255);",
  },
  {
    tailwind: "divide-violet-100",
    css: "border-color: rgb(237 233 254);",
  },
  {
    tailwind: "divide-violet-200",
    css: "border-color: rgb(221 214 254);",
  },
  {
    tailwind: "divide-violet-300",
    css: "border-color: rgb(196 181 253);",
  },
  {
    tailwind: "divide-violet-400",
    css: "border-color: rgb(167 139 250);",
  },
  {
    tailwind: "divide-violet-500",
    css: "border-color: rgb(139 92 246);",
  },
  {
    tailwind: "divide-violet-600",
    css: "border-color: rgb(124 58 237);",
  },
  {
    tailwind: "divide-violet-700",
    css: "border-color: rgb(109 40 217);",
  },
  {
    tailwind: "divide-violet-800",
    css: "border-color: rgb(91 33 182);",
  },
  {
    tailwind: "divide-violet-900",
    css: "border-color: rgb(76 29 149);",
  },
  {
    tailwind: "divide-violet-950",
    css: "border-color: rgb(46 16 101);",
  },
  {
    tailwind: "divide-purple-50",
    css: "border-color: rgb(250 245 255);",
  },
  {
    tailwind: "divide-purple-100",
    css: "border-color: rgb(243 232 255);",
  },
  {
    tailwind: "divide-purple-200",
    css: "border-color: rgb(233 213 255);",
  },
  {
    tailwind: "divide-purple-300",
    css: "border-color: rgb(216 180 254);",
  },
  {
    tailwind: "divide-purple-400",
    css: "border-color: rgb(192 132 252);",
  },
  {
    tailwind: "divide-purple-500",
    css: "border-color: rgb(168 85 247);",
  },
  {
    tailwind: "divide-purple-600",
    css: "border-color: rgb(147 51 234);",
  },
  {
    tailwind: "divide-purple-700",
    css: "border-color: rgb(126 34 206);",
  },
  {
    tailwind: "divide-purple-800",
    css: "border-color: rgb(107 33 168);",
  },
  {
    tailwind: "divide-purple-900",
    css: "border-color: rgb(88 28 135);",
  },
  {
    tailwind: "divide-purple-950",
    css: "border-color: rgb(59 7 100);",
  },
  {
    tailwind: "divide-fuchsia-50",
    css: "border-color: rgb(253 244 255);",
  },
  {
    tailwind: "divide-fuchsia-100",
    css: "border-color: rgb(250 232 255);",
  },
  {
    tailwind: "divide-fuchsia-200",
    css: "border-color: rgb(245 208 254);",
  },
  {
    tailwind: "divide-fuchsia-300",
    css: "border-color: rgb(240 171 252);",
  },
  {
    tailwind: "divide-fuchsia-400",
    css: "border-color: rgb(232 121 249);",
  },
  {
    tailwind: "divide-fuchsia-500",
    css: "border-color: rgb(217 70 239);",
  },
  {
    tailwind: "divide-fuchsia-600",
    css: "border-color: rgb(192 38 211);",
  },
  {
    tailwind: "divide-fuchsia-700",
    css: "border-color: rgb(162 28 175);",
  },
  {
    tailwind: "divide-fuchsia-800",
    css: "border-color: rgb(134 25 143);",
  },
  {
    tailwind: "divide-fuchsia-900",
    css: "border-color: rgb(112 26 117);",
  },
  {
    tailwind: "divide-fuchsia-950",
    css: "border-color: rgb(74 4 78);",
  },
  {
    tailwind: "divide-pink-50",
    css: "border-color: rgb(253 242 248);",
  },
  {
    tailwind: "divide-pink-100",
    css: "border-color: rgb(252 231 243);",
  },
  {
    tailwind: "divide-pink-200",
    css: "border-color: rgb(251 207 232);",
  },
  {
    tailwind: "divide-pink-300",
    css: "border-color: rgb(249 168 212);",
  },
  {
    tailwind: "divide-pink-400",
    css: "border-color: rgb(244 114 182);",
  },
  {
    tailwind: "divide-pink-500",
    css: "border-color: rgb(236 72 153);",
  },
  {
    tailwind: "divide-pink-600",
    css: "border-color: rgb(219 39 119);",
  },
  {
    tailwind: "divide-pink-700",
    css: "border-color: rgb(190 24 93);",
  },
  {
    tailwind: "divide-pink-800",
    css: "border-color: rgb(157 23 77);",
  },
  {
    tailwind: "divide-pink-900",
    css: "border-color: rgb(131 24 67);",
  },
  {
    tailwind: "divide-pink-950",
    css: "border-color: rgb(80 7 36);",
  },
  {
    tailwind: "divide-rose-50",
    css: "border-color: rgb(255 241 242);",
  },
  {
    tailwind: "divide-rose-100",
    css: "border-color: rgb(255 228 230);",
  },
  {
    tailwind: "divide-rose-200",
    css: "border-color: rgb(254 205 211);",
  },
  {
    tailwind: "divide-rose-300",
    css: "border-color: rgb(253 164 175);",
  },
  {
    tailwind: "divide-rose-400",
    css: "border-color: rgb(251 113 133);",
  },
  {
    tailwind: "divide-rose-500",
    css: "border-color: rgb(244 63 94);",
  },
  {
    tailwind: "divide-rose-600",
    css: "border-color: rgb(225 29 72);",
  },
  {
    tailwind: "divide-rose-700",
    css: "border-color: rgb(190 18 60);",
  },
  {
    tailwind: "divide-rose-800",
    css: "border-color: rgb(159 18 57);",
  },
  {
    tailwind: "divide-rose-900",
    css: "border-color: rgb(136 19 55);",
  },
  {
    tailwind: "divide-rose-950",
    css: "border-color: rgb(76 5 25);",
  },
  {
    tailwind: "divide-solid",
    css: "border-style: solid;",
  },
  {
    tailwind: "divide-dashed",
    css: "border-style: dashed;",
  },
  {
    tailwind: "divide-dotted",
    css: "border-style: dotted;",
  },
  {
    tailwind: "divide-double",
    css: "border-style: double;",
  },
  {
    tailwind: "divide-none",
    css: "border-style: none;",
  },
  {
    tailwind: "outline-0",
    css: "outline-width: 0px;",
  },
  {
    tailwind: "outline-1",
    css: "outline-width: 1px;",
  },
  {
    tailwind: "outline-2",
    css: "outline-width: 2px;",
  },
  {
    tailwind: "outline-4",
    css: "outline-width: 4px;",
  },
  {
    tailwind: "outline-8",
    css: "outline-width: 8px;",
  },
  {
    tailwind: "outline-inherit",
    css: "outline-color: inherit;",
  },
  {
    tailwind: "outline-current",
    css: "outline-color: currentColor;",
  },
  {
    tailwind: "outline-transparent",
    css: "outline-color: transparent;",
  },
  {
    tailwind: "outline-black",
    css: "outline-color: #000;",
  },
  {
    tailwind: "outline-white",
    css: "outline-color: #fff;",
  },
  {
    tailwind: "outline-slate-50",
    css: "outline-color: #f8fafc;",
  },
  {
    tailwind: "outline-slate-100",
    css: "outline-color: #f1f5f9;",
  },
  {
    tailwind: "outline-slate-200",
    css: "outline-color: #e2e8f0;",
  },
  {
    tailwind: "outline-slate-300",
    css: "outline-color: #cbd5e1;",
  },
  {
    tailwind: "outline-slate-400",
    css: "outline-color: #94a3b8;",
  },
  {
    tailwind: "outline-slate-500",
    css: "outline-color: #64748b;",
  },
  {
    tailwind: "outline-slate-600",
    css: "outline-color: #475569;",
  },
  {
    tailwind: "outline-slate-700",
    css: "outline-color: #334155;",
  },
  {
    tailwind: "outline-slate-800",
    css: "outline-color: #1e293b;",
  },
  {
    tailwind: "outline-slate-900",
    css: "outline-color: #0f172a;",
  },
  {
    tailwind: "outline-slate-950",
    css: "outline-color: #020617;",
  },
  {
    tailwind: "outline-gray-50",
    css: "outline-color: #f9fafb;",
  },
  {
    tailwind: "outline-gray-100",
    css: "outline-color: #f3f4f6;",
  },
  {
    tailwind: "outline-gray-200",
    css: "outline-color: #e5e7eb;",
  },
  {
    tailwind: "outline-gray-300",
    css: "outline-color: #d1d5db;",
  },
  {
    tailwind: "outline-gray-400",
    css: "outline-color: #9ca3af;",
  },
  {
    tailwind: "outline-gray-500",
    css: "outline-color: #6b7280;",
  },
  {
    tailwind: "outline-gray-600",
    css: "outline-color: #4b5563;",
  },
  {
    tailwind: "outline-gray-700",
    css: "outline-color: #374151;",
  },
  {
    tailwind: "outline-gray-800",
    css: "outline-color: #1f2937;",
  },
  {
    tailwind: "outline-gray-900",
    css: "outline-color: #111827;",
  },
  {
    tailwind: "outline-gray-950",
    css: "outline-color: #030712;",
  },
  {
    tailwind: "outline-zinc-50",
    css: "outline-color: #fafafa;",
  },
  {
    tailwind: "outline-zinc-100",
    css: "outline-color: #f4f4f5;",
  },
  {
    tailwind: "outline-zinc-200",
    css: "outline-color: #e4e4e7;",
  },
  {
    tailwind: "outline-zinc-300",
    css: "outline-color: #d4d4d8;",
  },
  {
    tailwind: "outline-zinc-400",
    css: "outline-color: #a1a1aa;",
  },
  {
    tailwind: "outline-zinc-500",
    css: "outline-color: #71717a;",
  },
  {
    tailwind: "outline-zinc-600",
    css: "outline-color: #52525b;",
  },
  {
    tailwind: "outline-zinc-700",
    css: "outline-color: #3f3f46;",
  },
  {
    tailwind: "outline-zinc-800",
    css: "outline-color: #27272a;",
  },
  {
    tailwind: "outline-zinc-900",
    css: "outline-color: #18181b;",
  },
  {
    tailwind: "outline-zinc-950",
    css: "outline-color: #09090b;",
  },
  {
    tailwind: "outline-neutral-50",
    css: "outline-color: #fafafa;",
  },
  {
    tailwind: "outline-neutral-100",
    css: "outline-color: #f5f5f5;",
  },
  {
    tailwind: "outline-neutral-200",
    css: "outline-color: #e5e5e5;",
  },
  {
    tailwind: "outline-neutral-300",
    css: "outline-color: #d4d4d4;",
  },
  {
    tailwind: "outline-neutral-400",
    css: "outline-color: #a3a3a3;",
  },
  {
    tailwind: "outline-neutral-500",
    css: "outline-color: #737373;",
  },
  {
    tailwind: "outline-neutral-600",
    css: "outline-color: #525252;",
  },
  {
    tailwind: "outline-neutral-700",
    css: "outline-color: #404040;",
  },
  {
    tailwind: "outline-neutral-800",
    css: "outline-color: #262626;",
  },
  {
    tailwind: "outline-neutral-900",
    css: "outline-color: #171717;",
  },
  {
    tailwind: "outline-neutral-950",
    css: "outline-color: #0a0a0a;",
  },
  {
    tailwind: "outline-stone-50",
    css: "outline-color: #fafaf9;",
  },
  {
    tailwind: "outline-stone-100",
    css: "outline-color: #f5f5f4;",
  },
  {
    tailwind: "outline-stone-200",
    css: "outline-color: #e7e5e4;",
  },
  {
    tailwind: "outline-stone-300",
    css: "outline-color: #d6d3d1;",
  },
  {
    tailwind: "outline-stone-400",
    css: "outline-color: #a8a29e;",
  },
  {
    tailwind: "outline-stone-500",
    css: "outline-color: #78716c;",
  },
  {
    tailwind: "outline-stone-600",
    css: "outline-color: #57534e;",
  },
  {
    tailwind: "outline-stone-700",
    css: "outline-color: #44403c;",
  },
  {
    tailwind: "outline-stone-800",
    css: "outline-color: #292524;",
  },
  {
    tailwind: "outline-stone-900",
    css: "outline-color: #1c1917;",
  },
  {
    tailwind: "outline-stone-950",
    css: "outline-color: #0c0a09;",
  },
  {
    tailwind: "outline-red-50",
    css: "outline-color: #fef2f2;",
  },
  {
    tailwind: "outline-red-100",
    css: "outline-color: #fee2e2;",
  },
  {
    tailwind: "outline-red-200",
    css: "outline-color: #fecaca;",
  },
  {
    tailwind: "outline-red-300",
    css: "outline-color: #fca5a5;",
  },
  {
    tailwind: "outline-red-400",
    css: "outline-color: #f87171;",
  },
  {
    tailwind: "outline-red-500",
    css: "outline-color: #ef4444;",
  },
  {
    tailwind: "outline-red-600",
    css: "outline-color: #dc2626;",
  },
  {
    tailwind: "outline-red-700",
    css: "outline-color: #b91c1c;",
  },
  {
    tailwind: "outline-red-800",
    css: "outline-color: #991b1b;",
  },
  {
    tailwind: "outline-red-900",
    css: "outline-color: #7f1d1d;",
  },
  {
    tailwind: "outline-red-950",
    css: "outline-color: #450a0a;",
  },
  {
    tailwind: "outline-orange-50",
    css: "outline-color: #fff7ed;",
  },
  {
    tailwind: "outline-orange-100",
    css: "outline-color: #ffedd5;",
  },
  {
    tailwind: "outline-orange-200",
    css: "outline-color: #fed7aa;",
  },
  {
    tailwind: "outline-orange-300",
    css: "outline-color: #fdba74;",
  },
  {
    tailwind: "outline-orange-400",
    css: "outline-color: #fb923c;",
  },
  {
    tailwind: "outline-orange-500",
    css: "outline-color: #f97316;",
  },
  {
    tailwind: "outline-orange-600",
    css: "outline-color: #ea580c;",
  },
  {
    tailwind: "outline-orange-700",
    css: "outline-color: #c2410c;",
  },
  {
    tailwind: "outline-orange-800",
    css: "outline-color: #9a3412;",
  },
  {
    tailwind: "outline-orange-900",
    css: "outline-color: #7c2d12;",
  },
  {
    tailwind: "outline-orange-950",
    css: "outline-color: #431407;",
  },
  {
    tailwind: "outline-amber-50",
    css: "outline-color: #fffbeb;",
  },
  {
    tailwind: "outline-amber-100",
    css: "outline-color: #fef3c7;",
  },
  {
    tailwind: "outline-amber-200",
    css: "outline-color: #fde68a;",
  },
  {
    tailwind: "outline-amber-300",
    css: "outline-color: #fcd34d;",
  },
  {
    tailwind: "outline-amber-400",
    css: "outline-color: #fbbf24;",
  },
  {
    tailwind: "outline-amber-500",
    css: "outline-color: #f59e0b;",
  },
  {
    tailwind: "outline-amber-600",
    css: "outline-color: #d97706;",
  },
  {
    tailwind: "outline-amber-700",
    css: "outline-color: #b45309;",
  },
  {
    tailwind: "outline-amber-800",
    css: "outline-color: #92400e;",
  },
  {
    tailwind: "outline-amber-900",
    css: "outline-color: #78350f;",
  },
  {
    tailwind: "outline-amber-950",
    css: "outline-color: #451a03;",
  },
  {
    tailwind: "outline-yellow-50",
    css: "outline-color: #fefce8;",
  },
  {
    tailwind: "outline-yellow-100",
    css: "outline-color: #fef9c3;",
  },
  {
    tailwind: "outline-yellow-200",
    css: "outline-color: #fef08a;",
  },
  {
    tailwind: "outline-yellow-300",
    css: "outline-color: #fde047;",
  },
  {
    tailwind: "outline-yellow-400",
    css: "outline-color: #facc15;",
  },
  {
    tailwind: "outline-yellow-500",
    css: "outline-color: #eab308;",
  },
  {
    tailwind: "outline-yellow-600",
    css: "outline-color: #ca8a04;",
  },
  {
    tailwind: "outline-yellow-700",
    css: "outline-color: #a16207;",
  },
  {
    tailwind: "outline-yellow-800",
    css: "outline-color: #854d0e;",
  },
  {
    tailwind: "outline-yellow-900",
    css: "outline-color: #713f12;",
  },
  {
    tailwind: "outline-yellow-950",
    css: "outline-color: #422006;",
  },
  {
    tailwind: "outline-lime-50",
    css: "outline-color: #f7fee7;",
  },
  {
    tailwind: "outline-lime-100",
    css: "outline-color: #ecfccb;",
  },
  {
    tailwind: "outline-lime-200",
    css: "outline-color: #d9f99d;",
  },
  {
    tailwind: "outline-lime-300",
    css: "outline-color: #bef264;",
  },
  {
    tailwind: "outline-lime-400",
    css: "outline-color: #a3e635;",
  },
  {
    tailwind: "outline-lime-500",
    css: "outline-color: #84cc16;",
  },
  {
    tailwind: "outline-lime-600",
    css: "outline-color: #65a30d;",
  },
  {
    tailwind: "outline-lime-700",
    css: "outline-color: #4d7c0f;",
  },
  {
    tailwind: "outline-lime-800",
    css: "outline-color: #3f6212;",
  },
  {
    tailwind: "outline-lime-900",
    css: "outline-color: #365314;",
  },
  {
    tailwind: "outline-lime-950",
    css: "outline-color: #1a2e05;",
  },
  {
    tailwind: "outline-green-50",
    css: "outline-color: #f0fdf4;",
  },
  {
    tailwind: "outline-green-100",
    css: "outline-color: #dcfce7;",
  },
  {
    tailwind: "outline-green-200",
    css: "outline-color: #bbf7d0;",
  },
  {
    tailwind: "outline-green-300",
    css: "outline-color: #86efac;",
  },
  {
    tailwind: "outline-green-400",
    css: "outline-color: #4ade80;",
  },
  {
    tailwind: "outline-green-500",
    css: "outline-color: #22c55e;",
  },
  {
    tailwind: "outline-green-600",
    css: "outline-color: #16a34a;",
  },
  {
    tailwind: "outline-green-700",
    css: "outline-color: #15803d;",
  },
  {
    tailwind: "outline-green-800",
    css: "outline-color: #166534;",
  },
  {
    tailwind: "outline-green-900",
    css: "outline-color: #14532d;",
  },
  {
    tailwind: "outline-green-950",
    css: "outline-color: #052e16;",
  },
  {
    tailwind: "outline-emerald-50",
    css: "outline-color: #ecfdf5;",
  },
  {
    tailwind: "outline-emerald-100",
    css: "outline-color: #d1fae5;",
  },
  {
    tailwind: "outline-emerald-200",
    css: "outline-color: #a7f3d0;",
  },
  {
    tailwind: "outline-emerald-300",
    css: "outline-color: #6ee7b7;",
  },
  {
    tailwind: "outline-emerald-400",
    css: "outline-color: #34d399;",
  },
  {
    tailwind: "outline-emerald-500",
    css: "outline-color: #10b981;",
  },
  {
    tailwind: "outline-emerald-600",
    css: "outline-color: #059669;",
  },
  {
    tailwind: "outline-emerald-700",
    css: "outline-color: #047857;",
  },
  {
    tailwind: "outline-emerald-800",
    css: "outline-color: #065f46;",
  },
  {
    tailwind: "outline-emerald-900",
    css: "outline-color: #064e3b;",
  },
  {
    tailwind: "outline-emerald-950",
    css: "outline-color: #022c22;",
  },
  {
    tailwind: "outline-teal-50",
    css: "outline-color: #f0fdfa;",
  },
  {
    tailwind: "outline-teal-100",
    css: "outline-color: #ccfbf1;",
  },
  {
    tailwind: "outline-teal-200",
    css: "outline-color: #99f6e4;",
  },
  {
    tailwind: "outline-teal-300",
    css: "outline-color: #5eead4;",
  },
  {
    tailwind: "outline-teal-400",
    css: "outline-color: #2dd4bf;",
  },
  {
    tailwind: "outline-teal-500",
    css: "outline-color: #14b8a6;",
  },
  {
    tailwind: "outline-teal-600",
    css: "outline-color: #0d9488;",
  },
  {
    tailwind: "outline-teal-700",
    css: "outline-color: #0f766e;",
  },
  {
    tailwind: "outline-teal-800",
    css: "outline-color: #115e59;",
  },
  {
    tailwind: "outline-teal-900",
    css: "outline-color: #134e4a;",
  },
  {
    tailwind: "outline-teal-950",
    css: "outline-color: #042f2e;",
  },
  {
    tailwind: "outline-cyan-50",
    css: "outline-color: #ecfeff;",
  },
  {
    tailwind: "outline-cyan-100",
    css: "outline-color: #cffafe;",
  },
  {
    tailwind: "outline-cyan-200",
    css: "outline-color: #a5f3fc;",
  },
  {
    tailwind: "outline-cyan-300",
    css: "outline-color: #67e8f9;",
  },
  {
    tailwind: "outline-cyan-400",
    css: "outline-color: #22d3ee;",
  },
  {
    tailwind: "outline-cyan-500",
    css: "outline-color: #06b6d4;",
  },
  {
    tailwind: "outline-cyan-600",
    css: "outline-color: #0891b2;",
  },
  {
    tailwind: "outline-cyan-700",
    css: "outline-color: #0e7490;",
  },
  {
    tailwind: "outline-cyan-800",
    css: "outline-color: #155e75;",
  },
  {
    tailwind: "outline-cyan-900",
    css: "outline-color: #164e63;",
  },
  {
    tailwind: "outline-cyan-950",
    css: "outline-color: #083344;",
  },
  {
    tailwind: "outline-sky-50",
    css: "outline-color: #f0f9ff;",
  },
  {
    tailwind: "outline-sky-100",
    css: "outline-color: #e0f2fe;",
  },
  {
    tailwind: "outline-sky-200",
    css: "outline-color: #bae6fd;",
  },
  {
    tailwind: "outline-sky-300",
    css: "outline-color: #7dd3fc;",
  },
  {
    tailwind: "outline-sky-400",
    css: "outline-color: #38bdf8;",
  },
  {
    tailwind: "outline-sky-500",
    css: "outline-color: #0ea5e9;",
  },
  {
    tailwind: "outline-sky-600",
    css: "outline-color: #0284c7;",
  },
  {
    tailwind: "outline-sky-700",
    css: "outline-color: #0369a1;",
  },
  {
    tailwind: "outline-sky-800",
    css: "outline-color: #075985;",
  },
  {
    tailwind: "outline-sky-900",
    css: "outline-color: #0c4a6e;",
  },
  {
    tailwind: "outline-sky-950",
    css: "outline-color: #082f49;",
  },
  {
    tailwind: "outline-blue-50",
    css: "outline-color: #eff6ff;",
  },
  {
    tailwind: "outline-blue-100",
    css: "outline-color: #dbeafe;",
  },
  {
    tailwind: "outline-blue-200",
    css: "outline-color: #bfdbfe;",
  },
  {
    tailwind: "outline-blue-300",
    css: "outline-color: #93c5fd;",
  },
  {
    tailwind: "outline-blue-400",
    css: "outline-color: #60a5fa;",
  },
  {
    tailwind: "outline-blue-500",
    css: "outline-color: #3b82f6;",
  },
  {
    tailwind: "outline-blue-600",
    css: "outline-color: #2563eb;",
  },
  {
    tailwind: "outline-blue-700",
    css: "outline-color: #1d4ed8;",
  },
  {
    tailwind: "outline-blue-800",
    css: "outline-color: #1e40af;",
  },
  {
    tailwind: "outline-blue-900",
    css: "outline-color: #1e3a8a;",
  },
  {
    tailwind: "outline-blue-950",
    css: "outline-color: #172554;",
  },
  {
    tailwind: "outline-indigo-50",
    css: "outline-color: #eef2ff;",
  },
  {
    tailwind: "outline-indigo-100",
    css: "outline-color: #e0e7ff;",
  },
  {
    tailwind: "outline-indigo-200",
    css: "outline-color: #c7d2fe;",
  },
  {
    tailwind: "outline-indigo-300",
    css: "outline-color: #a5b4fc;",
  },
  {
    tailwind: "outline-indigo-400",
    css: "outline-color: #818cf8;",
  },
  {
    tailwind: "outline-indigo-500",
    css: "outline-color: #6366f1;",
  },
  {
    tailwind: "outline-indigo-600",
    css: "outline-color: #4f46e5;",
  },
  {
    tailwind: "outline-indigo-700",
    css: "outline-color: #4338ca;",
  },
  {
    tailwind: "outline-indigo-800",
    css: "outline-color: #3730a3;",
  },
  {
    tailwind: "outline-indigo-900",
    css: "outline-color: #312e81;",
  },
  {
    tailwind: "outline-indigo-950",
    css: "outline-color: #1e1b4b;",
  },
  {
    tailwind: "outline-violet-50",
    css: "outline-color: #f5f3ff;",
  },
  {
    tailwind: "outline-violet-100",
    css: "outline-color: #ede9fe;",
  },
  {
    tailwind: "outline-violet-200",
    css: "outline-color: #ddd6fe;",
  },
  {
    tailwind: "outline-violet-300",
    css: "outline-color: #c4b5fd;",
  },
  {
    tailwind: "outline-violet-400",
    css: "outline-color: #a78bfa;",
  },
  {
    tailwind: "outline-violet-500",
    css: "outline-color: #8b5cf6;",
  },
  {
    tailwind: "outline-violet-600",
    css: "outline-color: #7c3aed;",
  },
  {
    tailwind: "outline-violet-700",
    css: "outline-color: #6d28d9;",
  },
  {
    tailwind: "outline-violet-800",
    css: "outline-color: #5b21b6;",
  },
  {
    tailwind: "outline-violet-900",
    css: "outline-color: #4c1d95;",
  },
  {
    tailwind: "outline-violet-950",
    css: "outline-color: #2e1065;",
  },
  {
    tailwind: "outline-purple-50",
    css: "outline-color: #faf5ff;",
  },
  {
    tailwind: "outline-purple-100",
    css: "outline-color: #f3e8ff;",
  },
  {
    tailwind: "outline-purple-200",
    css: "outline-color: #e9d5ff;",
  },
  {
    tailwind: "outline-purple-300",
    css: "outline-color: #d8b4fe;",
  },
  {
    tailwind: "outline-purple-400",
    css: "outline-color: #c084fc;",
  },
  {
    tailwind: "outline-purple-500",
    css: "outline-color: #a855f7;",
  },
  {
    tailwind: "outline-purple-600",
    css: "outline-color: #9333ea;",
  },
  {
    tailwind: "outline-purple-700",
    css: "outline-color: #7e22ce;",
  },
  {
    tailwind: "outline-purple-800",
    css: "outline-color: #6b21a8;",
  },
  {
    tailwind: "outline-purple-900",
    css: "outline-color: #581c87;",
  },
  {
    tailwind: "outline-purple-950",
    css: "outline-color: #3b0764;",
  },
  {
    tailwind: "outline-fuchsia-50",
    css: "outline-color: #fdf4ff;",
  },
  {
    tailwind: "outline-fuchsia-100",
    css: "outline-color: #fae8ff;",
  },
  {
    tailwind: "outline-fuchsia-200",
    css: "outline-color: #f5d0fe;",
  },
  {
    tailwind: "outline-fuchsia-300",
    css: "outline-color: #f0abfc;",
  },
  {
    tailwind: "outline-fuchsia-400",
    css: "outline-color: #e879f9;",
  },
  {
    tailwind: "outline-fuchsia-500",
    css: "outline-color: #d946ef;",
  },
  {
    tailwind: "outline-fuchsia-600",
    css: "outline-color: #c026d3;",
  },
  {
    tailwind: "outline-fuchsia-700",
    css: "outline-color: #a21caf;",
  },
  {
    tailwind: "outline-fuchsia-800",
    css: "outline-color: #86198f;",
  },
  {
    tailwind: "outline-fuchsia-900",
    css: "outline-color: #701a75;",
  },
  {
    tailwind: "outline-fuchsia-950",
    css: "outline-color: #4a044e;",
  },
  {
    tailwind: "outline-pink-50",
    css: "outline-color: #fdf2f8;",
  },
  {
    tailwind: "outline-pink-100",
    css: "outline-color: #fce7f3;",
  },
  {
    tailwind: "outline-pink-200",
    css: "outline-color: #fbcfe8;",
  },
  {
    tailwind: "outline-pink-300",
    css: "outline-color: #f9a8d4;",
  },
  {
    tailwind: "outline-pink-400",
    css: "outline-color: #f472b6;",
  },
  {
    tailwind: "outline-pink-500",
    css: "outline-color: #ec4899;",
  },
  {
    tailwind: "outline-pink-600",
    css: "outline-color: #db2777;",
  },
  {
    tailwind: "outline-pink-700",
    css: "outline-color: #be185d;",
  },
  {
    tailwind: "outline-pink-800",
    css: "outline-color: #9d174d;",
  },
  {
    tailwind: "outline-pink-900",
    css: "outline-color: #831843;",
  },
  {
    tailwind: "outline-pink-950",
    css: "outline-color: #500724;",
  },
  {
    tailwind: "outline-rose-50",
    css: "outline-color: #fff1f2;",
  },
  {
    tailwind: "outline-rose-100",
    css: "outline-color: #ffe4e6;",
  },
  {
    tailwind: "outline-rose-200",
    css: "outline-color: #fecdd3;",
  },
  {
    tailwind: "outline-rose-300",
    css: "outline-color: #fda4af;",
  },
  {
    tailwind: "outline-rose-400",
    css: "outline-color: #fb7185;",
  },
  {
    tailwind: "outline-rose-500",
    css: "outline-color: #f43f5e;",
  },
  {
    tailwind: "outline-rose-600",
    css: "outline-color: #e11d48;",
  },
  {
    tailwind: "outline-rose-700",
    css: "outline-color: #be123c;",
  },
  {
    tailwind: "outline-rose-800",
    css: "outline-color: #9f1239;",
  },
  {
    tailwind: "outline-rose-900",
    css: "outline-color: #881337;",
  },
  {
    tailwind: "outline-rose-950",
    css: "outline-color: #4c0519;",
  },
  {
    tailwind: "outline-none",
    css: "outline: 2px solid transparent;\noutline-offset: 2px;",
  },
  {
    tailwind: "outline",
    css: "outline-style: solid;",
  },
  {
    tailwind: "outline-dashed",
    css: "outline-style: dashed;",
  },
  {
    tailwind: "outline-dotted",
    css: "outline-style: dotted;",
  },
  {
    tailwind: "outline-double",
    css: "outline-style: double;",
  },
  {
    tailwind: "outline-offset-0",
    css: "outline-offset: 0px;",
  },
  {
    tailwind: "outline-offset-1",
    css: "outline-offset: 1px;",
  },
  {
    tailwind: "outline-offset-2",
    css: "outline-offset: 2px;",
  },
  {
    tailwind: "outline-offset-4",
    css: "outline-offset: 4px;",
  },
  {
    tailwind: "outline-offset-8",
    css: "outline-offset: 8px;",
  },
  {
    tailwind: "ring-0",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring-1",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring-2",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring-4",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring-8",
    css: "box-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
  },
  {
    tailwind: "ring-inset",
    css: "--tw-ring-inset: inset;",
  },
  {
    tailwind: "ring-inherit",
    css: "--tw-ring-color: inherit;",
  },
  {
    tailwind: "ring-current",
    css: "--tw-ring-color: currentColor;",
  },
  {
    tailwind: "ring-transparent",
    css: "--tw-ring-color: transparent;",
  },
  {
    tailwind: "ring-black",
    css: "--tw-ring-color: rgb(0 0 0);",
  },
  {
    tailwind: "ring-white",
    css: "--tw-ring-color: rgb(255 255 255);",
  },
  {
    tailwind: "ring-slate-50",
    css: "--tw-ring-color: rgb(248 250 252);",
  },
  {
    tailwind: "ring-slate-100",
    css: "--tw-ring-color: rgb(241 245 249);",
  },
  {
    tailwind: "ring-slate-200",
    css: "--tw-ring-color: rgb(226 232 240);",
  },
  {
    tailwind: "ring-slate-300",
    css: "--tw-ring-color: rgb(203 213 225);",
  },
  {
    tailwind: "ring-slate-400",
    css: "--tw-ring-color: rgb(148 163 184);",
  },
  {
    tailwind: "ring-slate-500",
    css: "--tw-ring-color: rgb(100 116 139);",
  },
  {
    tailwind: "ring-slate-600",
    css: "--tw-ring-color: rgb(71 85 105);",
  },
  {
    tailwind: "ring-slate-700",
    css: "--tw-ring-color: rgb(51 65 85);",
  },
  {
    tailwind: "ring-slate-800",
    css: "--tw-ring-color: rgb(30 41 59);",
  },
  {
    tailwind: "ring-slate-900",
    css: "--tw-ring-color: rgb(15 23 42);",
  },
  {
    tailwind: "ring-slate-950",
    css: "--tw-ring-color: rgb(2 6 23);",
  },
  {
    tailwind: "ring-gray-50",
    css: "--tw-ring-color: rgb(249 250 251);",
  },
  {
    tailwind: "ring-gray-100",
    css: "--tw-ring-color: rgb(243 244 246);",
  },
  {
    tailwind: "ring-gray-200",
    css: "--tw-ring-color: rgb(229 231 235);",
  },
  {
    tailwind: "ring-gray-300",
    css: "--tw-ring-color: rgb(209 213 219);",
  },
  {
    tailwind: "ring-gray-400",
    css: "--tw-ring-color: rgb(156 163 175);",
  },
  {
    tailwind: "ring-gray-500",
    css: "--tw-ring-color: rgb(107 114 128);",
  },
  {
    tailwind: "ring-gray-600",
    css: "--tw-ring-color: rgb(75 85 99);",
  },
  {
    tailwind: "ring-gray-700",
    css: "--tw-ring-color: rgb(55 65 81);",
  },
  {
    tailwind: "ring-gray-800",
    css: "--tw-ring-color: rgb(31 41 55);",
  },
  {
    tailwind: "ring-gray-900",
    css: "--tw-ring-color: rgb(17 24 39);",
  },
  {
    tailwind: "ring-gray-950",
    css: "--tw-ring-color: rgb(3 7 18);",
  },
  {
    tailwind: "ring-zinc-50",
    css: "--tw-ring-color: rgb(250 250 250);",
  },
  {
    tailwind: "ring-zinc-100",
    css: "--tw-ring-color: rgb(244 244 245);",
  },
  {
    tailwind: "ring-zinc-200",
    css: "--tw-ring-color: rgb(228 228 231);",
  },
  {
    tailwind: "ring-zinc-300",
    css: "--tw-ring-color: rgb(212 212 216);",
  },
  {
    tailwind: "ring-zinc-400",
    css: "--tw-ring-color: rgb(161 161 170);",
  },
  {
    tailwind: "ring-zinc-500",
    css: "--tw-ring-color: rgb(113 113 122);",
  },
  {
    tailwind: "ring-zinc-600",
    css: "--tw-ring-color: rgb(82 82 91);",
  },
  {
    tailwind: "ring-zinc-700",
    css: "--tw-ring-color: rgb(63 63 70);",
  },
  {
    tailwind: "ring-zinc-800",
    css: "--tw-ring-color: rgb(39 39 42);",
  },
  {
    tailwind: "ring-zinc-900",
    css: "--tw-ring-color: rgb(24 24 27);",
  },
  {
    tailwind: "ring-zinc-950",
    css: "--tw-ring-color: rgb(9 9 11);",
  },
  {
    tailwind: "ring-neutral-50",
    css: "--tw-ring-color: rgb(250 250 250);",
  },
  {
    tailwind: "ring-neutral-100",
    css: "--tw-ring-color: rgb(245 245 245);",
  },
  {
    tailwind: "ring-neutral-200",
    css: "--tw-ring-color: rgb(229 229 229);",
  },
  {
    tailwind: "ring-neutral-300",
    css: "--tw-ring-color: rgb(212 212 212);",
  },
  {
    tailwind: "ring-neutral-400",
    css: "--tw-ring-color: rgb(163 163 163);",
  },
  {
    tailwind: "ring-neutral-500",
    css: "--tw-ring-color: rgb(115 115 115);",
  },
  {
    tailwind: "ring-neutral-600",
    css: "--tw-ring-color: rgb(82 82 82);",
  },
  {
    tailwind: "ring-neutral-700",
    css: "--tw-ring-color: rgb(64 64 64);",
  },
  {
    tailwind: "ring-neutral-800",
    css: "--tw-ring-color: rgb(38 38 38);",
  },
  {
    tailwind: "ring-neutral-900",
    css: "--tw-ring-color: rgb(23 23 23);",
  },
  {
    tailwind: "ring-neutral-950",
    css: "--tw-ring-color: rgb(10 10 10);",
  },
  {
    tailwind: "ring-stone-50",
    css: "--tw-ring-color: rgb(250 250 249);",
  },
  {
    tailwind: "ring-stone-100",
    css: "--tw-ring-color: rgb(245 245 244);",
  },
  {
    tailwind: "ring-stone-200",
    css: "--tw-ring-color: rgb(231 229 228);",
  },
  {
    tailwind: "ring-stone-300",
    css: "--tw-ring-color: rgb(214 211 209);",
  },
  {
    tailwind: "ring-stone-400",
    css: "--tw-ring-color: rgb(168 162 158);",
  },
  {
    tailwind: "ring-stone-500",
    css: "--tw-ring-color: rgb(120 113 108);",
  },
  {
    tailwind: "ring-stone-600",
    css: "--tw-ring-color: rgb(87 83 78);",
  },
  {
    tailwind: "ring-stone-700",
    css: "--tw-ring-color: rgb(68 64 60);",
  },
  {
    tailwind: "ring-stone-800",
    css: "--tw-ring-color: rgb(41 37 36);",
  },
  {
    tailwind: "ring-stone-900",
    css: "--tw-ring-color: rgb(28 25 23);",
  },
  {
    tailwind: "ring-stone-950",
    css: "--tw-ring-color: rgb(12 10 9);",
  },
  {
    tailwind: "ring-red-50",
    css: "--tw-ring-color: rgb(254 242 242);",
  },
  {
    tailwind: "ring-red-100",
    css: "--tw-ring-color: rgb(254 226 226);",
  },
  {
    tailwind: "ring-red-200",
    css: "--tw-ring-color: rgb(254 202 202);",
  },
  {
    tailwind: "ring-red-300",
    css: "--tw-ring-color: rgb(252 165 165);",
  },
  {
    tailwind: "ring-red-400",
    css: "--tw-ring-color: rgb(248 113 113);",
  },
  {
    tailwind: "ring-red-500",
    css: "--tw-ring-color: rgb(239 68 68);",
  },
  {
    tailwind: "ring-red-600",
    css: "--tw-ring-color: rgb(220 38 38);",
  },
  {
    tailwind: "ring-red-700",
    css: "--tw-ring-color: rgb(185 28 28);",
  },
  {
    tailwind: "ring-red-800",
    css: "--tw-ring-color: rgb(153 27 27);",
  },
  {
    tailwind: "ring-red-900",
    css: "--tw-ring-color: rgb(127 29 29);",
  },
  {
    tailwind: "ring-red-950",
    css: "--tw-ring-color: rgb(69 10 10);",
  },
  {
    tailwind: "ring-orange-50",
    css: "--tw-ring-color: rgb(255 247 237);",
  },
  {
    tailwind: "ring-orange-100",
    css: "--tw-ring-color: rgb(255 237 213);",
  },
  {
    tailwind: "ring-orange-200",
    css: "--tw-ring-color: rgb(254 215 170);",
  },
  {
    tailwind: "ring-orange-300",
    css: "--tw-ring-color: rgb(253 186 116);",
  },
  {
    tailwind: "ring-orange-400",
    css: "--tw-ring-color: rgb(251 146 60);",
  },
  {
    tailwind: "ring-orange-500",
    css: "--tw-ring-color: rgb(249 115 22);",
  },
  {
    tailwind: "ring-orange-600",
    css: "--tw-ring-color: rgb(234 88 12);",
  },
  {
    tailwind: "ring-orange-700",
    css: "--tw-ring-color: rgb(194 65 12);",
  },
  {
    tailwind: "ring-orange-800",
    css: "--tw-ring-color: rgb(154 52 18);",
  },
  {
    tailwind: "ring-orange-900",
    css: "--tw-ring-color: rgb(124 45 18);",
  },
  {
    tailwind: "ring-orange-950",
    css: "--tw-ring-color: rgb(67 20 7);",
  },
  {
    tailwind: "ring-amber-50",
    css: "--tw-ring-color: rgb(255 251 235);",
  },
  {
    tailwind: "ring-amber-100",
    css: "--tw-ring-color: rgb(254 243 199);",
  },
  {
    tailwind: "ring-amber-200",
    css: "--tw-ring-color: rgb(253 230 138);",
  },
  {
    tailwind: "ring-amber-300",
    css: "--tw-ring-color: rgb(252 211 77);",
  },
  {
    tailwind: "ring-amber-400",
    css: "--tw-ring-color: rgb(251 191 36);",
  },
  {
    tailwind: "ring-amber-500",
    css: "--tw-ring-color: rgb(245 158 11);",
  },
  {
    tailwind: "ring-amber-600",
    css: "--tw-ring-color: rgb(217 119 6);",
  },
  {
    tailwind: "ring-amber-700",
    css: "--tw-ring-color: rgb(180 83 9);",
  },
  {
    tailwind: "ring-amber-800",
    css: "--tw-ring-color: rgb(146 64 14);",
  },
  {
    tailwind: "ring-amber-900",
    css: "--tw-ring-color: rgb(120 53 15);",
  },
  {
    tailwind: "ring-amber-950",
    css: "--tw-ring-color: rgb(69 26 3);",
  },
  {
    tailwind: "ring-yellow-50",
    css: "--tw-ring-color: rgb(254 252 232);",
  },
  {
    tailwind: "ring-yellow-100",
    css: "--tw-ring-color: rgb(254 249 195);",
  },
  {
    tailwind: "ring-yellow-200",
    css: "--tw-ring-color: rgb(254 240 138);",
  },
  {
    tailwind: "ring-yellow-300",
    css: "--tw-ring-color: rgb(253 224 71);",
  },
  {
    tailwind: "ring-yellow-400",
    css: "--tw-ring-color: rgb(250 204 21);",
  },
  {
    tailwind: "ring-yellow-500",
    css: "--tw-ring-color: rgb(234 179 8);",
  },
  {
    tailwind: "ring-yellow-600",
    css: "--tw-ring-color: rgb(202 138 4);",
  },
  {
    tailwind: "ring-yellow-700",
    css: "--tw-ring-color: rgb(161 98 7);",
  },
  {
    tailwind: "ring-yellow-800",
    css: "--tw-ring-color: rgb(133 77 14);",
  },
  {
    tailwind: "ring-yellow-900",
    css: "--tw-ring-color: rgb(113 63 18);",
  },
  {
    tailwind: "ring-yellow-950",
    css: "--tw-ring-color: rgb(66 32 6);",
  },
  {
    tailwind: "ring-lime-50",
    css: "--tw-ring-color: rgb(247 254 231);",
  },
  {
    tailwind: "ring-lime-100",
    css: "--tw-ring-color: rgb(236 252 203);",
  },
  {
    tailwind: "ring-lime-200",
    css: "--tw-ring-color: rgb(217 249 157);",
  },
  {
    tailwind: "ring-lime-300",
    css: "--tw-ring-color: rgb(190 242 100);",
  },
  {
    tailwind: "ring-lime-400",
    css: "--tw-ring-color: rgb(163 230 53);",
  },
  {
    tailwind: "ring-lime-500",
    css: "--tw-ring-color: rgb(132 204 22);",
  },
  {
    tailwind: "ring-lime-600",
    css: "--tw-ring-color: rgb(101 163 13);",
  },
  {
    tailwind: "ring-lime-700",
    css: "--tw-ring-color: rgb(77 124 15);",
  },
  {
    tailwind: "ring-lime-800",
    css: "--tw-ring-color: rgb(63 98 18);",
  },
  {
    tailwind: "ring-lime-900",
    css: "--tw-ring-color: rgb(54 83 20);",
  },
  {
    tailwind: "ring-lime-950",
    css: "--tw-ring-color: rgb(26 46 5);",
  },
  {
    tailwind: "ring-green-50",
    css: "--tw-ring-color: rgb(240 253 244);",
  },
  {
    tailwind: "ring-green-100",
    css: "--tw-ring-color: rgb(220 252 231);",
  },
  {
    tailwind: "ring-green-200",
    css: "--tw-ring-color: rgb(187 247 208);",
  },
  {
    tailwind: "ring-green-300",
    css: "--tw-ring-color: rgb(134 239 172);",
  },
  {
    tailwind: "ring-green-400",
    css: "--tw-ring-color: rgb(74 222 128);",
  },
  {
    tailwind: "ring-green-500",
    css: "--tw-ring-color: rgb(34 197 94);",
  },
  {
    tailwind: "ring-green-600",
    css: "--tw-ring-color: rgb(22 163 74);",
  },
  {
    tailwind: "ring-green-700",
    css: "--tw-ring-color: rgb(21 128 61);",
  },
  {
    tailwind: "ring-green-800",
    css: "--tw-ring-color: rgb(22 101 52);",
  },
  {
    tailwind: "ring-green-900",
    css: "--tw-ring-color: rgb(20 83 45);",
  },
  {
    tailwind: "ring-green-950",
    css: "--tw-ring-color: rgb(5 46 22);",
  },
  {
    tailwind: "ring-emerald-50",
    css: "--tw-ring-color: rgb(236 253 245);",
  },
  {
    tailwind: "ring-emerald-100",
    css: "--tw-ring-color: rgb(209 250 229);",
  },
  {
    tailwind: "ring-emerald-200",
    css: "--tw-ring-color: rgb(167 243 208);",
  },
  {
    tailwind: "ring-emerald-300",
    css: "--tw-ring-color: rgb(110 231 183);",
  },
  {
    tailwind: "ring-emerald-400",
    css: "--tw-ring-color: rgb(52 211 153);",
  },
  {
    tailwind: "ring-emerald-500",
    css: "--tw-ring-color: rgb(16 185 129);",
  },
  {
    tailwind: "ring-emerald-600",
    css: "--tw-ring-color: rgb(5 150 105);",
  },
  {
    tailwind: "ring-emerald-700",
    css: "--tw-ring-color: rgb(4 120 87);",
  },
  {
    tailwind: "ring-emerald-800",
    css: "--tw-ring-color: rgb(6 95 70);",
  },
  {
    tailwind: "ring-emerald-900",
    css: "--tw-ring-color: rgb(6 78 59);",
  },
  {
    tailwind: "ring-emerald-950",
    css: "--tw-ring-color: rgb(2 44 34);",
  },
  {
    tailwind: "ring-teal-50",
    css: "--tw-ring-color: rgb(240 253 250);",
  },
  {
    tailwind: "ring-teal-100",
    css: "--tw-ring-color: rgb(204 251 241);",
  },
  {
    tailwind: "ring-teal-200",
    css: "--tw-ring-color: rgb(153 246 228);",
  },
  {
    tailwind: "ring-teal-300",
    css: "--tw-ring-color: rgb(94 234 212);",
  },
  {
    tailwind: "ring-teal-400",
    css: "--tw-ring-color: rgb(45 212 191);",
  },
  {
    tailwind: "ring-teal-500",
    css: "--tw-ring-color: rgb(20 184 166);",
  },
  {
    tailwind: "ring-teal-600",
    css: "--tw-ring-color: rgb(13 148 136);",
  },
  {
    tailwind: "ring-teal-700",
    css: "--tw-ring-color: rgb(15 118 110);",
  },
  {
    tailwind: "ring-teal-800",
    css: "--tw-ring-color: rgb(17 94 89);",
  },
  {
    tailwind: "ring-teal-900",
    css: "--tw-ring-color: rgb(19 78 74);",
  },
  {
    tailwind: "ring-teal-950",
    css: "--tw-ring-color: rgb(4 47 46);",
  },
  {
    tailwind: "ring-cyan-50",
    css: "--tw-ring-color: rgb(236 254 255);",
  },
  {
    tailwind: "ring-cyan-100",
    css: "--tw-ring-color: rgb(207 250 254);",
  },
  {
    tailwind: "ring-cyan-200",
    css: "--tw-ring-color: rgb(165 243 252);",
  },
  {
    tailwind: "ring-cyan-300",
    css: "--tw-ring-color: rgb(103 232 249);",
  },
  {
    tailwind: "ring-cyan-400",
    css: "--tw-ring-color: rgb(34 211 238);",
  },
  {
    tailwind: "ring-cyan-500",
    css: "--tw-ring-color: rgb(6 182 212);",
  },
  {
    tailwind: "ring-cyan-600",
    css: "--tw-ring-color: rgb(8 145 178);",
  },
  {
    tailwind: "ring-cyan-700",
    css: "--tw-ring-color: rgb(14 116 144);",
  },
  {
    tailwind: "ring-cyan-800",
    css: "--tw-ring-color: rgb(21 94 117);",
  },
  {
    tailwind: "ring-cyan-900",
    css: "--tw-ring-color: rgb(22 78 99);",
  },
  {
    tailwind: "ring-cyan-950",
    css: "--tw-ring-color: rgb(8 51 68);",
  },
  {
    tailwind: "ring-sky-50",
    css: "--tw-ring-color: rgb(240 249 255);",
  },
  {
    tailwind: "ring-sky-100",
    css: "--tw-ring-color: rgb(224 242 254);",
  },
  {
    tailwind: "ring-sky-200",
    css: "--tw-ring-color: rgb(186 230 253);",
  },
  {
    tailwind: "ring-sky-300",
    css: "--tw-ring-color: rgb(125 211 252);",
  },
  {
    tailwind: "ring-sky-400",
    css: "--tw-ring-color: rgb(56 189 248);",
  },
  {
    tailwind: "ring-sky-500",
    css: "--tw-ring-color: rgb(14 165 233);",
  },
  {
    tailwind: "ring-sky-600",
    css: "--tw-ring-color: rgb(2 132 199);",
  },
  {
    tailwind: "ring-sky-700",
    css: "--tw-ring-color: rgb(3 105 161);",
  },
  {
    tailwind: "ring-sky-800",
    css: "--tw-ring-color: rgb(7 89 133);",
  },
  {
    tailwind: "ring-sky-900",
    css: "--tw-ring-color: rgb(12 74 110);",
  },
  {
    tailwind: "ring-sky-950",
    css: "--tw-ring-color: rgb(8 47 73);",
  },
  {
    tailwind: "ring-blue-50",
    css: "--tw-ring-color: rgb(239 246 255);",
  },
  {
    tailwind: "ring-blue-100",
    css: "--tw-ring-color: rgb(219 234 254);",
  },
  {
    tailwind: "ring-blue-200",
    css: "--tw-ring-color: rgb(191 219 254);",
  },
  {
    tailwind: "ring-blue-300",
    css: "--tw-ring-color: rgb(147 197 253);",
  },
  {
    tailwind: "ring-blue-400",
    css: "--tw-ring-color: rgb(96 165 250);",
  },
  {
    tailwind: "ring-blue-500",
    css: "--tw-ring-color: rgb(59 130 246);",
  },
  {
    tailwind: "ring-blue-600",
    css: "--tw-ring-color: rgb(37 99 235);",
  },
  {
    tailwind: "ring-blue-700",
    css: "--tw-ring-color: rgb(29 78 216);",
  },
  {
    tailwind: "ring-blue-800",
    css: "--tw-ring-color: rgb(30 64 175);",
  },
  {
    tailwind: "ring-blue-900",
    css: "--tw-ring-color: rgb(30 58 138);",
  },
  {
    tailwind: "ring-blue-950",
    css: "--tw-ring-color: rgb(23 37 84);",
  },
  {
    tailwind: "ring-indigo-50",
    css: "--tw-ring-color: rgb(238 242 255);",
  },
  {
    tailwind: "ring-indigo-100",
    css: "--tw-ring-color: rgb(224 231 255);",
  },
  {
    tailwind: "ring-indigo-200",
    css: "--tw-ring-color: rgb(199 210 254);",
  },
  {
    tailwind: "ring-indigo-300",
    css: "--tw-ring-color: rgb(165 180 252);",
  },
  {
    tailwind: "ring-indigo-400",
    css: "--tw-ring-color: rgb(129 140 248);",
  },
  {
    tailwind: "ring-indigo-500",
    css: "--tw-ring-color: rgb(99 102 241);",
  },
  {
    tailwind: "ring-indigo-600",
    css: "--tw-ring-color: rgb(79 70 229);",
  },
  {
    tailwind: "ring-indigo-700",
    css: "--tw-ring-color: rgb(67 56 202);",
  },
  {
    tailwind: "ring-indigo-800",
    css: "--tw-ring-color: rgb(55 48 163);",
  },
  {
    tailwind: "ring-indigo-900",
    css: "--tw-ring-color: rgb(49 46 129);",
  },
  {
    tailwind: "ring-indigo-950",
    css: "--tw-ring-color: rgb(30 27 75);",
  },
  {
    tailwind: "ring-violet-50",
    css: "--tw-ring-color: rgb(245 243 255);",
  },
  {
    tailwind: "ring-violet-100",
    css: "--tw-ring-color: rgb(237 233 254);",
  },
  {
    tailwind: "ring-violet-200",
    css: "--tw-ring-color: rgb(221 214 254);",
  },
  {
    tailwind: "ring-violet-300",
    css: "--tw-ring-color: rgb(196 181 253);",
  },
  {
    tailwind: "ring-violet-400",
    css: "--tw-ring-color: rgb(167 139 250);",
  },
  {
    tailwind: "ring-violet-500",
    css: "--tw-ring-color: rgb(139 92 246);",
  },
  {
    tailwind: "ring-violet-600",
    css: "--tw-ring-color: rgb(124 58 237);",
  },
  {
    tailwind: "ring-violet-700",
    css: "--tw-ring-color: rgb(109 40 217);",
  },
  {
    tailwind: "ring-violet-800",
    css: "--tw-ring-color: rgb(91 33 182);",
  },
  {
    tailwind: "ring-violet-900",
    css: "--tw-ring-color: rgb(76 29 149);",
  },
  {
    tailwind: "ring-violet-950",
    css: "--tw-ring-color: rgb(46 16 101);",
  },
  {
    tailwind: "ring-purple-50",
    css: "--tw-ring-color: rgb(250 245 255);",
  },
  {
    tailwind: "ring-purple-100",
    css: "--tw-ring-color: rgb(243 232 255);",
  },
  {
    tailwind: "ring-purple-200",
    css: "--tw-ring-color: rgb(233 213 255);",
  },
  {
    tailwind: "ring-purple-300",
    css: "--tw-ring-color: rgb(216 180 254);",
  },
  {
    tailwind: "ring-purple-400",
    css: "--tw-ring-color: rgb(192 132 252);",
  },
  {
    tailwind: "ring-purple-500",
    css: "--tw-ring-color: rgb(168 85 247);",
  },
  {
    tailwind: "ring-purple-600",
    css: "--tw-ring-color: rgb(147 51 234);",
  },
  {
    tailwind: "ring-purple-700",
    css: "--tw-ring-color: rgb(126 34 206);",
  },
  {
    tailwind: "ring-purple-800",
    css: "--tw-ring-color: rgb(107 33 168);",
  },
  {
    tailwind: "ring-purple-900",
    css: "--tw-ring-color: rgb(88 28 135);",
  },
  {
    tailwind: "ring-purple-950",
    css: "--tw-ring-color: rgb(59 7 100);",
  },
  {
    tailwind: "ring-fuchsia-50",
    css: "--tw-ring-color: rgb(253 244 255);",
  },
  {
    tailwind: "ring-fuchsia-100",
    css: "--tw-ring-color: rgb(250 232 255);",
  },
  {
    tailwind: "ring-fuchsia-200",
    css: "--tw-ring-color: rgb(245 208 254);",
  },
  {
    tailwind: "ring-fuchsia-300",
    css: "--tw-ring-color: rgb(240 171 252);",
  },
  {
    tailwind: "ring-fuchsia-400",
    css: "--tw-ring-color: rgb(232 121 249);",
  },
  {
    tailwind: "ring-fuchsia-500",
    css: "--tw-ring-color: rgb(217 70 239);",
  },
  {
    tailwind: "ring-fuchsia-600",
    css: "--tw-ring-color: rgb(192 38 211);",
  },
  {
    tailwind: "ring-fuchsia-700",
    css: "--tw-ring-color: rgb(162 28 175);",
  },
  {
    tailwind: "ring-fuchsia-800",
    css: "--tw-ring-color: rgb(134 25 143);",
  },
  {
    tailwind: "ring-fuchsia-900",
    css: "--tw-ring-color: rgb(112 26 117);",
  },
  {
    tailwind: "ring-fuchsia-950",
    css: "--tw-ring-color: rgb(74 4 78);",
  },
  {
    tailwind: "ring-pink-50",
    css: "--tw-ring-color: rgb(253 242 248);",
  },
  {
    tailwind: "ring-pink-100",
    css: "--tw-ring-color: rgb(252 231 243);",
  },
  {
    tailwind: "ring-pink-200",
    css: "--tw-ring-color: rgb(251 207 232);",
  },
  {
    tailwind: "ring-pink-300",
    css: "--tw-ring-color: rgb(249 168 212);",
  },
  {
    tailwind: "ring-pink-400",
    css: "--tw-ring-color: rgb(244 114 182);",
  },
  {
    tailwind: "ring-pink-500",
    css: "--tw-ring-color: rgb(236 72 153);",
  },
  {
    tailwind: "ring-pink-600",
    css: "--tw-ring-color: rgb(219 39 119);",
  },
  {
    tailwind: "ring-pink-700",
    css: "--tw-ring-color: rgb(190 24 93);",
  },
  {
    tailwind: "ring-pink-800",
    css: "--tw-ring-color: rgb(157 23 77);",
  },
  {
    tailwind: "ring-pink-900",
    css: "--tw-ring-color: rgb(131 24 67);",
  },
  {
    tailwind: "ring-pink-950",
    css: "--tw-ring-color: rgb(80 7 36);",
  },
  {
    tailwind: "ring-rose-50",
    css: "--tw-ring-color: rgb(255 241 242);",
  },
  {
    tailwind: "ring-rose-100",
    css: "--tw-ring-color: rgb(255 228 230);",
  },
  {
    tailwind: "ring-rose-200",
    css: "--tw-ring-color: rgb(254 205 211);",
  },
  {
    tailwind: "ring-rose-300",
    css: "--tw-ring-color: rgb(253 164 175);",
  },
  {
    tailwind: "ring-rose-400",
    css: "--tw-ring-color: rgb(251 113 133);",
  },
  {
    tailwind: "ring-rose-500",
    css: "--tw-ring-color: rgb(244 63 94);",
  },
  {
    tailwind: "ring-rose-600",
    css: "--tw-ring-color: rgb(225 29 72);",
  },
  {
    tailwind: "ring-rose-700",
    css: "--tw-ring-color: rgb(190 18 60);",
  },
  {
    tailwind: "ring-rose-800",
    css: "--tw-ring-color: rgb(159 18 57);",
  },
  {
    tailwind: "ring-rose-900",
    css: "--tw-ring-color: rgb(136 19 55);",
  },
  {
    tailwind: "ring-rose-950",
    css: "--tw-ring-color: rgb(76 5 25);",
  },
  {
    tailwind: "ring-offset-0",
    css: "--tw-ring-offset-width: 0px;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-1",
    css: "--tw-ring-offset-width: 1px;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-2",
    css: "--tw-ring-offset-width: 2px;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-4",
    css: "--tw-ring-offset-width: 4px;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-8",
    css: "--tw-ring-offset-width: 8px;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-inherit",
    css: "--tw-ring-offset-color: inherit;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-current",
    css: "--tw-ring-offset-color: currentColor;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-transparent",
    css: "--tw-ring-offset-color: transparent;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-black",
    css: "--tw-ring-offset-color: #000;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-white",
    css: "--tw-ring-offset-color: #fff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-50",
    css: "--tw-ring-offset-color: #f8fafc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-100",
    css: "--tw-ring-offset-color: #f1f5f9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-200",
    css: "--tw-ring-offset-color: #e2e8f0;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-300",
    css: "--tw-ring-offset-color: #cbd5e1;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-400",
    css: "--tw-ring-offset-color: #94a3b8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-500",
    css: "--tw-ring-offset-color: #64748b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-600",
    css: "--tw-ring-offset-color: #475569;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-700",
    css: "--tw-ring-offset-color: #334155;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-800",
    css: "--tw-ring-offset-color: #1e293b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-900",
    css: "--tw-ring-offset-color: #0f172a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-slate-950",
    css: "--tw-ring-offset-color: #020617;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-50",
    css: "--tw-ring-offset-color: #f9fafb;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-100",
    css: "--tw-ring-offset-color: #f3f4f6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-200",
    css: "--tw-ring-offset-color: #e5e7eb;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-300",
    css: "--tw-ring-offset-color: #d1d5db;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-400",
    css: "--tw-ring-offset-color: #9ca3af;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-500",
    css: "--tw-ring-offset-color: #6b7280;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-600",
    css: "--tw-ring-offset-color: #4b5563;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-700",
    css: "--tw-ring-offset-color: #374151;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-800",
    css: "--tw-ring-offset-color: #1f2937;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-900",
    css: "--tw-ring-offset-color: #111827;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-gray-950",
    css: "--tw-ring-offset-color: #030712;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-50",
    css: "--tw-ring-offset-color: #fafafa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-100",
    css: "--tw-ring-offset-color: #f4f4f5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-200",
    css: "--tw-ring-offset-color: #e4e4e7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-300",
    css: "--tw-ring-offset-color: #d4d4d8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-400",
    css: "--tw-ring-offset-color: #a1a1aa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-500",
    css: "--tw-ring-offset-color: #71717a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-600",
    css: "--tw-ring-offset-color: #52525b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-700",
    css: "--tw-ring-offset-color: #3f3f46;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-800",
    css: "--tw-ring-offset-color: #27272a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-900",
    css: "--tw-ring-offset-color: #18181b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-zinc-950",
    css: "--tw-ring-offset-color: #09090b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-50",
    css: "--tw-ring-offset-color: #fafafa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-100",
    css: "--tw-ring-offset-color: #f5f5f5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-200",
    css: "--tw-ring-offset-color: #e5e5e5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-300",
    css: "--tw-ring-offset-color: #d4d4d4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-400",
    css: "--tw-ring-offset-color: #a3a3a3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-500",
    css: "--tw-ring-offset-color: #737373;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-600",
    css: "--tw-ring-offset-color: #525252;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-700",
    css: "--tw-ring-offset-color: #404040;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-800",
    css: "--tw-ring-offset-color: #262626;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-900",
    css: "--tw-ring-offset-color: #171717;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-neutral-950",
    css: "--tw-ring-offset-color: #0a0a0a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-50",
    css: "--tw-ring-offset-color: #fafaf9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-100",
    css: "--tw-ring-offset-color: #f5f5f4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-200",
    css: "--tw-ring-offset-color: #e7e5e4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-300",
    css: "--tw-ring-offset-color: #d6d3d1;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-400",
    css: "--tw-ring-offset-color: #a8a29e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-500",
    css: "--tw-ring-offset-color: #78716c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-600",
    css: "--tw-ring-offset-color: #57534e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-700",
    css: "--tw-ring-offset-color: #44403c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-800",
    css: "--tw-ring-offset-color: #292524;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-900",
    css: "--tw-ring-offset-color: #1c1917;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-stone-950",
    css: "--tw-ring-offset-color: #0c0a09;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-50",
    css: "--tw-ring-offset-color: #fef2f2;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-100",
    css: "--tw-ring-offset-color: #fee2e2;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-200",
    css: "--tw-ring-offset-color: #fecaca;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-300",
    css: "--tw-ring-offset-color: #fca5a5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-400",
    css: "--tw-ring-offset-color: #f87171;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-500",
    css: "--tw-ring-offset-color: #ef4444;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-600",
    css: "--tw-ring-offset-color: #dc2626;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-700",
    css: "--tw-ring-offset-color: #b91c1c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-800",
    css: "--tw-ring-offset-color: #991b1b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-900",
    css: "--tw-ring-offset-color: #7f1d1d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-red-950",
    css: "--tw-ring-offset-color: #450a0a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-50",
    css: "--tw-ring-offset-color: #fff7ed;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-100",
    css: "--tw-ring-offset-color: #ffedd5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-200",
    css: "--tw-ring-offset-color: #fed7aa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-300",
    css: "--tw-ring-offset-color: #fdba74;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-400",
    css: "--tw-ring-offset-color: #fb923c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-500",
    css: "--tw-ring-offset-color: #f97316;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-600",
    css: "--tw-ring-offset-color: #ea580c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-700",
    css: "--tw-ring-offset-color: #c2410c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-800",
    css: "--tw-ring-offset-color: #9a3412;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-900",
    css: "--tw-ring-offset-color: #7c2d12;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-orange-950",
    css: "--tw-ring-offset-color: #431407;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-50",
    css: "--tw-ring-offset-color: #fffbeb;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-100",
    css: "--tw-ring-offset-color: #fef3c7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-200",
    css: "--tw-ring-offset-color: #fde68a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-300",
    css: "--tw-ring-offset-color: #fcd34d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-400",
    css: "--tw-ring-offset-color: #fbbf24;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-500",
    css: "--tw-ring-offset-color: #f59e0b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-600",
    css: "--tw-ring-offset-color: #d97706;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-700",
    css: "--tw-ring-offset-color: #b45309;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-800",
    css: "--tw-ring-offset-color: #92400e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-900",
    css: "--tw-ring-offset-color: #78350f;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-amber-950",
    css: "--tw-ring-offset-color: #451a03;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-50",
    css: "--tw-ring-offset-color: #fefce8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-100",
    css: "--tw-ring-offset-color: #fef9c3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-200",
    css: "--tw-ring-offset-color: #fef08a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-300",
    css: "--tw-ring-offset-color: #fde047;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-400",
    css: "--tw-ring-offset-color: #facc15;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-500",
    css: "--tw-ring-offset-color: #eab308;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-600",
    css: "--tw-ring-offset-color: #ca8a04;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-700",
    css: "--tw-ring-offset-color: #a16207;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-800",
    css: "--tw-ring-offset-color: #854d0e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-900",
    css: "--tw-ring-offset-color: #713f12;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-yellow-950",
    css: "--tw-ring-offset-color: #422006;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-50",
    css: "--tw-ring-offset-color: #f7fee7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-100",
    css: "--tw-ring-offset-color: #ecfccb;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-200",
    css: "--tw-ring-offset-color: #d9f99d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-300",
    css: "--tw-ring-offset-color: #bef264;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-400",
    css: "--tw-ring-offset-color: #a3e635;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-500",
    css: "--tw-ring-offset-color: #84cc16;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-600",
    css: "--tw-ring-offset-color: #65a30d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-700",
    css: "--tw-ring-offset-color: #4d7c0f;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-800",
    css: "--tw-ring-offset-color: #3f6212;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-900",
    css: "--tw-ring-offset-color: #365314;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-lime-950",
    css: "--tw-ring-offset-color: #1a2e05;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-50",
    css: "--tw-ring-offset-color: #f0fdf4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-100",
    css: "--tw-ring-offset-color: #dcfce7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-200",
    css: "--tw-ring-offset-color: #bbf7d0;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-300",
    css: "--tw-ring-offset-color: #86efac;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-400",
    css: "--tw-ring-offset-color: #4ade80;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-500",
    css: "--tw-ring-offset-color: #22c55e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-600",
    css: "--tw-ring-offset-color: #16a34a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-700",
    css: "--tw-ring-offset-color: #15803d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-800",
    css: "--tw-ring-offset-color: #166534;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-900",
    css: "--tw-ring-offset-color: #14532d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-green-950",
    css: "--tw-ring-offset-color: #052e16;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-50",
    css: "--tw-ring-offset-color: #ecfdf5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-100",
    css: "--tw-ring-offset-color: #d1fae5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-200",
    css: "--tw-ring-offset-color: #a7f3d0;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-300",
    css: "--tw-ring-offset-color: #6ee7b7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-400",
    css: "--tw-ring-offset-color: #34d399;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-500",
    css: "--tw-ring-offset-color: #10b981;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-600",
    css: "--tw-ring-offset-color: #059669;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-700",
    css: "--tw-ring-offset-color: #047857;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-800",
    css: "--tw-ring-offset-color: #065f46;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-900",
    css: "--tw-ring-offset-color: #064e3b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-emerald-950",
    css: "--tw-ring-offset-color: #022c22;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-50",
    css: "--tw-ring-offset-color: #f0fdfa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-100",
    css: "--tw-ring-offset-color: #ccfbf1;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-200",
    css: "--tw-ring-offset-color: #99f6e4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-300",
    css: "--tw-ring-offset-color: #5eead4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-400",
    css: "--tw-ring-offset-color: #2dd4bf;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-500",
    css: "--tw-ring-offset-color: #14b8a6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-600",
    css: "--tw-ring-offset-color: #0d9488;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-700",
    css: "--tw-ring-offset-color: #0f766e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-800",
    css: "--tw-ring-offset-color: #115e59;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-900",
    css: "--tw-ring-offset-color: #134e4a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-teal-950",
    css: "--tw-ring-offset-color: #042f2e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-50",
    css: "--tw-ring-offset-color: #ecfeff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-100",
    css: "--tw-ring-offset-color: #cffafe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-200",
    css: "--tw-ring-offset-color: #a5f3fc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-300",
    css: "--tw-ring-offset-color: #67e8f9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-400",
    css: "--tw-ring-offset-color: #22d3ee;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-500",
    css: "--tw-ring-offset-color: #06b6d4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-600",
    css: "--tw-ring-offset-color: #0891b2;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-700",
    css: "--tw-ring-offset-color: #0e7490;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-800",
    css: "--tw-ring-offset-color: #155e75;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-900",
    css: "--tw-ring-offset-color: #164e63;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-cyan-950",
    css: "--tw-ring-offset-color: #083344;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-50",
    css: "--tw-ring-offset-color: #f0f9ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-100",
    css: "--tw-ring-offset-color: #e0f2fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-200",
    css: "--tw-ring-offset-color: #bae6fd;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-300",
    css: "--tw-ring-offset-color: #7dd3fc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-400",
    css: "--tw-ring-offset-color: #38bdf8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-500",
    css: "--tw-ring-offset-color: #0ea5e9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-600",
    css: "--tw-ring-offset-color: #0284c7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-700",
    css: "--tw-ring-offset-color: #0369a1;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-800",
    css: "--tw-ring-offset-color: #075985;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-900",
    css: "--tw-ring-offset-color: #0c4a6e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-sky-950",
    css: "--tw-ring-offset-color: #082f49;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-50",
    css: "--tw-ring-offset-color: #eff6ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-100",
    css: "--tw-ring-offset-color: #dbeafe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-200",
    css: "--tw-ring-offset-color: #bfdbfe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-300",
    css: "--tw-ring-offset-color: #93c5fd;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-400",
    css: "--tw-ring-offset-color: #60a5fa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-500",
    css: "--tw-ring-offset-color: #3b82f6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-600",
    css: "--tw-ring-offset-color: #2563eb;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-700",
    css: "--tw-ring-offset-color: #1d4ed8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-800",
    css: "--tw-ring-offset-color: #1e40af;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-900",
    css: "--tw-ring-offset-color: #1e3a8a;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-blue-950",
    css: "--tw-ring-offset-color: #172554;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-50",
    css: "--tw-ring-offset-color: #eef2ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-100",
    css: "--tw-ring-offset-color: #e0e7ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-200",
    css: "--tw-ring-offset-color: #c7d2fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-300",
    css: "--tw-ring-offset-color: #a5b4fc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-400",
    css: "--tw-ring-offset-color: #818cf8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-500",
    css: "--tw-ring-offset-color: #6366f1;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-600",
    css: "--tw-ring-offset-color: #4f46e5;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-700",
    css: "--tw-ring-offset-color: #4338ca;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-800",
    css: "--tw-ring-offset-color: #3730a3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-900",
    css: "--tw-ring-offset-color: #312e81;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-indigo-950",
    css: "--tw-ring-offset-color: #1e1b4b;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-50",
    css: "--tw-ring-offset-color: #f5f3ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-100",
    css: "--tw-ring-offset-color: #ede9fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-200",
    css: "--tw-ring-offset-color: #ddd6fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-300",
    css: "--tw-ring-offset-color: #c4b5fd;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-400",
    css: "--tw-ring-offset-color: #a78bfa;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-500",
    css: "--tw-ring-offset-color: #8b5cf6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-600",
    css: "--tw-ring-offset-color: #7c3aed;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-700",
    css: "--tw-ring-offset-color: #6d28d9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-800",
    css: "--tw-ring-offset-color: #5b21b6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-900",
    css: "--tw-ring-offset-color: #4c1d95;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-violet-950",
    css: "--tw-ring-offset-color: #2e1065;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-50",
    css: "--tw-ring-offset-color: #faf5ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-100",
    css: "--tw-ring-offset-color: #f3e8ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-200",
    css: "--tw-ring-offset-color: #e9d5ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-300",
    css: "--tw-ring-offset-color: #d8b4fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-400",
    css: "--tw-ring-offset-color: #c084fc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-500",
    css: "--tw-ring-offset-color: #a855f7;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-600",
    css: "--tw-ring-offset-color: #9333ea;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-700",
    css: "--tw-ring-offset-color: #7e22ce;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-800",
    css: "--tw-ring-offset-color: #6b21a8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-900",
    css: "--tw-ring-offset-color: #581c87;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-purple-950",
    css: "--tw-ring-offset-color: #3b0764;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-50",
    css: "--tw-ring-offset-color: #fdf4ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-100",
    css: "--tw-ring-offset-color: #fae8ff;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-200",
    css: "--tw-ring-offset-color: #f5d0fe;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-300",
    css: "--tw-ring-offset-color: #f0abfc;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-400",
    css: "--tw-ring-offset-color: #e879f9;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-500",
    css: "--tw-ring-offset-color: #d946ef;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-600",
    css: "--tw-ring-offset-color: #c026d3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-700",
    css: "--tw-ring-offset-color: #a21caf;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-800",
    css: "--tw-ring-offset-color: #86198f;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-900",
    css: "--tw-ring-offset-color: #701a75;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-fuchsia-950",
    css: "--tw-ring-offset-color: #4a044e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-50",
    css: "--tw-ring-offset-color: #fdf2f8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-100",
    css: "--tw-ring-offset-color: #fce7f3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-200",
    css: "--tw-ring-offset-color: #fbcfe8;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-300",
    css: "--tw-ring-offset-color: #f9a8d4;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-400",
    css: "--tw-ring-offset-color: #f472b6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-500",
    css: "--tw-ring-offset-color: #ec4899;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-600",
    css: "--tw-ring-offset-color: #db2777;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-700",
    css: "--tw-ring-offset-color: #be185d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-800",
    css: "--tw-ring-offset-color: #9d174d;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-900",
    css: "--tw-ring-offset-color: #831843;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-pink-950",
    css: "--tw-ring-offset-color: #500724;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-50",
    css: "--tw-ring-offset-color: #fff1f2;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-100",
    css: "--tw-ring-offset-color: #ffe4e6;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-200",
    css: "--tw-ring-offset-color: #fecdd3;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-300",
    css: "--tw-ring-offset-color: #fda4af;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-400",
    css: "--tw-ring-offset-color: #fb7185;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-500",
    css: "--tw-ring-offset-color: #f43f5e;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-600",
    css: "--tw-ring-offset-color: #e11d48;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-700",
    css: "--tw-ring-offset-color: #be123c;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-800",
    css: "--tw-ring-offset-color: #9f1239;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-900",
    css: "--tw-ring-offset-color: #881337;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "ring-offset-rose-950",
    css: "--tw-ring-offset-color: #4c0519;\nbox-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);",
  },
  {
    tailwind: "shadow-sm",
    css: "box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);",
  },
  {
    tailwind: "shadow",
    css: "box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);",
  },
  {
    tailwind: "shadow-md",
    css: "box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);",
  },
  {
    tailwind: "shadow-lg",
    css: "box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);",
  },
  {
    tailwind: "shadow-xl",
    css: "box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);",
  },
  {
    tailwind: "shadow-2xl",
    css: "box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);",
  },
  {
    tailwind: "shadow-inner",
    css: "box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);",
  },
  {
    tailwind: "shadow-none",
    css: "box-shadow: 0 0 #0000;",
  },
  {
    tailwind: "shadow-inherit",
    css: "--tw-shadow-color: inherit;",
  },
  {
    tailwind: "shadow-current",
    css: "--tw-shadow-color: currentColor;",
  },
  {
    tailwind: "shadow-transparent",
    css: "--tw-shadow-color: transparent;",
  },
  {
    tailwind: "shadow-black",
    css: "--tw-shadow-color: #000;",
  },
  {
    tailwind: "shadow-white",
    css: "--tw-shadow-color: #fff;",
  },
  {
    tailwind: "shadow-slate-50",
    css: "--tw-shadow-color: #f8fafc;",
  },
  {
    tailwind: "shadow-slate-100",
    css: "--tw-shadow-color: #f1f5f9;",
  },
  {
    tailwind: "shadow-slate-200",
    css: "--tw-shadow-color: #e2e8f0;",
  },
  {
    tailwind: "shadow-slate-300",
    css: "--tw-shadow-color: #cbd5e1;",
  },
  {
    tailwind: "shadow-slate-400",
    css: "--tw-shadow-color: #94a3b8;",
  },
  {
    tailwind: "shadow-slate-500",
    css: "--tw-shadow-color: #64748b;",
  },
  {
    tailwind: "shadow-slate-600",
    css: "--tw-shadow-color: #475569;",
  },
  {
    tailwind: "shadow-slate-700",
    css: "--tw-shadow-color: #334155;",
  },
  {
    tailwind: "shadow-slate-800",
    css: "--tw-shadow-color: #1e293b;",
  },
  {
    tailwind: "shadow-slate-900",
    css: "--tw-shadow-color: #0f172a;",
  },
  {
    tailwind: "shadow-slate-950",
    css: "--tw-shadow-color: #020617;",
  },
  {
    tailwind: "shadow-gray-50",
    css: "--tw-shadow-color: #f9fafb;",
  },
  {
    tailwind: "shadow-gray-100",
    css: "--tw-shadow-color: #f3f4f6;",
  },
  {
    tailwind: "shadow-gray-200",
    css: "--tw-shadow-color: #e5e7eb;",
  },
  {
    tailwind: "shadow-gray-300",
    css: "--tw-shadow-color: #d1d5db;",
  },
  {
    tailwind: "shadow-gray-400",
    css: "--tw-shadow-color: #9ca3af;",
  },
  {
    tailwind: "shadow-gray-500",
    css: "--tw-shadow-color: #6b7280;",
  },
  {
    tailwind: "shadow-gray-600",
    css: "--tw-shadow-color: #4b5563;",
  },
  {
    tailwind: "shadow-gray-700",
    css: "--tw-shadow-color: #374151;",
  },
  {
    tailwind: "shadow-gray-800",
    css: "--tw-shadow-color: #1f2937;",
  },
  {
    tailwind: "shadow-gray-900",
    css: "--tw-shadow-color: #111827;",
  },
  {
    tailwind: "shadow-gray-950",
    css: "--tw-shadow-color: #030712;",
  },
  {
    tailwind: "shadow-zinc-50",
    css: "--tw-shadow-color: #fafafa;",
  },
  {
    tailwind: "shadow-zinc-100",
    css: "--tw-shadow-color: #f4f4f5;",
  },
  {
    tailwind: "shadow-zinc-200",
    css: "--tw-shadow-color: #e4e4e7;",
  },
  {
    tailwind: "shadow-zinc-300",
    css: "--tw-shadow-color: #d4d4d8;",
  },
  {
    tailwind: "shadow-zinc-400",
    css: "--tw-shadow-color: #a1a1aa;",
  },
  {
    tailwind: "shadow-zinc-500",
    css: "--tw-shadow-color: #71717a;",
  },
  {
    tailwind: "shadow-zinc-600",
    css: "--tw-shadow-color: #52525b;",
  },
  {
    tailwind: "shadow-zinc-700",
    css: "--tw-shadow-color: #3f3f46;",
  },
  {
    tailwind: "shadow-zinc-800",
    css: "--tw-shadow-color: #27272a;",
  },
  {
    tailwind: "shadow-zinc-900",
    css: "--tw-shadow-color: #18181b;",
  },
  {
    tailwind: "shadow-zinc-950",
    css: "--tw-shadow-color: #09090b;",
  },
  {
    tailwind: "shadow-neutral-50",
    css: "--tw-shadow-color: #fafafa;",
  },
  {
    tailwind: "shadow-neutral-100",
    css: "--tw-shadow-color: #f5f5f5;",
  },
  {
    tailwind: "shadow-neutral-200",
    css: "--tw-shadow-color: #e5e5e5;",
  },
  {
    tailwind: "shadow-neutral-300",
    css: "--tw-shadow-color: #d4d4d4;",
  },
  {
    tailwind: "shadow-neutral-400",
    css: "--tw-shadow-color: #a3a3a3;",
  },
  {
    tailwind: "shadow-neutral-500",
    css: "--tw-shadow-color: #737373;",
  },
  {
    tailwind: "shadow-neutral-600",
    css: "--tw-shadow-color: #525252;",
  },
  {
    tailwind: "shadow-neutral-700",
    css: "--tw-shadow-color: #404040;",
  },
  {
    tailwind: "shadow-neutral-800",
    css: "--tw-shadow-color: #262626;",
  },
  {
    tailwind: "shadow-neutral-900",
    css: "--tw-shadow-color: #171717;",
  },
  {
    tailwind: "shadow-neutral-950",
    css: "--tw-shadow-color: #0a0a0a;",
  },
  {
    tailwind: "shadow-stone-50",
    css: "--tw-shadow-color: #fafaf9;",
  },
  {
    tailwind: "shadow-stone-100",
    css: "--tw-shadow-color: #f5f5f4;",
  },
  {
    tailwind: "shadow-stone-200",
    css: "--tw-shadow-color: #e7e5e4;",
  },
  {
    tailwind: "shadow-stone-300",
    css: "--tw-shadow-color: #d6d3d1;",
  },
  {
    tailwind: "shadow-stone-400",
    css: "--tw-shadow-color: #a8a29e;",
  },
  {
    tailwind: "shadow-stone-500",
    css: "--tw-shadow-color: #78716c;",
  },
  {
    tailwind: "shadow-stone-600",
    css: "--tw-shadow-color: #57534e;",
  },
  {
    tailwind: "shadow-stone-700",
    css: "--tw-shadow-color: #44403c;",
  },
  {
    tailwind: "shadow-stone-800",
    css: "--tw-shadow-color: #292524;",
  },
  {
    tailwind: "shadow-stone-900",
    css: "--tw-shadow-color: #1c1917;",
  },
  {
    tailwind: "shadow-stone-950",
    css: "--tw-shadow-color: #0c0a09;",
  },
  {
    tailwind: "shadow-red-50",
    css: "--tw-shadow-color: #fef2f2;",
  },
  {
    tailwind: "shadow-red-100",
    css: "--tw-shadow-color: #fee2e2;",
  },
  {
    tailwind: "shadow-red-200",
    css: "--tw-shadow-color: #fecaca;",
  },
  {
    tailwind: "shadow-red-300",
    css: "--tw-shadow-color: #fca5a5;",
  },
  {
    tailwind: "shadow-red-400",
    css: "--tw-shadow-color: #f87171;",
  },
  {
    tailwind: "shadow-red-500",
    css: "--tw-shadow-color: #ef4444;",
  },
  {
    tailwind: "shadow-red-600",
    css: "--tw-shadow-color: #dc2626;",
  },
  {
    tailwind: "shadow-red-700",
    css: "--tw-shadow-color: #b91c1c;",
  },
  {
    tailwind: "shadow-red-800",
    css: "--tw-shadow-color: #991b1b;",
  },
  {
    tailwind: "shadow-red-900",
    css: "--tw-shadow-color: #7f1d1d;",
  },
  {
    tailwind: "shadow-red-950",
    css: "--tw-shadow-color: #450a0a;",
  },
  {
    tailwind: "shadow-orange-50",
    css: "--tw-shadow-color: #fff7ed;",
  },
  {
    tailwind: "shadow-orange-100",
    css: "--tw-shadow-color: #ffedd5;",
  },
  {
    tailwind: "shadow-orange-200",
    css: "--tw-shadow-color: #fed7aa;",
  },
  {
    tailwind: "shadow-orange-300",
    css: "--tw-shadow-color: #fdba74;",
  },
  {
    tailwind: "shadow-orange-400",
    css: "--tw-shadow-color: #fb923c;",
  },
  {
    tailwind: "shadow-orange-500",
    css: "--tw-shadow-color: #f97316;",
  },
  {
    tailwind: "shadow-orange-600",
    css: "--tw-shadow-color: #ea580c;",
  },
  {
    tailwind: "shadow-orange-700",
    css: "--tw-shadow-color: #c2410c;",
  },
  {
    tailwind: "shadow-orange-800",
    css: "--tw-shadow-color: #9a3412;",
  },
  {
    tailwind: "shadow-orange-900",
    css: "--tw-shadow-color: #7c2d12;",
  },
  {
    tailwind: "shadow-orange-950",
    css: "--tw-shadow-color: #431407;",
  },
  {
    tailwind: "shadow-amber-50",
    css: "--tw-shadow-color: #fffbeb;",
  },
  {
    tailwind: "shadow-amber-100",
    css: "--tw-shadow-color: #fef3c7;",
  },
  {
    tailwind: "shadow-amber-200",
    css: "--tw-shadow-color: #fde68a;",
  },
  {
    tailwind: "shadow-amber-300",
    css: "--tw-shadow-color: #fcd34d;",
  },
  {
    tailwind: "shadow-amber-400",
    css: "--tw-shadow-color: #fbbf24;",
  },
  {
    tailwind: "shadow-amber-500",
    css: "--tw-shadow-color: #f59e0b;",
  },
  {
    tailwind: "shadow-amber-600",
    css: "--tw-shadow-color: #d97706;",
  },
  {
    tailwind: "shadow-amber-700",
    css: "--tw-shadow-color: #b45309;",
  },
  {
    tailwind: "shadow-amber-800",
    css: "--tw-shadow-color: #92400e;",
  },
  {
    tailwind: "shadow-amber-900",
    css: "--tw-shadow-color: #78350f;",
  },
  {
    tailwind: "shadow-amber-950",
    css: "--tw-shadow-color: #451a03;",
  },
  {
    tailwind: "shadow-yellow-50",
    css: "--tw-shadow-color: #fefce8;",
  },
  {
    tailwind: "shadow-yellow-100",
    css: "--tw-shadow-color: #fef9c3;",
  },
  {
    tailwind: "shadow-yellow-200",
    css: "--tw-shadow-color: #fef08a;",
  },
  {
    tailwind: "shadow-yellow-300",
    css: "--tw-shadow-color: #fde047;",
  },
  {
    tailwind: "shadow-yellow-400",
    css: "--tw-shadow-color: #facc15;",
  },
  {
    tailwind: "shadow-yellow-500",
    css: "--tw-shadow-color: #eab308;",
  },
  {
    tailwind: "shadow-yellow-600",
    css: "--tw-shadow-color: #ca8a04;",
  },
  {
    tailwind: "shadow-yellow-700",
    css: "--tw-shadow-color: #a16207;",
  },
  {
    tailwind: "shadow-yellow-800",
    css: "--tw-shadow-color: #854d0e;",
  },
  {
    tailwind: "shadow-yellow-900",
    css: "--tw-shadow-color: #713f12;",
  },
  {
    tailwind: "shadow-yellow-950",
    css: "--tw-shadow-color: #422006;",
  },
  {
    tailwind: "shadow-lime-50",
    css: "--tw-shadow-color: #f7fee7;",
  },
  {
    tailwind: "shadow-lime-100",
    css: "--tw-shadow-color: #ecfccb;",
  },
  {
    tailwind: "shadow-lime-200",
    css: "--tw-shadow-color: #d9f99d;",
  },
  {
    tailwind: "shadow-lime-300",
    css: "--tw-shadow-color: #bef264;",
  },
  {
    tailwind: "shadow-lime-400",
    css: "--tw-shadow-color: #a3e635;",
  },
  {
    tailwind: "shadow-lime-500",
    css: "--tw-shadow-color: #84cc16;",
  },
  {
    tailwind: "shadow-lime-600",
    css: "--tw-shadow-color: #65a30d;",
  },
  {
    tailwind: "shadow-lime-700",
    css: "--tw-shadow-color: #4d7c0f;",
  },
  {
    tailwind: "shadow-lime-800",
    css: "--tw-shadow-color: #3f6212;",
  },
  {
    tailwind: "shadow-lime-900",
    css: "--tw-shadow-color: #365314;",
  },
  {
    tailwind: "shadow-lime-950",
    css: "--tw-shadow-color: #1a2e05;",
  },
  {
    tailwind: "shadow-green-50",
    css: "--tw-shadow-color: #f0fdf4;",
  },
  {
    tailwind: "shadow-green-100",
    css: "--tw-shadow-color: #dcfce7;",
  },
  {
    tailwind: "shadow-green-200",
    css: "--tw-shadow-color: #bbf7d0;",
  },
  {
    tailwind: "shadow-green-300",
    css: "--tw-shadow-color: #86efac;",
  },
  {
    tailwind: "shadow-green-400",
    css: "--tw-shadow-color: #4ade80;",
  },
  {
    tailwind: "shadow-green-500",
    css: "--tw-shadow-color: #22c55e;",
  },
  {
    tailwind: "shadow-green-600",
    css: "--tw-shadow-color: #16a34a;",
  },
  {
    tailwind: "shadow-green-700",
    css: "--tw-shadow-color: #15803d;",
  },
  {
    tailwind: "shadow-green-800",
    css: "--tw-shadow-color: #166534;",
  },
  {
    tailwind: "shadow-green-900",
    css: "--tw-shadow-color: #14532d;",
  },
  {
    tailwind: "shadow-green-950",
    css: "--tw-shadow-color: #052e16;",
  },
  {
    tailwind: "shadow-emerald-50",
    css: "--tw-shadow-color: #ecfdf5;",
  },
  {
    tailwind: "shadow-emerald-100",
    css: "--tw-shadow-color: #d1fae5;",
  },
  {
    tailwind: "shadow-emerald-200",
    css: "--tw-shadow-color: #a7f3d0;",
  },
  {
    tailwind: "shadow-emerald-300",
    css: "--tw-shadow-color: #6ee7b7;",
  },
  {
    tailwind: "shadow-emerald-400",
    css: "--tw-shadow-color: #34d399;",
  },
  {
    tailwind: "shadow-emerald-500",
    css: "--tw-shadow-color: #10b981;",
  },
  {
    tailwind: "shadow-emerald-600",
    css: "--tw-shadow-color: #059669;",
  },
  {
    tailwind: "shadow-emerald-700",
    css: "--tw-shadow-color: #047857;",
  },
  {
    tailwind: "shadow-emerald-800",
    css: "--tw-shadow-color: #065f46;",
  },
  {
    tailwind: "shadow-emerald-900",
    css: "--tw-shadow-color: #064e3b;",
  },
  {
    tailwind: "shadow-emerald-950",
    css: "--tw-shadow-color: #022c22;",
  },
  {
    tailwind: "shadow-teal-50",
    css: "--tw-shadow-color: #f0fdfa;",
  },
  {
    tailwind: "shadow-teal-100",
    css: "--tw-shadow-color: #ccfbf1;",
  },
  {
    tailwind: "shadow-teal-200",
    css: "--tw-shadow-color: #99f6e4;",
  },
  {
    tailwind: "shadow-teal-300",
    css: "--tw-shadow-color: #5eead4;",
  },
  {
    tailwind: "shadow-teal-400",
    css: "--tw-shadow-color: #2dd4bf;",
  },
  {
    tailwind: "shadow-teal-500",
    css: "--tw-shadow-color: #14b8a6;",
  },
  {
    tailwind: "shadow-teal-600",
    css: "--tw-shadow-color: #0d9488;",
  },
  {
    tailwind: "shadow-teal-700",
    css: "--tw-shadow-color: #0f766e;",
  },
  {
    tailwind: "shadow-teal-800",
    css: "--tw-shadow-color: #115e59;",
  },
  {
    tailwind: "shadow-teal-900",
    css: "--tw-shadow-color: #134e4a;",
  },
  {
    tailwind: "shadow-teal-950",
    css: "--tw-shadow-color: #042f2e;",
  },
  {
    tailwind: "shadow-cyan-50",
    css: "--tw-shadow-color: #ecfeff;",
  },
  {
    tailwind: "shadow-cyan-100",
    css: "--tw-shadow-color: #cffafe;",
  },
  {
    tailwind: "shadow-cyan-200",
    css: "--tw-shadow-color: #a5f3fc;",
  },
  {
    tailwind: "shadow-cyan-300",
    css: "--tw-shadow-color: #67e8f9;",
  },
  {
    tailwind: "shadow-cyan-400",
    css: "--tw-shadow-color: #22d3ee;",
  },
  {
    tailwind: "shadow-cyan-500",
    css: "--tw-shadow-color: #06b6d4;",
  },
  {
    tailwind: "shadow-cyan-600",
    css: "--tw-shadow-color: #0891b2;",
  },
  {
    tailwind: "shadow-cyan-700",
    css: "--tw-shadow-color: #0e7490;",
  },
  {
    tailwind: "shadow-cyan-800",
    css: "--tw-shadow-color: #155e75;",
  },
  {
    tailwind: "shadow-cyan-900",
    css: "--tw-shadow-color: #164e63;",
  },
  {
    tailwind: "shadow-cyan-950",
    css: "--tw-shadow-color: #083344;",
  },
  {
    tailwind: "shadow-sky-50",
    css: "--tw-shadow-color: #f0f9ff;",
  },
  {
    tailwind: "shadow-sky-100",
    css: "--tw-shadow-color: #e0f2fe;",
  },
  {
    tailwind: "shadow-sky-200",
    css: "--tw-shadow-color: #bae6fd;",
  },
  {
    tailwind: "shadow-sky-300",
    css: "--tw-shadow-color: #7dd3fc;",
  },
  {
    tailwind: "shadow-sky-400",
    css: "--tw-shadow-color: #38bdf8;",
  },
  {
    tailwind: "shadow-sky-500",
    css: "--tw-shadow-color: #0ea5e9;",
  },
  {
    tailwind: "shadow-sky-600",
    css: "--tw-shadow-color: #0284c7;",
  },
  {
    tailwind: "shadow-sky-700",
    css: "--tw-shadow-color: #0369a1;",
  },
  {
    tailwind: "shadow-sky-800",
    css: "--tw-shadow-color: #075985;",
  },
  {
    tailwind: "shadow-sky-900",
    css: "--tw-shadow-color: #0c4a6e;",
  },
  {
    tailwind: "shadow-sky-950",
    css: "--tw-shadow-color: #082f49;",
  },
  {
    tailwind: "shadow-blue-50",
    css: "--tw-shadow-color: #eff6ff;",
  },
  {
    tailwind: "shadow-blue-100",
    css: "--tw-shadow-color: #dbeafe;",
  },
  {
    tailwind: "shadow-blue-200",
    css: "--tw-shadow-color: #bfdbfe;",
  },
  {
    tailwind: "shadow-blue-300",
    css: "--tw-shadow-color: #93c5fd;",
  },
  {
    tailwind: "shadow-blue-400",
    css: "--tw-shadow-color: #60a5fa;",
  },
  {
    tailwind: "shadow-blue-500",
    css: "--tw-shadow-color: #3b82f6;",
  },
  {
    tailwind: "shadow-blue-600",
    css: "--tw-shadow-color: #2563eb;",
  },
  {
    tailwind: "shadow-blue-700",
    css: "--tw-shadow-color: #1d4ed8;",
  },
  {
    tailwind: "shadow-blue-800",
    css: "--tw-shadow-color: #1e40af;",
  },
  {
    tailwind: "shadow-blue-900",
    css: "--tw-shadow-color: #1e3a8a;",
  },
  {
    tailwind: "shadow-blue-950",
    css: "--tw-shadow-color: #172554;",
  },
  {
    tailwind: "shadow-indigo-50",
    css: "--tw-shadow-color: #eef2ff;",
  },
  {
    tailwind: "shadow-indigo-100",
    css: "--tw-shadow-color: #e0e7ff;",
  },
  {
    tailwind: "shadow-indigo-200",
    css: "--tw-shadow-color: #c7d2fe;",
  },
  {
    tailwind: "shadow-indigo-300",
    css: "--tw-shadow-color: #a5b4fc;",
  },
  {
    tailwind: "shadow-indigo-400",
    css: "--tw-shadow-color: #818cf8;",
  },
  {
    tailwind: "shadow-indigo-500",
    css: "--tw-shadow-color: #6366f1;",
  },
  {
    tailwind: "shadow-indigo-600",
    css: "--tw-shadow-color: #4f46e5;",
  },
  {
    tailwind: "shadow-indigo-700",
    css: "--tw-shadow-color: #4338ca;",
  },
  {
    tailwind: "shadow-indigo-800",
    css: "--tw-shadow-color: #3730a3;",
  },
  {
    tailwind: "shadow-indigo-900",
    css: "--tw-shadow-color: #312e81;",
  },
  {
    tailwind: "shadow-indigo-950",
    css: "--tw-shadow-color: #1e1b4b;",
  },
  {
    tailwind: "shadow-violet-50",
    css: "--tw-shadow-color: #f5f3ff;",
  },
  {
    tailwind: "shadow-violet-100",
    css: "--tw-shadow-color: #ede9fe;",
  },
  {
    tailwind: "shadow-violet-200",
    css: "--tw-shadow-color: #ddd6fe;",
  },
  {
    tailwind: "shadow-violet-300",
    css: "--tw-shadow-color: #c4b5fd;",
  },
  {
    tailwind: "shadow-violet-400",
    css: "--tw-shadow-color: #a78bfa;",
  },
  {
    tailwind: "shadow-violet-500",
    css: "--tw-shadow-color: #8b5cf6;",
  },
  {
    tailwind: "shadow-violet-600",
    css: "--tw-shadow-color: #7c3aed;",
  },
  {
    tailwind: "shadow-violet-700",
    css: "--tw-shadow-color: #6d28d9;",
  },
  {
    tailwind: "shadow-violet-800",
    css: "--tw-shadow-color: #5b21b6;",
  },
  {
    tailwind: "shadow-violet-900",
    css: "--tw-shadow-color: #4c1d95;",
  },
  {
    tailwind: "shadow-violet-950",
    css: "--tw-shadow-color: #2e1065;",
  },
  {
    tailwind: "shadow-purple-50",
    css: "--tw-shadow-color: #faf5ff;",
  },
  {
    tailwind: "shadow-purple-100",
    css: "--tw-shadow-color: #f3e8ff;",
  },
  {
    tailwind: "shadow-purple-200",
    css: "--tw-shadow-color: #e9d5ff;",
  },
  {
    tailwind: "shadow-purple-300",
    css: "--tw-shadow-color: #d8b4fe;",
  },
  {
    tailwind: "shadow-purple-400",
    css: "--tw-shadow-color: #c084fc;",
  },
  {
    tailwind: "shadow-purple-500",
    css: "--tw-shadow-color: #a855f7;",
  },
  {
    tailwind: "shadow-purple-600",
    css: "--tw-shadow-color: #9333ea;",
  },
  {
    tailwind: "shadow-purple-700",
    css: "--tw-shadow-color: #7e22ce;",
  },
  {
    tailwind: "shadow-purple-800",
    css: "--tw-shadow-color: #6b21a8;",
  },
  {
    tailwind: "shadow-purple-900",
    css: "--tw-shadow-color: #581c87;",
  },
  {
    tailwind: "shadow-purple-950",
    css: "--tw-shadow-color: #3b0764;",
  },
  {
    tailwind: "shadow-fuchsia-50",
    css: "--tw-shadow-color: #fdf4ff;",
  },
  {
    tailwind: "shadow-fuchsia-100",
    css: "--tw-shadow-color: #fae8ff;",
  },
  {
    tailwind: "shadow-fuchsia-200",
    css: "--tw-shadow-color: #f5d0fe;",
  },
  {
    tailwind: "shadow-fuchsia-300",
    css: "--tw-shadow-color: #f0abfc;",
  },
  {
    tailwind: "shadow-fuchsia-400",
    css: "--tw-shadow-color: #e879f9;",
  },
  {
    tailwind: "shadow-fuchsia-500",
    css: "--tw-shadow-color: #d946ef;",
  },
  {
    tailwind: "shadow-fuchsia-600",
    css: "--tw-shadow-color: #c026d3;",
  },
  {
    tailwind: "shadow-fuchsia-700",
    css: "--tw-shadow-color: #a21caf;",
  },
  {
    tailwind: "shadow-fuchsia-800",
    css: "--tw-shadow-color: #86198f;",
  },
  {
    tailwind: "shadow-fuchsia-900",
    css: "--tw-shadow-color: #701a75;",
  },
  {
    tailwind: "shadow-fuchsia-950",
    css: "--tw-shadow-color: #4a044e;",
  },
  {
    tailwind: "shadow-pink-50",
    css: "--tw-shadow-color: #fdf2f8;",
  },
  {
    tailwind: "shadow-pink-100",
    css: "--tw-shadow-color: #fce7f3;",
  },
  {
    tailwind: "shadow-pink-200",
    css: "--tw-shadow-color: #fbcfe8;",
  },
  {
    tailwind: "shadow-pink-300",
    css: "--tw-shadow-color: #f9a8d4;",
  },
  {
    tailwind: "shadow-pink-400",
    css: "--tw-shadow-color: #f472b6;",
  },
  {
    tailwind: "shadow-pink-500",
    css: "--tw-shadow-color: #ec4899;",
  },
  {
    tailwind: "shadow-pink-600",
    css: "--tw-shadow-color: #db2777;",
  },
  {
    tailwind: "shadow-pink-700",
    css: "--tw-shadow-color: #be185d;",
  },
  {
    tailwind: "shadow-pink-800",
    css: "--tw-shadow-color: #9d174d;",
  },
  {
    tailwind: "shadow-pink-900",
    css: "--tw-shadow-color: #831843;",
  },
  {
    tailwind: "shadow-pink-950",
    css: "--tw-shadow-color: #500724;",
  },
  {
    tailwind: "shadow-rose-50",
    css: "--tw-shadow-color: #fff1f2;",
  },
  {
    tailwind: "shadow-rose-100",
    css: "--tw-shadow-color: #ffe4e6;",
  },
  {
    tailwind: "shadow-rose-200",
    css: "--tw-shadow-color: #fecdd3;",
  },
  {
    tailwind: "shadow-rose-300",
    css: "--tw-shadow-color: #fda4af;",
  },
  {
    tailwind: "shadow-rose-400",
    css: "--tw-shadow-color: #fb7185;",
  },
  {
    tailwind: "shadow-rose-500",
    css: "--tw-shadow-color: #f43f5e;",
  },
  {
    tailwind: "shadow-rose-600",
    css: "--tw-shadow-color: #e11d48;",
  },
  {
    tailwind: "shadow-rose-700",
    css: "--tw-shadow-color: #be123c;",
  },
  {
    tailwind: "shadow-rose-800",
    css: "--tw-shadow-color: #9f1239;",
  },
  {
    tailwind: "shadow-rose-900",
    css: "--tw-shadow-color: #881337;",
  },
  {
    tailwind: "shadow-rose-950",
    css: "--tw-shadow-color: #4c0519;",
  },
  {
    tailwind: "opacity-0",
    css: "opacity: 0;",
  },
  {
    tailwind: "opacity-5",
    css: "opacity: 0.05;",
  },
  {
    tailwind: "opacity-10",
    css: "opacity: 0.1;",
  },
  {
    tailwind: "opacity-20",
    css: "opacity: 0.2;",
  },
  {
    tailwind: "opacity-25",
    css: "opacity: 0.25;",
  },
  {
    tailwind: "opacity-30",
    css: "opacity: 0.3;",
  },
  {
    tailwind: "opacity-40",
    css: "opacity: 0.4;",
  },
  {
    tailwind: "opacity-50",
    css: "opacity: 0.5;",
  },
  {
    tailwind: "opacity-60",
    css: "opacity: 0.6;",
  },
  {
    tailwind: "opacity-70",
    css: "opacity: 0.7;",
  },
  {
    tailwind: "opacity-75",
    css: "opacity: 0.75;",
  },
  {
    tailwind: "opacity-80",
    css: "opacity: 0.8;",
  },
  {
    tailwind: "opacity-90",
    css: "opacity: 0.9;",
  },
  {
    tailwind: "opacity-95",
    css: "opacity: 0.95;",
  },
  {
    tailwind: "opacity-100",
    css: "opacity: 1;",
  },
  {
    tailwind: "mix-blend-normal",
    css: "mix-blend-mode: normal;",
  },
  {
    tailwind: "mix-blend-multiply",
    css: "mix-blend-mode: multiply;",
  },
  {
    tailwind: "mix-blend-screen",
    css: "mix-blend-mode: screen;",
  },
  {
    tailwind: "mix-blend-overlay",
    css: "mix-blend-mode: overlay;",
  },
  {
    tailwind: "mix-blend-darken",
    css: "mix-blend-mode: darken;",
  },
  {
    tailwind: "mix-blend-lighten",
    css: "mix-blend-mode: lighten;",
  },
  {
    tailwind: "mix-blend-color-dodge",
    css: "mix-blend-mode: color-dodge;",
  },
  {
    tailwind: "mix-blend-color-burn",
    css: "mix-blend-mode: color-burn;",
  },
  {
    tailwind: "mix-blend-hard-light",
    css: "mix-blend-mode: hard-light;",
  },
  {
    tailwind: "mix-blend-soft-light",
    css: "mix-blend-mode: soft-light;",
  },
  {
    tailwind: "mix-blend-difference",
    css: "mix-blend-mode: difference;",
  },
  {
    tailwind: "mix-blend-exclusion",
    css: "mix-blend-mode: exclusion;",
  },
  {
    tailwind: "mix-blend-hue",
    css: "mix-blend-mode: hue;",
  },
  {
    tailwind: "mix-blend-saturation",
    css: "mix-blend-mode: saturation;",
  },
  {
    tailwind: "mix-blend-color",
    css: "mix-blend-mode: color;",
  },
  {
    tailwind: "mix-blend-luminosity",
    css: "mix-blend-mode: luminosity;",
  },
  {
    tailwind: "mix-blend-plus-lighter",
    css: "mix-blend-mode: plus-lighter;",
  },
  {
    tailwind: "bg-blend-normal",
    css: "background-blend-mode: normal;",
  },
  {
    tailwind: "bg-blend-multiply",
    css: "background-blend-mode: multiply;",
  },
  {
    tailwind: "bg-blend-screen",
    css: "background-blend-mode: screen;",
  },
  {
    tailwind: "bg-blend-overlay",
    css: "background-blend-mode: overlay;",
  },
  {
    tailwind: "bg-blend-darken",
    css: "background-blend-mode: darken;",
  },
  {
    tailwind: "bg-blend-lighten",
    css: "background-blend-mode: lighten;",
  },
  {
    tailwind: "bg-blend-color-dodge",
    css: "background-blend-mode: color-dodge;",
  },
  {
    tailwind: "bg-blend-color-burn",
    css: "background-blend-mode: color-burn;",
  },
  {
    tailwind: "bg-blend-hard-light",
    css: "background-blend-mode: hard-light;",
  },
  {
    tailwind: "bg-blend-soft-light",
    css: "background-blend-mode: soft-light;",
  },
  {
    tailwind: "bg-blend-difference",
    css: "background-blend-mode: difference;",
  },
  {
    tailwind: "bg-blend-exclusion",
    css: "background-blend-mode: exclusion;",
  },
  {
    tailwind: "bg-blend-hue",
    css: "background-blend-mode: hue;",
  },
  {
    tailwind: "bg-blend-saturation",
    css: "background-blend-mode: saturation;",
  },
  {
    tailwind: "bg-blend-color",
    css: "background-blend-mode: color;",
  },
  {
    tailwind: "bg-blend-luminosity",
    css: "background-blend-mode: luminosity;",
  },
  {
    tailwind: "blur-none",
    css: "filter: blur(0);",
  },
  {
    tailwind: "blur-sm",
    css: "filter: blur(4px);",
  },
  {
    tailwind: "blur",
    css: "filter: blur(8px);",
  },
  {
    tailwind: "blur-md",
    css: "filter: blur(12px);",
  },
  {
    tailwind: "blur-lg",
    css: "filter: blur(16px);",
  },
  {
    tailwind: "blur-xl",
    css: "filter: blur(24px);",
  },
  {
    tailwind: "blur-2xl",
    css: "filter: blur(40px);",
  },
  {
    tailwind: "blur-3xl",
    css: "filter: blur(64px);",
  },
  {
    tailwind: "brightness-0",
    css: "filter: brightness(0);",
  },
  {
    tailwind: "brightness-50",
    css: "filter: brightness(.5);",
  },
  {
    tailwind: "brightness-75",
    css: "filter: brightness(.75);",
  },
  {
    tailwind: "brightness-90",
    css: "filter: brightness(.9);",
  },
  {
    tailwind: "brightness-95",
    css: "filter: brightness(.95);",
  },
  {
    tailwind: "brightness-100",
    css: "filter: brightness(1);",
  },
  {
    tailwind: "brightness-105",
    css: "filter: brightness(1.05);",
  },
  {
    tailwind: "brightness-110",
    css: "filter: brightness(1.1);",
  },
  {
    tailwind: "brightness-125",
    css: "filter: brightness(1.25);",
  },
  {
    tailwind: "brightness-150",
    css: "filter: brightness(1.5);",
  },
  {
    tailwind: "brightness-200",
    css: "filter: brightness(2);",
  },
  {
    tailwind: "contrast-0",
    css: "filter: contrast(0);",
  },
  {
    tailwind: "contrast-50",
    css: "filter: contrast(.5);",
  },
  {
    tailwind: "contrast-75",
    css: "filter: contrast(.75);",
  },
  {
    tailwind: "contrast-100",
    css: "filter: contrast(1);",
  },
  {
    tailwind: "contrast-125",
    css: "filter: contrast(1.25);",
  },
  {
    tailwind: "contrast-150",
    css: "filter: contrast(1.5);",
  },
  {
    tailwind: "contrast-200",
    css: "filter: contrast(2);",
  },
  {
    tailwind: "drop-shadow-sm",
    css: "filter: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));",
  },
  {
    tailwind: "drop-shadow",
    css: "filter: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));",
  },
  {
    tailwind: "drop-shadow-md",
    css: "filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));",
  },
  {
    tailwind: "drop-shadow-lg",
    css: "filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));",
  },
  {
    tailwind: "drop-shadow-xl",
    css: "filter: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));",
  },
  {
    tailwind: "drop-shadow-2xl",
    css: "filter: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));",
  },
  {
    tailwind: "drop-shadow-none",
    css: "filter: drop-shadow(0 0 #0000);",
  },
  {
    tailwind: "grayscale-0",
    css: "filter: grayscale(0);",
  },
  {
    tailwind: "grayscale",
    css: "filter: grayscale(100%);",
  },
  {
    tailwind: "hue-rotate-0",
    css: "filter: hue-rotate(0deg);",
  },
  {
    tailwind: "hue-rotate-15",
    css: "filter: hue-rotate(15deg);",
  },
  {
    tailwind: "hue-rotate-30",
    css: "filter: hue-rotate(30deg);",
  },
  {
    tailwind: "hue-rotate-60",
    css: "filter: hue-rotate(60deg);",
  },
  {
    tailwind: "hue-rotate-90",
    css: "filter: hue-rotate(90deg);",
  },
  {
    tailwind: "hue-rotate-180",
    css: "filter: hue-rotate(180deg);",
  },
  {
    tailwind: "invert-0",
    css: "filter: invert(0);",
  },
  {
    tailwind: "invert",
    css: "filter: invert(100%);",
  },
  {
    tailwind: "saturate-0",
    css: "filter: saturate(0);",
  },
  {
    tailwind: "saturate-50",
    css: "filter: saturate(.5);",
  },
  {
    tailwind: "saturate-100",
    css: "filter: saturate(1);",
  },
  {
    tailwind: "saturate-150",
    css: "filter: saturate(1.5);",
  },
  {
    tailwind: "saturate-200",
    css: "filter: saturate(2);",
  },
  {
    tailwind: "sepia-0",
    css: "filter: sepia(0);",
  },
  {
    tailwind: "sepia",
    css: "filter: sepia(100%);",
  },
  {
    tailwind: "backdrop-blur-none",
    css: "backdrop-filter: blur(0);",
  },
  {
    tailwind: "backdrop-blur-sm",
    css: "backdrop-filter: blur(4px);",
  },
  {
    tailwind: "backdrop-blur",
    css: "backdrop-filter: blur(8px);",
  },
  {
    tailwind: "backdrop-blur-md",
    css: "backdrop-filter: blur(12px);",
  },
  {
    tailwind: "backdrop-blur-lg",
    css: "backdrop-filter: blur(16px);",
  },
  {
    tailwind: "backdrop-blur-xl",
    css: "backdrop-filter: blur(24px);",
  },
  {
    tailwind: "backdrop-blur-2xl",
    css: "backdrop-filter: blur(40px);",
  },
  {
    tailwind: "backdrop-blur-3xl",
    css: "backdrop-filter: blur(64px);",
  },
  {
    tailwind: "backdrop-brightness-0",
    css: "backdrop-filter: brightness(0);",
  },
  {
    tailwind: "backdrop-brightness-50",
    css: "backdrop-filter: brightness(.5);",
  },
  {
    tailwind: "backdrop-brightness-75",
    css: "backdrop-filter: brightness(.75);",
  },
  {
    tailwind: "backdrop-brightness-90",
    css: "backdrop-filter: brightness(.9);",
  },
  {
    tailwind: "backdrop-brightness-95",
    css: "backdrop-filter: brightness(.95);",
  },
  {
    tailwind: "backdrop-brightness-100",
    css: "backdrop-filter: brightness(1);",
  },
  {
    tailwind: "backdrop-brightness-105",
    css: "backdrop-filter: brightness(1.05);",
  },
  {
    tailwind: "backdrop-brightness-110",
    css: "backdrop-filter: brightness(1.1);",
  },
  {
    tailwind: "backdrop-brightness-125",
    css: "backdrop-filter: brightness(1.25);",
  },
  {
    tailwind: "backdrop-brightness-150",
    css: "backdrop-filter: brightness(1.5);",
  },
  {
    tailwind: "backdrop-brightness-200",
    css: "backdrop-filter: brightness(2);",
  },
  {
    tailwind: "backdrop-contrast-0",
    css: "backdrop-filter: contrast(0);",
  },
  {
    tailwind: "backdrop-contrast-50",
    css: "backdrop-filter: contrast(.5);",
  },
  {
    tailwind: "backdrop-contrast-75",
    css: "backdrop-filter: contrast(.75);",
  },
  {
    tailwind: "backdrop-contrast-100",
    css: "backdrop-filter: contrast(1);",
  },
  {
    tailwind: "backdrop-contrast-125",
    css: "backdrop-filter: contrast(1.25);",
  },
  {
    tailwind: "backdrop-contrast-150",
    css: "backdrop-filter: contrast(1.5);",
  },
  {
    tailwind: "backdrop-contrast-200",
    css: "backdrop-filter: contrast(2);",
  },
  {
    tailwind: "backdrop-grayscale-0",
    css: "backdrop-filter: grayscale(0);",
  },
  {
    tailwind: "backdrop-grayscale",
    css: "backdrop-filter: grayscale(100%);",
  },
  {
    tailwind: "backdrop-hue-rotate-0",
    css: "backdrop-filter: hue-rotate(0deg);",
  },
  {
    tailwind: "backdrop-hue-rotate-15",
    css: "backdrop-filter: hue-rotate(15deg);",
  },
  {
    tailwind: "backdrop-hue-rotate-30",
    css: "backdrop-filter: hue-rotate(30deg);",
  },
  {
    tailwind: "backdrop-hue-rotate-60",
    css: "backdrop-filter: hue-rotate(60deg);",
  },
  {
    tailwind: "backdrop-hue-rotate-90",
    css: "backdrop-filter: hue-rotate(90deg);",
  },
  {
    tailwind: "backdrop-hue-rotate-180",
    css: "backdrop-filter: hue-rotate(180deg);",
  },
  {
    tailwind: "backdrop-invert-0",
    css: "backdrop-filter: invert(0);",
  },
  {
    tailwind: "backdrop-invert",
    css: "backdrop-filter: invert(100%);",
  },
  {
    tailwind: "backdrop-opacity-0",
    css: "backdrop-filter: opacity(0);",
  },
  {
    tailwind: "backdrop-opacity-5",
    css: "backdrop-filter: opacity(0.05);",
  },
  {
    tailwind: "backdrop-opacity-10",
    css: "backdrop-filter: opacity(0.1);",
  },
  {
    tailwind: "backdrop-opacity-20",
    css: "backdrop-filter: opacity(0.2);",
  },
  {
    tailwind: "backdrop-opacity-25",
    css: "backdrop-filter: opacity(0.25);",
  },
  {
    tailwind: "backdrop-opacity-30",
    css: "backdrop-filter: opacity(0.3);",
  },
  {
    tailwind: "backdrop-opacity-40",
    css: "backdrop-filter: opacity(0.4);",
  },
  {
    tailwind: "backdrop-opacity-50",
    css: "backdrop-filter: opacity(0.5);",
  },
  {
    tailwind: "backdrop-opacity-60",
    css: "backdrop-filter: opacity(0.6);",
  },
  {
    tailwind: "backdrop-opacity-70",
    css: "backdrop-filter: opacity(0.7);",
  },
  {
    tailwind: "backdrop-opacity-75",
    css: "backdrop-filter: opacity(0.75);",
  },
  {
    tailwind: "backdrop-opacity-80",
    css: "backdrop-filter: opacity(0.8);",
  },
  {
    tailwind: "backdrop-opacity-90",
    css: "backdrop-filter: opacity(0.9);",
  },
  {
    tailwind: "backdrop-opacity-95",
    css: "backdrop-filter: opacity(0.95);",
  },
  {
    tailwind: "backdrop-opacity-100",
    css: "backdrop-filter: opacity(1);",
  },
  {
    tailwind: "backdrop-saturate-0",
    css: "backdrop-filter: saturate(0);",
  },
  {
    tailwind: "backdrop-saturate-50",
    css: "backdrop-filter: saturate(.5);",
  },
  {
    tailwind: "backdrop-saturate-100",
    css: "backdrop-filter: saturate(1);",
  },
  {
    tailwind: "backdrop-saturate-150",
    css: "backdrop-filter: saturate(1.5);",
  },
  {
    tailwind: "backdrop-saturate-200",
    css: "backdrop-filter: saturate(2);",
  },
  {
    tailwind: "backdrop-sepia-0",
    css: "backdrop-filter: sepia(0);",
  },
  {
    tailwind: "backdrop-sepia",
    css: "backdrop-filter: sepia(100%);",
  },
  {
    tailwind: "border-collapse",
    css: "border-collapse: collapse;",
  },
  {
    tailwind: "border-separate",
    css: "border-collapse: separate;",
  },
  {
    tailwind: "Indiana",
    css: "Indianapolis",
  },
  {
    tailwind: "Ohio",
    css: "Columbus",
  },
  {
    tailwind: "Michigan",
    css: "Detroit",
  },
  {
    tailwind: "Indiana",
    css: "Indianapolis",
  },
  {
    tailwind: "Ohio",
    css: "Columbus",
  },
  {
    tailwind: "Michigan",
    css: "Detroit",
  },
  {
    tailwind: "border-spacing-0",
    css: "border-spacing: 0px 0px;",
  },
  {
    tailwind: "border-spacing-x-0",
    css: "border-spacing: 0px var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-0",
    css: "border-spacing: var(--tw-border-spacing-x) 0px;",
  },
  {
    tailwind: "border-spacing-px",
    css: "border-spacing: 1px 1px;",
  },
  {
    tailwind: "border-spacing-x-px",
    css: "border-spacing: 1px var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-px",
    css: "border-spacing: var(--tw-border-spacing-x) 1px;",
  },
  {
    tailwind: "border-spacing-0.5",
    css: "border-spacing: 0.125rem 0.125rem;",
  },
  {
    tailwind: "border-spacing-x-0.5",
    css: "border-spacing: 0.125rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-0.5",
    css: "border-spacing: var(--tw-border-spacing-x) 0.125rem;",
  },
  {
    tailwind: "border-spacing-1",
    css: "border-spacing: 0.25rem 0.25rem;",
  },
  {
    tailwind: "border-spacing-x-1",
    css: "border-spacing: 0.25rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-1",
    css: "border-spacing: var(--tw-border-spacing-x) 0.25rem;",
  },
  {
    tailwind: "border-spacing-1.5",
    css: "border-spacing: 0.375rem 0.375rem;",
  },
  {
    tailwind: "border-spacing-x-1.5",
    css: "border-spacing: 0.375rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-1.5",
    css: "border-spacing: var(--tw-border-spacing-x) 0.375rem;",
  },
  {
    tailwind: "border-spacing-2",
    css: "border-spacing: 0.5rem 0.5rem;",
  },
  {
    tailwind: "border-spacing-x-2",
    css: "border-spacing: 0.5rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-2",
    css: "border-spacing: var(--tw-border-spacing-x) 0.5rem;",
  },
  {
    tailwind: "border-spacing-2.5",
    css: "border-spacing: 0.625rem 0.625rem;",
  },
  {
    tailwind: "border-spacing-x-2.5",
    css: "border-spacing: 0.625rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-2.5",
    css: "border-spacing: var(--tw-border-spacing-x) 0.625rem;",
  },
  {
    tailwind: "border-spacing-3",
    css: "border-spacing: 0.75rem 0.75rem;",
  },
  {
    tailwind: "border-spacing-x-3",
    css: "border-spacing: 0.75rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-3",
    css: "border-spacing: var(--tw-border-spacing-x) 0.75rem;",
  },
  {
    tailwind: "border-spacing-3.5",
    css: "border-spacing: 0.875rem 0.875rem;",
  },
  {
    tailwind: "border-spacing-x-3.5",
    css: "border-spacing: 0.875rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-3.5",
    css: "border-spacing: var(--tw-border-spacing-x) 0.875rem;",
  },
  {
    tailwind: "border-spacing-4",
    css: "border-spacing: 1rem 1rem;",
  },
  {
    tailwind: "border-spacing-x-4",
    css: "border-spacing: 1rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-4",
    css: "border-spacing: var(--tw-border-spacing-x) 1rem;",
  },
  {
    tailwind: "border-spacing-5",
    css: "border-spacing: 1.25rem 1.25rem;",
  },
  {
    tailwind: "border-spacing-x-5",
    css: "border-spacing: 1.25rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-5",
    css: "border-spacing: var(--tw-border-spacing-x) 1.25rem;",
  },
  {
    tailwind: "border-spacing-6",
    css: "border-spacing: 1.5rem 1.5rem;",
  },
  {
    tailwind: "border-spacing-x-6",
    css: "border-spacing: 1.5rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-6",
    css: "border-spacing: var(--tw-border-spacing-x) 1.5rem;",
  },
  {
    tailwind: "border-spacing-7",
    css: "border-spacing: 1.75rem 1.75rem;",
  },
  {
    tailwind: "border-spacing-x-7",
    css: "border-spacing: 1.75rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-7",
    css: "border-spacing: var(--tw-border-spacing-x) 1.75rem;",
  },
  {
    tailwind: "border-spacing-8",
    css: "border-spacing: 2rem 2rem;",
  },
  {
    tailwind: "border-spacing-x-8",
    css: "border-spacing: 2rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-8",
    css: "border-spacing: var(--tw-border-spacing-x) 2rem;",
  },
  {
    tailwind: "border-spacing-9",
    css: "border-spacing: 2.25rem 2.25rem;",
  },
  {
    tailwind: "border-spacing-x-9",
    css: "border-spacing: 2.25rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-9",
    css: "border-spacing: var(--tw-border-spacing-x) 2.25rem;",
  },
  {
    tailwind: "border-spacing-10",
    css: "border-spacing: 2.5rem 2.5rem;",
  },
  {
    tailwind: "border-spacing-x-10",
    css: "border-spacing: 2.5rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-10",
    css: "border-spacing: var(--tw-border-spacing-x) 2.5rem;",
  },
  {
    tailwind: "border-spacing-11",
    css: "border-spacing: 2.75rem 2.75rem;",
  },
  {
    tailwind: "border-spacing-x-11",
    css: "border-spacing: 2.75rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-11",
    css: "border-spacing: var(--tw-border-spacing-x) 2.75rem;",
  },
  {
    tailwind: "border-spacing-12",
    css: "border-spacing: 3rem 3rem;",
  },
  {
    tailwind: "border-spacing-x-12",
    css: "border-spacing: 3rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-12",
    css: "border-spacing: var(--tw-border-spacing-x) 3rem;",
  },
  {
    tailwind: "border-spacing-14",
    css: "border-spacing: 3.5rem 3.5rem;",
  },
  {
    tailwind: "border-spacing-x-14",
    css: "border-spacing: 3.5rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-14",
    css: "border-spacing: var(--tw-border-spacing-x) 3.5rem;",
  },
  {
    tailwind: "border-spacing-16",
    css: "border-spacing: 4rem 4rem;",
  },
  {
    tailwind: "border-spacing-x-16",
    css: "border-spacing: 4rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-16",
    css: "border-spacing: var(--tw-border-spacing-x) 4rem;",
  },
  {
    tailwind: "border-spacing-20",
    css: "border-spacing: 5rem 5rem;",
  },
  {
    tailwind: "border-spacing-x-20",
    css: "border-spacing: 5rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-20",
    css: "border-spacing: var(--tw-border-spacing-x) 5rem;",
  },
  {
    tailwind: "border-spacing-24",
    css: "border-spacing: 6rem 6rem;",
  },
  {
    tailwind: "border-spacing-x-24",
    css: "border-spacing: 6rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-24",
    css: "border-spacing: var(--tw-border-spacing-x) 6rem;",
  },
  {
    tailwind: "border-spacing-28",
    css: "border-spacing: 7rem 7rem;",
  },
  {
    tailwind: "border-spacing-x-28",
    css: "border-spacing: 7rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-28",
    css: "border-spacing: var(--tw-border-spacing-x) 7rem;",
  },
  {
    tailwind: "border-spacing-32",
    css: "border-spacing: 8rem 8rem;",
  },
  {
    tailwind: "border-spacing-x-32",
    css: "border-spacing: 8rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-32",
    css: "border-spacing: var(--tw-border-spacing-x) 8rem;",
  },
  {
    tailwind: "border-spacing-36",
    css: "border-spacing: 9rem 9rem;",
  },
  {
    tailwind: "border-spacing-x-36",
    css: "border-spacing: 9rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-36",
    css: "border-spacing: var(--tw-border-spacing-x) 9rem;",
  },
  {
    tailwind: "border-spacing-40",
    css: "border-spacing: 10rem 10rem;",
  },
  {
    tailwind: "border-spacing-x-40",
    css: "border-spacing: 10rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-40",
    css: "border-spacing: var(--tw-border-spacing-x) 10rem;",
  },
  {
    tailwind: "border-spacing-44",
    css: "border-spacing: 11rem 11rem;",
  },
  {
    tailwind: "border-spacing-x-44",
    css: "border-spacing: 11rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-44",
    css: "border-spacing: var(--tw-border-spacing-x) 11rem;",
  },
  {
    tailwind: "border-spacing-48",
    css: "border-spacing: 12rem 12rem;",
  },
  {
    tailwind: "border-spacing-x-48",
    css: "border-spacing: 12rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-48",
    css: "border-spacing: var(--tw-border-spacing-x) 12rem;",
  },
  {
    tailwind: "border-spacing-52",
    css: "border-spacing: 13rem 13rem;",
  },
  {
    tailwind: "border-spacing-x-52",
    css: "border-spacing: 13rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-52",
    css: "border-spacing: var(--tw-border-spacing-x) 13rem;",
  },
  {
    tailwind: "border-spacing-56",
    css: "border-spacing: 14rem 14rem;",
  },
  {
    tailwind: "border-spacing-x-56",
    css: "border-spacing: 14rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-56",
    css: "border-spacing: var(--tw-border-spacing-x) 14rem;",
  },
  {
    tailwind: "border-spacing-60",
    css: "border-spacing: 15rem 15rem;",
  },
  {
    tailwind: "border-spacing-x-60",
    css: "border-spacing: 15rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-60",
    css: "border-spacing: var(--tw-border-spacing-x) 15rem;",
  },
  {
    tailwind: "border-spacing-64",
    css: "border-spacing: 16rem 16rem;",
  },
  {
    tailwind: "border-spacing-x-64",
    css: "border-spacing: 16rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-64",
    css: "border-spacing: var(--tw-border-spacing-x) 16rem;",
  },
  {
    tailwind: "border-spacing-72",
    css: "border-spacing: 18rem 18rem;",
  },
  {
    tailwind: "border-spacing-x-72",
    css: "border-spacing: 18rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-72",
    css: "border-spacing: var(--tw-border-spacing-x) 18rem;",
  },
  {
    tailwind: "border-spacing-80",
    css: "border-spacing: 20rem 20rem;",
  },
  {
    tailwind: "border-spacing-x-80",
    css: "border-spacing: 20rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-80",
    css: "border-spacing: var(--tw-border-spacing-x) 20rem;",
  },
  {
    tailwind: "border-spacing-96",
    css: "border-spacing: 24rem 24rem;",
  },
  {
    tailwind: "border-spacing-x-96",
    css: "border-spacing: 24rem var(--tw-border-spacing-y);",
  },
  {
    tailwind: "border-spacing-y-96",
    css: "border-spacing: var(--tw-border-spacing-x) 24rem;",
  },
  {
    tailwind: "Indiana",
    css: "Indianapolis",
  },
  {
    tailwind: "Ohio",
    css: "Columbus",
  },
  {
    tailwind: "Michigan",
    css: "Detroit",
  },
  {
    tailwind: "table-auto",
    css: "table-layout: auto;",
  },
  {
    tailwind: "table-fixed",
    css: "table-layout: fixed;",
  },
  {
    tailwind: "caption-top",
    css: "caption-side: top;",
  },
  {
    tailwind: "caption-bottom",
    css: "caption-side: bottom;",
  },
  {
    tailwind: "transition-none",
    css: "transition-property: none;",
  },
  {
    tailwind: "transition-all",
    css: "transition-property: all;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "transition",
    css: "transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "transition-colors",
    css: "transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "transition-opacity",
    css: "transition-property: opacity;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "transition-shadow",
    css: "transition-property: box-shadow;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "transition-transform",
    css: "transition-property: transform;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 150ms;",
  },
  {
    tailwind: "duration-0",
    css: "transition-duration: 0s;",
  },
  {
    tailwind: "duration-75",
    css: "transition-duration: 75ms;",
  },
  {
    tailwind: "duration-100",
    css: "transition-duration: 100ms;",
  },
  {
    tailwind: "duration-150",
    css: "transition-duration: 150ms;",
  },
  {
    tailwind: "duration-200",
    css: "transition-duration: 200ms;",
  },
  {
    tailwind: "duration-300",
    css: "transition-duration: 300ms;",
  },
  {
    tailwind: "duration-500",
    css: "transition-duration: 500ms;",
  },
  {
    tailwind: "duration-700",
    css: "transition-duration: 700ms;",
  },
  {
    tailwind: "duration-1000",
    css: "transition-duration: 1000ms;",
  },
  {
    tailwind: "ease-linear",
    css: "transition-timing-function: linear;",
  },
  {
    tailwind: "ease-in",
    css: "transition-timing-function: cubic-bezier(0.4, 0, 1, 1);",
  },
  {
    tailwind: "ease-out",
    css: "transition-timing-function: cubic-bezier(0, 0, 0.2, 1);",
  },
  {
    tailwind: "ease-in-out",
    css: "transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);",
  },
  {
    tailwind: "delay-0",
    css: "transition-delay: 0s;",
  },
  {
    tailwind: "delay-75",
    css: "transition-delay: 75ms;",
  },
  {
    tailwind: "delay-100",
    css: "transition-delay: 100ms;",
  },
  {
    tailwind: "delay-150",
    css: "transition-delay: 150ms;",
  },
  {
    tailwind: "delay-200",
    css: "transition-delay: 200ms;",
  },
  {
    tailwind: "delay-300",
    css: "transition-delay: 300ms;",
  },
  {
    tailwind: "delay-500",
    css: "transition-delay: 500ms;",
  },
  {
    tailwind: "delay-700",
    css: "transition-delay: 700ms;",
  },
  {
    tailwind: "delay-1000",
    css: "transition-delay: 1000ms;",
  },
  {
    tailwind: "animate-none",
    css: "animation: none;",
  },
  {
    tailwind: "animate-spin",
    css: "animation: spin 1s linear infinite;\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}",
  },
  {
    tailwind: "animate-ping",
    css: "animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}",
  },
  {
    tailwind: "animate-pulse",
    css: "animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .5;\n  }\n}",
  },
  {
    tailwind: "animate-bounce",
    css: "animation: bounce 1s infinite;\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: translateY(0);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n}",
  },
  {
    tailwind: "scale-0",
    css: "transform: scale(0);",
  },
  {
    tailwind: "scale-x-0",
    css: "transform: scaleX(0);",
  },
  {
    tailwind: "scale-y-0",
    css: "transform: scaleY(0);",
  },
  {
    tailwind: "scale-50",
    css: "transform: scale(.5);",
  },
  {
    tailwind: "scale-x-50",
    css: "transform: scaleX(.5);",
  },
  {
    tailwind: "scale-y-50",
    css: "transform: scaleY(.5);",
  },
  {
    tailwind: "scale-75",
    css: "transform: scale(.75);",
  },
  {
    tailwind: "scale-x-75",
    css: "transform: scaleX(.75);",
  },
  {
    tailwind: "scale-y-75",
    css: "transform: scaleY(.75);",
  },
  {
    tailwind: "scale-90",
    css: "transform: scale(.9);",
  },
  {
    tailwind: "scale-x-90",
    css: "transform: scaleX(.9);",
  },
  {
    tailwind: "scale-y-90",
    css: "transform: scaleY(.9);",
  },
  {
    tailwind: "scale-95",
    css: "transform: scale(.95);",
  },
  {
    tailwind: "scale-x-95",
    css: "transform: scaleX(.95);",
  },
  {
    tailwind: "scale-y-95",
    css: "transform: scaleY(.95);",
  },
  {
    tailwind: "scale-100",
    css: "transform: scale(1);",
  },
  {
    tailwind: "scale-x-100",
    css: "transform: scaleX(1);",
  },
  {
    tailwind: "scale-y-100",
    css: "transform: scaleY(1);",
  },
  {
    tailwind: "scale-105",
    css: "transform: scale(1.05);",
  },
  {
    tailwind: "scale-x-105",
    css: "transform: scaleX(1.05);",
  },
  {
    tailwind: "scale-y-105",
    css: "transform: scaleY(1.05);",
  },
  {
    tailwind: "scale-110",
    css: "transform: scale(1.1);",
  },
  {
    tailwind: "scale-x-110",
    css: "transform: scaleX(1.1);",
  },
  {
    tailwind: "scale-y-110",
    css: "transform: scaleY(1.1);",
  },
  {
    tailwind: "scale-125",
    css: "transform: scale(1.25);",
  },
  {
    tailwind: "scale-x-125",
    css: "transform: scaleX(1.25);",
  },
  {
    tailwind: "scale-y-125",
    css: "transform: scaleY(1.25);",
  },
  {
    tailwind: "scale-150",
    css: "transform: scale(1.5);",
  },
  {
    tailwind: "scale-x-150",
    css: "transform: scaleX(1.5);",
  },
  {
    tailwind: "scale-y-150",
    css: "transform: scaleY(1.5);",
  },
  {
    tailwind: "rotate-0",
    css: "transform: rotate(0deg);",
  },
  {
    tailwind: "rotate-1",
    css: "transform: rotate(1deg);",
  },
  {
    tailwind: "rotate-2",
    css: "transform: rotate(2deg);",
  },
  {
    tailwind: "rotate-3",
    css: "transform: rotate(3deg);",
  },
  {
    tailwind: "rotate-6",
    css: "transform: rotate(6deg);",
  },
  {
    tailwind: "rotate-12",
    css: "transform: rotate(12deg);",
  },
  {
    tailwind: "rotate-45",
    css: "transform: rotate(45deg);",
  },
  {
    tailwind: "rotate-90",
    css: "transform: rotate(90deg);",
  },
  {
    tailwind: "rotate-180",
    css: "transform: rotate(180deg);",
  },
  {
    tailwind: "translate-x-0",
    css: "transform: translateX(0px);",
  },
  {
    tailwind: "translate-y-0",
    css: "transform: translateY(0px);",
  },
  {
    tailwind: "translate-x-px",
    css: "transform: translateX(1px);",
  },
  {
    tailwind: "translate-y-px",
    css: "transform: translateY(1px);",
  },
  {
    tailwind: "translate-x-0.5",
    css: "transform: translateX(0.125rem);",
  },
  {
    tailwind: "translate-y-0.5",
    css: "transform: translateY(0.125rem);",
  },
  {
    tailwind: "translate-x-1",
    css: "transform: translateX(0.25rem);",
  },
  {
    tailwind: "translate-y-1",
    css: "transform: translateY(0.25rem);",
  },
  {
    tailwind: "translate-x-1.5",
    css: "transform: translateX(0.375rem);",
  },
  {
    tailwind: "translate-y-1.5",
    css: "transform: translateY(0.375rem);",
  },
  {
    tailwind: "translate-x-2",
    css: "transform: translateX(0.5rem);",
  },
  {
    tailwind: "translate-y-2",
    css: "transform: translateY(0.5rem);",
  },
  {
    tailwind: "translate-x-2.5",
    css: "transform: translateX(0.625rem);",
  },
  {
    tailwind: "translate-y-2.5",
    css: "transform: translateY(0.625rem);",
  },
  {
    tailwind: "translate-x-3",
    css: "transform: translateX(0.75rem);",
  },
  {
    tailwind: "translate-y-3",
    css: "transform: translateY(0.75rem);",
  },
  {
    tailwind: "translate-x-3.5",
    css: "transform: translateX(0.875rem);",
  },
  {
    tailwind: "translate-y-3.5",
    css: "transform: translateY(0.875rem);",
  },
  {
    tailwind: "translate-x-4",
    css: "transform: translateX(1rem);",
  },
  {
    tailwind: "translate-y-4",
    css: "transform: translateY(1rem);",
  },
  {
    tailwind: "translate-x-5",
    css: "transform: translateX(1.25rem);",
  },
  {
    tailwind: "translate-y-5",
    css: "transform: translateY(1.25rem);",
  },
  {
    tailwind: "translate-x-6",
    css: "transform: translateX(1.5rem);",
  },
  {
    tailwind: "translate-y-6",
    css: "transform: translateY(1.5rem);",
  },
  {
    tailwind: "translate-x-7",
    css: "transform: translateX(1.75rem);",
  },
  {
    tailwind: "translate-y-7",
    css: "transform: translateY(1.75rem);",
  },
  {
    tailwind: "translate-x-8",
    css: "transform: translateX(2rem);",
  },
  {
    tailwind: "translate-y-8",
    css: "transform: translateY(2rem);",
  },
  {
    tailwind: "translate-x-9",
    css: "transform: translateX(2.25rem);",
  },
  {
    tailwind: "translate-y-9",
    css: "transform: translateY(2.25rem);",
  },
  {
    tailwind: "translate-x-10",
    css: "transform: translateX(2.5rem);",
  },
  {
    tailwind: "translate-y-10",
    css: "transform: translateY(2.5rem);",
  },
  {
    tailwind: "translate-x-11",
    css: "transform: translateX(2.75rem);",
  },
  {
    tailwind: "translate-y-11",
    css: "transform: translateY(2.75rem);",
  },
  {
    tailwind: "translate-x-12",
    css: "transform: translateX(3rem);",
  },
  {
    tailwind: "translate-y-12",
    css: "transform: translateY(3rem);",
  },
  {
    tailwind: "translate-x-14",
    css: "transform: translateX(3.5rem);",
  },
  {
    tailwind: "translate-y-14",
    css: "transform: translateY(3.5rem);",
  },
  {
    tailwind: "translate-x-16",
    css: "transform: translateX(4rem);",
  },
  {
    tailwind: "translate-y-16",
    css: "transform: translateY(4rem);",
  },
  {
    tailwind: "translate-x-20",
    css: "transform: translateX(5rem);",
  },
  {
    tailwind: "translate-y-20",
    css: "transform: translateY(5rem);",
  },
  {
    tailwind: "translate-x-24",
    css: "transform: translateX(6rem);",
  },
  {
    tailwind: "translate-y-24",
    css: "transform: translateY(6rem);",
  },
  {
    tailwind: "translate-x-28",
    css: "transform: translateX(7rem);",
  },
  {
    tailwind: "translate-y-28",
    css: "transform: translateY(7rem);",
  },
  {
    tailwind: "translate-x-32",
    css: "transform: translateX(8rem);",
  },
  {
    tailwind: "translate-y-32",
    css: "transform: translateY(8rem);",
  },
  {
    tailwind: "translate-x-36",
    css: "transform: translateX(9rem);",
  },
  {
    tailwind: "translate-y-36",
    css: "transform: translateY(9rem);",
  },
  {
    tailwind: "translate-x-40",
    css: "transform: translateX(10rem);",
  },
  {
    tailwind: "translate-y-40",
    css: "transform: translateY(10rem);",
  },
  {
    tailwind: "translate-x-44",
    css: "transform: translateX(11rem);",
  },
  {
    tailwind: "translate-y-44",
    css: "transform: translateY(11rem);",
  },
  {
    tailwind: "translate-x-48",
    css: "transform: translateX(12rem);",
  },
  {
    tailwind: "translate-y-48",
    css: "transform: translateY(12rem);",
  },
  {
    tailwind: "translate-x-52",
    css: "transform: translateX(13rem);",
  },
  {
    tailwind: "translate-y-52",
    css: "transform: translateY(13rem);",
  },
  {
    tailwind: "translate-x-56",
    css: "transform: translateX(14rem);",
  },
  {
    tailwind: "translate-y-56",
    css: "transform: translateY(14rem);",
  },
  {
    tailwind: "translate-x-60",
    css: "transform: translateX(15rem);",
  },
  {
    tailwind: "translate-y-60",
    css: "transform: translateY(15rem);",
  },
  {
    tailwind: "translate-x-64",
    css: "transform: translateX(16rem);",
  },
  {
    tailwind: "translate-y-64",
    css: "transform: translateY(16rem);",
  },
  {
    tailwind: "translate-x-72",
    css: "transform: translateX(18rem);",
  },
  {
    tailwind: "translate-y-72",
    css: "transform: translateY(18rem);",
  },
  {
    tailwind: "translate-x-80",
    css: "transform: translateX(20rem);",
  },
  {
    tailwind: "translate-y-80",
    css: "transform: translateY(20rem);",
  },
  {
    tailwind: "translate-x-96",
    css: "transform: translateX(24rem);",
  },
  {
    tailwind: "translate-y-96",
    css: "transform: translateY(24rem);",
  },
  {
    tailwind: "translate-x-1/2",
    css: "transform: translateX(50%);",
  },
  {
    tailwind: "translate-x-1/3",
    css: "transform: translateX(33.333333%);",
  },
  {
    tailwind: "translate-x-2/3",
    css: "transform: translateX(66.666667%);",
  },
  {
    tailwind: "translate-x-1/4",
    css: "transform: translateX(25%);",
  },
  {
    tailwind: "translate-x-2/4",
    css: "transform: translateX(50%);",
  },
  {
    tailwind: "translate-x-3/4",
    css: "transform: translateX(75%);",
  },
  {
    tailwind: "translate-x-full",
    css: "transform: translateX(100%);",
  },
  {
    tailwind: "translate-y-1/2",
    css: "transform: translateY(50%);",
  },
  {
    tailwind: "translate-y-1/3",
    css: "transform: translateY(33.333333%);",
  },
  {
    tailwind: "translate-y-2/3",
    css: "transform: translateY(66.666667%);",
  },
  {
    tailwind: "translate-y-1/4",
    css: "transform: translateY(25%);",
  },
  {
    tailwind: "translate-y-2/4",
    css: "transform: translateY(50%);",
  },
  {
    tailwind: "translate-y-3/4",
    css: "transform: translateY(75%);",
  },
  {
    tailwind: "translate-y-full",
    css: "transform: translateY(100%);",
  },
  {
    tailwind: "skew-x-0",
    css: "transform: skewX(0deg);",
  },
  {
    tailwind: "skew-y-0",
    css: "transform: skewY(0deg);",
  },
  {
    tailwind: "skew-x-1",
    css: "transform: skewX(1deg);",
  },
  {
    tailwind: "skew-y-1",
    css: "transform: skewY(1deg);",
  },
  {
    tailwind: "skew-x-2",
    css: "transform: skewX(2deg);",
  },
  {
    tailwind: "skew-y-2",
    css: "transform: skewY(2deg);",
  },
  {
    tailwind: "skew-x-3",
    css: "transform: skewX(3deg);",
  },
  {
    tailwind: "skew-y-3",
    css: "transform: skewY(3deg);",
  },
  {
    tailwind: "skew-x-6",
    css: "transform: skewX(6deg);",
  },
  {
    tailwind: "skew-y-6",
    css: "transform: skewY(6deg);",
  },
  {
    tailwind: "skew-x-12",
    css: "transform: skewX(12deg);",
  },
  {
    tailwind: "skew-y-12",
    css: "transform: skewY(12deg);",
  },
  {
    tailwind: "origin-center",
    css: "transform-origin: center;",
  },
  {
    tailwind: "origin-top",
    css: "transform-origin: top;",
  },
  {
    tailwind: "origin-top-right",
    css: "transform-origin: top right;",
  },
  {
    tailwind: "origin-right",
    css: "transform-origin: right;",
  },
  {
    tailwind: "origin-bottom-right",
    css: "transform-origin: bottom right;",
  },
  {
    tailwind: "origin-bottom",
    css: "transform-origin: bottom;",
  },
  {
    tailwind: "origin-bottom-left",
    css: "transform-origin: bottom left;",
  },
  {
    tailwind: "origin-left",
    css: "transform-origin: left;",
  },
  {
    tailwind: "origin-top-left",
    css: "transform-origin: top left;",
  },
  {
    tailwind: "accent-inherit",
    css: "accent-color: inherit;",
  },
  {
    tailwind: "accent-current",
    css: "accent-color: currentColor;",
  },
  {
    tailwind: "accent-transparent",
    css: "accent-color: transparent;",
  },
  {
    tailwind: "accent-black",
    css: "accent-color: #000;",
  },
  {
    tailwind: "accent-white",
    css: "accent-color: #fff;",
  },
  {
    tailwind: "accent-slate-50",
    css: "accent-color: #f8fafc;",
  },
  {
    tailwind: "accent-slate-100",
    css: "accent-color: #f1f5f9;",
  },
  {
    tailwind: "accent-slate-200",
    css: "accent-color: #e2e8f0;",
  },
  {
    tailwind: "accent-slate-300",
    css: "accent-color: #cbd5e1;",
  },
  {
    tailwind: "accent-slate-400",
    css: "accent-color: #94a3b8;",
  },
  {
    tailwind: "accent-slate-500",
    css: "accent-color: #64748b;",
  },
  {
    tailwind: "accent-slate-600",
    css: "accent-color: #475569;",
  },
  {
    tailwind: "accent-slate-700",
    css: "accent-color: #334155;",
  },
  {
    tailwind: "accent-slate-800",
    css: "accent-color: #1e293b;",
  },
  {
    tailwind: "accent-slate-900",
    css: "accent-color: #0f172a;",
  },
  {
    tailwind: "accent-slate-950",
    css: "accent-color: #020617;",
  },
  {
    tailwind: "accent-gray-50",
    css: "accent-color: #f9fafb;",
  },
  {
    tailwind: "accent-gray-100",
    css: "accent-color: #f3f4f6;",
  },
  {
    tailwind: "accent-gray-200",
    css: "accent-color: #e5e7eb;",
  },
  {
    tailwind: "accent-gray-300",
    css: "accent-color: #d1d5db;",
  },
  {
    tailwind: "accent-gray-400",
    css: "accent-color: #9ca3af;",
  },
  {
    tailwind: "accent-gray-500",
    css: "accent-color: #6b7280;",
  },
  {
    tailwind: "accent-gray-600",
    css: "accent-color: #4b5563;",
  },
  {
    tailwind: "accent-gray-700",
    css: "accent-color: #374151;",
  },
  {
    tailwind: "accent-gray-800",
    css: "accent-color: #1f2937;",
  },
  {
    tailwind: "accent-gray-900",
    css: "accent-color: #111827;",
  },
  {
    tailwind: "accent-gray-950",
    css: "accent-color: #030712;",
  },
  {
    tailwind: "accent-zinc-50",
    css: "accent-color: #fafafa;",
  },
  {
    tailwind: "accent-zinc-100",
    css: "accent-color: #f4f4f5;",
  },
  {
    tailwind: "accent-zinc-200",
    css: "accent-color: #e4e4e7;",
  },
  {
    tailwind: "accent-zinc-300",
    css: "accent-color: #d4d4d8;",
  },
  {
    tailwind: "accent-zinc-400",
    css: "accent-color: #a1a1aa;",
  },
  {
    tailwind: "accent-zinc-500",
    css: "accent-color: #71717a;",
  },
  {
    tailwind: "accent-zinc-600",
    css: "accent-color: #52525b;",
  },
  {
    tailwind: "accent-zinc-700",
    css: "accent-color: #3f3f46;",
  },
  {
    tailwind: "accent-zinc-800",
    css: "accent-color: #27272a;",
  },
  {
    tailwind: "accent-zinc-900",
    css: "accent-color: #18181b;",
  },
  {
    tailwind: "accent-zinc-950",
    css: "accent-color: #09090b;",
  },
  {
    tailwind: "accent-neutral-50",
    css: "accent-color: #fafafa;",
  },
  {
    tailwind: "accent-neutral-100",
    css: "accent-color: #f5f5f5;",
  },
  {
    tailwind: "accent-neutral-200",
    css: "accent-color: #e5e5e5;",
  },
  {
    tailwind: "accent-neutral-300",
    css: "accent-color: #d4d4d4;",
  },
  {
    tailwind: "accent-neutral-400",
    css: "accent-color: #a3a3a3;",
  },
  {
    tailwind: "accent-neutral-500",
    css: "accent-color: #737373;",
  },
  {
    tailwind: "accent-neutral-600",
    css: "accent-color: #525252;",
  },
  {
    tailwind: "accent-neutral-700",
    css: "accent-color: #404040;",
  },
  {
    tailwind: "accent-neutral-800",
    css: "accent-color: #262626;",
  },
  {
    tailwind: "accent-neutral-900",
    css: "accent-color: #171717;",
  },
  {
    tailwind: "accent-neutral-950",
    css: "accent-color: #0a0a0a;",
  },
  {
    tailwind: "accent-stone-50",
    css: "accent-color: #fafaf9;",
  },
  {
    tailwind: "accent-stone-100",
    css: "accent-color: #f5f5f4;",
  },
  {
    tailwind: "accent-stone-200",
    css: "accent-color: #e7e5e4;",
  },
  {
    tailwind: "accent-stone-300",
    css: "accent-color: #d6d3d1;",
  },
  {
    tailwind: "accent-stone-400",
    css: "accent-color: #a8a29e;",
  },
  {
    tailwind: "accent-stone-500",
    css: "accent-color: #78716c;",
  },
  {
    tailwind: "accent-stone-600",
    css: "accent-color: #57534e;",
  },
  {
    tailwind: "accent-stone-700",
    css: "accent-color: #44403c;",
  },
  {
    tailwind: "accent-stone-800",
    css: "accent-color: #292524;",
  },
  {
    tailwind: "accent-stone-900",
    css: "accent-color: #1c1917;",
  },
  {
    tailwind: "accent-stone-950",
    css: "accent-color: #0c0a09;",
  },
  {
    tailwind: "accent-red-50",
    css: "accent-color: #fef2f2;",
  },
  {
    tailwind: "accent-red-100",
    css: "accent-color: #fee2e2;",
  },
  {
    tailwind: "accent-red-200",
    css: "accent-color: #fecaca;",
  },
  {
    tailwind: "accent-red-300",
    css: "accent-color: #fca5a5;",
  },
  {
    tailwind: "accent-red-400",
    css: "accent-color: #f87171;",
  },
  {
    tailwind: "accent-red-500",
    css: "accent-color: #ef4444;",
  },
  {
    tailwind: "accent-red-600",
    css: "accent-color: #dc2626;",
  },
  {
    tailwind: "accent-red-700",
    css: "accent-color: #b91c1c;",
  },
  {
    tailwind: "accent-red-800",
    css: "accent-color: #991b1b;",
  },
  {
    tailwind: "accent-red-900",
    css: "accent-color: #7f1d1d;",
  },
  {
    tailwind: "accent-red-950",
    css: "accent-color: #450a0a;",
  },
  {
    tailwind: "accent-orange-50",
    css: "accent-color: #fff7ed;",
  },
  {
    tailwind: "accent-orange-100",
    css: "accent-color: #ffedd5;",
  },
  {
    tailwind: "accent-orange-200",
    css: "accent-color: #fed7aa;",
  },
  {
    tailwind: "accent-orange-300",
    css: "accent-color: #fdba74;",
  },
  {
    tailwind: "accent-orange-400",
    css: "accent-color: #fb923c;",
  },
  {
    tailwind: "accent-orange-500",
    css: "accent-color: #f97316;",
  },
  {
    tailwind: "accent-orange-600",
    css: "accent-color: #ea580c;",
  },
  {
    tailwind: "accent-orange-700",
    css: "accent-color: #c2410c;",
  },
  {
    tailwind: "accent-orange-800",
    css: "accent-color: #9a3412;",
  },
  {
    tailwind: "accent-orange-900",
    css: "accent-color: #7c2d12;",
  },
  {
    tailwind: "accent-orange-950",
    css: "accent-color: #431407;",
  },
  {
    tailwind: "accent-amber-50",
    css: "accent-color: #fffbeb;",
  },
  {
    tailwind: "accent-amber-100",
    css: "accent-color: #fef3c7;",
  },
  {
    tailwind: "accent-amber-200",
    css: "accent-color: #fde68a;",
  },
  {
    tailwind: "accent-amber-300",
    css: "accent-color: #fcd34d;",
  },
  {
    tailwind: "accent-amber-400",
    css: "accent-color: #fbbf24;",
  },
  {
    tailwind: "accent-amber-500",
    css: "accent-color: #f59e0b;",
  },
  {
    tailwind: "accent-amber-600",
    css: "accent-color: #d97706;",
  },
  {
    tailwind: "accent-amber-700",
    css: "accent-color: #b45309;",
  },
  {
    tailwind: "accent-amber-800",
    css: "accent-color: #92400e;",
  },
  {
    tailwind: "accent-amber-900",
    css: "accent-color: #78350f;",
  },
  {
    tailwind: "accent-amber-950",
    css: "accent-color: #451a03;",
  },
  {
    tailwind: "accent-yellow-50",
    css: "accent-color: #fefce8;",
  },
  {
    tailwind: "accent-yellow-100",
    css: "accent-color: #fef9c3;",
  },
  {
    tailwind: "accent-yellow-200",
    css: "accent-color: #fef08a;",
  },
  {
    tailwind: "accent-yellow-300",
    css: "accent-color: #fde047;",
  },
  {
    tailwind: "accent-yellow-400",
    css: "accent-color: #facc15;",
  },
  {
    tailwind: "accent-yellow-500",
    css: "accent-color: #eab308;",
  },
  {
    tailwind: "accent-yellow-600",
    css: "accent-color: #ca8a04;",
  },
  {
    tailwind: "accent-yellow-700",
    css: "accent-color: #a16207;",
  },
  {
    tailwind: "accent-yellow-800",
    css: "accent-color: #854d0e;",
  },
  {
    tailwind: "accent-yellow-900",
    css: "accent-color: #713f12;",
  },
  {
    tailwind: "accent-yellow-950",
    css: "accent-color: #422006;",
  },
  {
    tailwind: "accent-lime-50",
    css: "accent-color: #f7fee7;",
  },
  {
    tailwind: "accent-lime-100",
    css: "accent-color: #ecfccb;",
  },
  {
    tailwind: "accent-lime-200",
    css: "accent-color: #d9f99d;",
  },
  {
    tailwind: "accent-lime-300",
    css: "accent-color: #bef264;",
  },
  {
    tailwind: "accent-lime-400",
    css: "accent-color: #a3e635;",
  },
  {
    tailwind: "accent-lime-500",
    css: "accent-color: #84cc16;",
  },
  {
    tailwind: "accent-lime-600",
    css: "accent-color: #65a30d;",
  },
  {
    tailwind: "accent-lime-700",
    css: "accent-color: #4d7c0f;",
  },
  {
    tailwind: "accent-lime-800",
    css: "accent-color: #3f6212;",
  },
  {
    tailwind: "accent-lime-900",
    css: "accent-color: #365314;",
  },
  {
    tailwind: "accent-lime-950",
    css: "accent-color: #1a2e05;",
  },
  {
    tailwind: "accent-green-50",
    css: "accent-color: #f0fdf4;",
  },
  {
    tailwind: "accent-green-100",
    css: "accent-color: #dcfce7;",
  },
  {
    tailwind: "accent-green-200",
    css: "accent-color: #bbf7d0;",
  },
  {
    tailwind: "accent-green-300",
    css: "accent-color: #86efac;",
  },
  {
    tailwind: "accent-green-400",
    css: "accent-color: #4ade80;",
  },
  {
    tailwind: "accent-green-500",
    css: "accent-color: #22c55e;",
  },
  {
    tailwind: "accent-green-600",
    css: "accent-color: #16a34a;",
  },
  {
    tailwind: "accent-green-700",
    css: "accent-color: #15803d;",
  },
  {
    tailwind: "accent-green-800",
    css: "accent-color: #166534;",
  },
  {
    tailwind: "accent-green-900",
    css: "accent-color: #14532d;",
  },
  {
    tailwind: "accent-green-950",
    css: "accent-color: #052e16;",
  },
  {
    tailwind: "accent-emerald-50",
    css: "accent-color: #ecfdf5;",
  },
  {
    tailwind: "accent-emerald-100",
    css: "accent-color: #d1fae5;",
  },
  {
    tailwind: "accent-emerald-200",
    css: "accent-color: #a7f3d0;",
  },
  {
    tailwind: "accent-emerald-300",
    css: "accent-color: #6ee7b7;",
  },
  {
    tailwind: "accent-emerald-400",
    css: "accent-color: #34d399;",
  },
  {
    tailwind: "accent-emerald-500",
    css: "accent-color: #10b981;",
  },
  {
    tailwind: "accent-emerald-600",
    css: "accent-color: #059669;",
  },
  {
    tailwind: "accent-emerald-700",
    css: "accent-color: #047857;",
  },
  {
    tailwind: "accent-emerald-800",
    css: "accent-color: #065f46;",
  },
  {
    tailwind: "accent-emerald-900",
    css: "accent-color: #064e3b;",
  },
  {
    tailwind: "accent-emerald-950",
    css: "accent-color: #022c22;",
  },
  {
    tailwind: "accent-teal-50",
    css: "accent-color: #f0fdfa;",
  },
  {
    tailwind: "accent-teal-100",
    css: "accent-color: #ccfbf1;",
  },
  {
    tailwind: "accent-teal-200",
    css: "accent-color: #99f6e4;",
  },
  {
    tailwind: "accent-teal-300",
    css: "accent-color: #5eead4;",
  },
  {
    tailwind: "accent-teal-400",
    css: "accent-color: #2dd4bf;",
  },
  {
    tailwind: "accent-teal-500",
    css: "accent-color: #14b8a6;",
  },
  {
    tailwind: "accent-teal-600",
    css: "accent-color: #0d9488;",
  },
  {
    tailwind: "accent-teal-700",
    css: "accent-color: #0f766e;",
  },
  {
    tailwind: "accent-teal-800",
    css: "accent-color: #115e59;",
  },
  {
    tailwind: "accent-teal-900",
    css: "accent-color: #134e4a;",
  },
  {
    tailwind: "accent-teal-950",
    css: "accent-color: #042f2e;",
  },
  {
    tailwind: "accent-cyan-50",
    css: "accent-color: #ecfeff;",
  },
  {
    tailwind: "accent-cyan-100",
    css: "accent-color: #cffafe;",
  },
  {
    tailwind: "accent-cyan-200",
    css: "accent-color: #a5f3fc;",
  },
  {
    tailwind: "accent-cyan-300",
    css: "accent-color: #67e8f9;",
  },
  {
    tailwind: "accent-cyan-400",
    css: "accent-color: #22d3ee;",
  },
  {
    tailwind: "accent-cyan-500",
    css: "accent-color: #06b6d4;",
  },
  {
    tailwind: "accent-cyan-600",
    css: "accent-color: #0891b2;",
  },
  {
    tailwind: "accent-cyan-700",
    css: "accent-color: #0e7490;",
  },
  {
    tailwind: "accent-cyan-800",
    css: "accent-color: #155e75;",
  },
  {
    tailwind: "accent-cyan-900",
    css: "accent-color: #164e63;",
  },
  {
    tailwind: "accent-cyan-950",
    css: "accent-color: #083344;",
  },
  {
    tailwind: "accent-sky-50",
    css: "accent-color: #f0f9ff;",
  },
  {
    tailwind: "accent-sky-100",
    css: "accent-color: #e0f2fe;",
  },
  {
    tailwind: "accent-sky-200",
    css: "accent-color: #bae6fd;",
  },
  {
    tailwind: "accent-sky-300",
    css: "accent-color: #7dd3fc;",
  },
  {
    tailwind: "accent-sky-400",
    css: "accent-color: #38bdf8;",
  },
  {
    tailwind: "accent-sky-500",
    css: "accent-color: #0ea5e9;",
  },
  {
    tailwind: "accent-sky-600",
    css: "accent-color: #0284c7;",
  },
  {
    tailwind: "accent-sky-700",
    css: "accent-color: #0369a1;",
  },
  {
    tailwind: "accent-sky-800",
    css: "accent-color: #075985;",
  },
  {
    tailwind: "accent-sky-900",
    css: "accent-color: #0c4a6e;",
  },
  {
    tailwind: "accent-sky-950",
    css: "accent-color: #082f49;",
  },
  {
    tailwind: "accent-blue-50",
    css: "accent-color: #eff6ff;",
  },
  {
    tailwind: "accent-blue-100",
    css: "accent-color: #dbeafe;",
  },
  {
    tailwind: "accent-blue-200",
    css: "accent-color: #bfdbfe;",
  },
  {
    tailwind: "accent-blue-300",
    css: "accent-color: #93c5fd;",
  },
  {
    tailwind: "accent-blue-400",
    css: "accent-color: #60a5fa;",
  },
  {
    tailwind: "accent-blue-500",
    css: "accent-color: #3b82f6;",
  },
  {
    tailwind: "accent-blue-600",
    css: "accent-color: #2563eb;",
  },
  {
    tailwind: "accent-blue-700",
    css: "accent-color: #1d4ed8;",
  },
  {
    tailwind: "accent-blue-800",
    css: "accent-color: #1e40af;",
  },
  {
    tailwind: "accent-blue-900",
    css: "accent-color: #1e3a8a;",
  },
  {
    tailwind: "accent-blue-950",
    css: "accent-color: #172554;",
  },
  {
    tailwind: "accent-indigo-50",
    css: "accent-color: #eef2ff;",
  },
  {
    tailwind: "accent-indigo-100",
    css: "accent-color: #e0e7ff;",
  },
  {
    tailwind: "accent-indigo-200",
    css: "accent-color: #c7d2fe;",
  },
  {
    tailwind: "accent-indigo-300",
    css: "accent-color: #a5b4fc;",
  },
  {
    tailwind: "accent-indigo-400",
    css: "accent-color: #818cf8;",
  },
  {
    tailwind: "accent-indigo-500",
    css: "accent-color: #6366f1;",
  },
  {
    tailwind: "accent-indigo-600",
    css: "accent-color: #4f46e5;",
  },
  {
    tailwind: "accent-indigo-700",
    css: "accent-color: #4338ca;",
  },
  {
    tailwind: "accent-indigo-800",
    css: "accent-color: #3730a3;",
  },
  {
    tailwind: "accent-indigo-900",
    css: "accent-color: #312e81;",
  },
  {
    tailwind: "accent-indigo-950",
    css: "accent-color: #1e1b4b;",
  },
  {
    tailwind: "accent-violet-50",
    css: "accent-color: #f5f3ff;",
  },
  {
    tailwind: "accent-violet-100",
    css: "accent-color: #ede9fe;",
  },
  {
    tailwind: "accent-violet-200",
    css: "accent-color: #ddd6fe;",
  },
  {
    tailwind: "accent-violet-300",
    css: "accent-color: #c4b5fd;",
  },
  {
    tailwind: "accent-violet-400",
    css: "accent-color: #a78bfa;",
  },
  {
    tailwind: "accent-violet-500",
    css: "accent-color: #8b5cf6;",
  },
  {
    tailwind: "accent-violet-600",
    css: "accent-color: #7c3aed;",
  },
  {
    tailwind: "accent-violet-700",
    css: "accent-color: #6d28d9;",
  },
  {
    tailwind: "accent-violet-800",
    css: "accent-color: #5b21b6;",
  },
  {
    tailwind: "accent-violet-900",
    css: "accent-color: #4c1d95;",
  },
  {
    tailwind: "accent-violet-950",
    css: "accent-color: #2e1065;",
  },
  {
    tailwind: "accent-purple-50",
    css: "accent-color: #faf5ff;",
  },
  {
    tailwind: "accent-purple-100",
    css: "accent-color: #f3e8ff;",
  },
  {
    tailwind: "accent-purple-200",
    css: "accent-color: #e9d5ff;",
  },
  {
    tailwind: "accent-purple-300",
    css: "accent-color: #d8b4fe;",
  },
  {
    tailwind: "accent-purple-400",
    css: "accent-color: #c084fc;",
  },
  {
    tailwind: "accent-purple-500",
    css: "accent-color: #a855f7;",
  },
  {
    tailwind: "accent-purple-600",
    css: "accent-color: #9333ea;",
  },
  {
    tailwind: "accent-purple-700",
    css: "accent-color: #7e22ce;",
  },
  {
    tailwind: "accent-purple-800",
    css: "accent-color: #6b21a8;",
  },
  {
    tailwind: "accent-purple-900",
    css: "accent-color: #581c87;",
  },
  {
    tailwind: "accent-purple-950",
    css: "accent-color: #3b0764;",
  },
  {
    tailwind: "accent-fuchsia-50",
    css: "accent-color: #fdf4ff;",
  },
  {
    tailwind: "accent-fuchsia-100",
    css: "accent-color: #fae8ff;",
  },
  {
    tailwind: "accent-fuchsia-200",
    css: "accent-color: #f5d0fe;",
  },
  {
    tailwind: "accent-fuchsia-300",
    css: "accent-color: #f0abfc;",
  },
  {
    tailwind: "accent-fuchsia-400",
    css: "accent-color: #e879f9;",
  },
  {
    tailwind: "accent-fuchsia-500",
    css: "accent-color: #d946ef;",
  },
  {
    tailwind: "accent-fuchsia-600",
    css: "accent-color: #c026d3;",
  },
  {
    tailwind: "accent-fuchsia-700",
    css: "accent-color: #a21caf;",
  },
  {
    tailwind: "accent-fuchsia-800",
    css: "accent-color: #86198f;",
  },
  {
    tailwind: "accent-fuchsia-900",
    css: "accent-color: #701a75;",
  },
  {
    tailwind: "accent-fuchsia-950",
    css: "accent-color: #4a044e;",
  },
  {
    tailwind: "accent-pink-50",
    css: "accent-color: #fdf2f8;",
  },
  {
    tailwind: "accent-pink-100",
    css: "accent-color: #fce7f3;",
  },
  {
    tailwind: "accent-pink-200",
    css: "accent-color: #fbcfe8;",
  },
  {
    tailwind: "accent-pink-300",
    css: "accent-color: #f9a8d4;",
  },
  {
    tailwind: "accent-pink-400",
    css: "accent-color: #f472b6;",
  },
  {
    tailwind: "accent-pink-500",
    css: "accent-color: #ec4899;",
  },
  {
    tailwind: "accent-pink-600",
    css: "accent-color: #db2777;",
  },
  {
    tailwind: "accent-pink-700",
    css: "accent-color: #be185d;",
  },
  {
    tailwind: "accent-pink-800",
    css: "accent-color: #9d174d;",
  },
  {
    tailwind: "accent-pink-900",
    css: "accent-color: #831843;",
  },
  {
    tailwind: "accent-pink-950",
    css: "accent-color: #500724;",
  },
  {
    tailwind: "accent-rose-50",
    css: "accent-color: #fff1f2;",
  },
  {
    tailwind: "accent-rose-100",
    css: "accent-color: #ffe4e6;",
  },
  {
    tailwind: "accent-rose-200",
    css: "accent-color: #fecdd3;",
  },
  {
    tailwind: "accent-rose-300",
    css: "accent-color: #fda4af;",
  },
  {
    tailwind: "accent-rose-400",
    css: "accent-color: #fb7185;",
  },
  {
    tailwind: "accent-rose-500",
    css: "accent-color: #f43f5e;",
  },
  {
    tailwind: "accent-rose-600",
    css: "accent-color: #e11d48;",
  },
  {
    tailwind: "accent-rose-700",
    css: "accent-color: #be123c;",
  },
  {
    tailwind: "accent-rose-800",
    css: "accent-color: #9f1239;",
  },
  {
    tailwind: "accent-rose-900",
    css: "accent-color: #881337;",
  },
  {
    tailwind: "accent-rose-950",
    css: "accent-color: #4c0519;",
  },
  {
    tailwind: "accent-auto",
    css: "accent-color: auto;",
  },
  {
    tailwind: "appearance-none",
    css: "appearance: none;",
  },
  {
    tailwind: "cursor-auto",
    css: "cursor: auto;",
  },
  {
    tailwind: "cursor-default",
    css: "cursor: default;",
  },
  {
    tailwind: "cursor-pointer",
    css: "cursor: pointer;",
  },
  {
    tailwind: "cursor-wait",
    css: "cursor: wait;",
  },
  {
    tailwind: "cursor-text",
    css: "cursor: text;",
  },
  {
    tailwind: "cursor-move",
    css: "cursor: move;",
  },
  {
    tailwind: "cursor-help",
    css: "cursor: help;",
  },
  {
    tailwind: "cursor-not-allowed",
    css: "cursor: not-allowed;",
  },
  {
    tailwind: "cursor-none",
    css: "cursor: none;",
  },
  {
    tailwind: "cursor-context-menu",
    css: "cursor: context-menu;",
  },
  {
    tailwind: "cursor-progress",
    css: "cursor: progress;",
  },
  {
    tailwind: "cursor-cell",
    css: "cursor: cell;",
  },
  {
    tailwind: "cursor-crosshair",
    css: "cursor: crosshair;",
  },
  {
    tailwind: "cursor-vertical-text",
    css: "cursor: vertical-text;",
  },
  {
    tailwind: "cursor-alias",
    css: "cursor: alias;",
  },
  {
    tailwind: "cursor-copy",
    css: "cursor: copy;",
  },
  {
    tailwind: "cursor-no-drop",
    css: "cursor: no-drop;",
  },
  {
    tailwind: "cursor-grab",
    css: "cursor: grab;",
  },
  {
    tailwind: "cursor-grabbing",
    css: "cursor: grabbing;",
  },
  {
    tailwind: "cursor-all-scroll",
    css: "cursor: all-scroll;",
  },
  {
    tailwind: "cursor-col-resize",
    css: "cursor: col-resize;",
  },
  {
    tailwind: "cursor-row-resize",
    css: "cursor: row-resize;",
  },
  {
    tailwind: "cursor-n-resize",
    css: "cursor: n-resize;",
  },
  {
    tailwind: "cursor-e-resize",
    css: "cursor: e-resize;",
  },
  {
    tailwind: "cursor-s-resize",
    css: "cursor: s-resize;",
  },
  {
    tailwind: "cursor-w-resize",
    css: "cursor: w-resize;",
  },
  {
    tailwind: "cursor-ne-resize",
    css: "cursor: ne-resize;",
  },
  {
    tailwind: "cursor-nw-resize",
    css: "cursor: nw-resize;",
  },
  {
    tailwind: "cursor-se-resize",
    css: "cursor: se-resize;",
  },
  {
    tailwind: "cursor-sw-resize",
    css: "cursor: sw-resize;",
  },
  {
    tailwind: "cursor-ew-resize",
    css: "cursor: ew-resize;",
  },
  {
    tailwind: "cursor-ns-resize",
    css: "cursor: ns-resize;",
  },
  {
    tailwind: "cursor-nesw-resize",
    css: "cursor: nesw-resize;",
  },
  {
    tailwind: "cursor-nwse-resize",
    css: "cursor: nwse-resize;",
  },
  {
    tailwind: "cursor-zoom-in",
    css: "cursor: zoom-in;",
  },
  {
    tailwind: "cursor-zoom-out",
    css: "cursor: zoom-out;",
  },
  {
    tailwind: "caret-inherit",
    css: "caret-color: inherit;",
  },
  {
    tailwind: "caret-current",
    css: "caret-color: currentColor;",
  },
  {
    tailwind: "caret-transparent",
    css: "caret-color: transparent;",
  },
  {
    tailwind: "caret-black",
    css: "caret-color: #000;",
  },
  {
    tailwind: "caret-white",
    css: "caret-color: #fff;",
  },
  {
    tailwind: "caret-slate-50",
    css: "caret-color: #f8fafc;",
  },
  {
    tailwind: "caret-slate-100",
    css: "caret-color: #f1f5f9;",
  },
  {
    tailwind: "caret-slate-200",
    css: "caret-color: #e2e8f0;",
  },
  {
    tailwind: "caret-slate-300",
    css: "caret-color: #cbd5e1;",
  },
  {
    tailwind: "caret-slate-400",
    css: "caret-color: #94a3b8;",
  },
  {
    tailwind: "caret-slate-500",
    css: "caret-color: #64748b;",
  },
  {
    tailwind: "caret-slate-600",
    css: "caret-color: #475569;",
  },
  {
    tailwind: "caret-slate-700",
    css: "caret-color: #334155;",
  },
  {
    tailwind: "caret-slate-800",
    css: "caret-color: #1e293b;",
  },
  {
    tailwind: "caret-slate-900",
    css: "caret-color: #0f172a;",
  },
  {
    tailwind: "caret-slate-950",
    css: "caret-color: #020617;",
  },
  {
    tailwind: "caret-gray-50",
    css: "caret-color: #f9fafb;",
  },
  {
    tailwind: "caret-gray-100",
    css: "caret-color: #f3f4f6;",
  },
  {
    tailwind: "caret-gray-200",
    css: "caret-color: #e5e7eb;",
  },
  {
    tailwind: "caret-gray-300",
    css: "caret-color: #d1d5db;",
  },
  {
    tailwind: "caret-gray-400",
    css: "caret-color: #9ca3af;",
  },
  {
    tailwind: "caret-gray-500",
    css: "caret-color: #6b7280;",
  },
  {
    tailwind: "caret-gray-600",
    css: "caret-color: #4b5563;",
  },
  {
    tailwind: "caret-gray-700",
    css: "caret-color: #374151;",
  },
  {
    tailwind: "caret-gray-800",
    css: "caret-color: #1f2937;",
  },
  {
    tailwind: "caret-gray-900",
    css: "caret-color: #111827;",
  },
  {
    tailwind: "caret-gray-950",
    css: "caret-color: #030712;",
  },
  {
    tailwind: "caret-zinc-50",
    css: "caret-color: #fafafa;",
  },
  {
    tailwind: "caret-zinc-100",
    css: "caret-color: #f4f4f5;",
  },
  {
    tailwind: "caret-zinc-200",
    css: "caret-color: #e4e4e7;",
  },
  {
    tailwind: "caret-zinc-300",
    css: "caret-color: #d4d4d8;",
  },
  {
    tailwind: "caret-zinc-400",
    css: "caret-color: #a1a1aa;",
  },
  {
    tailwind: "caret-zinc-500",
    css: "caret-color: #71717a;",
  },
  {
    tailwind: "caret-zinc-600",
    css: "caret-color: #52525b;",
  },
  {
    tailwind: "caret-zinc-700",
    css: "caret-color: #3f3f46;",
  },
  {
    tailwind: "caret-zinc-800",
    css: "caret-color: #27272a;",
  },
  {
    tailwind: "caret-zinc-900",
    css: "caret-color: #18181b;",
  },
  {
    tailwind: "caret-zinc-950",
    css: "caret-color: #09090b;",
  },
  {
    tailwind: "caret-neutral-50",
    css: "caret-color: #fafafa;",
  },
  {
    tailwind: "caret-neutral-100",
    css: "caret-color: #f5f5f5;",
  },
  {
    tailwind: "caret-neutral-200",
    css: "caret-color: #e5e5e5;",
  },
  {
    tailwind: "caret-neutral-300",
    css: "caret-color: #d4d4d4;",
  },
  {
    tailwind: "caret-neutral-400",
    css: "caret-color: #a3a3a3;",
  },
  {
    tailwind: "caret-neutral-500",
    css: "caret-color: #737373;",
  },
  {
    tailwind: "caret-neutral-600",
    css: "caret-color: #525252;",
  },
  {
    tailwind: "caret-neutral-700",
    css: "caret-color: #404040;",
  },
  {
    tailwind: "caret-neutral-800",
    css: "caret-color: #262626;",
  },
  {
    tailwind: "caret-neutral-900",
    css: "caret-color: #171717;",
  },
  {
    tailwind: "caret-neutral-950",
    css: "caret-color: #0a0a0a;",
  },
  {
    tailwind: "caret-stone-50",
    css: "caret-color: #fafaf9;",
  },
  {
    tailwind: "caret-stone-100",
    css: "caret-color: #f5f5f4;",
  },
  {
    tailwind: "caret-stone-200",
    css: "caret-color: #e7e5e4;",
  },
  {
    tailwind: "caret-stone-300",
    css: "caret-color: #d6d3d1;",
  },
  {
    tailwind: "caret-stone-400",
    css: "caret-color: #a8a29e;",
  },
  {
    tailwind: "caret-stone-500",
    css: "caret-color: #78716c;",
  },
  {
    tailwind: "caret-stone-600",
    css: "caret-color: #57534e;",
  },
  {
    tailwind: "caret-stone-700",
    css: "caret-color: #44403c;",
  },
  {
    tailwind: "caret-stone-800",
    css: "caret-color: #292524;",
  },
  {
    tailwind: "caret-stone-900",
    css: "caret-color: #1c1917;",
  },
  {
    tailwind: "caret-stone-950",
    css: "caret-color: #0c0a09;",
  },
  {
    tailwind: "caret-red-50",
    css: "caret-color: #fef2f2;",
  },
  {
    tailwind: "caret-red-100",
    css: "caret-color: #fee2e2;",
  },
  {
    tailwind: "caret-red-200",
    css: "caret-color: #fecaca;",
  },
  {
    tailwind: "caret-red-300",
    css: "caret-color: #fca5a5;",
  },
  {
    tailwind: "caret-red-400",
    css: "caret-color: #f87171;",
  },
  {
    tailwind: "caret-red-500",
    css: "caret-color: #ef4444;",
  },
  {
    tailwind: "caret-red-600",
    css: "caret-color: #dc2626;",
  },
  {
    tailwind: "caret-red-700",
    css: "caret-color: #b91c1c;",
  },
  {
    tailwind: "caret-red-800",
    css: "caret-color: #991b1b;",
  },
  {
    tailwind: "caret-red-900",
    css: "caret-color: #7f1d1d;",
  },
  {
    tailwind: "caret-red-950",
    css: "caret-color: #450a0a;",
  },
  {
    tailwind: "caret-orange-50",
    css: "caret-color: #fff7ed;",
  },
  {
    tailwind: "caret-orange-100",
    css: "caret-color: #ffedd5;",
  },
  {
    tailwind: "caret-orange-200",
    css: "caret-color: #fed7aa;",
  },
  {
    tailwind: "caret-orange-300",
    css: "caret-color: #fdba74;",
  },
  {
    tailwind: "caret-orange-400",
    css: "caret-color: #fb923c;",
  },
  {
    tailwind: "caret-orange-500",
    css: "caret-color: #f97316;",
  },
  {
    tailwind: "caret-orange-600",
    css: "caret-color: #ea580c;",
  },
  {
    tailwind: "caret-orange-700",
    css: "caret-color: #c2410c;",
  },
  {
    tailwind: "caret-orange-800",
    css: "caret-color: #9a3412;",
  },
  {
    tailwind: "caret-orange-900",
    css: "caret-color: #7c2d12;",
  },
  {
    tailwind: "caret-orange-950",
    css: "caret-color: #431407;",
  },
  {
    tailwind: "caret-amber-50",
    css: "caret-color: #fffbeb;",
  },
  {
    tailwind: "caret-amber-100",
    css: "caret-color: #fef3c7;",
  },
  {
    tailwind: "caret-amber-200",
    css: "caret-color: #fde68a;",
  },
  {
    tailwind: "caret-amber-300",
    css: "caret-color: #fcd34d;",
  },
  {
    tailwind: "caret-amber-400",
    css: "caret-color: #fbbf24;",
  },
  {
    tailwind: "caret-amber-500",
    css: "caret-color: #f59e0b;",
  },
  {
    tailwind: "caret-amber-600",
    css: "caret-color: #d97706;",
  },
  {
    tailwind: "caret-amber-700",
    css: "caret-color: #b45309;",
  },
  {
    tailwind: "caret-amber-800",
    css: "caret-color: #92400e;",
  },
  {
    tailwind: "caret-amber-900",
    css: "caret-color: #78350f;",
  },
  {
    tailwind: "caret-amber-950",
    css: "caret-color: #451a03;",
  },
  {
    tailwind: "caret-yellow-50",
    css: "caret-color: #fefce8;",
  },
  {
    tailwind: "caret-yellow-100",
    css: "caret-color: #fef9c3;",
  },
  {
    tailwind: "caret-yellow-200",
    css: "caret-color: #fef08a;",
  },
  {
    tailwind: "caret-yellow-300",
    css: "caret-color: #fde047;",
  },
  {
    tailwind: "caret-yellow-400",
    css: "caret-color: #facc15;",
  },
  {
    tailwind: "caret-yellow-500",
    css: "caret-color: #eab308;",
  },
  {
    tailwind: "caret-yellow-600",
    css: "caret-color: #ca8a04;",
  },
  {
    tailwind: "caret-yellow-700",
    css: "caret-color: #a16207;",
  },
  {
    tailwind: "caret-yellow-800",
    css: "caret-color: #854d0e;",
  },
  {
    tailwind: "caret-yellow-900",
    css: "caret-color: #713f12;",
  },
  {
    tailwind: "caret-yellow-950",
    css: "caret-color: #422006;",
  },
  {
    tailwind: "caret-lime-50",
    css: "caret-color: #f7fee7;",
  },
  {
    tailwind: "caret-lime-100",
    css: "caret-color: #ecfccb;",
  },
  {
    tailwind: "caret-lime-200",
    css: "caret-color: #d9f99d;",
  },
  {
    tailwind: "caret-lime-300",
    css: "caret-color: #bef264;",
  },
  {
    tailwind: "caret-lime-400",
    css: "caret-color: #a3e635;",
  },
  {
    tailwind: "caret-lime-500",
    css: "caret-color: #84cc16;",
  },
  {
    tailwind: "caret-lime-600",
    css: "caret-color: #65a30d;",
  },
  {
    tailwind: "caret-lime-700",
    css: "caret-color: #4d7c0f;",
  },
  {
    tailwind: "caret-lime-800",
    css: "caret-color: #3f6212;",
  },
  {
    tailwind: "caret-lime-900",
    css: "caret-color: #365314;",
  },
  {
    tailwind: "caret-lime-950",
    css: "caret-color: #1a2e05;",
  },
  {
    tailwind: "caret-green-50",
    css: "caret-color: #f0fdf4;",
  },
  {
    tailwind: "caret-green-100",
    css: "caret-color: #dcfce7;",
  },
  {
    tailwind: "caret-green-200",
    css: "caret-color: #bbf7d0;",
  },
  {
    tailwind: "caret-green-300",
    css: "caret-color: #86efac;",
  },
  {
    tailwind: "caret-green-400",
    css: "caret-color: #4ade80;",
  },
  {
    tailwind: "caret-green-500",
    css: "caret-color: #22c55e;",
  },
  {
    tailwind: "caret-green-600",
    css: "caret-color: #16a34a;",
  },
  {
    tailwind: "caret-green-700",
    css: "caret-color: #15803d;",
  },
  {
    tailwind: "caret-green-800",
    css: "caret-color: #166534;",
  },
  {
    tailwind: "caret-green-900",
    css: "caret-color: #14532d;",
  },
  {
    tailwind: "caret-green-950",
    css: "caret-color: #052e16;",
  },
  {
    tailwind: "caret-emerald-50",
    css: "caret-color: #ecfdf5;",
  },
  {
    tailwind: "caret-emerald-100",
    css: "caret-color: #d1fae5;",
  },
  {
    tailwind: "caret-emerald-200",
    css: "caret-color: #a7f3d0;",
  },
  {
    tailwind: "caret-emerald-300",
    css: "caret-color: #6ee7b7;",
  },
  {
    tailwind: "caret-emerald-400",
    css: "caret-color: #34d399;",
  },
  {
    tailwind: "caret-emerald-500",
    css: "caret-color: #10b981;",
  },
  {
    tailwind: "caret-emerald-600",
    css: "caret-color: #059669;",
  },
  {
    tailwind: "caret-emerald-700",
    css: "caret-color: #047857;",
  },
  {
    tailwind: "caret-emerald-800",
    css: "caret-color: #065f46;",
  },
  {
    tailwind: "caret-emerald-900",
    css: "caret-color: #064e3b;",
  },
  {
    tailwind: "caret-emerald-950",
    css: "caret-color: #022c22;",
  },
  {
    tailwind: "caret-teal-50",
    css: "caret-color: #f0fdfa;",
  },
  {
    tailwind: "caret-teal-100",
    css: "caret-color: #ccfbf1;",
  },
  {
    tailwind: "caret-teal-200",
    css: "caret-color: #99f6e4;",
  },
  {
    tailwind: "caret-teal-300",
    css: "caret-color: #5eead4;",
  },
  {
    tailwind: "caret-teal-400",
    css: "caret-color: #2dd4bf;",
  },
  {
    tailwind: "caret-teal-500",
    css: "caret-color: #14b8a6;",
  },
  {
    tailwind: "caret-teal-600",
    css: "caret-color: #0d9488;",
  },
  {
    tailwind: "caret-teal-700",
    css: "caret-color: #0f766e;",
  },
  {
    tailwind: "caret-teal-800",
    css: "caret-color: #115e59;",
  },
  {
    tailwind: "caret-teal-900",
    css: "caret-color: #134e4a;",
  },
  {
    tailwind: "caret-teal-950",
    css: "caret-color: #042f2e;",
  },
  {
    tailwind: "caret-cyan-50",
    css: "caret-color: #ecfeff;",
  },
  {
    tailwind: "caret-cyan-100",
    css: "caret-color: #cffafe;",
  },
  {
    tailwind: "caret-cyan-200",
    css: "caret-color: #a5f3fc;",
  },
  {
    tailwind: "caret-cyan-300",
    css: "caret-color: #67e8f9;",
  },
  {
    tailwind: "caret-cyan-400",
    css: "caret-color: #22d3ee;",
  },
  {
    tailwind: "caret-cyan-500",
    css: "caret-color: #06b6d4;",
  },
  {
    tailwind: "caret-cyan-600",
    css: "caret-color: #0891b2;",
  },
  {
    tailwind: "caret-cyan-700",
    css: "caret-color: #0e7490;",
  },
  {
    tailwind: "caret-cyan-800",
    css: "caret-color: #155e75;",
  },
  {
    tailwind: "caret-cyan-900",
    css: "caret-color: #164e63;",
  },
  {
    tailwind: "caret-cyan-950",
    css: "caret-color: #083344;",
  },
  {
    tailwind: "caret-sky-50",
    css: "caret-color: #f0f9ff;",
  },
  {
    tailwind: "caret-sky-100",
    css: "caret-color: #e0f2fe;",
  },
  {
    tailwind: "caret-sky-200",
    css: "caret-color: #bae6fd;",
  },
  {
    tailwind: "caret-sky-300",
    css: "caret-color: #7dd3fc;",
  },
  {
    tailwind: "caret-sky-400",
    css: "caret-color: #38bdf8;",
  },
  {
    tailwind: "caret-sky-500",
    css: "caret-color: #0ea5e9;",
  },
  {
    tailwind: "caret-sky-600",
    css: "caret-color: #0284c7;",
  },
  {
    tailwind: "caret-sky-700",
    css: "caret-color: #0369a1;",
  },
  {
    tailwind: "caret-sky-800",
    css: "caret-color: #075985;",
  },
  {
    tailwind: "caret-sky-900",
    css: "caret-color: #0c4a6e;",
  },
  {
    tailwind: "caret-sky-950",
    css: "caret-color: #082f49;",
  },
  {
    tailwind: "caret-blue-50",
    css: "caret-color: #eff6ff;",
  },
  {
    tailwind: "caret-blue-100",
    css: "caret-color: #dbeafe;",
  },
  {
    tailwind: "caret-blue-200",
    css: "caret-color: #bfdbfe;",
  },
  {
    tailwind: "caret-blue-300",
    css: "caret-color: #93c5fd;",
  },
  {
    tailwind: "caret-blue-400",
    css: "caret-color: #60a5fa;",
  },
  {
    tailwind: "caret-blue-500",
    css: "caret-color: #3b82f6;",
  },
  {
    tailwind: "caret-blue-600",
    css: "caret-color: #2563eb;",
  },
  {
    tailwind: "caret-blue-700",
    css: "caret-color: #1d4ed8;",
  },
  {
    tailwind: "caret-blue-800",
    css: "caret-color: #1e40af;",
  },
  {
    tailwind: "caret-blue-900",
    css: "caret-color: #1e3a8a;",
  },
  {
    tailwind: "caret-blue-950",
    css: "caret-color: #172554;",
  },
  {
    tailwind: "caret-indigo-50",
    css: "caret-color: #eef2ff;",
  },
  {
    tailwind: "caret-indigo-100",
    css: "caret-color: #e0e7ff;",
  },
  {
    tailwind: "caret-indigo-200",
    css: "caret-color: #c7d2fe;",
  },
  {
    tailwind: "caret-indigo-300",
    css: "caret-color: #a5b4fc;",
  },
  {
    tailwind: "caret-indigo-400",
    css: "caret-color: #818cf8;",
  },
  {
    tailwind: "caret-indigo-500",
    css: "caret-color: #6366f1;",
  },
  {
    tailwind: "caret-indigo-600",
    css: "caret-color: #4f46e5;",
  },
  {
    tailwind: "caret-indigo-700",
    css: "caret-color: #4338ca;",
  },
  {
    tailwind: "caret-indigo-800",
    css: "caret-color: #3730a3;",
  },
  {
    tailwind: "caret-indigo-900",
    css: "caret-color: #312e81;",
  },
  {
    tailwind: "caret-indigo-950",
    css: "caret-color: #1e1b4b;",
  },
  {
    tailwind: "caret-violet-50",
    css: "caret-color: #f5f3ff;",
  },
  {
    tailwind: "caret-violet-100",
    css: "caret-color: #ede9fe;",
  },
  {
    tailwind: "caret-violet-200",
    css: "caret-color: #ddd6fe;",
  },
  {
    tailwind: "caret-violet-300",
    css: "caret-color: #c4b5fd;",
  },
  {
    tailwind: "caret-violet-400",
    css: "caret-color: #a78bfa;",
  },
  {
    tailwind: "caret-violet-500",
    css: "caret-color: #8b5cf6;",
  },
  {
    tailwind: "caret-violet-600",
    css: "caret-color: #7c3aed;",
  },
  {
    tailwind: "caret-violet-700",
    css: "caret-color: #6d28d9;",
  },
  {
    tailwind: "caret-violet-800",
    css: "caret-color: #5b21b6;",
  },
  {
    tailwind: "caret-violet-900",
    css: "caret-color: #4c1d95;",
  },
  {
    tailwind: "caret-violet-950",
    css: "caret-color: #2e1065;",
  },
  {
    tailwind: "caret-purple-50",
    css: "caret-color: #faf5ff;",
  },
  {
    tailwind: "caret-purple-100",
    css: "caret-color: #f3e8ff;",
  },
  {
    tailwind: "caret-purple-200",
    css: "caret-color: #e9d5ff;",
  },
  {
    tailwind: "caret-purple-300",
    css: "caret-color: #d8b4fe;",
  },
  {
    tailwind: "caret-purple-400",
    css: "caret-color: #c084fc;",
  },
  {
    tailwind: "caret-purple-500",
    css: "caret-color: #a855f7;",
  },
  {
    tailwind: "caret-purple-600",
    css: "caret-color: #9333ea;",
  },
  {
    tailwind: "caret-purple-700",
    css: "caret-color: #7e22ce;",
  },
  {
    tailwind: "caret-purple-800",
    css: "caret-color: #6b21a8;",
  },
  {
    tailwind: "caret-purple-900",
    css: "caret-color: #581c87;",
  },
  {
    tailwind: "caret-purple-950",
    css: "caret-color: #3b0764;",
  },
  {
    tailwind: "caret-fuchsia-50",
    css: "caret-color: #fdf4ff;",
  },
  {
    tailwind: "caret-fuchsia-100",
    css: "caret-color: #fae8ff;",
  },
  {
    tailwind: "caret-fuchsia-200",
    css: "caret-color: #f5d0fe;",
  },
  {
    tailwind: "caret-fuchsia-300",
    css: "caret-color: #f0abfc;",
  },
  {
    tailwind: "caret-fuchsia-400",
    css: "caret-color: #e879f9;",
  },
  {
    tailwind: "caret-fuchsia-500",
    css: "caret-color: #d946ef;",
  },
  {
    tailwind: "caret-fuchsia-600",
    css: "caret-color: #c026d3;",
  },
  {
    tailwind: "caret-fuchsia-700",
    css: "caret-color: #a21caf;",
  },
  {
    tailwind: "caret-fuchsia-800",
    css: "caret-color: #86198f;",
  },
  {
    tailwind: "caret-fuchsia-900",
    css: "caret-color: #701a75;",
  },
  {
    tailwind: "caret-fuchsia-950",
    css: "caret-color: #4a044e;",
  },
  {
    tailwind: "caret-pink-50",
    css: "caret-color: #fdf2f8;",
  },
  {
    tailwind: "caret-pink-100",
    css: "caret-color: #fce7f3;",
  },
  {
    tailwind: "caret-pink-200",
    css: "caret-color: #fbcfe8;",
  },
  {
    tailwind: "caret-pink-300",
    css: "caret-color: #f9a8d4;",
  },
  {
    tailwind: "caret-pink-400",
    css: "caret-color: #f472b6;",
  },
  {
    tailwind: "caret-pink-500",
    css: "caret-color: #ec4899;",
  },
  {
    tailwind: "caret-pink-600",
    css: "caret-color: #db2777;",
  },
  {
    tailwind: "caret-pink-700",
    css: "caret-color: #be185d;",
  },
  {
    tailwind: "caret-pink-800",
    css: "caret-color: #9d174d;",
  },
  {
    tailwind: "caret-pink-900",
    css: "caret-color: #831843;",
  },
  {
    tailwind: "caret-pink-950",
    css: "caret-color: #500724;",
  },
  {
    tailwind: "caret-rose-50",
    css: "caret-color: #fff1f2;",
  },
  {
    tailwind: "caret-rose-100",
    css: "caret-color: #ffe4e6;",
  },
  {
    tailwind: "caret-rose-200",
    css: "caret-color: #fecdd3;",
  },
  {
    tailwind: "caret-rose-300",
    css: "caret-color: #fda4af;",
  },
  {
    tailwind: "caret-rose-400",
    css: "caret-color: #fb7185;",
  },
  {
    tailwind: "caret-rose-500",
    css: "caret-color: #f43f5e;",
  },
  {
    tailwind: "caret-rose-600",
    css: "caret-color: #e11d48;",
  },
  {
    tailwind: "caret-rose-700",
    css: "caret-color: #be123c;",
  },
  {
    tailwind: "caret-rose-800",
    css: "caret-color: #9f1239;",
  },
  {
    tailwind: "caret-rose-900",
    css: "caret-color: #881337;",
  },
  {
    tailwind: "caret-rose-950",
    css: "caret-color: #4c0519;",
  },
  {
    tailwind: "pointer-events-none",
    css: "pointer-events: none;",
  },
  {
    tailwind: "pointer-events-auto",
    css: "pointer-events: auto;",
  },
  {
    tailwind: "resize-none",
    css: "resize: none;",
  },
  {
    tailwind: "resize-y",
    css: "resize: vertical;",
  },
  {
    tailwind: "resize-x",
    css: "resize: horizontal;",
  },
  {
    tailwind: "resize",
    css: "resize: both;",
  },
  {
    tailwind: "scroll-auto",
    css: "scroll-behavior: auto;",
  },
  {
    tailwind: "scroll-smooth",
    css: "scroll-behavior: smooth;",
  },
  {
    tailwind: "scroll-m-0",
    css: "scroll-margin: 0px;",
  },
  {
    tailwind: "scroll-mx-0",
    css: "scroll-margin-left: 0px;\nscroll-margin-right: 0px;",
  },
  {
    tailwind: "scroll-my-0",
    css: "scroll-margin-top: 0px;\nscroll-margin-bottom: 0px;",
  },
  {
    tailwind: "scroll-ms-0",
    css: "scroll-margin-inline-start: 0px;",
  },
  {
    tailwind: "scroll-me-0",
    css: "scroll-margin-inline-end: 0px;",
  },
  {
    tailwind: "scroll-mt-0",
    css: "scroll-margin-top: 0px;",
  },
  {
    tailwind: "scroll-mr-0",
    css: "scroll-margin-right: 0px;",
  },
  {
    tailwind: "scroll-mb-0",
    css: "scroll-margin-bottom: 0px;",
  },
  {
    tailwind: "scroll-ml-0",
    css: "scroll-margin-left: 0px;",
  },
  {
    tailwind: "scroll-m-px",
    css: "scroll-margin: 1px;",
  },
  {
    tailwind: "scroll-mx-px",
    css: "scroll-margin-left: 1px;\nscroll-margin-right: 1px;",
  },
  {
    tailwind: "scroll-my-px",
    css: "scroll-margin-top: 1px;\nscroll-margin-bottom: 1px;",
  },
  {
    tailwind: "scroll-ms-px",
    css: "scroll-margin-inline-start: 1px;",
  },
  {
    tailwind: "scroll-me-px",
    css: "scroll-margin-inline-end: 1px;",
  },
  {
    tailwind: "scroll-mt-px",
    css: "scroll-margin-top: 1px;",
  },
  {
    tailwind: "scroll-mr-px",
    css: "scroll-margin-right: 1px;",
  },
  {
    tailwind: "scroll-mb-px",
    css: "scroll-margin-bottom: 1px;",
  },
  {
    tailwind: "scroll-ml-px",
    css: "scroll-margin-left: 1px;",
  },
  {
    tailwind: "scroll-m-0.5",
    css: "scroll-margin: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-mx-0.5",
    css: "scroll-margin-left: 0.125rem; /* 2px */\nscroll-margin-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-my-0.5",
    css: "scroll-margin-top: 0.125rem; /* 2px */\nscroll-margin-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-ms-0.5",
    css: "scroll-margin-inline-start: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-me-0.5",
    css: "scroll-margin-inline-end: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-mt-0.5",
    css: "scroll-margin-top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-mr-0.5",
    css: "scroll-margin-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-mb-0.5",
    css: "scroll-margin-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-ml-0.5",
    css: "scroll-margin-left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-m-1",
    css: "scroll-margin: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-mx-1",
    css: "scroll-margin-left: 0.25rem; /* 4px */\nscroll-margin-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-my-1",
    css: "scroll-margin-top: 0.25rem; /* 4px */\nscroll-margin-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-ms-1",
    css: "scroll-margin-inline-start: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-me-1",
    css: "scroll-margin-inline-end: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-mt-1",
    css: "scroll-margin-top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-mr-1",
    css: "scroll-margin-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-mb-1",
    css: "scroll-margin-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-ml-1",
    css: "scroll-margin-left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-m-1.5",
    css: "scroll-margin: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-mx-1.5",
    css: "scroll-margin-left: 0.375rem; /* 6px */\nscroll-margin-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-my-1.5",
    css: "scroll-margin-top: 0.375rem; /* 6px */\nscroll-margin-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-ms-1.5",
    css: "scroll-margin-inline-start: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-me-1.5",
    css: "scroll-margin-inline-end: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-mt-1.5",
    css: "scroll-margin-top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-mr-1.5",
    css: "scroll-margin-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-mb-1.5",
    css: "scroll-margin-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-ml-1.5",
    css: "scroll-margin-left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-m-2",
    css: "scroll-margin: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-mx-2",
    css: "scroll-margin-left: 0.5rem; /* 8px */\nscroll-margin-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-my-2",
    css: "scroll-margin-top: 0.5rem; /* 8px */\nscroll-margin-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-ms-2",
    css: "scroll-margin-inline-start: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-me-2",
    css: "scroll-margin-inline-end: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-mt-2",
    css: "scroll-margin-top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-mr-2",
    css: "scroll-margin-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-mb-2",
    css: "scroll-margin-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-ml-2",
    css: "scroll-margin-left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-m-2.5",
    css: "scroll-margin: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-mx-2.5",
    css: "scroll-margin-left: 0.625rem; /* 10px */\nscroll-margin-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-my-2.5",
    css: "scroll-margin-top: 0.625rem; /* 10px */\nscroll-margin-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-ms-2.5",
    css: "scroll-margin-inline-start: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-me-2.5",
    css: "scroll-margin-inline-end: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-mt-2.5",
    css: "scroll-margin-top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-mr-2.5",
    css: "scroll-margin-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-mb-2.5",
    css: "scroll-margin-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-ml-2.5",
    css: "scroll-margin-left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-m-3",
    css: "scroll-margin: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-mx-3",
    css: "scroll-margin-left: 0.75rem; /* 12px */\nscroll-margin-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-my-3",
    css: "scroll-margin-top: 0.75rem; /* 12px */\nscroll-margin-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-ms-3",
    css: "scroll-margin-inline-start: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-me-3",
    css: "scroll-margin-inline-end: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-mt-3",
    css: "scroll-margin-top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-mr-3",
    css: "scroll-margin-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-mb-3",
    css: "scroll-margin-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-ml-3",
    css: "scroll-margin-left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-m-3.5",
    css: "scroll-margin: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-mx-3.5",
    css: "scroll-margin-left: 0.875rem; /* 14px */\nscroll-margin-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-my-3.5",
    css: "scroll-margin-top: 0.875rem; /* 14px */\nscroll-margin-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-ms-3.5",
    css: "scroll-margin-inline-start: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-me-3.5",
    css: "scroll-margin-inline-end: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-mt-3.5",
    css: "scroll-margin-top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-mr-3.5",
    css: "scroll-margin-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-mb-3.5",
    css: "scroll-margin-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-ml-3.5",
    css: "scroll-margin-left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-m-4",
    css: "scroll-margin: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-mx-4",
    css: "scroll-margin-left: 1rem; /* 16px */\nscroll-margin-right: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-my-4",
    css: "scroll-margin-top: 1rem; /* 16px */\nscroll-margin-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-ms-4",
    css: "scroll-margin-inline-start: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-me-4",
    css: "scroll-margin-inline-end: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-mt-4",
    css: "scroll-margin-top: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-mr-4",
    css: "scroll-margin-right: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-mb-4",
    css: "scroll-margin-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-ml-4",
    css: "scroll-margin-left: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-m-5",
    css: "scroll-margin: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-mx-5",
    css: "scroll-margin-left: 1.25rem; /* 20px */\nscroll-margin-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-my-5",
    css: "scroll-margin-top: 1.25rem; /* 20px */\nscroll-margin-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-ms-5",
    css: "scroll-margin-inline-start: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-me-5",
    css: "scroll-margin-inline-end: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-mt-5",
    css: "scroll-margin-top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-mr-5",
    css: "scroll-margin-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-mb-5",
    css: "scroll-margin-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-ml-5",
    css: "scroll-margin-left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-m-6",
    css: "scroll-margin: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-mx-6",
    css: "scroll-margin-left: 1.5rem; /* 24px */\nscroll-margin-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-my-6",
    css: "scroll-margin-top: 1.5rem; /* 24px */\nscroll-margin-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-ms-6",
    css: "scroll-margin-inline-start: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-me-6",
    css: "scroll-margin-inline-end: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-mt-6",
    css: "scroll-margin-top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-mr-6",
    css: "scroll-margin-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-mb-6",
    css: "scroll-margin-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-ml-6",
    css: "scroll-margin-left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-m-7",
    css: "scroll-margin: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-mx-7",
    css: "scroll-margin-left: 1.75rem; /* 28px */\nscroll-margin-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-my-7",
    css: "scroll-margin-top: 1.75rem; /* 28px */\nscroll-margin-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-ms-7",
    css: "scroll-margin-inline-start: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-me-7",
    css: "scroll-margin-inline-end: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-mt-7",
    css: "scroll-margin-top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-mr-7",
    css: "scroll-margin-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-mb-7",
    css: "scroll-margin-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-ml-7",
    css: "scroll-margin-left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-m-8",
    css: "scroll-margin: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-mx-8",
    css: "scroll-margin-left: 2rem; /* 32px */\nscroll-margin-right: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-my-8",
    css: "scroll-margin-top: 2rem; /* 32px */\nscroll-margin-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-ms-8",
    css: "scroll-margin-inline-start: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-me-8",
    css: "scroll-margin-inline-end: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-mt-8",
    css: "scroll-margin-top: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-mr-8",
    css: "scroll-margin-right: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-mb-8",
    css: "scroll-margin-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-ml-8",
    css: "scroll-margin-left: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-m-9",
    css: "scroll-margin: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-mx-9",
    css: "scroll-margin-left: 2.25rem; /* 36px */\nscroll-margin-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-my-9",
    css: "scroll-margin-top: 2.25rem; /* 36px */\nscroll-margin-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-ms-9",
    css: "scroll-margin-inline-start: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-me-9",
    css: "scroll-margin-inline-end: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-mt-9",
    css: "scroll-margin-top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-mr-9",
    css: "scroll-margin-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-mb-9",
    css: "scroll-margin-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-ml-9",
    css: "scroll-margin-left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-m-10",
    css: "scroll-margin: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-mx-10",
    css: "scroll-margin-left: 2.5rem; /* 40px */\nscroll-margin-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-my-10",
    css: "scroll-margin-top: 2.5rem; /* 40px */\nscroll-margin-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-ms-10",
    css: "scroll-margin-inline-start: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-me-10",
    css: "scroll-margin-inline-end: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-mt-10",
    css: "scroll-margin-top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-mr-10",
    css: "scroll-margin-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-mb-10",
    css: "scroll-margin-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-ml-10",
    css: "scroll-margin-left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-m-11",
    css: "scroll-margin: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-mx-11",
    css: "scroll-margin-left: 2.75rem; /* 44px */\nscroll-margin-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-my-11",
    css: "scroll-margin-top: 2.75rem; /* 44px */\nscroll-margin-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-ms-11",
    css: "scroll-margin-inline-start: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-me-11",
    css: "scroll-margin-inline-end: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-mt-11",
    css: "scroll-margin-top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-mr-11",
    css: "scroll-margin-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-mb-11",
    css: "scroll-margin-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-ml-11",
    css: "scroll-margin-left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-m-12",
    css: "scroll-margin: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-mx-12",
    css: "scroll-margin-left: 3rem; /* 48px */\nscroll-margin-right: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-my-12",
    css: "scroll-margin-top: 3rem; /* 48px */\nscroll-margin-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-ms-12",
    css: "scroll-margin-inline-start: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-me-12",
    css: "scroll-margin-inline-end: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-mt-12",
    css: "scroll-margin-top: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-mr-12",
    css: "scroll-margin-right: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-mb-12",
    css: "scroll-margin-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-ml-12",
    css: "scroll-margin-left: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-m-14",
    css: "scroll-margin: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-mx-14",
    css: "scroll-margin-left: 3.5rem; /* 56px */\nscroll-margin-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-my-14",
    css: "scroll-margin-top: 3.5rem; /* 56px */\nscroll-margin-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-ms-14",
    css: "scroll-margin-inline-start: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-me-14",
    css: "scroll-margin-inline-end: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-mt-14",
    css: "scroll-margin-top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-mr-14",
    css: "scroll-margin-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-mb-14",
    css: "scroll-margin-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-ml-14",
    css: "scroll-margin-left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-m-16",
    css: "scroll-margin: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-mx-16",
    css: "scroll-margin-left: 4rem; /* 64px */\nscroll-margin-right: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-my-16",
    css: "scroll-margin-top: 4rem; /* 64px */\nscroll-margin-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-ms-16",
    css: "scroll-margin-inline-start: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-me-16",
    css: "scroll-margin-inline-end: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-mt-16",
    css: "scroll-margin-top: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-mr-16",
    css: "scroll-margin-right: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-mb-16",
    css: "scroll-margin-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-ml-16",
    css: "scroll-margin-left: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-m-20",
    css: "scroll-margin: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-mx-20",
    css: "scroll-margin-left: 5rem; /* 80px */\nscroll-margin-right: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-my-20",
    css: "scroll-margin-top: 5rem; /* 80px */\nscroll-margin-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-ms-20",
    css: "scroll-margin-inline-start: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-me-20",
    css: "scroll-margin-inline-end: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-mt-20",
    css: "scroll-margin-top: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-mr-20",
    css: "scroll-margin-right: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-mb-20",
    css: "scroll-margin-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-ml-20",
    css: "scroll-margin-left: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-m-24",
    css: "scroll-margin: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-mx-24",
    css: "scroll-margin-left: 6rem; /* 96px */\nscroll-margin-right: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-my-24",
    css: "scroll-margin-top: 6rem; /* 96px */\nscroll-margin-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-ms-24",
    css: "scroll-margin-inline-start: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-me-24",
    css: "scroll-margin-inline-end: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-mt-24",
    css: "scroll-margin-top: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-mr-24",
    css: "scroll-margin-right: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-mb-24",
    css: "scroll-margin-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-ml-24",
    css: "scroll-margin-left: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-m-28",
    css: "scroll-margin: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-mx-28",
    css: "scroll-margin-left: 7rem; /* 112px */\nscroll-margin-right: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-my-28",
    css: "scroll-margin-top: 7rem; /* 112px */\nscroll-margin-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-ms-28",
    css: "scroll-margin-inline-start: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-me-28",
    css: "scroll-margin-inline-end: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-mt-28",
    css: "scroll-margin-top: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-mr-28",
    css: "scroll-margin-right: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-mb-28",
    css: "scroll-margin-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-ml-28",
    css: "scroll-margin-left: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-m-32",
    css: "scroll-margin: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-mx-32",
    css: "scroll-margin-left: 8rem; /* 128px */\nscroll-margin-right: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-my-32",
    css: "scroll-margin-top: 8rem; /* 128px */\nscroll-margin-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-ms-32",
    css: "scroll-margin-inline-start: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-me-32",
    css: "scroll-margin-inline-end: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-mt-32",
    css: "scroll-margin-top: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-mr-32",
    css: "scroll-margin-right: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-mb-32",
    css: "scroll-margin-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-ml-32",
    css: "scroll-margin-left: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-m-36",
    css: "scroll-margin: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-mx-36",
    css: "scroll-margin-left: 9rem; /* 144px */\nscroll-margin-right: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-my-36",
    css: "scroll-margin-top: 9rem; /* 144px */\nscroll-margin-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-ms-36",
    css: "scroll-margin-inline-start: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-me-36",
    css: "scroll-margin-inline-end: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-mt-36",
    css: "scroll-margin-top: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-mr-36",
    css: "scroll-margin-right: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-mb-36",
    css: "scroll-margin-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-ml-36",
    css: "scroll-margin-left: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-m-40",
    css: "scroll-margin: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-mx-40",
    css: "scroll-margin-left: 10rem; /* 160px */\nscroll-margin-right: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-my-40",
    css: "scroll-margin-top: 10rem; /* 160px */\nscroll-margin-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-ms-40",
    css: "scroll-margin-inline-start: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-me-40",
    css: "scroll-margin-inline-end: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-mt-40",
    css: "scroll-margin-top: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-mr-40",
    css: "scroll-margin-right: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-mb-40",
    css: "scroll-margin-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-ml-40",
    css: "scroll-margin-left: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-m-44",
    css: "scroll-margin: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-mx-44",
    css: "scroll-margin-left: 11rem; /* 176px */\nscroll-margin-right: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-my-44",
    css: "scroll-margin-top: 11rem; /* 176px */\nscroll-margin-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-ms-44",
    css: "scroll-margin-inline-start: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-me-44",
    css: "scroll-margin-inline-end: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-mt-44",
    css: "scroll-margin-top: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-mr-44",
    css: "scroll-margin-right: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-mb-44",
    css: "scroll-margin-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-ml-44",
    css: "scroll-margin-left: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-m-48",
    css: "scroll-margin: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-mx-48",
    css: "scroll-margin-left: 12rem; /* 192px */\nscroll-margin-right: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-my-48",
    css: "scroll-margin-top: 12rem; /* 192px */\nscroll-margin-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-ms-48",
    css: "scroll-margin-inline-start: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-me-48",
    css: "scroll-margin-inline-end: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-mt-48",
    css: "scroll-margin-top: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-mr-48",
    css: "scroll-margin-right: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-mb-48",
    css: "scroll-margin-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-ml-48",
    css: "scroll-margin-left: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-m-52",
    css: "scroll-margin: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-mx-52",
    css: "scroll-margin-left: 13rem; /* 208px */\nscroll-margin-right: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-my-52",
    css: "scroll-margin-top: 13rem; /* 208px */\nscroll-margin-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-ms-52",
    css: "scroll-margin-inline-start: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-me-52",
    css: "scroll-margin-inline-end: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-mt-52",
    css: "scroll-margin-top: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-mr-52",
    css: "scroll-margin-right: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-mb-52",
    css: "scroll-margin-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-ml-52",
    css: "scroll-margin-left: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-m-56",
    css: "scroll-margin: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-mx-56",
    css: "scroll-margin-left: 14rem; /* 224px */\nscroll-margin-right: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-my-56",
    css: "scroll-margin-top: 14rem; /* 224px */\nscroll-margin-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-ms-56",
    css: "scroll-margin-inline-start: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-me-56",
    css: "scroll-margin-inline-end: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-mt-56",
    css: "scroll-margin-top: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-mr-56",
    css: "scroll-margin-right: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-mb-56",
    css: "scroll-margin-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-ml-56",
    css: "scroll-margin-left: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-m-60",
    css: "scroll-margin: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-mx-60",
    css: "scroll-margin-left: 15rem; /* 240px */\nscroll-margin-right: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-my-60",
    css: "scroll-margin-top: 15rem; /* 240px */\nscroll-margin-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-ms-60",
    css: "scroll-margin-inline-start: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-me-60",
    css: "scroll-margin-inline-end: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-mt-60",
    css: "scroll-margin-top: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-mr-60",
    css: "scroll-margin-right: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-mb-60",
    css: "scroll-margin-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-ml-60",
    css: "scroll-margin-left: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-m-64",
    css: "scroll-margin: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-mx-64",
    css: "scroll-margin-left: 16rem; /* 256px */\nscroll-margin-right: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-my-64",
    css: "scroll-margin-top: 16rem; /* 256px */\nscroll-margin-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-ms-64",
    css: "scroll-margin-inline-start: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-me-64",
    css: "scroll-margin-inline-end: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-mt-64",
    css: "scroll-margin-top: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-mr-64",
    css: "scroll-margin-right: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-mb-64",
    css: "scroll-margin-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-ml-64",
    css: "scroll-margin-left: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-m-72",
    css: "scroll-margin: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-mx-72",
    css: "scroll-margin-left: 18rem; /* 288px */\nscroll-margin-right: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-my-72",
    css: "scroll-margin-top: 18rem; /* 288px */\nscroll-margin-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-ms-72",
    css: "scroll-margin-inline-start: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-me-72",
    css: "scroll-margin-inline-end: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-mt-72",
    css: "scroll-margin-top: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-mr-72",
    css: "scroll-margin-right: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-mb-72",
    css: "scroll-margin-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-ml-72",
    css: "scroll-margin-left: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-m-80",
    css: "scroll-margin: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-mx-80",
    css: "scroll-margin-left: 20rem; /* 320px */\nscroll-margin-right: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-my-80",
    css: "scroll-margin-top: 20rem; /* 320px */\nscroll-margin-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-ms-80",
    css: "scroll-margin-inline-start: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-me-80",
    css: "scroll-margin-inline-end: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-mt-80",
    css: "scroll-margin-top: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-mr-80",
    css: "scroll-margin-right: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-mb-80",
    css: "scroll-margin-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-ml-80",
    css: "scroll-margin-left: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-m-96",
    css: "scroll-margin: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-mx-96",
    css: "scroll-margin-left: 24rem; /* 384px */\nscroll-margin-right: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-my-96",
    css: "scroll-margin-top: 24rem; /* 384px */\nscroll-margin-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-ms-96",
    css: "scroll-margin-inline-start: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-me-96",
    css: "scroll-margin-inline-end: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-mt-96",
    css: "scroll-margin-top: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-mr-96",
    css: "scroll-margin-right: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-mb-96",
    css: "scroll-margin-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-ml-96",
    css: "scroll-margin-left: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-p-0",
    css: "scroll-padding: 0px;",
  },
  {
    tailwind: "scroll-px-0",
    css: "scroll-padding-left: 0px;\nscroll-padding-right: 0px;",
  },
  {
    tailwind: "scroll-py-0",
    css: "scroll-padding-top: 0px;\nscroll-padding-bottom: 0px;",
  },
  {
    tailwind: "scroll-ps-0",
    css: "scroll-padding-inline-start: 0px;",
  },
  {
    tailwind: "scroll-pe-0",
    css: "scroll-padding-inline-end: 0px;",
  },
  {
    tailwind: "scroll-pt-0",
    css: "scroll-padding-top: 0px;",
  },
  {
    tailwind: "scroll-pr-0",
    css: "scroll-padding-right: 0px;",
  },
  {
    tailwind: "scroll-pb-0",
    css: "scroll-padding-bottom: 0px;",
  },
  {
    tailwind: "scroll-pl-0",
    css: "scroll-padding-left: 0px;",
  },
  {
    tailwind: "scroll-p-px",
    css: "scroll-padding: 1px;",
  },
  {
    tailwind: "scroll-px-px",
    css: "scroll-padding-left: 1px;\nscroll-padding-right: 1px;",
  },
  {
    tailwind: "scroll-py-px",
    css: "scroll-padding-top: 1px;\nscroll-padding-bottom: 1px;",
  },
  {
    tailwind: "scroll-ps-px",
    css: "scroll-padding-inline-start: 1px;",
  },
  {
    tailwind: "scroll-pe-px",
    css: "scroll-padding-inline-end: 1px;",
  },
  {
    tailwind: "scroll-pt-px",
    css: "scroll-padding-top: 1px;",
  },
  {
    tailwind: "scroll-pr-px",
    css: "scroll-padding-right: 1px;",
  },
  {
    tailwind: "scroll-pb-px",
    css: "scroll-padding-bottom: 1px;",
  },
  {
    tailwind: "scroll-pl-px",
    css: "scroll-padding-left: 1px;",
  },
  {
    tailwind: "scroll-p-0.5",
    css: "scroll-padding: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-px-0.5",
    css: "scroll-padding-left: 0.125rem; /* 2px */\nscroll-padding-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-py-0.5",
    css: "scroll-padding-top: 0.125rem; /* 2px */\nscroll-padding-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-ps-0.5",
    css: "scroll-padding-inline-start: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-pe-0.5",
    css: "scroll-padding-inline-end: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-pt-0.5",
    css: "scroll-padding-top: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-pr-0.5",
    css: "scroll-padding-right: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-pb-0.5",
    css: "scroll-padding-bottom: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-pl-0.5",
    css: "scroll-padding-left: 0.125rem; /* 2px */",
  },
  {
    tailwind: "scroll-p-1",
    css: "scroll-padding: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-px-1",
    css: "scroll-padding-left: 0.25rem; /* 4px */\nscroll-padding-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-py-1",
    css: "scroll-padding-top: 0.25rem; /* 4px */\nscroll-padding-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-ps-1",
    css: "scroll-padding-inline-start: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-pe-1",
    css: "scroll-padding-inline-end: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-pt-1",
    css: "scroll-padding-top: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-pr-1",
    css: "scroll-padding-right: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-pb-1",
    css: "scroll-padding-bottom: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-pl-1",
    css: "scroll-padding-left: 0.25rem; /* 4px */",
  },
  {
    tailwind: "scroll-p-1.5",
    css: "scroll-padding: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-px-1.5",
    css: "scroll-padding-left: 0.375rem; /* 6px */\nscroll-padding-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-py-1.5",
    css: "scroll-padding-top: 0.375rem; /* 6px */\nscroll-padding-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-ps-1.5",
    css: "scroll-padding-inline-start: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-pe-1.5",
    css: "scroll-padding-inline-end: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-pt-1.5",
    css: "scroll-padding-top: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-pr-1.5",
    css: "scroll-padding-right: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-pb-1.5",
    css: "scroll-padding-bottom: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-pl-1.5",
    css: "scroll-padding-left: 0.375rem; /* 6px */",
  },
  {
    tailwind: "scroll-p-2",
    css: "scroll-padding: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-px-2",
    css: "scroll-padding-left: 0.5rem; /* 8px */\nscroll-padding-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-py-2",
    css: "scroll-padding-top: 0.5rem; /* 8px */\nscroll-padding-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-ps-2",
    css: "scroll-padding-inline-start: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-pe-2",
    css: "scroll-padding-inline-end: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-pt-2",
    css: "scroll-padding-top: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-pr-2",
    css: "scroll-padding-right: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-pb-2",
    css: "scroll-padding-bottom: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-pl-2",
    css: "scroll-padding-left: 0.5rem; /* 8px */",
  },
  {
    tailwind: "scroll-p-2.5",
    css: "scroll-padding: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-px-2.5",
    css: "scroll-padding-left: 0.625rem; /* 10px */\nscroll-padding-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-py-2.5",
    css: "scroll-padding-top: 0.625rem; /* 10px */\nscroll-padding-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-ps-2.5",
    css: "scroll-padding-inline-start: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-pe-2.5",
    css: "scroll-padding-inline-end: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-pt-2.5",
    css: "scroll-padding-top: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-pr-2.5",
    css: "scroll-padding-right: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-pb-2.5",
    css: "scroll-padding-bottom: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-pl-2.5",
    css: "scroll-padding-left: 0.625rem; /* 10px */",
  },
  {
    tailwind: "scroll-p-3",
    css: "scroll-padding: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-px-3",
    css: "scroll-padding-left: 0.75rem; /* 12px */\nscroll-padding-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-py-3",
    css: "scroll-padding-top: 0.75rem; /* 12px */\nscroll-padding-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-ps-3",
    css: "scroll-padding-inline-start: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-pe-3",
    css: "scroll-padding-inline-end: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-pt-3",
    css: "scroll-padding-top: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-pr-3",
    css: "scroll-padding-right: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-pb-3",
    css: "scroll-padding-bottom: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-pl-3",
    css: "scroll-padding-left: 0.75rem; /* 12px */",
  },
  {
    tailwind: "scroll-p-3.5",
    css: "scroll-padding: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-px-3.5",
    css: "scroll-padding-left: 0.875rem; /* 14px */\nscroll-padding-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-py-3.5",
    css: "scroll-padding-top: 0.875rem; /* 14px */\nscroll-padding-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-ps-3.5",
    css: "scroll-padding-inline-start: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-pe-3.5",
    css: "scroll-padding-inline-end: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-pt-3.5",
    css: "scroll-padding-top: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-pr-3.5",
    css: "scroll-padding-right: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-pb-3.5",
    css: "scroll-padding-bottom: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-pl-3.5",
    css: "scroll-padding-left: 0.875rem; /* 14px */",
  },
  {
    tailwind: "scroll-p-4",
    css: "scroll-padding: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-px-4",
    css: "scroll-padding-left: 1rem; /* 16px */\nscroll-padding-right: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-py-4",
    css: "scroll-padding-top: 1rem; /* 16px */\nscroll-padding-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-ps-4",
    css: "scroll-padding-inline-start: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-pe-4",
    css: "scroll-padding-inline-end: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-pt-4",
    css: "scroll-padding-top: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-pr-4",
    css: "scroll-padding-right: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-pb-4",
    css: "scroll-padding-bottom: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-pl-4",
    css: "scroll-padding-left: 1rem; /* 16px */",
  },
  {
    tailwind: "scroll-p-5",
    css: "scroll-padding: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-px-5",
    css: "scroll-padding-left: 1.25rem; /* 20px */\nscroll-padding-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-py-5",
    css: "scroll-padding-top: 1.25rem; /* 20px */\nscroll-padding-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-ps-5",
    css: "scroll-padding-inline-start: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-pe-5",
    css: "scroll-padding-inline-end: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-pt-5",
    css: "scroll-padding-top: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-pr-5",
    css: "scroll-padding-right: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-pb-5",
    css: "scroll-padding-bottom: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-pl-5",
    css: "scroll-padding-left: 1.25rem; /* 20px */",
  },
  {
    tailwind: "scroll-p-6",
    css: "scroll-padding: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-px-6",
    css: "scroll-padding-left: 1.5rem; /* 24px */\nscroll-padding-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-py-6",
    css: "scroll-padding-top: 1.5rem; /* 24px */\nscroll-padding-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-ps-6",
    css: "scroll-padding-inline-start: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-pe-6",
    css: "scroll-padding-inline-end: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-pt-6",
    css: "scroll-padding-top: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-pr-6",
    css: "scroll-padding-right: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-pb-6",
    css: "scroll-padding-bottom: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-pl-6",
    css: "scroll-padding-left: 1.5rem; /* 24px */",
  },
  {
    tailwind: "scroll-p-7",
    css: "scroll-padding: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-px-7",
    css: "scroll-padding-left: 1.75rem; /* 28px */\nscroll-padding-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-py-7",
    css: "scroll-padding-top: 1.75rem; /* 28px */\nscroll-padding-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-ps-7",
    css: "scroll-padding-inline-start: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-pe-7",
    css: "scroll-padding-inline-end: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-pt-7",
    css: "scroll-padding-top: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-pr-7",
    css: "scroll-padding-right: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-pb-7",
    css: "scroll-padding-bottom: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-pl-7",
    css: "scroll-padding-left: 1.75rem; /* 28px */",
  },
  {
    tailwind: "scroll-p-8",
    css: "scroll-padding: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-px-8",
    css: "scroll-padding-left: 2rem; /* 32px */\nscroll-padding-right: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-py-8",
    css: "scroll-padding-top: 2rem; /* 32px */\nscroll-padding-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-ps-8",
    css: "scroll-padding-inline-start: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-pe-8",
    css: "scroll-padding-inline-end: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-pt-8",
    css: "scroll-padding-top: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-pr-8",
    css: "scroll-padding-right: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-pb-8",
    css: "scroll-padding-bottom: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-pl-8",
    css: "scroll-padding-left: 2rem; /* 32px */",
  },
  {
    tailwind: "scroll-p-9",
    css: "scroll-padding: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-px-9",
    css: "scroll-padding-left: 2.25rem; /* 36px */\nscroll-padding-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-py-9",
    css: "scroll-padding-top: 2.25rem; /* 36px */\nscroll-padding-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-ps-9",
    css: "scroll-padding-inline-start: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-pe-9",
    css: "scroll-padding-inline-end: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-pt-9",
    css: "scroll-padding-top: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-pr-9",
    css: "scroll-padding-right: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-pb-9",
    css: "scroll-padding-bottom: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-pl-9",
    css: "scroll-padding-left: 2.25rem; /* 36px */",
  },
  {
    tailwind: "scroll-p-10",
    css: "scroll-padding: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-px-10",
    css: "scroll-padding-left: 2.5rem; /* 40px */\nscroll-padding-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-py-10",
    css: "scroll-padding-top: 2.5rem; /* 40px */\nscroll-padding-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-ps-10",
    css: "scroll-padding-inline-start: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-pe-10",
    css: "scroll-padding-inline-end: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-pt-10",
    css: "scroll-padding-top: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-pr-10",
    css: "scroll-padding-right: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-pb-10",
    css: "scroll-padding-bottom: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-pl-10",
    css: "scroll-padding-left: 2.5rem; /* 40px */",
  },
  {
    tailwind: "scroll-p-11",
    css: "scroll-padding: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-px-11",
    css: "scroll-padding-left: 2.75rem; /* 44px */\nscroll-padding-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-py-11",
    css: "scroll-padding-top: 2.75rem; /* 44px */\nscroll-padding-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-ps-11",
    css: "scroll-padding-inline-start: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-pe-11",
    css: "scroll-padding-inline-end: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-pt-11",
    css: "scroll-padding-top: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-pr-11",
    css: "scroll-padding-right: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-pb-11",
    css: "scroll-padding-bottom: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-pl-11",
    css: "scroll-padding-left: 2.75rem; /* 44px */",
  },
  {
    tailwind: "scroll-p-12",
    css: "scroll-padding: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-px-12",
    css: "scroll-padding-left: 3rem; /* 48px */\nscroll-padding-right: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-py-12",
    css: "scroll-padding-top: 3rem; /* 48px */\nscroll-padding-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-ps-12",
    css: "scroll-padding-inline-start: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-pe-12",
    css: "scroll-padding-inline-end: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-pt-12",
    css: "scroll-padding-top: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-pr-12",
    css: "scroll-padding-right: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-pb-12",
    css: "scroll-padding-bottom: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-pl-12",
    css: "scroll-padding-left: 3rem; /* 48px */",
  },
  {
    tailwind: "scroll-p-14",
    css: "scroll-padding: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-px-14",
    css: "scroll-padding-left: 3.5rem; /* 56px */\nscroll-padding-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-py-14",
    css: "scroll-padding-top: 3.5rem; /* 56px */\nscroll-padding-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-ps-14",
    css: "scroll-padding-inline-start: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-pe-14",
    css: "scroll-padding-inline-end: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-pt-14",
    css: "scroll-padding-top: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-pr-14",
    css: "scroll-padding-right: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-pb-14",
    css: "scroll-padding-bottom: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-pl-14",
    css: "scroll-padding-left: 3.5rem; /* 56px */",
  },
  {
    tailwind: "scroll-p-16",
    css: "scroll-padding: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-px-16",
    css: "scroll-padding-left: 4rem; /* 64px */\nscroll-padding-right: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-py-16",
    css: "scroll-padding-top: 4rem; /* 64px */\nscroll-padding-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-ps-16",
    css: "scroll-padding-inline-start: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-pe-16",
    css: "scroll-padding-inline-end: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-pt-16",
    css: "scroll-padding-top: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-pr-16",
    css: "scroll-padding-right: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-pb-16",
    css: "scroll-padding-bottom: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-pl-16",
    css: "scroll-padding-left: 4rem; /* 64px */",
  },
  {
    tailwind: "scroll-p-20",
    css: "scroll-padding: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-px-20",
    css: "scroll-padding-left: 5rem; /* 80px */\nscroll-padding-right: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-py-20",
    css: "scroll-padding-top: 5rem; /* 80px */\nscroll-padding-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-ps-20",
    css: "scroll-padding-inline-start: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-pe-20",
    css: "scroll-padding-inline-end: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-pt-20",
    css: "scroll-padding-top: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-pr-20",
    css: "scroll-padding-right: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-pb-20",
    css: "scroll-padding-bottom: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-pl-20",
    css: "scroll-padding-left: 5rem; /* 80px */",
  },
  {
    tailwind: "scroll-p-24",
    css: "scroll-padding: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-px-24",
    css: "scroll-padding-left: 6rem; /* 96px */\nscroll-padding-right: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-py-24",
    css: "scroll-padding-top: 6rem; /* 96px */\nscroll-padding-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-ps-24",
    css: "scroll-padding-inline-start: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-pe-24",
    css: "scroll-padding-inline-end: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-pt-24",
    css: "scroll-padding-top: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-pr-24",
    css: "scroll-padding-right: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-pb-24",
    css: "scroll-padding-bottom: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-pl-24",
    css: "scroll-padding-left: 6rem; /* 96px */",
  },
  {
    tailwind: "scroll-p-28",
    css: "scroll-padding: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-px-28",
    css: "scroll-padding-left: 7rem; /* 112px */\nscroll-padding-right: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-py-28",
    css: "scroll-padding-top: 7rem; /* 112px */\nscroll-padding-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-ps-28",
    css: "scroll-padding-inline-start: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-pe-28",
    css: "scroll-padding-inline-end: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-pt-28",
    css: "scroll-padding-top: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-pr-28",
    css: "scroll-padding-right: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-pb-28",
    css: "scroll-padding-bottom: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-pl-28",
    css: "scroll-padding-left: 7rem; /* 112px */",
  },
  {
    tailwind: "scroll-p-32",
    css: "scroll-padding: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-px-32",
    css: "scroll-padding-left: 8rem; /* 128px */\nscroll-padding-right: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-py-32",
    css: "scroll-padding-top: 8rem; /* 128px */\nscroll-padding-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-ps-32",
    css: "scroll-padding-inline-start: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-pe-32",
    css: "scroll-padding-inline-end: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-pt-32",
    css: "scroll-padding-top: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-pr-32",
    css: "scroll-padding-right: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-pb-32",
    css: "scroll-padding-bottom: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-pl-32",
    css: "scroll-padding-left: 8rem; /* 128px */",
  },
  {
    tailwind: "scroll-p-36",
    css: "scroll-padding: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-px-36",
    css: "scroll-padding-left: 9rem; /* 144px */\nscroll-padding-right: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-py-36",
    css: "scroll-padding-top: 9rem; /* 144px */\nscroll-padding-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-ps-36",
    css: "scroll-padding-inline-start: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-pe-36",
    css: "scroll-padding-inline-end: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-pt-36",
    css: "scroll-padding-top: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-pr-36",
    css: "scroll-padding-right: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-pb-36",
    css: "scroll-padding-bottom: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-pl-36",
    css: "scroll-padding-left: 9rem; /* 144px */",
  },
  {
    tailwind: "scroll-p-40",
    css: "scroll-padding: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-px-40",
    css: "scroll-padding-left: 10rem; /* 160px */\nscroll-padding-right: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-py-40",
    css: "scroll-padding-top: 10rem; /* 160px */\nscroll-padding-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-ps-40",
    css: "scroll-padding-inline-start: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-pe-40",
    css: "scroll-padding-inline-end: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-pt-40",
    css: "scroll-padding-top: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-pr-40",
    css: "scroll-padding-right: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-pb-40",
    css: "scroll-padding-bottom: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-pl-40",
    css: "scroll-padding-left: 10rem; /* 160px */",
  },
  {
    tailwind: "scroll-p-44",
    css: "scroll-padding: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-px-44",
    css: "scroll-padding-left: 11rem; /* 176px */\nscroll-padding-right: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-py-44",
    css: "scroll-padding-top: 11rem; /* 176px */\nscroll-padding-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-ps-44",
    css: "scroll-padding-inline-start: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-pe-44",
    css: "scroll-padding-inline-end: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-pt-44",
    css: "scroll-padding-top: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-pr-44",
    css: "scroll-padding-right: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-pb-44",
    css: "scroll-padding-bottom: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-pl-44",
    css: "scroll-padding-left: 11rem; /* 176px */",
  },
  {
    tailwind: "scroll-p-48",
    css: "scroll-padding: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-px-48",
    css: "scroll-padding-left: 12rem; /* 192px */\nscroll-padding-right: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-py-48",
    css: "scroll-padding-top: 12rem; /* 192px */\nscroll-padding-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-ps-48",
    css: "scroll-padding-inline-start: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-pe-48",
    css: "scroll-padding-inline-end: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-pt-48",
    css: "scroll-padding-top: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-pr-48",
    css: "scroll-padding-right: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-pb-48",
    css: "scroll-padding-bottom: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-pl-48",
    css: "scroll-padding-left: 12rem; /* 192px */",
  },
  {
    tailwind: "scroll-p-52",
    css: "scroll-padding: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-px-52",
    css: "scroll-padding-left: 13rem; /* 208px */\nscroll-padding-right: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-py-52",
    css: "scroll-padding-top: 13rem; /* 208px */\nscroll-padding-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-ps-52",
    css: "scroll-padding-inline-start: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-pe-52",
    css: "scroll-padding-inline-end: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-pt-52",
    css: "scroll-padding-top: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-pr-52",
    css: "scroll-padding-right: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-pb-52",
    css: "scroll-padding-bottom: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-pl-52",
    css: "scroll-padding-left: 13rem; /* 208px */",
  },
  {
    tailwind: "scroll-p-56",
    css: "scroll-padding: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-px-56",
    css: "scroll-padding-left: 14rem; /* 224px */\nscroll-padding-right: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-py-56",
    css: "scroll-padding-top: 14rem; /* 224px */\nscroll-padding-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-ps-56",
    css: "scroll-padding-inline-start: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-pe-56",
    css: "scroll-padding-inline-end: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-pt-56",
    css: "scroll-padding-top: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-pr-56",
    css: "scroll-padding-right: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-pb-56",
    css: "scroll-padding-bottom: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-pl-56",
    css: "scroll-padding-left: 14rem; /* 224px */",
  },
  {
    tailwind: "scroll-p-60",
    css: "scroll-padding: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-px-60",
    css: "scroll-padding-left: 15rem; /* 240px */\nscroll-padding-right: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-py-60",
    css: "scroll-padding-top: 15rem; /* 240px */\nscroll-padding-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-ps-60",
    css: "scroll-padding-inline-start: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-pe-60",
    css: "scroll-padding-inline-end: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-pt-60",
    css: "scroll-padding-top: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-pr-60",
    css: "scroll-padding-right: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-pb-60",
    css: "scroll-padding-bottom: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-pl-60",
    css: "scroll-padding-left: 15rem; /* 240px */",
  },
  {
    tailwind: "scroll-p-64",
    css: "scroll-padding: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-px-64",
    css: "scroll-padding-left: 16rem; /* 256px */\nscroll-padding-right: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-py-64",
    css: "scroll-padding-top: 16rem; /* 256px */\nscroll-padding-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-ps-64",
    css: "scroll-padding-inline-start: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-pe-64",
    css: "scroll-padding-inline-end: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-pt-64",
    css: "scroll-padding-top: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-pr-64",
    css: "scroll-padding-right: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-pb-64",
    css: "scroll-padding-bottom: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-pl-64",
    css: "scroll-padding-left: 16rem; /* 256px */",
  },
  {
    tailwind: "scroll-p-72",
    css: "scroll-padding: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-px-72",
    css: "scroll-padding-left: 18rem; /* 288px */\nscroll-padding-right: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-py-72",
    css: "scroll-padding-top: 18rem; /* 288px */\nscroll-padding-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-ps-72",
    css: "scroll-padding-inline-start: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-pe-72",
    css: "scroll-padding-inline-end: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-pt-72",
    css: "scroll-padding-top: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-pr-72",
    css: "scroll-padding-right: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-pb-72",
    css: "scroll-padding-bottom: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-pl-72",
    css: "scroll-padding-left: 18rem; /* 288px */",
  },
  {
    tailwind: "scroll-p-80",
    css: "scroll-padding: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-px-80",
    css: "scroll-padding-left: 20rem; /* 320px */\nscroll-padding-right: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-py-80",
    css: "scroll-padding-top: 20rem; /* 320px */\nscroll-padding-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-ps-80",
    css: "scroll-padding-inline-start: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-pe-80",
    css: "scroll-padding-inline-end: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-pt-80",
    css: "scroll-padding-top: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-pr-80",
    css: "scroll-padding-right: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-pb-80",
    css: "scroll-padding-bottom: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-pl-80",
    css: "scroll-padding-left: 20rem; /* 320px */",
  },
  {
    tailwind: "scroll-p-96",
    css: "scroll-padding: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-px-96",
    css: "scroll-padding-left: 24rem; /* 384px */\nscroll-padding-right: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-py-96",
    css: "scroll-padding-top: 24rem; /* 384px */\nscroll-padding-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-ps-96",
    css: "scroll-padding-inline-start: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-pe-96",
    css: "scroll-padding-inline-end: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-pt-96",
    css: "scroll-padding-top: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-pr-96",
    css: "scroll-padding-right: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-pb-96",
    css: "scroll-padding-bottom: 24rem; /* 384px */",
  },
  {
    tailwind: "scroll-pl-96",
    css: "scroll-padding-left: 24rem; /* 384px */",
  },
  {
    tailwind: "snap-start",
    css: "scroll-snap-align: start;",
  },
  {
    tailwind: "snap-end",
    css: "scroll-snap-align: end;",
  },
  {
    tailwind: "snap-center",
    css: "scroll-snap-align: center;",
  },
  {
    tailwind: "snap-align-none",
    css: "scroll-snap-align: none;",
  },
  {
    tailwind: "snap-normal",
    css: "scroll-snap-stop: normal;",
  },
  {
    tailwind: "snap-always",
    css: "scroll-snap-stop: always;",
  },
  {
    tailwind: "snap-none",
    css: "scroll-snap-type: none;",
  },
  {
    tailwind: "snap-x",
    css: "scroll-snap-type: x var(--tw-scroll-snap-strictness);",
  },
  {
    tailwind: "snap-y",
    css: "scroll-snap-type: y var(--tw-scroll-snap-strictness);",
  },
  {
    tailwind: "snap-both",
    css: "scroll-snap-type: both var(--tw-scroll-snap-strictness);",
  },
  {
    tailwind: "snap-mandatory",
    css: "--tw-scroll-snap-strictness: mandatory;",
  },
  {
    tailwind: "snap-proximity",
    css: "--tw-scroll-snap-strictness: proximity;",
  },
  {
    tailwind: "touch-auto",
    css: "touch-action: auto;",
  },
  {
    tailwind: "touch-none",
    css: "touch-action: none;",
  },
  {
    tailwind: "touch-pan-x",
    css: "touch-action: pan-x;",
  },
  {
    tailwind: "touch-pan-left",
    css: "touch-action: pan-left;",
  },
  {
    tailwind: "touch-pan-right",
    css: "touch-action: pan-right;",
  },
  {
    tailwind: "touch-pan-y",
    css: "touch-action: pan-y;",
  },
  {
    tailwind: "touch-pan-up",
    css: "touch-action: pan-up;",
  },
  {
    tailwind: "touch-pan-down",
    css: "touch-action: pan-down;",
  },
  {
    tailwind: "touch-pinch-zoom",
    css: "touch-action: pinch-zoom;",
  },
  {
    tailwind: "touch-manipulation",
    css: "touch-action: manipulation;",
  },
  {
    tailwind: "select-none",
    css: "user-select: none;",
  },
  {
    tailwind: "select-text",
    css: "user-select: text;",
  },
  {
    tailwind: "select-all",
    css: "user-select: all;",
  },
  {
    tailwind: "select-auto",
    css: "user-select: auto;",
  },
  {
    tailwind: "will-change-auto",
    css: "will-change: auto;",
  },
  {
    tailwind: "will-change-scroll",
    css: "will-change: scroll-position;",
  },
  {
    tailwind: "will-change-contents",
    css: "will-change: contents;",
  },
  {
    tailwind: "will-change-transform",
    css: "will-change: transform;",
  },
  {
    tailwind: "fill-none",
    css: "fill: none;",
  },
  {
    tailwind: "fill-inherit",
    css: "fill: inherit;",
  },
  {
    tailwind: "fill-current",
    css: "fill: currentColor;",
  },
  {
    tailwind: "fill-transparent",
    css: "fill: transparent;",
  },
  {
    tailwind: "fill-black",
    css: "fill: #000;",
  },
  {
    tailwind: "fill-white",
    css: "fill: #fff;",
  },
  {
    tailwind: "fill-slate-50",
    css: "fill: #f8fafc;",
  },
  {
    tailwind: "fill-slate-100",
    css: "fill: #f1f5f9;",
  },
  {
    tailwind: "fill-slate-200",
    css: "fill: #e2e8f0;",
  },
  {
    tailwind: "fill-slate-300",
    css: "fill: #cbd5e1;",
  },
  {
    tailwind: "fill-slate-400",
    css: "fill: #94a3b8;",
  },
  {
    tailwind: "fill-slate-500",
    css: "fill: #64748b;",
  },
  {
    tailwind: "fill-slate-600",
    css: "fill: #475569;",
  },
  {
    tailwind: "fill-slate-700",
    css: "fill: #334155;",
  },
  {
    tailwind: "fill-slate-800",
    css: "fill: #1e293b;",
  },
  {
    tailwind: "fill-slate-900",
    css: "fill: #0f172a;",
  },
  {
    tailwind: "fill-slate-950",
    css: "fill: #020617;",
  },
  {
    tailwind: "fill-gray-50",
    css: "fill: #f9fafb;",
  },
  {
    tailwind: "fill-gray-100",
    css: "fill: #f3f4f6;",
  },
  {
    tailwind: "fill-gray-200",
    css: "fill: #e5e7eb;",
  },
  {
    tailwind: "fill-gray-300",
    css: "fill: #d1d5db;",
  },
  {
    tailwind: "fill-gray-400",
    css: "fill: #9ca3af;",
  },
  {
    tailwind: "fill-gray-500",
    css: "fill: #6b7280;",
  },
  {
    tailwind: "fill-gray-600",
    css: "fill: #4b5563;",
  },
  {
    tailwind: "fill-gray-700",
    css: "fill: #374151;",
  },
  {
    tailwind: "fill-gray-800",
    css: "fill: #1f2937;",
  },
  {
    tailwind: "fill-gray-900",
    css: "fill: #111827;",
  },
  {
    tailwind: "fill-gray-950",
    css: "fill: #030712;",
  },
  {
    tailwind: "fill-zinc-50",
    css: "fill: #fafafa;",
  },
  {
    tailwind: "fill-zinc-100",
    css: "fill: #f4f4f5;",
  },
  {
    tailwind: "fill-zinc-200",
    css: "fill: #e4e4e7;",
  },
  {
    tailwind: "fill-zinc-300",
    css: "fill: #d4d4d8;",
  },
  {
    tailwind: "fill-zinc-400",
    css: "fill: #a1a1aa;",
  },
  {
    tailwind: "fill-zinc-500",
    css: "fill: #71717a;",
  },
  {
    tailwind: "fill-zinc-600",
    css: "fill: #52525b;",
  },
  {
    tailwind: "fill-zinc-700",
    css: "fill: #3f3f46;",
  },
  {
    tailwind: "fill-zinc-800",
    css: "fill: #27272a;",
  },
  {
    tailwind: "fill-zinc-900",
    css: "fill: #18181b;",
  },
  {
    tailwind: "fill-zinc-950",
    css: "fill: #09090b;",
  },
  {
    tailwind: "fill-neutral-50",
    css: "fill: #fafafa;",
  },
  {
    tailwind: "fill-neutral-100",
    css: "fill: #f5f5f5;",
  },
  {
    tailwind: "fill-neutral-200",
    css: "fill: #e5e5e5;",
  },
  {
    tailwind: "fill-neutral-300",
    css: "fill: #d4d4d4;",
  },
  {
    tailwind: "fill-neutral-400",
    css: "fill: #a3a3a3;",
  },
  {
    tailwind: "fill-neutral-500",
    css: "fill: #737373;",
  },
  {
    tailwind: "fill-neutral-600",
    css: "fill: #525252;",
  },
  {
    tailwind: "fill-neutral-700",
    css: "fill: #404040;",
  },
  {
    tailwind: "fill-neutral-800",
    css: "fill: #262626;",
  },
  {
    tailwind: "fill-neutral-900",
    css: "fill: #171717;",
  },
  {
    tailwind: "fill-neutral-950",
    css: "fill: #0a0a0a;",
  },
  {
    tailwind: "fill-stone-50",
    css: "fill: #fafaf9;",
  },
  {
    tailwind: "fill-stone-100",
    css: "fill: #f5f5f4;",
  },
  {
    tailwind: "fill-stone-200",
    css: "fill: #e7e5e4;",
  },
  {
    tailwind: "fill-stone-300",
    css: "fill: #d6d3d1;",
  },
  {
    tailwind: "fill-stone-400",
    css: "fill: #a8a29e;",
  },
  {
    tailwind: "fill-stone-500",
    css: "fill: #78716c;",
  },
  {
    tailwind: "fill-stone-600",
    css: "fill: #57534e;",
  },
  {
    tailwind: "fill-stone-700",
    css: "fill: #44403c;",
  },
  {
    tailwind: "fill-stone-800",
    css: "fill: #292524;",
  },
  {
    tailwind: "fill-stone-900",
    css: "fill: #1c1917;",
  },
  {
    tailwind: "fill-stone-950",
    css: "fill: #0c0a09;",
  },
  {
    tailwind: "fill-red-50",
    css: "fill: #fef2f2;",
  },
  {
    tailwind: "fill-red-100",
    css: "fill: #fee2e2;",
  },
  {
    tailwind: "fill-red-200",
    css: "fill: #fecaca;",
  },
  {
    tailwind: "fill-red-300",
    css: "fill: #fca5a5;",
  },
  {
    tailwind: "fill-red-400",
    css: "fill: #f87171;",
  },
  {
    tailwind: "fill-red-500",
    css: "fill: #ef4444;",
  },
  {
    tailwind: "fill-red-600",
    css: "fill: #dc2626;",
  },
  {
    tailwind: "fill-red-700",
    css: "fill: #b91c1c;",
  },
  {
    tailwind: "fill-red-800",
    css: "fill: #991b1b;",
  },
  {
    tailwind: "fill-red-900",
    css: "fill: #7f1d1d;",
  },
  {
    tailwind: "fill-red-950",
    css: "fill: #450a0a;",
  },
  {
    tailwind: "fill-orange-50",
    css: "fill: #fff7ed;",
  },
  {
    tailwind: "fill-orange-100",
    css: "fill: #ffedd5;",
  },
  {
    tailwind: "fill-orange-200",
    css: "fill: #fed7aa;",
  },
  {
    tailwind: "fill-orange-300",
    css: "fill: #fdba74;",
  },
  {
    tailwind: "fill-orange-400",
    css: "fill: #fb923c;",
  },
  {
    tailwind: "fill-orange-500",
    css: "fill: #f97316;",
  },
  {
    tailwind: "fill-orange-600",
    css: "fill: #ea580c;",
  },
  {
    tailwind: "fill-orange-700",
    css: "fill: #c2410c;",
  },
  {
    tailwind: "fill-orange-800",
    css: "fill: #9a3412;",
  },
  {
    tailwind: "fill-orange-900",
    css: "fill: #7c2d12;",
  },
  {
    tailwind: "fill-orange-950",
    css: "fill: #431407;",
  },
  {
    tailwind: "fill-amber-50",
    css: "fill: #fffbeb;",
  },
  {
    tailwind: "fill-amber-100",
    css: "fill: #fef3c7;",
  },
  {
    tailwind: "fill-amber-200",
    css: "fill: #fde68a;",
  },
  {
    tailwind: "fill-amber-300",
    css: "fill: #fcd34d;",
  },
  {
    tailwind: "fill-amber-400",
    css: "fill: #fbbf24;",
  },
  {
    tailwind: "fill-amber-500",
    css: "fill: #f59e0b;",
  },
  {
    tailwind: "fill-amber-600",
    css: "fill: #d97706;",
  },
  {
    tailwind: "fill-amber-700",
    css: "fill: #b45309;",
  },
  {
    tailwind: "fill-amber-800",
    css: "fill: #92400e;",
  },
  {
    tailwind: "fill-amber-900",
    css: "fill: #78350f;",
  },
  {
    tailwind: "fill-amber-950",
    css: "fill: #451a03;",
  },
  {
    tailwind: "fill-yellow-50",
    css: "fill: #fefce8;",
  },
  {
    tailwind: "fill-yellow-100",
    css: "fill: #fef9c3;",
  },
  {
    tailwind: "fill-yellow-200",
    css: "fill: #fef08a;",
  },
  {
    tailwind: "fill-yellow-300",
    css: "fill: #fde047;",
  },
  {
    tailwind: "fill-yellow-400",
    css: "fill: #facc15;",
  },
  {
    tailwind: "fill-yellow-500",
    css: "fill: #eab308;",
  },
  {
    tailwind: "fill-yellow-600",
    css: "fill: #ca8a04;",
  },
  {
    tailwind: "fill-yellow-700",
    css: "fill: #a16207;",
  },
  {
    tailwind: "fill-yellow-800",
    css: "fill: #854d0e;",
  },
  {
    tailwind: "fill-yellow-900",
    css: "fill: #713f12;",
  },
  {
    tailwind: "fill-yellow-950",
    css: "fill: #422006;",
  },
  {
    tailwind: "fill-lime-50",
    css: "fill: #f7fee7;",
  },
  {
    tailwind: "fill-lime-100",
    css: "fill: #ecfccb;",
  },
  {
    tailwind: "fill-lime-200",
    css: "fill: #d9f99d;",
  },
  {
    tailwind: "fill-lime-300",
    css: "fill: #bef264;",
  },
  {
    tailwind: "fill-lime-400",
    css: "fill: #a3e635;",
  },
  {
    tailwind: "fill-lime-500",
    css: "fill: #84cc16;",
  },
  {
    tailwind: "fill-lime-600",
    css: "fill: #65a30d;",
  },
  {
    tailwind: "fill-lime-700",
    css: "fill: #4d7c0f;",
  },
  {
    tailwind: "fill-lime-800",
    css: "fill: #3f6212;",
  },
  {
    tailwind: "fill-lime-900",
    css: "fill: #365314;",
  },
  {
    tailwind: "fill-lime-950",
    css: "fill: #1a2e05;",
  },
  {
    tailwind: "fill-green-50",
    css: "fill: #f0fdf4;",
  },
  {
    tailwind: "fill-green-100",
    css: "fill: #dcfce7;",
  },
  {
    tailwind: "fill-green-200",
    css: "fill: #bbf7d0;",
  },
  {
    tailwind: "fill-green-300",
    css: "fill: #86efac;",
  },
  {
    tailwind: "fill-green-400",
    css: "fill: #4ade80;",
  },
  {
    tailwind: "fill-green-500",
    css: "fill: #22c55e;",
  },
  {
    tailwind: "fill-green-600",
    css: "fill: #16a34a;",
  },
  {
    tailwind: "fill-green-700",
    css: "fill: #15803d;",
  },
  {
    tailwind: "fill-green-800",
    css: "fill: #166534;",
  },
  {
    tailwind: "fill-green-900",
    css: "fill: #14532d;",
  },
  {
    tailwind: "fill-green-950",
    css: "fill: #052e16;",
  },
  {
    tailwind: "fill-emerald-50",
    css: "fill: #ecfdf5;",
  },
  {
    tailwind: "fill-emerald-100",
    css: "fill: #d1fae5;",
  },
  {
    tailwind: "fill-emerald-200",
    css: "fill: #a7f3d0;",
  },
  {
    tailwind: "fill-emerald-300",
    css: "fill: #6ee7b7;",
  },
  {
    tailwind: "fill-emerald-400",
    css: "fill: #34d399;",
  },
  {
    tailwind: "fill-emerald-500",
    css: "fill: #10b981;",
  },
  {
    tailwind: "fill-emerald-600",
    css: "fill: #059669;",
  },
  {
    tailwind: "fill-emerald-700",
    css: "fill: #047857;",
  },
  {
    tailwind: "fill-emerald-800",
    css: "fill: #065f46;",
  },
  {
    tailwind: "fill-emerald-900",
    css: "fill: #064e3b;",
  },
  {
    tailwind: "fill-emerald-950",
    css: "fill: #022c22;",
  },
  {
    tailwind: "fill-teal-50",
    css: "fill: #f0fdfa;",
  },
  {
    tailwind: "fill-teal-100",
    css: "fill: #ccfbf1;",
  },
  {
    tailwind: "fill-teal-200",
    css: "fill: #99f6e4;",
  },
  {
    tailwind: "fill-teal-300",
    css: "fill: #5eead4;",
  },
  {
    tailwind: "fill-teal-400",
    css: "fill: #2dd4bf;",
  },
  {
    tailwind: "fill-teal-500",
    css: "fill: #14b8a6;",
  },
  {
    tailwind: "fill-teal-600",
    css: "fill: #0d9488;",
  },
  {
    tailwind: "fill-teal-700",
    css: "fill: #0f766e;",
  },
  {
    tailwind: "fill-teal-800",
    css: "fill: #115e59;",
  },
  {
    tailwind: "fill-teal-900",
    css: "fill: #134e4a;",
  },
  {
    tailwind: "fill-teal-950",
    css: "fill: #042f2e;",
  },
  {
    tailwind: "fill-cyan-50",
    css: "fill: #ecfeff;",
  },
  {
    tailwind: "fill-cyan-100",
    css: "fill: #cffafe;",
  },
  {
    tailwind: "fill-cyan-200",
    css: "fill: #a5f3fc;",
  },
  {
    tailwind: "fill-cyan-300",
    css: "fill: #67e8f9;",
  },
  {
    tailwind: "fill-cyan-400",
    css: "fill: #22d3ee;",
  },
  {
    tailwind: "fill-cyan-500",
    css: "fill: #06b6d4;",
  },
  {
    tailwind: "fill-cyan-600",
    css: "fill: #0891b2;",
  },
  {
    tailwind: "fill-cyan-700",
    css: "fill: #0e7490;",
  },
  {
    tailwind: "fill-cyan-800",
    css: "fill: #155e75;",
  },
  {
    tailwind: "fill-cyan-900",
    css: "fill: #164e63;",
  },
  {
    tailwind: "fill-cyan-950",
    css: "fill: #083344;",
  },
  {
    tailwind: "fill-sky-50",
    css: "fill: #f0f9ff;",
  },
  {
    tailwind: "fill-sky-100",
    css: "fill: #e0f2fe;",
  },
  {
    tailwind: "fill-sky-200",
    css: "fill: #bae6fd;",
  },
  {
    tailwind: "fill-sky-300",
    css: "fill: #7dd3fc;",
  },
  {
    tailwind: "fill-sky-400",
    css: "fill: #38bdf8;",
  },
  {
    tailwind: "fill-sky-500",
    css: "fill: #0ea5e9;",
  },
  {
    tailwind: "fill-sky-600",
    css: "fill: #0284c7;",
  },
  {
    tailwind: "fill-sky-700",
    css: "fill: #0369a1;",
  },
  {
    tailwind: "fill-sky-800",
    css: "fill: #075985;",
  },
  {
    tailwind: "fill-sky-900",
    css: "fill: #0c4a6e;",
  },
  {
    tailwind: "fill-sky-950",
    css: "fill: #082f49;",
  },
  {
    tailwind: "fill-blue-50",
    css: "fill: #eff6ff;",
  },
  {
    tailwind: "fill-blue-100",
    css: "fill: #dbeafe;",
  },
  {
    tailwind: "fill-blue-200",
    css: "fill: #bfdbfe;",
  },
  {
    tailwind: "fill-blue-300",
    css: "fill: #93c5fd;",
  },
  {
    tailwind: "fill-blue-400",
    css: "fill: #60a5fa;",
  },
  {
    tailwind: "fill-blue-500",
    css: "fill: #3b82f6;",
  },
  {
    tailwind: "fill-blue-600",
    css: "fill: #2563eb;",
  },
  {
    tailwind: "fill-blue-700",
    css: "fill: #1d4ed8;",
  },
  {
    tailwind: "fill-blue-800",
    css: "fill: #1e40af;",
  },
  {
    tailwind: "fill-blue-900",
    css: "fill: #1e3a8a;",
  },
  {
    tailwind: "fill-blue-950",
    css: "fill: #172554;",
  },
  {
    tailwind: "fill-indigo-50",
    css: "fill: #eef2ff;",
  },
  {
    tailwind: "fill-indigo-100",
    css: "fill: #e0e7ff;",
  },
  {
    tailwind: "fill-indigo-200",
    css: "fill: #c7d2fe;",
  },
  {
    tailwind: "fill-indigo-300",
    css: "fill: #a5b4fc;",
  },
  {
    tailwind: "fill-indigo-400",
    css: "fill: #818cf8;",
  },
  {
    tailwind: "fill-indigo-500",
    css: "fill: #6366f1;",
  },
  {
    tailwind: "fill-indigo-600",
    css: "fill: #4f46e5;",
  },
  {
    tailwind: "fill-indigo-700",
    css: "fill: #4338ca;",
  },
  {
    tailwind: "fill-indigo-800",
    css: "fill: #3730a3;",
  },
  {
    tailwind: "fill-indigo-900",
    css: "fill: #312e81;",
  },
  {
    tailwind: "fill-indigo-950",
    css: "fill: #1e1b4b;",
  },
  {
    tailwind: "fill-violet-50",
    css: "fill: #f5f3ff;",
  },
  {
    tailwind: "fill-violet-100",
    css: "fill: #ede9fe;",
  },
  {
    tailwind: "fill-violet-200",
    css: "fill: #ddd6fe;",
  },
  {
    tailwind: "fill-violet-300",
    css: "fill: #c4b5fd;",
  },
  {
    tailwind: "fill-violet-400",
    css: "fill: #a78bfa;",
  },
  {
    tailwind: "fill-violet-500",
    css: "fill: #8b5cf6;",
  },
  {
    tailwind: "fill-violet-600",
    css: "fill: #7c3aed;",
  },
  {
    tailwind: "fill-violet-700",
    css: "fill: #6d28d9;",
  },
  {
    tailwind: "fill-violet-800",
    css: "fill: #5b21b6;",
  },
  {
    tailwind: "fill-violet-900",
    css: "fill: #4c1d95;",
  },
  {
    tailwind: "fill-violet-950",
    css: "fill: #2e1065;",
  },
  {
    tailwind: "fill-purple-50",
    css: "fill: #faf5ff;",
  },
  {
    tailwind: "fill-purple-100",
    css: "fill: #f3e8ff;",
  },
  {
    tailwind: "fill-purple-200",
    css: "fill: #e9d5ff;",
  },
  {
    tailwind: "fill-purple-300",
    css: "fill: #d8b4fe;",
  },
  {
    tailwind: "fill-purple-400",
    css: "fill: #c084fc;",
  },
  {
    tailwind: "fill-purple-500",
    css: "fill: #a855f7;",
  },
  {
    tailwind: "fill-purple-600",
    css: "fill: #9333ea;",
  },
  {
    tailwind: "fill-purple-700",
    css: "fill: #7e22ce;",
  },
  {
    tailwind: "fill-purple-800",
    css: "fill: #6b21a8;",
  },
  {
    tailwind: "fill-purple-900",
    css: "fill: #581c87;",
  },
  {
    tailwind: "fill-purple-950",
    css: "fill: #3b0764;",
  },
  {
    tailwind: "fill-fuchsia-50",
    css: "fill: #fdf4ff;",
  },
  {
    tailwind: "fill-fuchsia-100",
    css: "fill: #fae8ff;",
  },
  {
    tailwind: "fill-fuchsia-200",
    css: "fill: #f5d0fe;",
  },
  {
    tailwind: "fill-fuchsia-300",
    css: "fill: #f0abfc;",
  },
  {
    tailwind: "fill-fuchsia-400",
    css: "fill: #e879f9;",
  },
  {
    tailwind: "fill-fuchsia-500",
    css: "fill: #d946ef;",
  },
  {
    tailwind: "fill-fuchsia-600",
    css: "fill: #c026d3;",
  },
  {
    tailwind: "fill-fuchsia-700",
    css: "fill: #a21caf;",
  },
  {
    tailwind: "fill-fuchsia-800",
    css: "fill: #86198f;",
  },
  {
    tailwind: "fill-fuchsia-900",
    css: "fill: #701a75;",
  },
  {
    tailwind: "fill-fuchsia-950",
    css: "fill: #4a044e;",
  },
  {
    tailwind: "fill-pink-50",
    css: "fill: #fdf2f8;",
  },
  {
    tailwind: "fill-pink-100",
    css: "fill: #fce7f3;",
  },
  {
    tailwind: "fill-pink-200",
    css: "fill: #fbcfe8;",
  },
  {
    tailwind: "fill-pink-300",
    css: "fill: #f9a8d4;",
  },
  {
    tailwind: "fill-pink-400",
    css: "fill: #f472b6;",
  },
  {
    tailwind: "fill-pink-500",
    css: "fill: #ec4899;",
  },
  {
    tailwind: "fill-pink-600",
    css: "fill: #db2777;",
  },
  {
    tailwind: "fill-pink-700",
    css: "fill: #be185d;",
  },
  {
    tailwind: "fill-pink-800",
    css: "fill: #9d174d;",
  },
  {
    tailwind: "fill-pink-900",
    css: "fill: #831843;",
  },
  {
    tailwind: "fill-pink-950",
    css: "fill: #500724;",
  },
  {
    tailwind: "fill-rose-50",
    css: "fill: #fff1f2;",
  },
  {
    tailwind: "fill-rose-100",
    css: "fill: #ffe4e6;",
  },
  {
    tailwind: "fill-rose-200",
    css: "fill: #fecdd3;",
  },
  {
    tailwind: "fill-rose-300",
    css: "fill: #fda4af;",
  },
  {
    tailwind: "fill-rose-400",
    css: "fill: #fb7185;",
  },
  {
    tailwind: "fill-rose-500",
    css: "fill: #f43f5e;",
  },
  {
    tailwind: "fill-rose-600",
    css: "fill: #e11d48;",
  },
  {
    tailwind: "fill-rose-700",
    css: "fill: #be123c;",
  },
  {
    tailwind: "fill-rose-800",
    css: "fill: #9f1239;",
  },
  {
    tailwind: "fill-rose-900",
    css: "fill: #881337;",
  },
  {
    tailwind: "fill-rose-950",
    css: "fill: #4c0519;",
  },
  {
    tailwind: "stroke-none",
    css: "stroke: none;",
  },
  {
    tailwind: "stroke-inherit",
    css: "stroke: inherit;",
  },
  {
    tailwind: "stroke-current",
    css: "stroke: currentColor;",
  },
  {
    tailwind: "stroke-transparent",
    css: "stroke: transparent;",
  },
  {
    tailwind: "stroke-black",
    css: "stroke: #000;",
  },
  {
    tailwind: "stroke-white",
    css: "stroke: #fff;",
  },
  {
    tailwind: "stroke-slate-50",
    css: "stroke: #f8fafc;",
  },
  {
    tailwind: "stroke-slate-100",
    css: "stroke: #f1f5f9;",
  },
  {
    tailwind: "stroke-slate-200",
    css: "stroke: #e2e8f0;",
  },
  {
    tailwind: "stroke-slate-300",
    css: "stroke: #cbd5e1;",
  },
  {
    tailwind: "stroke-slate-400",
    css: "stroke: #94a3b8;",
  },
  {
    tailwind: "stroke-slate-500",
    css: "stroke: #64748b;",
  },
  {
    tailwind: "stroke-slate-600",
    css: "stroke: #475569;",
  },
  {
    tailwind: "stroke-slate-700",
    css: "stroke: #334155;",
  },
  {
    tailwind: "stroke-slate-800",
    css: "stroke: #1e293b;",
  },
  {
    tailwind: "stroke-slate-900",
    css: "stroke: #0f172a;",
  },
  {
    tailwind: "stroke-slate-950",
    css: "stroke: #020617;",
  },
  {
    tailwind: "stroke-gray-50",
    css: "stroke: #f9fafb;",
  },
  {
    tailwind: "stroke-gray-100",
    css: "stroke: #f3f4f6;",
  },
  {
    tailwind: "stroke-gray-200",
    css: "stroke: #e5e7eb;",
  },
  {
    tailwind: "stroke-gray-300",
    css: "stroke: #d1d5db;",
  },
  {
    tailwind: "stroke-gray-400",
    css: "stroke: #9ca3af;",
  },
  {
    tailwind: "stroke-gray-500",
    css: "stroke: #6b7280;",
  },
  {
    tailwind: "stroke-gray-600",
    css: "stroke: #4b5563;",
  },
  {
    tailwind: "stroke-gray-700",
    css: "stroke: #374151;",
  },
  {
    tailwind: "stroke-gray-800",
    css: "stroke: #1f2937;",
  },
  {
    tailwind: "stroke-gray-900",
    css: "stroke: #111827;",
  },
  {
    tailwind: "stroke-gray-950",
    css: "stroke: #030712;",
  },
  {
    tailwind: "stroke-zinc-50",
    css: "stroke: #fafafa;",
  },
  {
    tailwind: "stroke-zinc-100",
    css: "stroke: #f4f4f5;",
  },
  {
    tailwind: "stroke-zinc-200",
    css: "stroke: #e4e4e7;",
  },
  {
    tailwind: "stroke-zinc-300",
    css: "stroke: #d4d4d8;",
  },
  {
    tailwind: "stroke-zinc-400",
    css: "stroke: #a1a1aa;",
  },
  {
    tailwind: "stroke-zinc-500",
    css: "stroke: #71717a;",
  },
  {
    tailwind: "stroke-zinc-600",
    css: "stroke: #52525b;",
  },
  {
    tailwind: "stroke-zinc-700",
    css: "stroke: #3f3f46;",
  },
  {
    tailwind: "stroke-zinc-800",
    css: "stroke: #27272a;",
  },
  {
    tailwind: "stroke-zinc-900",
    css: "stroke: #18181b;",
  },
  {
    tailwind: "stroke-zinc-950",
    css: "stroke: #09090b;",
  },
  {
    tailwind: "stroke-neutral-50",
    css: "stroke: #fafafa;",
  },
  {
    tailwind: "stroke-neutral-100",
    css: "stroke: #f5f5f5;",
  },
  {
    tailwind: "stroke-neutral-200",
    css: "stroke: #e5e5e5;",
  },
  {
    tailwind: "stroke-neutral-300",
    css: "stroke: #d4d4d4;",
  },
  {
    tailwind: "stroke-neutral-400",
    css: "stroke: #a3a3a3;",
  },
  {
    tailwind: "stroke-neutral-500",
    css: "stroke: #737373;",
  },
  {
    tailwind: "stroke-neutral-600",
    css: "stroke: #525252;",
  },
  {
    tailwind: "stroke-neutral-700",
    css: "stroke: #404040;",
  },
  {
    tailwind: "stroke-neutral-800",
    css: "stroke: #262626;",
  },
  {
    tailwind: "stroke-neutral-900",
    css: "stroke: #171717;",
  },
  {
    tailwind: "stroke-neutral-950",
    css: "stroke: #0a0a0a;",
  },
  {
    tailwind: "stroke-stone-50",
    css: "stroke: #fafaf9;",
  },
  {
    tailwind: "stroke-stone-100",
    css: "stroke: #f5f5f4;",
  },
  {
    tailwind: "stroke-stone-200",
    css: "stroke: #e7e5e4;",
  },
  {
    tailwind: "stroke-stone-300",
    css: "stroke: #d6d3d1;",
  },
  {
    tailwind: "stroke-stone-400",
    css: "stroke: #a8a29e;",
  },
  {
    tailwind: "stroke-stone-500",
    css: "stroke: #78716c;",
  },
  {
    tailwind: "stroke-stone-600",
    css: "stroke: #57534e;",
  },
  {
    tailwind: "stroke-stone-700",
    css: "stroke: #44403c;",
  },
  {
    tailwind: "stroke-stone-800",
    css: "stroke: #292524;",
  },
  {
    tailwind: "stroke-stone-900",
    css: "stroke: #1c1917;",
  },
  {
    tailwind: "stroke-stone-950",
    css: "stroke: #0c0a09;",
  },
  {
    tailwind: "stroke-red-50",
    css: "stroke: #fef2f2;",
  },
  {
    tailwind: "stroke-red-100",
    css: "stroke: #fee2e2;",
  },
  {
    tailwind: "stroke-red-200",
    css: "stroke: #fecaca;",
  },
  {
    tailwind: "stroke-red-300",
    css: "stroke: #fca5a5;",
  },
  {
    tailwind: "stroke-red-400",
    css: "stroke: #f87171;",
  },
  {
    tailwind: "stroke-red-500",
    css: "stroke: #ef4444;",
  },
  {
    tailwind: "stroke-red-600",
    css: "stroke: #dc2626;",
  },
  {
    tailwind: "stroke-red-700",
    css: "stroke: #b91c1c;",
  },
  {
    tailwind: "stroke-red-800",
    css: "stroke: #991b1b;",
  },
  {
    tailwind: "stroke-red-900",
    css: "stroke: #7f1d1d;",
  },
  {
    tailwind: "stroke-red-950",
    css: "stroke: #450a0a;",
  },
  {
    tailwind: "stroke-orange-50",
    css: "stroke: #fff7ed;",
  },
  {
    tailwind: "stroke-orange-100",
    css: "stroke: #ffedd5;",
  },
  {
    tailwind: "stroke-orange-200",
    css: "stroke: #fed7aa;",
  },
  {
    tailwind: "stroke-orange-300",
    css: "stroke: #fdba74;",
  },
  {
    tailwind: "stroke-orange-400",
    css: "stroke: #fb923c;",
  },
  {
    tailwind: "stroke-orange-500",
    css: "stroke: #f97316;",
  },
  {
    tailwind: "stroke-orange-600",
    css: "stroke: #ea580c;",
  },
  {
    tailwind: "stroke-orange-700",
    css: "stroke: #c2410c;",
  },
  {
    tailwind: "stroke-orange-800",
    css: "stroke: #9a3412;",
  },
  {
    tailwind: "stroke-orange-900",
    css: "stroke: #7c2d12;",
  },
  {
    tailwind: "stroke-orange-950",
    css: "stroke: #431407;",
  },
  {
    tailwind: "stroke-amber-50",
    css: "stroke: #fffbeb;",
  },
  {
    tailwind: "stroke-amber-100",
    css: "stroke: #fef3c7;",
  },
  {
    tailwind: "stroke-amber-200",
    css: "stroke: #fde68a;",
  },
  {
    tailwind: "stroke-amber-300",
    css: "stroke: #fcd34d;",
  },
  {
    tailwind: "stroke-amber-400",
    css: "stroke: #fbbf24;",
  },
  {
    tailwind: "stroke-amber-500",
    css: "stroke: #f59e0b;",
  },
  {
    tailwind: "stroke-amber-600",
    css: "stroke: #d97706;",
  },
  {
    tailwind: "stroke-amber-700",
    css: "stroke: #b45309;",
  },
  {
    tailwind: "stroke-amber-800",
    css: "stroke: #92400e;",
  },
  {
    tailwind: "stroke-amber-900",
    css: "stroke: #78350f;",
  },
  {
    tailwind: "stroke-amber-950",
    css: "stroke: #451a03;",
  },
  {
    tailwind: "stroke-yellow-50",
    css: "stroke: #fefce8;",
  },
  {
    tailwind: "stroke-yellow-100",
    css: "stroke: #fef9c3;",
  },
  {
    tailwind: "stroke-yellow-200",
    css: "stroke: #fef08a;",
  },
  {
    tailwind: "stroke-yellow-300",
    css: "stroke: #fde047;",
  },
  {
    tailwind: "stroke-yellow-400",
    css: "stroke: #facc15;",
  },
  {
    tailwind: "stroke-yellow-500",
    css: "stroke: #eab308;",
  },
  {
    tailwind: "stroke-yellow-600",
    css: "stroke: #ca8a04;",
  },
  {
    tailwind: "stroke-yellow-700",
    css: "stroke: #a16207;",
  },
  {
    tailwind: "stroke-yellow-800",
    css: "stroke: #854d0e;",
  },
  {
    tailwind: "stroke-yellow-900",
    css: "stroke: #713f12;",
  },
  {
    tailwind: "stroke-yellow-950",
    css: "stroke: #422006;",
  },
  {
    tailwind: "stroke-lime-50",
    css: "stroke: #f7fee7;",
  },
  {
    tailwind: "stroke-lime-100",
    css: "stroke: #ecfccb;",
  },
  {
    tailwind: "stroke-lime-200",
    css: "stroke: #d9f99d;",
  },
  {
    tailwind: "stroke-lime-300",
    css: "stroke: #bef264;",
  },
  {
    tailwind: "stroke-lime-400",
    css: "stroke: #a3e635;",
  },
  {
    tailwind: "stroke-lime-500",
    css: "stroke: #84cc16;",
  },
  {
    tailwind: "stroke-lime-600",
    css: "stroke: #65a30d;",
  },
  {
    tailwind: "stroke-lime-700",
    css: "stroke: #4d7c0f;",
  },
  {
    tailwind: "stroke-lime-800",
    css: "stroke: #3f6212;",
  },
  {
    tailwind: "stroke-lime-900",
    css: "stroke: #365314;",
  },
  {
    tailwind: "stroke-lime-950",
    css: "stroke: #1a2e05;",
  },
  {
    tailwind: "stroke-green-50",
    css: "stroke: #f0fdf4;",
  },
  {
    tailwind: "stroke-green-100",
    css: "stroke: #dcfce7;",
  },
  {
    tailwind: "stroke-green-200",
    css: "stroke: #bbf7d0;",
  },
  {
    tailwind: "stroke-green-300",
    css: "stroke: #86efac;",
  },
  {
    tailwind: "stroke-green-400",
    css: "stroke: #4ade80;",
  },
  {
    tailwind: "stroke-green-500",
    css: "stroke: #22c55e;",
  },
  {
    tailwind: "stroke-green-600",
    css: "stroke: #16a34a;",
  },
  {
    tailwind: "stroke-green-700",
    css: "stroke: #15803d;",
  },
  {
    tailwind: "stroke-green-800",
    css: "stroke: #166534;",
  },
  {
    tailwind: "stroke-green-900",
    css: "stroke: #14532d;",
  },
  {
    tailwind: "stroke-green-950",
    css: "stroke: #052e16;",
  },
  {
    tailwind: "stroke-emerald-50",
    css: "stroke: #ecfdf5;",
  },
  {
    tailwind: "stroke-emerald-100",
    css: "stroke: #d1fae5;",
  },
  {
    tailwind: "stroke-emerald-200",
    css: "stroke: #a7f3d0;",
  },
  {
    tailwind: "stroke-emerald-300",
    css: "stroke: #6ee7b7;",
  },
  {
    tailwind: "stroke-emerald-400",
    css: "stroke: #34d399;",
  },
  {
    tailwind: "stroke-emerald-500",
    css: "stroke: #10b981;",
  },
  {
    tailwind: "stroke-emerald-600",
    css: "stroke: #059669;",
  },
  {
    tailwind: "stroke-emerald-700",
    css: "stroke: #047857;",
  },
  {
    tailwind: "stroke-emerald-800",
    css: "stroke: #065f46;",
  },
  {
    tailwind: "stroke-emerald-900",
    css: "stroke: #064e3b;",
  },
  {
    tailwind: "stroke-emerald-950",
    css: "stroke: #022c22;",
  },
  {
    tailwind: "stroke-teal-50",
    css: "stroke: #f0fdfa;",
  },
  {
    tailwind: "stroke-teal-100",
    css: "stroke: #ccfbf1;",
  },
  {
    tailwind: "stroke-teal-200",
    css: "stroke: #99f6e4;",
  },
  {
    tailwind: "stroke-teal-300",
    css: "stroke: #5eead4;",
  },
  {
    tailwind: "stroke-teal-400",
    css: "stroke: #2dd4bf;",
  },
  {
    tailwind: "stroke-teal-500",
    css: "stroke: #14b8a6;",
  },
  {
    tailwind: "stroke-teal-600",
    css: "stroke: #0d9488;",
  },
  {
    tailwind: "stroke-teal-700",
    css: "stroke: #0f766e;",
  },
  {
    tailwind: "stroke-teal-800",
    css: "stroke: #115e59;",
  },
  {
    tailwind: "stroke-teal-900",
    css: "stroke: #134e4a;",
  },
  {
    tailwind: "stroke-teal-950",
    css: "stroke: #042f2e;",
  },
  {
    tailwind: "stroke-cyan-50",
    css: "stroke: #ecfeff;",
  },
  {
    tailwind: "stroke-cyan-100",
    css: "stroke: #cffafe;",
  },
  {
    tailwind: "stroke-cyan-200",
    css: "stroke: #a5f3fc;",
  },
  {
    tailwind: "stroke-cyan-300",
    css: "stroke: #67e8f9;",
  },
  {
    tailwind: "stroke-cyan-400",
    css: "stroke: #22d3ee;",
  },
  {
    tailwind: "stroke-cyan-500",
    css: "stroke: #06b6d4;",
  },
  {
    tailwind: "stroke-cyan-600",
    css: "stroke: #0891b2;",
  },
  {
    tailwind: "stroke-cyan-700",
    css: "stroke: #0e7490;",
  },
  {
    tailwind: "stroke-cyan-800",
    css: "stroke: #155e75;",
  },
  {
    tailwind: "stroke-cyan-900",
    css: "stroke: #164e63;",
  },
  {
    tailwind: "stroke-cyan-950",
    css: "stroke: #083344;",
  },
  {
    tailwind: "stroke-sky-50",
    css: "stroke: #f0f9ff;",
  },
  {
    tailwind: "stroke-sky-100",
    css: "stroke: #e0f2fe;",
  },
  {
    tailwind: "stroke-sky-200",
    css: "stroke: #bae6fd;",
  },
  {
    tailwind: "stroke-sky-300",
    css: "stroke: #7dd3fc;",
  },
  {
    tailwind: "stroke-sky-400",
    css: "stroke: #38bdf8;",
  },
  {
    tailwind: "stroke-sky-500",
    css: "stroke: #0ea5e9;",
  },
  {
    tailwind: "stroke-sky-600",
    css: "stroke: #0284c7;",
  },
  {
    tailwind: "stroke-sky-700",
    css: "stroke: #0369a1;",
  },
  {
    tailwind: "stroke-sky-800",
    css: "stroke: #075985;",
  },
  {
    tailwind: "stroke-sky-900",
    css: "stroke: #0c4a6e;",
  },
  {
    tailwind: "stroke-sky-950",
    css: "stroke: #082f49;",
  },
  {
    tailwind: "stroke-blue-50",
    css: "stroke: #eff6ff;",
  },
  {
    tailwind: "stroke-blue-100",
    css: "stroke: #dbeafe;",
  },
  {
    tailwind: "stroke-blue-200",
    css: "stroke: #bfdbfe;",
  },
  {
    tailwind: "stroke-blue-300",
    css: "stroke: #93c5fd;",
  },
  {
    tailwind: "stroke-blue-400",
    css: "stroke: #60a5fa;",
  },
  {
    tailwind: "stroke-blue-500",
    css: "stroke: #3b82f6;",
  },
  {
    tailwind: "stroke-blue-600",
    css: "stroke: #2563eb;",
  },
  {
    tailwind: "stroke-blue-700",
    css: "stroke: #1d4ed8;",
  },
  {
    tailwind: "stroke-blue-800",
    css: "stroke: #1e40af;",
  },
  {
    tailwind: "stroke-blue-900",
    css: "stroke: #1e3a8a;",
  },
  {
    tailwind: "stroke-blue-950",
    css: "stroke: #172554;",
  },
  {
    tailwind: "stroke-indigo-50",
    css: "stroke: #eef2ff;",
  },
  {
    tailwind: "stroke-indigo-100",
    css: "stroke: #e0e7ff;",
  },
  {
    tailwind: "stroke-indigo-200",
    css: "stroke: #c7d2fe;",
  },
  {
    tailwind: "stroke-indigo-300",
    css: "stroke: #a5b4fc;",
  },
  {
    tailwind: "stroke-indigo-400",
    css: "stroke: #818cf8;",
  },
  {
    tailwind: "stroke-indigo-500",
    css: "stroke: #6366f1;",
  },
  {
    tailwind: "stroke-indigo-600",
    css: "stroke: #4f46e5;",
  },
  {
    tailwind: "stroke-indigo-700",
    css: "stroke: #4338ca;",
  },
  {
    tailwind: "stroke-indigo-800",
    css: "stroke: #3730a3;",
  },
  {
    tailwind: "stroke-indigo-900",
    css: "stroke: #312e81;",
  },
  {
    tailwind: "stroke-indigo-950",
    css: "stroke: #1e1b4b;",
  },
  {
    tailwind: "stroke-violet-50",
    css: "stroke: #f5f3ff;",
  },
  {
    tailwind: "stroke-violet-100",
    css: "stroke: #ede9fe;",
  },
  {
    tailwind: "stroke-violet-200",
    css: "stroke: #ddd6fe;",
  },
  {
    tailwind: "stroke-violet-300",
    css: "stroke: #c4b5fd;",
  },
  {
    tailwind: "stroke-violet-400",
    css: "stroke: #a78bfa;",
  },
  {
    tailwind: "stroke-violet-500",
    css: "stroke: #8b5cf6;",
  },
  {
    tailwind: "stroke-violet-600",
    css: "stroke: #7c3aed;",
  },
  {
    tailwind: "stroke-violet-700",
    css: "stroke: #6d28d9;",
  },
  {
    tailwind: "stroke-violet-800",
    css: "stroke: #5b21b6;",
  },
  {
    tailwind: "stroke-violet-900",
    css: "stroke: #4c1d95;",
  },
  {
    tailwind: "stroke-violet-950",
    css: "stroke: #2e1065;",
  },
  {
    tailwind: "stroke-purple-50",
    css: "stroke: #faf5ff;",
  },
  {
    tailwind: "stroke-purple-100",
    css: "stroke: #f3e8ff;",
  },
  {
    tailwind: "stroke-purple-200",
    css: "stroke: #e9d5ff;",
  },
  {
    tailwind: "stroke-purple-300",
    css: "stroke: #d8b4fe;",
  },
  {
    tailwind: "stroke-purple-400",
    css: "stroke: #c084fc;",
  },
  {
    tailwind: "stroke-purple-500",
    css: "stroke: #a855f7;",
  },
  {
    tailwind: "stroke-purple-600",
    css: "stroke: #9333ea;",
  },
  {
    tailwind: "stroke-purple-700",
    css: "stroke: #7e22ce;",
  },
  {
    tailwind: "stroke-purple-800",
    css: "stroke: #6b21a8;",
  },
  {
    tailwind: "stroke-purple-900",
    css: "stroke: #581c87;",
  },
  {
    tailwind: "stroke-purple-950",
    css: "stroke: #3b0764;",
  },
  {
    tailwind: "stroke-fuchsia-50",
    css: "stroke: #fdf4ff;",
  },
  {
    tailwind: "stroke-fuchsia-100",
    css: "stroke: #fae8ff;",
  },
  {
    tailwind: "stroke-fuchsia-200",
    css: "stroke: #f5d0fe;",
  },
  {
    tailwind: "stroke-fuchsia-300",
    css: "stroke: #f0abfc;",
  },
  {
    tailwind: "stroke-fuchsia-400",
    css: "stroke: #e879f9;",
  },
  {
    tailwind: "stroke-fuchsia-500",
    css: "stroke: #d946ef;",
  },
  {
    tailwind: "stroke-fuchsia-600",
    css: "stroke: #c026d3;",
  },
  {
    tailwind: "stroke-fuchsia-700",
    css: "stroke: #a21caf;",
  },
  {
    tailwind: "stroke-fuchsia-800",
    css: "stroke: #86198f;",
  },
  {
    tailwind: "stroke-fuchsia-900",
    css: "stroke: #701a75;",
  },
  {
    tailwind: "stroke-fuchsia-950",
    css: "stroke: #4a044e;",
  },
  {
    tailwind: "stroke-pink-50",
    css: "stroke: #fdf2f8;",
  },
  {
    tailwind: "stroke-pink-100",
    css: "stroke: #fce7f3;",
  },
  {
    tailwind: "stroke-pink-200",
    css: "stroke: #fbcfe8;",
  },
  {
    tailwind: "stroke-pink-300",
    css: "stroke: #f9a8d4;",
  },
  {
    tailwind: "stroke-pink-400",
    css: "stroke: #f472b6;",
  },
  {
    tailwind: "stroke-pink-500",
    css: "stroke: #ec4899;",
  },
  {
    tailwind: "stroke-pink-600",
    css: "stroke: #db2777;",
  },
  {
    tailwind: "stroke-pink-700",
    css: "stroke: #be185d;",
  },
  {
    tailwind: "stroke-pink-800",
    css: "stroke: #9d174d;",
  },
  {
    tailwind: "stroke-pink-900",
    css: "stroke: #831843;",
  },
  {
    tailwind: "stroke-pink-950",
    css: "stroke: #500724;",
  },
  {
    tailwind: "stroke-rose-50",
    css: "stroke: #fff1f2;",
  },
  {
    tailwind: "stroke-rose-100",
    css: "stroke: #ffe4e6;",
  },
  {
    tailwind: "stroke-rose-200",
    css: "stroke: #fecdd3;",
  },
  {
    tailwind: "stroke-rose-300",
    css: "stroke: #fda4af;",
  },
  {
    tailwind: "stroke-rose-400",
    css: "stroke: #fb7185;",
  },
  {
    tailwind: "stroke-rose-500",
    css: "stroke: #f43f5e;",
  },
  {
    tailwind: "stroke-rose-600",
    css: "stroke: #e11d48;",
  },
  {
    tailwind: "stroke-rose-700",
    css: "stroke: #be123c;",
  },
  {
    tailwind: "stroke-rose-800",
    css: "stroke: #9f1239;",
  },
  {
    tailwind: "stroke-rose-900",
    css: "stroke: #881337;",
  },
  {
    tailwind: "stroke-rose-950",
    css: "stroke: #4c0519;",
  },
  {
    tailwind: "stroke-0",
    css: "stroke-width: 0;",
  },
  {
    tailwind: "stroke-1",
    css: "stroke-width: 1;",
  },
  {
    tailwind: "stroke-2",
    css: "stroke-width: 2;",
  },
  {
    tailwind: "sr-only",
    css: "position: absolute;\nwidth: 1px;\nheight: 1px;\npadding: 0;\nmargin: -1px;\noverflow: hidden;\nclip: rect(0, 0, 0, 0);\nwhite-space: nowrap;\nborder-width: 0;",
  },
  {
    tailwind: "not-sr-only",
    css: "position: static;\nwidth: auto;\nheight: auto;\npadding: 0;\nmargin: 0;\noverflow: visible;\nclip: auto;\nwhite-space: normal;",
  },
];

export default PROPERTIES;
